(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["lib"] = factory();
	else
		root["lib"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 621:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var http = __webpack_require__(439)
var url = __webpack_require__(269)

var https = module.exports

for (var key in http) {
  if (http.hasOwnProperty(key)) https[key] = http[key]
}

https.request = function (params, cb) {
  params = validateParams(params)
  return http.request.call(this, params, cb)
}

https.get = function (params, cb) {
  params = validateParams(params)
  return http.get.call(this, params, cb)
}

function validateParams (params) {
  if (typeof params === 'string') {
    params = url.parse(params)
  }
  if (!params.protocol) {
    params.protocol = 'https:'
  }
  if (params.protocol !== 'https:') {
    throw new Error('Protocol "' + params.protocol + '" not supported. Expected "https:"')
  }
  return params
}


/***/ }),

/***/ 23:
/***/ (function(module) {

"use strict";
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



function assertPath(path) {
  if (typeof path !== 'string') {
    throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
  }
}

// Resolves . and .. elements in a path with directory names
function normalizeStringPosix(path, allowAboveRoot) {
  var res = '';
  var lastSegmentLength = 0;
  var lastSlash = -1;
  var dots = 0;
  var code;
  for (var i = 0; i <= path.length; ++i) {
    if (i < path.length)
      code = path.charCodeAt(i);
    else if (code === 47 /*/*/)
      break;
    else
      code = 47 /*/*/;
    if (code === 47 /*/*/) {
      if (lastSlash === i - 1 || dots === 1) {
        // NOOP
      } else if (lastSlash !== i - 1 && dots === 2) {
        if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/ || res.charCodeAt(res.length - 2) !== 46 /*.*/) {
          if (res.length > 2) {
            var lastSlashIndex = res.lastIndexOf('/');
            if (lastSlashIndex !== res.length - 1) {
              if (lastSlashIndex === -1) {
                res = '';
                lastSegmentLength = 0;
              } else {
                res = res.slice(0, lastSlashIndex);
                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
              }
              lastSlash = i;
              dots = 0;
              continue;
            }
          } else if (res.length === 2 || res.length === 1) {
            res = '';
            lastSegmentLength = 0;
            lastSlash = i;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          if (res.length > 0)
            res += '/..';
          else
            res = '..';
          lastSegmentLength = 2;
        }
      } else {
        if (res.length > 0)
          res += '/' + path.slice(lastSlash + 1, i);
        else
          res = path.slice(lastSlash + 1, i);
        lastSegmentLength = i - lastSlash - 1;
      }
      lastSlash = i;
      dots = 0;
    } else if (code === 46 /*.*/ && dots !== -1) {
      ++dots;
    } else {
      dots = -1;
    }
  }
  return res;
}

function _format(sep, pathObject) {
  var dir = pathObject.dir || pathObject.root;
  var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
  if (!dir) {
    return base;
  }
  if (dir === pathObject.root) {
    return dir + base;
  }
  return dir + sep + base;
}

var posix = {
  // path.resolve([from ...], to)
  resolve: function resolve() {
    var resolvedPath = '';
    var resolvedAbsolute = false;
    var cwd;

    for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
      var path;
      if (i >= 0)
        path = arguments[i];
      else {
        if (cwd === undefined)
          cwd = process.cwd();
        path = cwd;
      }

      assertPath(path);

      // Skip empty entries
      if (path.length === 0) {
        continue;
      }

      resolvedPath = path + '/' + resolvedPath;
      resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/;
    }

    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)

    // Normalize the path
    resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);

    if (resolvedAbsolute) {
      if (resolvedPath.length > 0)
        return '/' + resolvedPath;
      else
        return '/';
    } else if (resolvedPath.length > 0) {
      return resolvedPath;
    } else {
      return '.';
    }
  },

  normalize: function normalize(path) {
    assertPath(path);

    if (path.length === 0) return '.';

    var isAbsolute = path.charCodeAt(0) === 47 /*/*/;
    var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/;

    // Normalize the path
    path = normalizeStringPosix(path, !isAbsolute);

    if (path.length === 0 && !isAbsolute) path = '.';
    if (path.length > 0 && trailingSeparator) path += '/';

    if (isAbsolute) return '/' + path;
    return path;
  },

  isAbsolute: function isAbsolute(path) {
    assertPath(path);
    return path.length > 0 && path.charCodeAt(0) === 47 /*/*/;
  },

  join: function join() {
    if (arguments.length === 0)
      return '.';
    var joined;
    for (var i = 0; i < arguments.length; ++i) {
      var arg = arguments[i];
      assertPath(arg);
      if (arg.length > 0) {
        if (joined === undefined)
          joined = arg;
        else
          joined += '/' + arg;
      }
    }
    if (joined === undefined)
      return '.';
    return posix.normalize(joined);
  },

  relative: function relative(from, to) {
    assertPath(from);
    assertPath(to);

    if (from === to) return '';

    from = posix.resolve(from);
    to = posix.resolve(to);

    if (from === to) return '';

    // Trim any leading backslashes
    var fromStart = 1;
    for (; fromStart < from.length; ++fromStart) {
      if (from.charCodeAt(fromStart) !== 47 /*/*/)
        break;
    }
    var fromEnd = from.length;
    var fromLen = fromEnd - fromStart;

    // Trim any leading backslashes
    var toStart = 1;
    for (; toStart < to.length; ++toStart) {
      if (to.charCodeAt(toStart) !== 47 /*/*/)
        break;
    }
    var toEnd = to.length;
    var toLen = toEnd - toStart;

    // Compare paths to find the longest common path from root
    var length = fromLen < toLen ? fromLen : toLen;
    var lastCommonSep = -1;
    var i = 0;
    for (; i <= length; ++i) {
      if (i === length) {
        if (toLen > length) {
          if (to.charCodeAt(toStart + i) === 47 /*/*/) {
            // We get here if `from` is the exact base path for `to`.
            // For example: from='/foo/bar'; to='/foo/bar/baz'
            return to.slice(toStart + i + 1);
          } else if (i === 0) {
            // We get here if `from` is the root
            // For example: from='/'; to='/foo'
            return to.slice(toStart + i);
          }
        } else if (fromLen > length) {
          if (from.charCodeAt(fromStart + i) === 47 /*/*/) {
            // We get here if `to` is the exact base path for `from`.
            // For example: from='/foo/bar/baz'; to='/foo/bar'
            lastCommonSep = i;
          } else if (i === 0) {
            // We get here if `to` is the root.
            // For example: from='/foo'; to='/'
            lastCommonSep = 0;
          }
        }
        break;
      }
      var fromCode = from.charCodeAt(fromStart + i);
      var toCode = to.charCodeAt(toStart + i);
      if (fromCode !== toCode)
        break;
      else if (fromCode === 47 /*/*/)
        lastCommonSep = i;
    }

    var out = '';
    // Generate the relative path based on the path difference between `to`
    // and `from`
    for (i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i) {
      if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/) {
        if (out.length === 0)
          out += '..';
        else
          out += '/..';
      }
    }

    // Lastly, append the rest of the destination (`to`) path that comes after
    // the common path parts
    if (out.length > 0)
      return out + to.slice(toStart + lastCommonSep);
    else {
      toStart += lastCommonSep;
      if (to.charCodeAt(toStart) === 47 /*/*/)
        ++toStart;
      return to.slice(toStart);
    }
  },

  _makeLong: function _makeLong(path) {
    return path;
  },

  dirname: function dirname(path) {
    assertPath(path);
    if (path.length === 0) return '.';
    var code = path.charCodeAt(0);
    var hasRoot = code === 47 /*/*/;
    var end = -1;
    var matchedSlash = true;
    for (var i = path.length - 1; i >= 1; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          if (!matchedSlash) {
            end = i;
            break;
          }
        } else {
        // We saw the first non-path separator
        matchedSlash = false;
      }
    }

    if (end === -1) return hasRoot ? '/' : '.';
    if (hasRoot && end === 1) return '//';
    return path.slice(0, end);
  },

  basename: function basename(path, ext) {
    if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
    assertPath(path);

    var start = 0;
    var end = -1;
    var matchedSlash = true;
    var i;

    if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
      if (ext.length === path.length && ext === path) return '';
      var extIdx = ext.length - 1;
      var firstNonSlashEnd = -1;
      for (i = path.length - 1; i >= 0; --i) {
        var code = path.charCodeAt(i);
        if (code === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else {
          if (firstNonSlashEnd === -1) {
            // We saw the first non-path separator, remember this index in case
            // we need it if the extension ends up not matching
            matchedSlash = false;
            firstNonSlashEnd = i + 1;
          }
          if (extIdx >= 0) {
            // Try to match the explicit extension
            if (code === ext.charCodeAt(extIdx)) {
              if (--extIdx === -1) {
                // We matched the extension, so mark this as the end of our path
                // component
                end = i;
              }
            } else {
              // Extension does not match, so our result is the entire path
              // component
              extIdx = -1;
              end = firstNonSlashEnd;
            }
          }
        }
      }

      if (start === end) end = firstNonSlashEnd;else if (end === -1) end = path.length;
      return path.slice(start, end);
    } else {
      for (i = path.length - 1; i >= 0; --i) {
        if (path.charCodeAt(i) === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else if (end === -1) {
          // We saw the first non-path separator, mark this as the end of our
          // path component
          matchedSlash = false;
          end = i + 1;
        }
      }

      if (end === -1) return '';
      return path.slice(start, end);
    }
  },

  extname: function extname(path) {
    assertPath(path);
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;
    for (var i = path.length - 1; i >= 0; --i) {
      var code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1)
            startDot = i;
          else if (preDotState !== 1)
            preDotState = 1;
      } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
        // We saw a non-dot character immediately before the dot
        preDotState === 0 ||
        // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      return '';
    }
    return path.slice(startDot, end);
  },

  format: function format(pathObject) {
    if (pathObject === null || typeof pathObject !== 'object') {
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
    }
    return _format('/', pathObject);
  },

  parse: function parse(path) {
    assertPath(path);

    var ret = { root: '', dir: '', base: '', ext: '', name: '' };
    if (path.length === 0) return ret;
    var code = path.charCodeAt(0);
    var isAbsolute = code === 47 /*/*/;
    var start;
    if (isAbsolute) {
      ret.root = '/';
      start = 1;
    } else {
      start = 0;
    }
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    var i = path.length - 1;

    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;

    // Get non-dir info
    for (; i >= start; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1) startDot = i;else if (preDotState !== 1) preDotState = 1;
        } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
    // We saw a non-dot character immediately before the dot
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly '..'
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      if (end !== -1) {
        if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);else ret.base = ret.name = path.slice(startPart, end);
      }
    } else {
      if (startPart === 0 && isAbsolute) {
        ret.name = path.slice(1, startDot);
        ret.base = path.slice(1, end);
      } else {
        ret.name = path.slice(startPart, startDot);
        ret.base = path.slice(startPart, end);
      }
      ret.ext = path.slice(startDot, end);
    }

    if (startPart > 0) ret.dir = path.slice(0, startPart - 1);else if (isAbsolute) ret.dir = '/';

    return ret;
  },

  sep: '/',
  delimiter: ':',
  win32: null,
  posix: null
};

posix.posix = posix;

module.exports = posix;


/***/ }),

/***/ 439:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var ClientRequest = __webpack_require__(224)
var response = __webpack_require__(291)
var extend = __webpack_require__(170)
var statusCodes = __webpack_require__(405)
var url = __webpack_require__(269)

var http = exports

http.request = function (opts, cb) {
	if (typeof opts === 'string')
		opts = url.parse(opts)
	else
		opts = extend(opts)

	// Normally, the page is loaded from http or https, so not specifying a protocol
	// will result in a (valid) protocol-relative url. However, this won't work if
	// the protocol is something else, like 'file:'
	var defaultProtocol = __webpack_require__.g.location.protocol.search(/^https?:$/) === -1 ? 'http:' : ''

	var protocol = opts.protocol || defaultProtocol
	var host = opts.hostname || opts.host
	var port = opts.port
	var path = opts.path || '/'

	// Necessary for IPv6 addresses
	if (host && host.indexOf(':') !== -1)
		host = '[' + host + ']'

	// This may be a relative url. The browser should always be able to interpret it correctly.
	opts.url = (host ? (protocol + '//' + host) : '') + (port ? ':' + port : '') + path
	opts.method = (opts.method || 'GET').toUpperCase()
	opts.headers = opts.headers || {}

	// Also valid opts.auth, opts.mode

	var req = new ClientRequest(opts)
	if (cb)
		req.on('response', cb)
	return req
}

http.get = function get (opts, cb) {
	var req = http.request(opts, cb)
	req.end()
	return req
}

http.ClientRequest = ClientRequest
http.IncomingMessage = response.IncomingMessage

http.Agent = function () {}
http.Agent.defaultMaxSockets = 4

http.globalAgent = new http.Agent()

http.STATUS_CODES = statusCodes

http.METHODS = [
	'CHECKOUT',
	'CONNECT',
	'COPY',
	'DELETE',
	'GET',
	'HEAD',
	'LOCK',
	'M-SEARCH',
	'MERGE',
	'MKACTIVITY',
	'MKCOL',
	'MOVE',
	'NOTIFY',
	'OPTIONS',
	'PATCH',
	'POST',
	'PROPFIND',
	'PROPPATCH',
	'PURGE',
	'PUT',
	'REPORT',
	'SEARCH',
	'SUBSCRIBE',
	'TRACE',
	'UNLOCK',
	'UNSUBSCRIBE'
]

/***/ }),

/***/ 633:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

exports.fetch = isFunction(__webpack_require__.g.fetch) && isFunction(__webpack_require__.g.ReadableStream)

exports.writableStream = isFunction(__webpack_require__.g.WritableStream)

exports.abortController = isFunction(__webpack_require__.g.AbortController)

// The xhr request to example.com may violate some restrictive CSP configurations,
// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
// and assume support for certain features below.
var xhr
function getXHR () {
	// Cache the xhr value
	if (xhr !== undefined) return xhr

	if (__webpack_require__.g.XMLHttpRequest) {
		xhr = new __webpack_require__.g.XMLHttpRequest()
		// If XDomainRequest is available (ie only, where xhr might not work
		// cross domain), use the page location. Otherwise use example.com
		// Note: this doesn't actually make an http request.
		try {
			xhr.open('GET', __webpack_require__.g.XDomainRequest ? '/' : 'https://example.com')
		} catch(e) {
			xhr = null
		}
	} else {
		// Service workers don't have XHR
		xhr = null
	}
	return xhr
}

function checkTypeSupport (type) {
	var xhr = getXHR()
	if (!xhr) return false
	try {
		xhr.responseType = type
		return xhr.responseType === type
	} catch (e) {}
	return false
}

// If fetch is supported, then arraybuffer will be supported too. Skip calling
// checkTypeSupport(), since that calls getXHR().
exports.arraybuffer = exports.fetch || checkTypeSupport('arraybuffer')

// These next two tests unavoidably show warnings in Chrome. Since fetch will always
// be used if it's available, just return false for these to avoid the warnings.
exports.msstream = !exports.fetch && checkTypeSupport('ms-stream')
exports.mozchunkedarraybuffer = !exports.fetch && checkTypeSupport('moz-chunked-arraybuffer')

// If fetch is supported, then overrideMimeType will be supported too. Skip calling
// getXHR().
exports.overrideMimeType = exports.fetch || (getXHR() ? isFunction(getXHR().overrideMimeType) : false)

function isFunction (value) {
	return typeof value === 'function'
}

xhr = null // Help gc


/***/ }),

/***/ 224:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var capability = __webpack_require__(633)
var inherits = __webpack_require__(766)
var response = __webpack_require__(291)
var stream = __webpack_require__(248)

var IncomingMessage = response.IncomingMessage
var rStates = response.readyStates

function decideMode (preferBinary, useFetch) {
	if (capability.fetch && useFetch) {
		return 'fetch'
	} else if (capability.mozchunkedarraybuffer) {
		return 'moz-chunked-arraybuffer'
	} else if (capability.msstream) {
		return 'ms-stream'
	} else if (capability.arraybuffer && preferBinary) {
		return 'arraybuffer'
	} else {
		return 'text'
	}
}

var ClientRequest = module.exports = function (opts) {
	var self = this
	stream.Writable.call(self)

	self._opts = opts
	self._body = []
	self._headers = {}
	if (opts.auth)
		self.setHeader('Authorization', 'Basic ' + Buffer.from(opts.auth).toString('base64'))
	Object.keys(opts.headers).forEach(function (name) {
		self.setHeader(name, opts.headers[name])
	})

	var preferBinary
	var useFetch = true
	if (opts.mode === 'disable-fetch' || ('requestTimeout' in opts && !capability.abortController)) {
		// If the use of XHR should be preferred. Not typically needed.
		useFetch = false
		preferBinary = true
	} else if (opts.mode === 'prefer-streaming') {
		// If streaming is a high priority but binary compatibility and
		// the accuracy of the 'content-type' header aren't
		preferBinary = false
	} else if (opts.mode === 'allow-wrong-content-type') {
		// If streaming is more important than preserving the 'content-type' header
		preferBinary = !capability.overrideMimeType
	} else if (!opts.mode || opts.mode === 'default' || opts.mode === 'prefer-fast') {
		// Use binary if text streaming may corrupt data or the content-type header, or for speed
		preferBinary = true
	} else {
		throw new Error('Invalid value for opts.mode')
	}
	self._mode = decideMode(preferBinary, useFetch)
	self._fetchTimer = null
	self._socketTimeout = null
	self._socketTimer = null

	self.on('finish', function () {
		self._onFinish()
	})
}

inherits(ClientRequest, stream.Writable)

ClientRequest.prototype.setHeader = function (name, value) {
	var self = this
	var lowerName = name.toLowerCase()
	// This check is not necessary, but it prevents warnings from browsers about setting unsafe
	// headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
	// http-browserify did it, so I will too.
	if (unsafeHeaders.indexOf(lowerName) !== -1)
		return

	self._headers[lowerName] = {
		name: name,
		value: value
	}
}

ClientRequest.prototype.getHeader = function (name) {
	var header = this._headers[name.toLowerCase()]
	if (header)
		return header.value
	return null
}

ClientRequest.prototype.removeHeader = function (name) {
	var self = this
	delete self._headers[name.toLowerCase()]
}

ClientRequest.prototype._onFinish = function () {
	var self = this

	if (self._destroyed)
		return
	var opts = self._opts

	if ('timeout' in opts && opts.timeout !== 0) {
		self.setTimeout(opts.timeout)
	}

	var headersObj = self._headers
	var body = null
	if (opts.method !== 'GET' && opts.method !== 'HEAD') {
        body = new Blob(self._body, {
            type: (headersObj['content-type'] || {}).value || ''
        });
    }

	// create flattened list of headers
	var headersList = []
	Object.keys(headersObj).forEach(function (keyName) {
		var name = headersObj[keyName].name
		var value = headersObj[keyName].value
		if (Array.isArray(value)) {
			value.forEach(function (v) {
				headersList.push([name, v])
			})
		} else {
			headersList.push([name, value])
		}
	})

	if (self._mode === 'fetch') {
		var signal = null
		if (capability.abortController) {
			var controller = new AbortController()
			signal = controller.signal
			self._fetchAbortController = controller

			if ('requestTimeout' in opts && opts.requestTimeout !== 0) {
				self._fetchTimer = __webpack_require__.g.setTimeout(function () {
					self.emit('requestTimeout')
					if (self._fetchAbortController)
						self._fetchAbortController.abort()
				}, opts.requestTimeout)
			}
		}

		__webpack_require__.g.fetch(self._opts.url, {
			method: self._opts.method,
			headers: headersList,
			body: body || undefined,
			mode: 'cors',
			credentials: opts.withCredentials ? 'include' : 'same-origin',
			signal: signal
		}).then(function (response) {
			self._fetchResponse = response
			self._resetTimers(false)
			self._connect()
		}, function (reason) {
			self._resetTimers(true)
			if (!self._destroyed)
				self.emit('error', reason)
		})
	} else {
		var xhr = self._xhr = new __webpack_require__.g.XMLHttpRequest()
		try {
			xhr.open(self._opts.method, self._opts.url, true)
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err)
			})
			return
		}

		// Can't set responseType on really old browsers
		if ('responseType' in xhr)
			xhr.responseType = self._mode

		if ('withCredentials' in xhr)
			xhr.withCredentials = !!opts.withCredentials

		if (self._mode === 'text' && 'overrideMimeType' in xhr)
			xhr.overrideMimeType('text/plain; charset=x-user-defined')

		if ('requestTimeout' in opts) {
			xhr.timeout = opts.requestTimeout
			xhr.ontimeout = function () {
				self.emit('requestTimeout')
			}
		}

		headersList.forEach(function (header) {
			xhr.setRequestHeader(header[0], header[1])
		})

		self._response = null
		xhr.onreadystatechange = function () {
			switch (xhr.readyState) {
				case rStates.LOADING:
				case rStates.DONE:
					self._onXHRProgress()
					break
			}
		}
		// Necessary for streaming in Firefox, since xhr.response is ONLY defined
		// in onprogress, not in onreadystatechange with xhr.readyState = 3
		if (self._mode === 'moz-chunked-arraybuffer') {
			xhr.onprogress = function () {
				self._onXHRProgress()
			}
		}

		xhr.onerror = function () {
			if (self._destroyed)
				return
			self._resetTimers(true)
			self.emit('error', new Error('XHR error'))
		}

		try {
			xhr.send(body)
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err)
			})
			return
		}
	}
}

/**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */
function statusValid (xhr) {
	try {
		var status = xhr.status
		return (status !== null && status !== 0)
	} catch (e) {
		return false
	}
}

ClientRequest.prototype._onXHRProgress = function () {
	var self = this

	self._resetTimers(false)

	if (!statusValid(self._xhr) || self._destroyed)
		return

	if (!self._response)
		self._connect()

	self._response._onXHRProgress(self._resetTimers.bind(self))
}

ClientRequest.prototype._connect = function () {
	var self = this

	if (self._destroyed)
		return

	self._response = new IncomingMessage(self._xhr, self._fetchResponse, self._mode, self._resetTimers.bind(self))
	self._response.on('error', function(err) {
		self.emit('error', err)
	})

	self.emit('response', self._response)
}

ClientRequest.prototype._write = function (chunk, encoding, cb) {
	var self = this

	self._body.push(chunk)
	cb()
}

ClientRequest.prototype._resetTimers = function (done) {
	var self = this

	__webpack_require__.g.clearTimeout(self._socketTimer)
	self._socketTimer = null

	if (done) {
		__webpack_require__.g.clearTimeout(self._fetchTimer)
		self._fetchTimer = null
	} else if (self._socketTimeout) {
		self._socketTimer = __webpack_require__.g.setTimeout(function () {
			self.emit('timeout')
		}, self._socketTimeout)
	}
}

ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function (err) {
	var self = this
	self._destroyed = true
	self._resetTimers(true)
	if (self._response)
		self._response._destroyed = true
	if (self._xhr)
		self._xhr.abort()
	else if (self._fetchAbortController)
		self._fetchAbortController.abort()

	if (err)
		self.emit('error', err)
}

ClientRequest.prototype.end = function (data, encoding, cb) {
	var self = this
	if (typeof data === 'function') {
		cb = data
		data = undefined
	}

	stream.Writable.prototype.end.call(self, data, encoding, cb)
}

ClientRequest.prototype.setTimeout = function (timeout, cb) {
	var self = this

	if (cb)
		self.once('timeout', cb)

	self._socketTimeout = timeout
	self._resetTimers(false)
}

ClientRequest.prototype.flushHeaders = function () {}
ClientRequest.prototype.setNoDelay = function () {}
ClientRequest.prototype.setSocketKeepAlive = function () {}

// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
var unsafeHeaders = [
	'accept-charset',
	'accept-encoding',
	'access-control-request-headers',
	'access-control-request-method',
	'connection',
	'content-length',
	'cookie',
	'cookie2',
	'date',
	'dnt',
	'expect',
	'host',
	'keep-alive',
	'origin',
	'referer',
	'te',
	'trailer',
	'transfer-encoding',
	'upgrade',
	'via'
]


/***/ }),

/***/ 291:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var capability = __webpack_require__(633)
var inherits = __webpack_require__(766)
var stream = __webpack_require__(248)

var rStates = exports.readyStates = {
	UNSENT: 0,
	OPENED: 1,
	HEADERS_RECEIVED: 2,
	LOADING: 3,
	DONE: 4
}

var IncomingMessage = exports.IncomingMessage = function (xhr, response, mode, resetTimers) {
	var self = this
	stream.Readable.call(self)

	self._mode = mode
	self.headers = {}
	self.rawHeaders = []
	self.trailers = {}
	self.rawTrailers = []

	// Fake the 'close' event, but only once 'end' fires
	self.on('end', function () {
		// The nextTick is necessary to prevent the 'request' module from causing an infinite loop
		process.nextTick(function () {
			self.emit('close')
		})
	})

	if (mode === 'fetch') {
		self._fetchResponse = response

		self.url = response.url
		self.statusCode = response.status
		self.statusMessage = response.statusText
		
		response.headers.forEach(function (header, key){
			self.headers[key.toLowerCase()] = header
			self.rawHeaders.push(key, header)
		})

		if (capability.writableStream) {
			var writable = new WritableStream({
				write: function (chunk) {
					resetTimers(false)
					return new Promise(function (resolve, reject) {
						if (self._destroyed) {
							reject()
						} else if(self.push(Buffer.from(chunk))) {
							resolve()
						} else {
							self._resumeFetch = resolve
						}
					})
				},
				close: function () {
					resetTimers(true)
					if (!self._destroyed)
						self.push(null)
				},
				abort: function (err) {
					resetTimers(true)
					if (!self._destroyed)
						self.emit('error', err)
				}
			})

			try {
				response.body.pipeTo(writable).catch(function (err) {
					resetTimers(true)
					if (!self._destroyed)
						self.emit('error', err)
				})
				return
			} catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
		}
		// fallback for when writableStream or pipeTo aren't available
		var reader = response.body.getReader()
		function read () {
			reader.read().then(function (result) {
				if (self._destroyed)
					return
				resetTimers(result.done)
				if (result.done) {
					self.push(null)
					return
				}
				self.push(Buffer.from(result.value))
				read()
			}).catch(function (err) {
				resetTimers(true)
				if (!self._destroyed)
					self.emit('error', err)
			})
		}
		read()
	} else {
		self._xhr = xhr
		self._pos = 0

		self.url = xhr.responseURL
		self.statusCode = xhr.status
		self.statusMessage = xhr.statusText
		var headers = xhr.getAllResponseHeaders().split(/\r?\n/)
		headers.forEach(function (header) {
			var matches = header.match(/^([^:]+):\s*(.*)/)
			if (matches) {
				var key = matches[1].toLowerCase()
				if (key === 'set-cookie') {
					if (self.headers[key] === undefined) {
						self.headers[key] = []
					}
					self.headers[key].push(matches[2])
				} else if (self.headers[key] !== undefined) {
					self.headers[key] += ', ' + matches[2]
				} else {
					self.headers[key] = matches[2]
				}
				self.rawHeaders.push(matches[1], matches[2])
			}
		})

		self._charset = 'x-user-defined'
		if (!capability.overrideMimeType) {
			var mimeType = self.rawHeaders['mime-type']
			if (mimeType) {
				var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/)
				if (charsetMatch) {
					self._charset = charsetMatch[1].toLowerCase()
				}
			}
			if (!self._charset)
				self._charset = 'utf-8' // best guess
		}
	}
}

inherits(IncomingMessage, stream.Readable)

IncomingMessage.prototype._read = function () {
	var self = this

	var resolve = self._resumeFetch
	if (resolve) {
		self._resumeFetch = null
		resolve()
	}
}

IncomingMessage.prototype._onXHRProgress = function (resetTimers) {
	var self = this

	var xhr = self._xhr

	var response = null
	switch (self._mode) {
		case 'text':
			response = xhr.responseText
			if (response.length > self._pos) {
				var newData = response.substr(self._pos)
				if (self._charset === 'x-user-defined') {
					var buffer = Buffer.alloc(newData.length)
					for (var i = 0; i < newData.length; i++)
						buffer[i] = newData.charCodeAt(i) & 0xff

					self.push(buffer)
				} else {
					self.push(newData, self._charset)
				}
				self._pos = response.length
			}
			break
		case 'arraybuffer':
			if (xhr.readyState !== rStates.DONE || !xhr.response)
				break
			response = xhr.response
			self.push(Buffer.from(new Uint8Array(response)))
			break
		case 'moz-chunked-arraybuffer': // take whole
			response = xhr.response
			if (xhr.readyState !== rStates.LOADING || !response)
				break
			self.push(Buffer.from(new Uint8Array(response)))
			break
		case 'ms-stream':
			response = xhr.response
			if (xhr.readyState !== rStates.LOADING)
				break
			var reader = new __webpack_require__.g.MSStreamReader()
			reader.onprogress = function () {
				if (reader.result.byteLength > self._pos) {
					self.push(Buffer.from(new Uint8Array(reader.result.slice(self._pos))))
					self._pos = reader.result.byteLength
				}
			}
			reader.onload = function () {
				resetTimers(true)
				self.push(null)
			}
			// reader.onerror = ??? // TODO: this
			reader.readAsArrayBuffer(response)
			break
	}

	// The ms-stream case handles end separately in reader.onload()
	if (self._xhr.readyState === rStates.DONE && self._mode !== 'ms-stream') {
		resetTimers(true)
		self.push(null)
	}
}


/***/ }),

/***/ 298:
/***/ (function(module) {

"use strict";
module.exports = "/img/App_Store.a2e763b8.svg";

/***/ }),

/***/ 243:
/***/ (function(module) {

"use strict";
module.exports = "/img/MM_logo_HORIZ_NEG_color.91518759.svg";

/***/ }),

/***/ 835:
/***/ (function(module) {

"use strict";
module.exports = "/img/MM_logo_HORIZ_color.32ad7087.svg";

/***/ }),

/***/ 915:
/***/ (function(module) {

"use strict";
module.exports = "/img/huawei.d9ac6f52.svg";

/***/ }),

/***/ 193:
/***/ (function(module) {

"use strict";
module.exports = require("@soda/get-current-script");

/***/ }),

/***/ 405:
/***/ (function(module) {

"use strict";
module.exports = require("builtin-status-codes");

/***/ }),

/***/ 766:
/***/ (function(module) {

"use strict";
module.exports = require("inherits");

/***/ }),

/***/ 248:
/***/ (function(module) {

"use strict";
module.exports = require("readable-stream");

/***/ }),

/***/ 269:
/***/ (function(module) {

"use strict";
module.exports = require("url");

/***/ }),

/***/ 170:
/***/ (function(module) {

"use strict";
module.exports = require("xtend");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AccountAutocomplete": function() { return /* reexport */ AccountAutocomplete; },
  "ActionButton": function() { return /* reexport */ ActionButton; },
  "AppHeaderTemplate": function() { return /* reexport */ AppHeaderTemplate; },
  "BaseItem": function() { return /* reexport */ BaseItem; },
  "ChangePasswordForm": function() { return /* reexport */ ChangePasswordForm; },
  "ChangePasswordView": function() { return /* reexport */ ChangePasswordView; },
  "CloneDialog": function() { return /* reexport */ CloneDialog; },
  "CloneDialogTemplate": function() { return /* reexport */ CloneDialogTemplate; },
  "ConfirmDialog": function() { return /* reexport */ ConfirmDialog; },
  "CustomError": function() { return /* reexport */ CustomError; },
  "CustomPage": function() { return /* reexport */ CustomPage; },
  "DashboardAccessRequestsRow": function() { return /* reexport */ DashboardAccessRequestsRow; },
  "DashboardFullStorageWarningRow": function() { return /* reexport */ DashboardFullStorageWarningRow; },
  "DashboardModule": function() { return /* reexport */ DashboardModule; },
  "DashboardProjectsRow": function() { return /* reexport */ DashboardProjectsRow; },
  "DashboardUsageInfoRow": function() { return /* reexport */ DashboardUsageInfoRow; },
  "DashboardViewTemplate": function() { return /* reexport */ DashboardViewTemplate; },
  "DialogModule": function() { return /* reexport */ DialogModule; },
  "DialogWindows": function() { return /* reexport */ DialogWindows; },
  "DropArea": function() { return /* reexport */ DropArea; },
  "EMPTY_INVITE_ITEM": function() { return /* reexport */ EMPTY_INVITE_ITEM; },
  "EditProfileForm": function() { return /* reexport */ EditProfileForm; },
  "FileBrowserView": function() { return /* reexport */ FileBrowserView; },
  "FileChangesetSummaryTable": function() { return /* reexport */ FileChangesetSummaryTable; },
  "FileDetailView": function() { return /* reexport */ FileDetailView; },
  "FileIcon": function() { return /* reexport */ FileIcon; },
  "FileMenu": function() { return /* reexport */ FileMenu; },
  "FileVersionDetailView": function() { return /* reexport */ FileVersionDetailView; },
  "FolderDiff": function() { return /* reexport */ FolderDiff; },
  "FormMixin": function() { return /* reexport */ FormMixin; },
  "FormModule": function() { return /* reexport */ FormModule; },
  "FullStorageWarning": function() { return /* reexport */ FullStorageWarning; },
  "FullStorageWarningTemplate": function() { return /* reexport */ FullStorageWarningTemplate; },
  "GlobalWarning": function() { return /* reexport */ GlobalWarning; },
  "GlobalWarningTemplate": function() { return /* reexport */ GlobalWarningTemplate; },
  "InstanceApi": function() { return /* reexport */ InstanceApi; },
  "InstanceModule": function() { return /* reexport */ InstanceModule; },
  "LayoutModule": function() { return /* reexport */ LayoutModule; },
  "LoginViewTemplate": function() { return /* reexport */ LoginViewTemplate; },
  "MerginAPIMixin": function() { return /* reexport */ MerginAPIMixin; },
  "MerginComponentUuidMixin": function() { return /* reexport */ MerginComponentUuidMixin; },
  "MerginLogoLight": function() { return /* reexport */ MerginLogoLight; },
  "NotFoundView": function() { return /* reexport */ NotFoundView; },
  "NotificationModule": function() { return /* reexport */ NotificationModule; },
  "Notifications": function() { return /* reexport */ Notifications; },
  "PageFooter": function() { return /* reexport */ Footer; },
  "PageView": function() { return /* reexport */ PageView; },
  "PermissionInfo": function() { return /* reexport */ PermissionInfo; },
  "ProfileAccessRequestsRow": function() { return /* reexport */ ProfileAccessRequestsRow; },
  "ProfileViewTemplate": function() { return /* reexport */ ProfileViewTemplate; },
  "ProgressSpinner": function() { return /* reexport */ ProgressSpinner; },
  "ProjectAccessRequest": function() { return /* reexport */ ProjectAccessRequest; },
  "ProjectAccessRequestTable": function() { return /* reexport */ ProjectAccessRequestTable; },
  "ProjectAccessRequestTableTemplate": function() { return /* reexport */ ProjectAccessRequestTableTemplate; },
  "ProjectApi": function() { return /* reexport */ ProjectApi; },
  "ProjectForm": function() { return /* reexport */ ProjectForm; },
  "ProjectModule": function() { return /* reexport */ ProjectModule; },
  "ProjectPermissionsTemplate": function() { return /* reexport */ ProjectPermissionsTemplate; },
  "ProjectSettingsViewTemplate": function() { return /* reexport */ ProjectSettingsViewTemplate; },
  "ProjectShareButton": function() { return /* reexport */ ProjectShareButton; },
  "ProjectShareButtonTemplate": function() { return /* reexport */ ProjectShareButtonTemplate; },
  "ProjectShareDialog": function() { return /* reexport */ ProjectShareDialog; },
  "ProjectVersionsView": function() { return /* reexport */ ProjectVersionsView; },
  "ProjectVersionsViewTemplate": function() { return /* reexport */ ProjectVersionsViewTemplate; },
  "ProjectViewTemplate": function() { return /* reexport */ ProjectViewTemplate; },
  "ProjectsListViewTemplate": function() { return /* reexport */ ProjectsListViewTemplate; },
  "ProjectsTable": function() { return /* reexport */ ProjectsTable; },
  "ProjectsTableDataLoader": function() { return /* reexport */ ProjectsTableDataLoader; },
  "Router": function() { return /* reexport */ (external_vue_router_default()); },
  "SideBarItem": function() { return /* reexport */ SideBarItem; },
  "SideBarTemplate": function() { return /* reexport */ SideBarTemplate; },
  "UploadPanel": function() { return /* reexport */ UploadPanel; },
  "UploadProgress": function() { return /* reexport */ UploadProgress; },
  "UsageStatus": function() { return /* reexport */ UsageStatus; },
  "UsageStatusTemplate": function() { return /* reexport */ UsageStatusTemplate; },
  "UserApi": function() { return /* reexport */ UserApi; },
  "UserModule": function() { return /* reexport */ UserModule; },
  "UserSearchChip": function() { return /* reexport */ UserSearchChip; },
  "VerifyEmailView": function() { return /* reexport */ VerifyEmailView; },
  "VersionDetailView": function() { return /* reexport */ VersionDetailView; },
  "WarningMessage": function() { return /* reexport */ WarningMessage; },
  "WarningMessageTemplate": function() { return /* reexport */ WarningMessageTemplate; },
  "dateUtils": function() { return /* reexport */ date_utils_namespaceObject; },
  "getDefaultRetryOptions": function() { return /* reexport */ getDefaultRetryOptions; },
  "htmlUtils": function() { return /* reexport */ html_utils_namespaceObject; },
  "http": function() { return /* reexport */ http; },
  "initCsrfToken": function() { return /* reexport */ initCsrfToken; },
  "initRequestInterceptors": function() { return /* reexport */ initRequestInterceptors; },
  "initResponseInterceptors": function() { return /* reexport */ initResponseInterceptors; },
  "merginUtils": function() { return /* reexport */ mergin_utils_namespaceObject; },
  "moduleUtils": function() { return /* reexport */ module_utils_namespaceObject; },
  "numberUtils": function() { return /* reexport */ number_utils_namespaceObject; },
  "pathUtils": function() { return /* reexport */ path_utils_namespaceObject; },
  "permissionUtils": function() { return /* reexport */ permission_utils_namespaceObject; },
  "postRetryCond": function() { return /* reexport */ postRetryCond; },
  "routeUtils": function() { return /* reexport */ route_utils_namespaceObject; },
  "textUtils": function() { return /* reexport */ text_utils_namespaceObject; },
  "validateStatus": function() { return /* reexport */ validateStatus; }
});

// NAMESPACE OBJECT: ./src/common/date_utils.ts
var date_utils_namespaceObject = {};
__webpack_require__.r(date_utils_namespaceObject);
__webpack_require__.d(date_utils_namespaceObject, {
  "formatDate": function() { return formatDate; },
  "formatDateTime": function() { return formatDateTime; },
  "formatRemainingTime": function() { return formatRemainingTime; },
  "formatTimeDiff": function() { return formatTimeDiff; }
});

// NAMESPACE OBJECT: ./src/common/html_utils.ts
var html_utils_namespaceObject = {};
__webpack_require__.r(html_utils_namespaceObject);
__webpack_require__.d(html_utils_namespaceObject, {
  "downloadJsonList": function() { return downloadJsonList; },
  "waitCursor": function() { return waitCursor; }
});

// NAMESPACE OBJECT: ./src/common/mergin_utils.ts
var mergin_utils_namespaceObject = {};
__webpack_require__.r(mergin_utils_namespaceObject);
__webpack_require__.d(mergin_utils_namespaceObject, {
  "CHUNK_SIZE": function() { return CHUNK_SIZE; },
  "calculateChunks": function() { return calculateChunks; },
  "checksum": function() { return checksum; },
  "filesDiff": function() { return filesDiff; },
  "getFiles": function() { return getFiles; },
  "isVersionedFile": function() { return isVersionedFile; },
  "parseError": function() { return parseError; }
});

// NAMESPACE OBJECT: ./src/common/module_utils.ts
var module_utils_namespaceObject = {};
__webpack_require__.r(module_utils_namespaceObject);
__webpack_require__.d(module_utils_namespaceObject, {
  "applyRouteOverride": function() { return applyRouteOverride; },
  "initializeAppModule": function() { return initializeAppModule; }
});

// NAMESPACE OBJECT: ./src/common/number_utils.ts
var number_utils_namespaceObject = {};
__webpack_require__.r(number_utils_namespaceObject);
__webpack_require__.d(number_utils_namespaceObject, {
  "formatFileSize": function() { return formatFileSize; },
  "formatToCurrency": function() { return formatToCurrency; }
});

// NAMESPACE OBJECT: ./src/common/path_utils.ts
var path_utils_namespaceObject = {};
__webpack_require__.r(path_utils_namespaceObject);
__webpack_require__.d(path_utils_namespaceObject, {
  "dirname": function() { return dirname; }
});

// NAMESPACE OBJECT: ./src/common/permission_utils.ts
var permission_utils_namespaceObject = {};
__webpack_require__.r(permission_utils_namespaceObject);
__webpack_require__.d(permission_utils_namespaceObject, {
  "PROJECT_PERMISSION_BY_NAME": function() { return PROJECT_PERMISSION_BY_NAME; },
  "PROJECT_PERMISSION_LABEL_BY_NAME": function() { return PROJECT_PERMISSION_LABEL_BY_NAME; },
  "PROJECT_PERMISSION_NAME_BY_PERMISSION": function() { return PROJECT_PERMISSION_NAME_BY_PERMISSION; },
  "PROJECT_ROLE_BY_NAME": function() { return PROJECT_ROLE_BY_NAME; },
  "PROJECT_ROLE_LABEL_BY_NAME": function() { return PROJECT_ROLE_LABEL_BY_NAME; },
  "PROJECT_ROLE_NAME_BY_ROLE": function() { return PROJECT_ROLE_NAME_BY_ROLE; },
  "ProjectPermission": function() { return ProjectPermission; },
  "ProjectRole": function() { return ProjectRole; },
  "USER_ROLE_BY_NAME": function() { return USER_ROLE_BY_NAME; },
  "USER_ROLE_LABEL_BY_NAME": function() { return USER_ROLE_LABEL_BY_NAME; },
  "USER_ROLE_NAME_BY_ROLE": function() { return USER_ROLE_NAME_BY_ROLE; },
  "UserRole": function() { return UserRole; },
  "getProjectPermissionValuesForSelect": function() { return getProjectPermissionValuesForSelect; },
  "getUserRoleValuesForSelect": function() { return getUserRoleValuesForSelect; },
  "isAtLeastProjectPermission": function() { return isAtLeastProjectPermission; },
  "isAtLeastProjectRole": function() { return isAtLeastProjectRole; },
  "isAtLeastRole": function() { return isAtLeastRole; }
});

// NAMESPACE OBJECT: ./src/common/text_utils.ts
var text_utils_namespaceObject = {};
__webpack_require__.r(text_utils_namespaceObject);
__webpack_require__.d(text_utils_namespaceObject, {
  "EMAIL_LIST_DEFAULT_SEPARATOR": function() { return EMAIL_LIST_DEFAULT_SEPARATOR; },
  "EMAIL_LIST_SEPARATORS": function() { return EMAIL_LIST_SEPARATORS; },
  "formatToTitle": function() { return formatToTitle; },
  "isValidEmail": function() { return isValidEmail; },
  "removeAccents": function() { return removeAccents; }
});

// NAMESPACE OBJECT: ./src/common/route_utils.ts
var route_utils_namespaceObject = {};
__webpack_require__.r(route_utils_namespaceObject);
__webpack_require__.d(route_utils_namespaceObject, {
  "getTagsFromQuery": function() { return getTagsFromQuery; },
  "isAuthenticatedGuard": function() { return isAuthenticatedGuard; },
  "isSuperUser": function() { return isSuperUser; },
  "isTheSameRoute": function() { return isTheSameRoute; }
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__(193)
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// CONCATENATED MODULE: external "vuetify/lib/components/VIcon"
var VIcon_namespaceObject = require("vuetify/lib/components/VIcon");
;// CONCATENATED MODULE: external "vuetify/lib/components/VList"
var VList_namespaceObject = require("vuetify/lib/components/VList");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/base/BaseItem.vue?vue&type=template&id=6acbf0b6&scoped=true&







var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VList_namespaceObject.VListItem,{attrs:{"href":_vm.href,"rel":_vm.href && _vm.href !== '#' ? 'noopener' : undefined,"target":_vm.href && _vm.href !== '#' ? '_blank' : undefined,"to":_vm.item.to,"active-class":"baseItemActiveColor"}},[(_vm.text)?_c(VList_namespaceObject.VListItemIcon,{staticClass:"v-list-item__icon--text",class:`${_vm.color}--text`,domProps:{"textContent":_vm._s(_vm.computedText)}}):(_vm.item.icon || _vm.item.tablerIcon)?_c(VList_namespaceObject.VListItemIcon,{staticClass:"mr-2",class:`${_vm.color}--text`},[(_vm.item.icon)?_c(VIcon_namespaceObject.VIcon,{class:`${_vm.color}--text`,domProps:{"textContent":_vm._s(_vm.item.icon)}}):_vm._e(),(_vm.item.tablerIcon)?_vm._t("icon"):_vm._e()],2):_vm._e(),(_vm.item.title || _vm.item.subtitle)?_c(VList_namespaceObject.VListItemContent,{class:`${_vm.color}--text`},[_c(VList_namespaceObject.VListItemTitle,{domProps:{"textContent":_vm._s(_vm.item.title)}}),_c(VList_namespaceObject.VListItemSubtitle,{domProps:{"textContent":_vm._s(_vm.item.subtitle)}})],1):_vm._e()],1)
}
var staticRenderFns = []


;// CONCATENATED MODULE: ./src/common/components/base/BaseItem.vue?vue&type=template&id=6acbf0b6&scoped=true&

;// CONCATENATED MODULE: external "vue"
var external_vue_namespaceObject = require("vue");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_namespaceObject);
;// CONCATENATED MODULE: external "vuetify/lib/mixins/themeable"
var themeable_namespaceObject = require("vuetify/lib/mixins/themeable");
var themeable_default = /*#__PURE__*/__webpack_require__.n(themeable_namespaceObject);
;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/base/BaseItem.vue?vue&type=script&lang=ts&


/* harmony default export */ var BaseItemvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'Item',
    mixins: [(themeable_default())],
    props: {
        color: {
            type: String,
            default: 'white'
        },
        item: {
            type: Object,
            default: function () { return ({
                href: undefined,
                icon: undefined,
                tablerIcon: false,
                subtitle: undefined,
                title: undefined,
                to: undefined
            }); }
        },
        text: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        computedText: function () {
            if (!this.item || !this.item.title)
                return '';
            var text = '';
            this.item.title.split(' ').forEach(function (val) {
                text += val.substring(0, 1);
            });
            return text;
        },
        href: function () {
            return this.item.href || (this.item.to ? undefined : '#');
        }
    }
}));

;// CONCATENATED MODULE: ./src/common/components/base/BaseItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var base_BaseItemvue_type_script_lang_ts_ = (BaseItemvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/base/BaseItem.vue?vue&type=style&index=0&id=6acbf0b6&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/common/components/base/BaseItem.vue?vue&type=style&index=0&id=6acbf0b6&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/common/components/base/BaseItem.vue



;


/* normalize component */

var component = normalizeComponent(
  base_BaseItemvue_type_script_lang_ts_,
  render,
  staticRenderFns,
  false,
  null,
  "6acbf0b6",
  null
  
)

/* harmony default export */ var BaseItem = (component.exports);
;// CONCATENATED MODULE: ./src/common/components/base/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial


;// CONCATENATED MODULE: external "vuetify/lib/components/VBtn"
var VBtn_namespaceObject = require("vuetify/lib/components/VBtn");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/ActionButton.vue?vue&type=template&id=0a5f9aee&scoped=true&


var ActionButtonvue_type_template_id_0a5f9aee_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn_namespaceObject.VBtn,_vm._g(_vm._b({class:`${_vm.colorClass} white--text font-weight-bold ${
    // TODO: start to work in Vue 3 (remove this comment after upgrade to vue 3) - https://v3-migration.vuejs.org/breaking-changes/attrs-includes-class-style.html#attrs-includes-class-style
    _vm.$attrs.class ? _vm.$attrs.class : ''
  }`},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('span',{staticClass:"mr-2 d-inline-flex"},[_vm._t("icon")],2),_c('span',[_vm._t("default")],2)])
}
var ActionButtonvue_type_template_id_0a5f9aee_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/common/components/ActionButton.vue?vue&type=template&id=0a5f9aee&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/ActionButton.vue?vue&type=script&lang=ts&

/* harmony default export */ var ActionButtonvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'ActionButton',
    props: {
        colorClass: { type: String, default: 'primary' }
    }
}));

;// CONCATENATED MODULE: ./src/common/components/ActionButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ActionButtonvue_type_script_lang_ts_ = (ActionButtonvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/common/components/ActionButton.vue





/* normalize component */
;
var ActionButton_component = normalizeComponent(
  components_ActionButtonvue_type_script_lang_ts_,
  ActionButtonvue_type_template_id_0a5f9aee_scoped_true_render,
  ActionButtonvue_type_template_id_0a5f9aee_scoped_true_staticRenderFns,
  false,
  null,
  "0a5f9aee",
  null
  
)

/* harmony default export */ var ActionButton = (ActionButton_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VGrid"
var VGrid_namespaceObject = require("vuetify/lib/components/VGrid");
;// CONCATENATED MODULE: external "vuetify/lib/components/VImg"
var VImg_namespaceObject = require("vuetify/lib/components/VImg");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/CustomPage.vue?vue&type=template&id=e32af724&scoped=true&




var CustomPagevue_type_template_id_e32af724_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-window"},[_c(VGrid_namespaceObject.VLayout,{attrs:{"justify-center":"","align-end":"","shrink":""}},[_c(VImg_namespaceObject.VImg,{attrs:{"contain":"","max-width":"300","position":"center bottom","transition":false}})],1),_c(VGrid_namespaceObject.VContainer,{staticClass:"py-1"},[_c('div',{staticClass:"form-wrapper"},[_vm._t("default")],2)])],1)
}
var CustomPagevue_type_template_id_e32af724_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/common/components/CustomPage.vue?vue&type=template&id=e32af724&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/CustomPage.vue?vue&type=script&lang=ts&

/* harmony default export */ var CustomPagevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'CustomPage'
}));

;// CONCATENATED MODULE: ./src/common/components/CustomPage.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_CustomPagevue_type_script_lang_ts_ = (CustomPagevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/CustomPage.vue?vue&type=style&index=0&id=e32af724&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/common/components/CustomPage.vue?vue&type=style&index=0&id=e32af724&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/common/components/CustomPage.vue



;


/* normalize component */

var CustomPage_component = normalizeComponent(
  components_CustomPagevue_type_script_lang_ts_,
  CustomPagevue_type_template_id_e32af724_scoped_true_render,
  CustomPagevue_type_template_id_e32af724_scoped_true_staticRenderFns,
  false,
  null,
  "e32af724",
  null
  
)

/* harmony default export */ var CustomPage = (CustomPage_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/Footer.vue?vue&type=template&id=31a02280&scoped=true&





var Footervue_type_template_id_31a02280_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"footer py-4"},[_c(VGrid_namespaceObject.VLayout,{attrs:{"row":"","wrap":"","align-center":""}},[_c(VGrid_namespaceObject.VRow,[_c(VGrid_namespaceObject.VCol,{attrs:{"xs12":"","sm6":"","px-4":"","text-xs-center":"","text-sm-left":""}},[_c('span',[_vm._v("© 2019-"+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"https://www.lutraconsulting.co.uk/"}},[_vm._v("Lutra Consulting Limited")]),_vm._v(". All rights reserved.")])]),_c(VGrid_namespaceObject.VCol,{class:{
          'justify-center': _vm.$vuetify.breakpoint.xs,
          'justify-end': _vm.$vuetify.breakpoint.smAndUp
        },staticStyle:{"text-align":"right"},attrs:{"sm6":"","text-sm-right":"","xs12":"","px-4":""}},[_c('a',{staticClass:"icon",attrs:{"href":"https://github.com/lutraconsulting/"}},[_c(VIcon_namespaceObject.VIcon,[_vm._v("fab fa-github")])],1),_c('a',{staticClass:"icon",attrs:{"href":"https://twitter.com/lutraconsulting/"}},[_c(VIcon_namespaceObject.VIcon,[_vm._v("fab fa-twitter")])],1),_c('a',{staticClass:"icon",attrs:{"href":"https://www.linkedin.com/company/lutra-consulting"}},[_c(VIcon_namespaceObject.VIcon,[_vm._v("fab fa-linkedin")])],1)])],1)],1)],1)
}
var Footervue_type_template_id_31a02280_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/common/components/Footer.vue?vue&type=template&id=31a02280&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/Footer.vue?vue&type=script&lang=js&

/* harmony default export */ var Footervue_type_script_lang_js_ = ({
  name: 'Footer'
});

;// CONCATENATED MODULE: ./src/common/components/Footer.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Footervue_type_script_lang_js_ = (Footervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/Footer.vue?vue&type=style&index=0&id=31a02280&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/common/components/Footer.vue?vue&type=style&index=0&id=31a02280&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/common/components/Footer.vue



;


/* normalize component */

var Footer_component = normalizeComponent(
  components_Footervue_type_script_lang_js_,
  Footervue_type_template_id_31a02280_scoped_true_render,
  Footervue_type_template_id_31a02280_scoped_true_staticRenderFns,
  false,
  null,
  "31a02280",
  null
  
)

/* harmony default export */ var Footer = (Footer_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/FullStorageWarning.vue?vue&type=template&id=20c5c98a&scoped=true&
var FullStorageWarningvue_type_template_id_20c5c98a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FullStorageWarningTemplate',{attrs:{"usage":_vm.usage}})
}
var FullStorageWarningvue_type_template_id_20c5c98a_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: external "vuetify/lib/components/VCard"
var VCard_namespaceObject = require("vuetify/lib/components/VCard");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/FullStorageWarningTemplate.vue?vue&type=template&id=2fc64c27&scoped=true&


var FullStorageWarningTemplatevue_type_template_id_2fc64c27_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCard_namespaceObject.VCard,{staticClass:"bubble mt-3",staticStyle:{"background-color":"#fce8e6","color":"rgba(0, 0, 0, 0.87)"},attrs:{"outlined":""}},[_c('span',[_c('b',[_vm._v("Your storage is almost full ("+_vm._s(_vm.usage)+"%).")]),_vm._v(" Soon you will not be able to sync your projects. "),_vm._t("buttons")],2)])
}
var FullStorageWarningTemplatevue_type_template_id_2fc64c27_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/common/components/FullStorageWarningTemplate.vue?vue&type=template&id=2fc64c27&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/FullStorageWarningTemplate.vue?vue&type=script&lang=ts&

/* harmony default export */ var FullStorageWarningTemplatevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'FullStorageWarningTemplate',
    props: {
        usage: Number
    }
}));

;// CONCATENATED MODULE: ./src/common/components/FullStorageWarningTemplate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_FullStorageWarningTemplatevue_type_script_lang_ts_ = (FullStorageWarningTemplatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/common/components/FullStorageWarningTemplate.vue





/* normalize component */
;
var FullStorageWarningTemplate_component = normalizeComponent(
  components_FullStorageWarningTemplatevue_type_script_lang_ts_,
  FullStorageWarningTemplatevue_type_template_id_2fc64c27_scoped_true_render,
  FullStorageWarningTemplatevue_type_template_id_2fc64c27_scoped_true_staticRenderFns,
  false,
  null,
  "2fc64c27",
  null
  
)

/* harmony default export */ var FullStorageWarningTemplate = (FullStorageWarningTemplate_component.exports);
;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/FullStorageWarning.vue?vue&type=script&lang=ts&


/* harmony default export */ var FullStorageWarningvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'FullStorageWarning',
    components: { FullStorageWarningTemplate: FullStorageWarningTemplate },
    props: {
        usage: Number,
        username: String
    }
}));

;// CONCATENATED MODULE: ./src/common/components/FullStorageWarning.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_FullStorageWarningvue_type_script_lang_ts_ = (FullStorageWarningvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/common/components/FullStorageWarning.vue





/* normalize component */
;
var FullStorageWarning_component = normalizeComponent(
  components_FullStorageWarningvue_type_script_lang_ts_,
  FullStorageWarningvue_type_template_id_20c5c98a_scoped_true_render,
  FullStorageWarningvue_type_template_id_20c5c98a_scoped_true_staticRenderFns,
  false,
  null,
  "20c5c98a",
  null
  
)

/* harmony default export */ var FullStorageWarning = (FullStorageWarning_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/GlobalWarning.vue?vue&type=template&id=a3ef2598&scoped=true&
var GlobalWarningvue_type_template_id_a3ef2598_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('global-warning-template')
}
var GlobalWarningvue_type_template_id_a3ef2598_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/GlobalWarningTemplate.vue?vue&type=template&id=afb00ab2&scoped=true&
var GlobalWarningTemplatevue_type_template_id_afb00ab2_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("warning")],2)
}
var GlobalWarningTemplatevue_type_template_id_afb00ab2_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/GlobalWarningTemplate.vue?vue&type=script&lang=ts&

/* harmony default export */ var GlobalWarningTemplatevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'GlobalWarningTemplate'
}));

;// CONCATENATED MODULE: ./src/common/components/GlobalWarningTemplate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_GlobalWarningTemplatevue_type_script_lang_ts_ = (GlobalWarningTemplatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/common/components/GlobalWarningTemplate.vue





/* normalize component */
;
var GlobalWarningTemplate_component = normalizeComponent(
  components_GlobalWarningTemplatevue_type_script_lang_ts_,
  GlobalWarningTemplatevue_type_template_id_afb00ab2_scoped_true_render,
  GlobalWarningTemplatevue_type_template_id_afb00ab2_scoped_true_staticRenderFns,
  false,
  null,
  "afb00ab2",
  null
  
)

/* harmony default export */ var GlobalWarningTemplate = (GlobalWarningTemplate_component.exports);
;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/GlobalWarning.vue?vue&type=script&lang=ts&


/* harmony default export */ var GlobalWarningvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'GlobalWarning',
    components: { GlobalWarningTemplate: GlobalWarningTemplate }
}));

;// CONCATENATED MODULE: ./src/common/components/GlobalWarning.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_GlobalWarningvue_type_script_lang_ts_ = (GlobalWarningvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/common/components/GlobalWarning.vue





/* normalize component */
;
var GlobalWarning_component = normalizeComponent(
  components_GlobalWarningvue_type_script_lang_ts_,
  GlobalWarningvue_type_template_id_a3ef2598_scoped_true_render,
  GlobalWarningvue_type_template_id_a3ef2598_scoped_true_staticRenderFns,
  false,
  null,
  "a3ef2598",
  null
  
)

/* harmony default export */ var GlobalWarning = (GlobalWarning_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VResponsive"
var VResponsive_namespaceObject = require("vuetify/lib/components/VResponsive");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/MerginLogoLight.vue?vue&type=template&id=244f0c63&


var MerginLogoLightvue_type_template_id_244f0c63_render = function render(){var _vm=this,_c=_vm._self._c;return _c(VResponsive_namespaceObject.VResponsive,{staticClass:"mt-2"},[_c('img',{attrs:{"src":__webpack_require__(835),"alt":"Mergin logo"},on:{"click":function($event){return _vm.$emit('click')}}})])
}
var MerginLogoLightvue_type_template_id_244f0c63_staticRenderFns = []


;// CONCATENATED MODULE: ./src/common/components/MerginLogoLight.vue?vue&type=template&id=244f0c63&

;// CONCATENATED MODULE: ./src/common/components/MerginLogoLight.vue

var script = {}


/* normalize component */
;
var MerginLogoLight_component = normalizeComponent(
  script,
  MerginLogoLightvue_type_template_id_244f0c63_render,
  MerginLogoLightvue_type_template_id_244f0c63_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MerginLogoLight = (MerginLogoLight_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VProgressCircular"
var VProgressCircular_namespaceObject = require("vuetify/lib/components/VProgressCircular");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/ProgressSpinner.vue?vue&type=template&id=2d750d0e&scoped=true&


var ProgressSpinnervue_type_template_id_2d750d0e_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VProgressCircular_namespaceObject.VProgressCircular,{staticClass:"mx-2",attrs:{"size":22,"width":3,"indeterminate":""}})
}
var ProgressSpinnervue_type_template_id_2d750d0e_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/common/components/ProgressSpinner.vue?vue&type=template&id=2d750d0e&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/ProgressSpinner.vue?vue&type=script&lang=ts&

/* harmony default export */ var ProgressSpinnervue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'ProgressSpinner'
}));

;// CONCATENATED MODULE: ./src/common/components/ProgressSpinner.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ProgressSpinnervue_type_script_lang_ts_ = (ProgressSpinnervue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/common/components/ProgressSpinner.vue





/* normalize component */
;
var ProgressSpinner_component = normalizeComponent(
  components_ProgressSpinnervue_type_script_lang_ts_,
  ProgressSpinnervue_type_template_id_2d750d0e_scoped_true_render,
  ProgressSpinnervue_type_template_id_2d750d0e_scoped_true_staticRenderFns,
  false,
  null,
  "2d750d0e",
  null
  
)

/* harmony default export */ var ProgressSpinner = (ProgressSpinner_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VSnackbar"
var VSnackbar_namespaceObject = require("vuetify/lib/components/VSnackbar");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/UploadProgress.vue?vue&type=template&id=7ee28466&scoped=true&




var UploadProgressvue_type_template_id_7ee28466_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.list.length)?_c(VSnackbar_namespaceObject.VSnackbar,{attrs:{"bottom":"","right":"","auto-height":"","timeout":-1,"value":_vm.visible}},[_c(VGrid_namespaceObject.VLayout,{attrs:{"column":""}},_vm._l((_vm.uploads),function(upload,project){return _c(VGrid_namespaceObject.VLayout,{key:project,staticClass:"py-1 row align-center justify-space-between"},[_c('span',[_vm._v(_vm._s(project))]),_c(VProgressCircular_namespaceObject.VProgressCircular,{attrs:{"size":55,"width":8,"value":(upload.loaded / upload.total) * 100,"color":"teal"}},[_vm._v(" "+_vm._s(Math.floor((upload.loaded / upload.total) * 100))+"% ")])],1)}),1)],1):_vm._e()
}
var UploadProgressvue_type_template_id_7ee28466_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/common/components/UploadProgress.vue?vue&type=template&id=7ee28466&scoped=true&

;// CONCATENATED MODULE: external "lodash/debounce"
var debounce_namespaceObject = require("lodash/debounce");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_namespaceObject);
;// CONCATENATED MODULE: external "vuex"
var external_vuex_namespaceObject = require("vuex");
;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/UploadProgress.vue?vue&type=script&lang=ts&
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



/* harmony default export */ var UploadProgressvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'upload-progress',
    data: function () {
        return {
            visible: false
        };
    },
    computed: __assign(__assign({}, (0,external_vuex_namespaceObject.mapState)('projectModule', ['uploads'])), { list: function () {
            return Object.values(this.uploads);
        }, uploading: function () {
            return this.list.some(function (u) { return u.running; });
        } }),
    watch: {
        uploading: 'updateVisibility'
    },
    methods: {
        updateVisibility: debounce_default()(function (value) {
            this.visible = value;
        }, 500)
    }
}));

;// CONCATENATED MODULE: ./src/common/components/UploadProgress.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_UploadProgressvue_type_script_lang_ts_ = (UploadProgressvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/UploadProgress.vue?vue&type=style&index=0&id=7ee28466&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/common/components/UploadProgress.vue?vue&type=style&index=0&id=7ee28466&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/common/components/UploadProgress.vue



;


/* normalize component */

var UploadProgress_component = normalizeComponent(
  components_UploadProgressvue_type_script_lang_ts_,
  UploadProgressvue_type_template_id_7ee28466_scoped_true_render,
  UploadProgressvue_type_template_id_7ee28466_scoped_true_staticRenderFns,
  false,
  null,
  "7ee28466",
  null
  
)

/* harmony default export */ var UploadProgress = (UploadProgress_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/UsageStatus.vue?vue&type=template&id=65cfe234&scoped=true&
var UsageStatusvue_type_template_id_65cfe234_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('UsageStatusTemplate')
}
var UsageStatusvue_type_template_id_65cfe234_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/UsageStatusTemplate.vue?vue&type=template&id=76c0890a&scoped=true&
var UsageStatusTemplatevue_type_template_id_76c0890a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("billing")],2)
}
var UsageStatusTemplatevue_type_template_id_76c0890a_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/UsageStatusTemplate.vue?vue&type=script&lang=ts&

/* harmony default export */ var UsageStatusTemplatevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'UsageStatusTemplate'
}));

;// CONCATENATED MODULE: ./src/common/components/UsageStatusTemplate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_UsageStatusTemplatevue_type_script_lang_ts_ = (UsageStatusTemplatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/common/components/UsageStatusTemplate.vue





/* normalize component */
;
var UsageStatusTemplate_component = normalizeComponent(
  components_UsageStatusTemplatevue_type_script_lang_ts_,
  UsageStatusTemplatevue_type_template_id_76c0890a_scoped_true_render,
  UsageStatusTemplatevue_type_template_id_76c0890a_scoped_true_staticRenderFns,
  false,
  null,
  "76c0890a",
  null
  
)

/* harmony default export */ var UsageStatusTemplate = (UsageStatusTemplate_component.exports);
;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/UsageStatus.vue?vue&type=script&lang=ts&


/* harmony default export */ var UsageStatusvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'UsageStatus',
    components: { UsageStatusTemplate: UsageStatusTemplate }
}));

;// CONCATENATED MODULE: ./src/common/components/UsageStatus.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_UsageStatusvue_type_script_lang_ts_ = (UsageStatusvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/common/components/UsageStatus.vue





/* normalize component */
;
var UsageStatus_component = normalizeComponent(
  components_UsageStatusvue_type_script_lang_ts_,
  UsageStatusvue_type_template_id_65cfe234_scoped_true_render,
  UsageStatusvue_type_template_id_65cfe234_scoped_true_staticRenderFns,
  false,
  null,
  "65cfe234",
  null
  
)

/* harmony default export */ var UsageStatus = (UsageStatus_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/WarningMessage.vue?vue&type=template&id=720e5572&scoped=true&
var WarningMessagevue_type_template_id_720e5572_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.text)?_c('warning-message-template',{scopedSlots:_vm._u([{key:"message",fn:function(){return [_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v(" "+_vm._s(_vm.text))])]},proxy:true}],null,false,3345420020)}):_vm._e()
}
var WarningMessagevue_type_template_id_720e5572_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/WarningMessageTemplate.vue?vue&type=template&id=050787c0&scoped=true&


var WarningMessageTemplatevue_type_template_id_050787c0_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCard_namespaceObject.VCard,{staticClass:"bubble mt-3",staticStyle:{"background-color":"#ffc863","color":"rgba(0, 0, 0, 0.87)","padding":"10px"},attrs:{"outlined":""}},[_vm._t("message")],2)
}
var WarningMessageTemplatevue_type_template_id_050787c0_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/common/components/WarningMessageTemplate.vue?vue&type=template&id=050787c0&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/WarningMessageTemplate.vue?vue&type=script&lang=ts&

/* harmony default export */ var WarningMessageTemplatevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'WarningMessageTemplate'
}));

;// CONCATENATED MODULE: ./src/common/components/WarningMessageTemplate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_WarningMessageTemplatevue_type_script_lang_ts_ = (WarningMessageTemplatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/common/components/WarningMessageTemplate.vue





/* normalize component */
;
var WarningMessageTemplate_component = normalizeComponent(
  components_WarningMessageTemplatevue_type_script_lang_ts_,
  WarningMessageTemplatevue_type_template_id_050787c0_scoped_true_render,
  WarningMessageTemplatevue_type_template_id_050787c0_scoped_true_staticRenderFns,
  false,
  null,
  "050787c0",
  null
  
)

/* harmony default export */ var WarningMessageTemplate = (WarningMessageTemplate_component.exports);
;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/common/components/WarningMessage.vue?vue&type=script&lang=ts&


/* harmony default export */ var WarningMessagevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'WarningMessage',
    components: { WarningMessageTemplate: WarningMessageTemplate },
    props: {
        text: null
    }
}));

;// CONCATENATED MODULE: ./src/common/components/WarningMessage.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_WarningMessagevue_type_script_lang_ts_ = (WarningMessagevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/common/components/WarningMessage.vue





/* normalize component */
;
var WarningMessage_component = normalizeComponent(
  components_WarningMessagevue_type_script_lang_ts_,
  WarningMessagevue_type_template_id_720e5572_scoped_true_render,
  WarningMessagevue_type_template_id_720e5572_scoped_true_staticRenderFns,
  false,
  null,
  "720e5572",
  null
  
)

/* harmony default export */ var WarningMessage = (WarningMessage_component.exports);
;// CONCATENATED MODULE: ./src/common/components/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
















;// CONCATENATED MODULE: ./src/common/errors.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CustomError = /** @class */ (function (_super) {
    __extends(CustomError, _super);
    function CustomError(message, response) {
        var _this = _super.call(this, message) || this;
        Object.defineProperty(_this, "response", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.setPrototypeOf(_this, CustomError.prototype);
        _this.response = response;
        return _this;
    }
    return CustomError;
}(Error));


;// CONCATENATED MODULE: ./src/common/mixins/FormMixin.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
/* harmony default export */ var FormMixin = ({
    data: function () {
        return {
            errors: {},
            errorMsg: null
        };
    },
    methods: {
        clearErrors: function () {
            this.errors = {};
            this.errorMsg = null;
        },
        handleError: function (err, generalMsg) {
            if (generalMsg === void 0) { generalMsg = 'Error'; }
            if (typeof err.response.data === 'object') {
                // two types of error responses
                if (typeof err.response.data.status === 'number') {
                    this.errorMsg = err.response.data.detail;
                }
                else {
                    this.errors = err.response.data;
                }
            }
            else {
                this.errorMsg = err.response.data || generalMsg;
            }
        }
    }
});

;// CONCATENATED MODULE: external "file-saver"
var external_file_saver_namespaceObject = require("file-saver");
var external_file_saver_default = /*#__PURE__*/__webpack_require__.n(external_file_saver_namespaceObject);
;// CONCATENATED MODULE: ./src/common/mixins/MerginAPIMixin.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

/* harmony default export */ var MerginAPIMixin = ({
    methods: {
        /**
         * fetch logged user profile
         * @return user's profile
         */
        // TODO: used only in billing module, use user module action there instead
        fetchUserProfile: function (username) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.$http
                                .get("/v1/user/".concat(username))
                                .then(function (resp) {
                                _this.$store.commit('updateUserProfile', resp.data);
                                _this.$store.commit('updateVerifiedEmailFlag', resp.data.verified_email);
                            })
                                .catch(function () {
                                return _this.$store.dispatch('notificationModule/error', {
                                    text: "Failed to fetch user's profile"
                                });
                            })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        // TODO: transform to project module action
        downloadArchive: function (url) {
            var _this = this;
            this.$http
                .get(url, { responseType: 'blob' })
                .then(function (resp) {
                var fileName = resp.headers['content-disposition'].split('filename=')[1];
                external_file_saver_default().saveAs(resp.data, fileName);
            })
                .catch(function (e) {
                // parse error details from blob
                var resp;
                var blob = new Blob([e.response.data], { type: 'text/plain' });
                blob.text().then(function (text) {
                    resp = JSON.parse(text);
                    _this.$store.dispatch('notificationModule/error', {
                        text: resp.detail
                    });
                });
            });
        }
    }
});

;// CONCATENATED MODULE: ./src/common/mixins/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial



;// CONCATENATED MODULE: external "axios"
var external_axios_namespaceObject = require("axios");
var external_axios_default = /*#__PURE__*/__webpack_require__.n(external_axios_namespaceObject);
;// CONCATENATED MODULE: external "axios-retry"
var external_axios_retry_namespaceObject = require("axios-retry");
var external_axios_retry_default = /*#__PURE__*/__webpack_require__.n(external_axios_retry_namespaceObject);
// EXTERNAL MODULE: ../../node_modules/https-browserify/index.js
var https_browserify = __webpack_require__(621);
var https_browserify_default = /*#__PURE__*/__webpack_require__.n(https_browserify);
;// CONCATENATED MODULE: ./src/common/http.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial




var HTTP = external_axios_default().create({
    baseURL: '',
    withCredentials: true,
    httpsAgent: new (https_browserify_default()).Agent({
        rejectUnauthorized: false
    }),
    headers: { 'X-Client': 'vue' },
    maxContentLength: 4 * 1024 * 1024 * 1024
});
HTTP.absUrl = function (url) {
    return HTTP.defaults.baseURL + url;
};
HTTP.appendParams = function (url, params) {
    var u = new URL(url);
    for (var key in params) {
        if (params[key] !== undefined) {
            u.searchParams.append(key, params[key]);
        }
    }
    return u.href;
};
external_axios_retry_default()(HTTP, {
    retries: 0,
    retryDelay: function () {
        return 60 * 1000;
    }
});
function initRequestInterceptors(isMaintenance, ignoredUrl) {
    HTTP.interceptors.request.use(function (request) {
        if (isMaintenance() &&
            request.method !== 'get' &&
            !ignoredUrl.some(function (url) { return request.url.includes(url); })) {
            // mimic regular response object, server will not be called
            var custError = new CustomError('reason', {
                data: {
                    detail: 'The service is currently in read-only mode for maintenance. Upload and update functions are not available at this time. Please try again later.'
                },
                status: 503
            });
            return Promise.reject(custError);
        }
        return request;
    }, function (error) {
        return Promise.reject(error);
    });
}
function initResponseInterceptors(authErrorCallback) {
    HTTP.interceptors.response.use(function (response) { return response; }, function (error) {
        var _a;
        if (error.response) {
            // detail is returned from flask_wtf library
            if (error.response.status === 400 &&
                ((_a = error.response.data) === null || _a === void 0 ? void 0 : _a.detail) === 'The CSRF token has expired.') {
                return HTTP.get('/app/auth/refresh/csrf').then(function (resp) {
                    HTTP.defaults.headers.common['X-CSRF-Token'] = resp.data.csrf;
                    var config = error.config;
                    return restartRequest(config)
                        .then(function (resp) {
                        return resp;
                    })
                        .catch(function (err) {
                        return Promise.reject(err);
                    });
                });
            }
            else {
                var status = error.response.status;
                if (status === 401) {
                    authErrorCallback();
                }
                return Promise.reject(error);
            }
        }
        else {
            return Promise.reject(error);
        }
    });
}
function initCsrfToken(response) {
    HTTP.defaults.headers.common['X-CSRF-Token'] =
        response.headers['x-csrf-token'];
}
/* harmony default export */ var http = (HTTP);
function postRetryCond(error) {
    if (!error.config) {
        return false;
    }
    return (0,external_axios_retry_namespaceObject.isNetworkError)(error) || (0,external_axios_retry_namespaceObject.isRetryableError)(error);
}
function getDefaultRetryOptions() {
    return {
        'axios-retry': {
            retries: 5,
            retryCondition: function (error) { return postRetryCond(error); }
        }
    };
}
function restartRequest(request) {
    request.headers = HTTP.defaults.headers.common;
    // create object from origin request body again
    request.data = request.data ? JSON.parse(request.data) : request.data;
    return HTTP.request(request);
}
/**
 * Axios default status codes overwrite for 207
 */
function validateStatus(status) {
    return (status >= 200 && status < 207) || (status > 207 && status < 300);
}

;// CONCATENATED MODULE: external "vue-router"
var external_vue_router_namespaceObject = require("vue-router");
var external_vue_router_default = /*#__PURE__*/__webpack_require__.n(external_vue_router_namespaceObject);
;// CONCATENATED MODULE: ./src/common/router_without_navigation_failure.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial

// fixed problem with vue router - catch Detecting Navigation Failures
var originalPush = (external_vue_router_default()).prototype.push;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
(external_vue_router_default()).prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(function (err) {
        if (external_vue_router_default().isNavigationFailure(err)) {
            // resolve err
            return err;
        }
        // rethrow error
        return Promise.reject(err);
    });
};


;// CONCATENATED MODULE: external "date-fns/differenceInDays"
var differenceInDays_namespaceObject = require("date-fns/differenceInDays");
var differenceInDays_default = /*#__PURE__*/__webpack_require__.n(differenceInDays_namespaceObject);
;// CONCATENATED MODULE: external "date-fns/differenceInHours"
var differenceInHours_namespaceObject = require("date-fns/differenceInHours");
var differenceInHours_default = /*#__PURE__*/__webpack_require__.n(differenceInHours_namespaceObject);
;// CONCATENATED MODULE: external "date-fns/differenceInMinutes"
var differenceInMinutes_namespaceObject = require("date-fns/differenceInMinutes");
var differenceInMinutes_default = /*#__PURE__*/__webpack_require__.n(differenceInMinutes_namespaceObject);
;// CONCATENATED MODULE: external "date-fns/differenceInMonths"
var differenceInMonths_namespaceObject = require("date-fns/differenceInMonths");
var differenceInMonths_default = /*#__PURE__*/__webpack_require__.n(differenceInMonths_namespaceObject);
;// CONCATENATED MODULE: external "date-fns/differenceInWeeks"
var differenceInWeeks_namespaceObject = require("date-fns/differenceInWeeks");
var differenceInWeeks_default = /*#__PURE__*/__webpack_require__.n(differenceInWeeks_namespaceObject);
;// CONCATENATED MODULE: external "date-fns/differenceInYears"
var differenceInYears_namespaceObject = require("date-fns/differenceInYears");
var differenceInYears_default = /*#__PURE__*/__webpack_require__.n(differenceInYears_namespaceObject);
;// CONCATENATED MODULE: external "date-fns/isDate"
var isDate_namespaceObject = require("date-fns/isDate");
var isDate_default = /*#__PURE__*/__webpack_require__.n(isDate_namespaceObject);
;// CONCATENATED MODULE: external "date-fns/isValid"
var isValid_namespaceObject = require("date-fns/isValid");
var isValid_default = /*#__PURE__*/__webpack_require__.n(isValid_namespaceObject);
;// CONCATENATED MODULE: ./src/common/date_utils.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial








var DurationKeys = {
    years: ['year', 'years'],
    months: ['month', 'months'],
    weeks: ['week', 'weeks'],
    days: ['day', 'days'],
    hours: ['hour', 'hours'],
    minutes: ['minute', 'minutes']
};
function formatDateTime(isoString) {
    return isoString ? new Date(isoString).toUTCString() : '';
}
function formatDate(isoString) {
    return isoString ? new Date(isoString).toDateString() : '';
}
function formatDuration(num, unit) {
    return "".concat(num, " ").concat(DurationKeys[unit][num === 1 ? 0 : 1], " ago");
}
function remainingFormatDuration(num, unit) {
    return "".concat(num, " ").concat(DurationKeys[unit][num === 1 ? 0 : 1]);
}
function parseDate(date) {
    return isDate_default()(date) ? date : new Date(date);
}
function formatTimeDiff(t1, t2) {
    if (t2 === void 0) { t2 = new Date(); }
    var t1Parsed = parseDate(t1);
    var t2Parsed = parseDate(t2);
    if (!isValid_default()(t1Parsed) || !t1) {
        return '-';
    }
    var days = differenceInDays_default()(t2Parsed, t1Parsed);
    if (days > 365) {
        return formatDuration(differenceInYears_default()(t2Parsed, t1Parsed), 'years');
    }
    if (days > 31) {
        return formatDuration(differenceInMonths_default()(t2Parsed, t1Parsed), 'months');
    }
    if (days > 6) {
        return formatDuration(differenceInWeeks_default()(t2Parsed, t1Parsed), 'weeks');
    }
    if (days < 1) {
        var hours = differenceInHours_default()(t2Parsed, t1Parsed);
        if (hours < 1) {
            var minutes = differenceInMinutes_default()(t2Parsed, t1Parsed);
            if (minutes < 0) {
                return 'N/A';
            }
            return formatDuration(minutes, 'minutes');
        }
        return formatDuration(hours, 'hours');
    }
    return formatDuration(days, 'days');
}
function formatRemainingTime(t2, t1) {
    if (t1 === void 0) { t1 = new Date(); }
    var t1Parsed = parseDate(t1);
    var t2Parsed = parseDate(t2);
    if (!isValid_default()(t1Parsed)) {
        return '-';
    }
    var days = differenceInDays_default()(t2Parsed, t1Parsed);
    var hours = differenceInHours_default()(t2Parsed, t1Parsed);
    switch (true) {
        case days > 365:
            return remainingFormatDuration(differenceInYears_default()(t2Parsed, t1Parsed), 'years');
        case days > 31:
            return remainingFormatDuration(differenceInMonths_default()(t2Parsed, t1Parsed), 'months');
        case days > 6:
            return remainingFormatDuration(differenceInWeeks_default()(t2Parsed, t1Parsed), 'weeks');
        case days < 1:
            if (days < 0) {
                return 'expired';
            }
            if (hours < 1) {
                var minutes = differenceInMinutes_default()(t2Parsed, t1Parsed);
                if (minutes <= 0) {
                    return 'expired';
                }
                else {
                    return remainingFormatDuration(minutes, 'minutes');
                }
            }
            return remainingFormatDuration(hours, 'hours');
        default:
            return remainingFormatDuration(days, 'days');
    }
}

;// CONCATENATED MODULE: ./src/common/html_utils.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
function waitCursor(on) {
    document.body.style.cursor = on ? 'wait' : 'default';
}
function downloadJsonList(jsonList, headers, filename, output) {
    if (output === void 0) { output = 'csv'; }
    /** download json as csv, but we need to put it in one level
     :param jsonList: dict **/
    if (!jsonList || !headers) {
        return;
    }
    headers = headers.filter(function (h) { return h.value; });
    var headerTexts = Object.keys(headers).map(function (key) {
        return headers[key].text;
    });
    var headerValues = Object.keys(headers).map(function (key) {
        return headers[key].value;
    });
    if (output === 'csv') {
        var content_1 = headerTexts.join(';') + '\n';
        jsonList.forEach(function (row) {
            var currentContent = '';
            headerValues.forEach(function (header) {
                var headerSplit = header.split('.');
                if (headerSplit.length > 1) {
                    currentContent +=
                        (row[headerSplit[0]][headerSplit[1]] !== null
                            ? row[headerSplit[0]][headerSplit[1]]
                            : '') + ';';
                }
                else {
                    currentContent += (row[header] !== null ? row[header] : '') + ';';
                }
            });
            content_1 += currentContent + '\n';
        });
        var hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(content_1);
        hiddenElement.target = '_blank';
        hiddenElement.download = filename + '.csv';
        hiddenElement.click();
        document.removeChild(hiddenElement);
    }
}

;// CONCATENATED MODULE: external "crypto-js/core"
var core_namespaceObject = require("crypto-js/core");
var core_default = /*#__PURE__*/__webpack_require__.n(core_namespaceObject);
;// CONCATENATED MODULE: external "crypto-js/sha1"
var sha1_namespaceObject = require("crypto-js/sha1");
;// CONCATENATED MODULE: external "lodash/difference"
var difference_namespaceObject = require("lodash/difference");
var difference_default = /*#__PURE__*/__webpack_require__.n(difference_namespaceObject);
;// CONCATENATED MODULE: ./src/common/mergin_utils.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
var mergin_utils_assign = (undefined && undefined.__assign) || function () {
    mergin_utils_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return mergin_utils_assign.apply(this, arguments);
};
var mergin_utils_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var mergin_utils_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var CHUNK_SIZE = 10 * 1024 * 1024;
function arrayBufferToWordArray(ab) {
    var i8a = new Uint8Array(ab);
    var a = [];
    for (var i = 0; i < i8a.length; i += 4) {
        a.push((i8a[i] << 24) | (i8a[i + 1] << 16) | (i8a[i + 2] << 8) | i8a[i + 3]);
    }
    return core_default().lib.WordArray.create(a, i8a.length);
}
function getFiles(rootEntry, configData) {
    return mergin_utils_awaiter(this, void 0, void 0, function () {
        function traverseFileTree(item, configData, path) {
            if (path === void 0) { path = null; }
            return mergin_utils_awaiter(this, void 0, void 0, function () {
                var file, fileInfo, dirReader_1, entries, _i, entries_1, entry;
                return mergin_utils_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(item.isFile &&
                                configData &&
                                !configData.blacklist_files.includes(item.name))) return [3 /*break*/, 4];
                            file = void 0;
                            if (!(item.constructor === File)) return [3 /*break*/, 1];
                            file = item;
                            return [3 /*break*/, 3];
                        case 1: return [4 /*yield*/, new Promise(function (resolve) { return item.file(resolve); })];
                        case 2:
                            file = _a.sent();
                            _a.label = 3;
                        case 3:
                            fileInfo = {
                                path: (path || '') + file.name,
                                size: file.size,
                                mtime: new Date(file.lastModified),
                                file: file,
                                chunks: calculateChunks(file.size)
                            };
                            files.push(fileInfo);
                            return [3 /*break*/, 11];
                        case 4:
                            if (!item.isDirectory) return [3 /*break*/, 11];
                            dirReader_1 = item.createReader();
                            entries = void 0;
                            _a.label = 5;
                        case 5: return [4 /*yield*/, new Promise(function (resolve) { return dirReader_1.readEntries(resolve); })];
                        case 6:
                            entries = _a.sent();
                            _i = 0, entries_1 = entries;
                            _a.label = 7;
                        case 7:
                            if (!(_i < entries_1.length)) return [3 /*break*/, 10];
                            entry = entries_1[_i];
                            if (configData && configData.blacklist_dirs.includes(item.name)) {
                                return [3 /*break*/, 9];
                            }
                            return [4 /*yield*/, traverseFileTree(entry, configData, path === null ? '' : path + item.name + '/')];
                        case 8:
                            _a.sent();
                            _a.label = 9;
                        case 9:
                            _i++;
                            return [3 /*break*/, 7];
                        case 10:
                            if (entries.length) return [3 /*break*/, 5];
                            _a.label = 11;
                        case 11: return [2 /*return*/];
                    }
                });
            });
        }
        var files;
        return mergin_utils_generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    files = [];
                    return [4 /*yield*/, traverseFileTree(rootEntry, configData)];
                case 1:
                    _a.sent();
                    return [2 /*return*/, files];
            }
        });
    });
}
function checksum(file) {
    return new Promise(function (resolve) {
        var fileSize = file.size;
        var chunkSize = 256 * 1024;
        var offset = 0;
        var hash = core_default().algo.SHA1.create();
        var readEventHandler = function (e) {
            // offset += e.target.result.length
            offset += e.target.result.byteLength;
            // hash.update(e.target.result)
            hash.update(arrayBufferToWordArray(e.target.result));
            if (offset >= fileSize) {
                var h = hash.finalize();
                resolve(core_default().enc.Hex.stringify(h));
            }
            else {
                chunkReaderBlock(offset, chunkSize, file);
            }
        };
        var chunkReaderBlock = function (_offset, length, _file) {
            var r = new FileReader();
            var blob = _file.slice(_offset, length + _offset);
            r.onload = readEventHandler;
            r.readAsArrayBuffer(blob);
            // r.readAsText(blob)
        };
        chunkReaderBlock(offset, chunkSize, file);
    });
}
function filesDiff(oldFiles, newFiles) {
    var oFilesPaths = Object.keys(oldFiles).filter(function (path) { return !ignoreFile(path); });
    var nFilesPaths = Object.keys(newFiles).filter(function (path) { return !ignoreFile(path); });
    var updated = Object.keys(oldFiles).filter(function (path) {
        var f2 = newFiles[path];
        return f2 && f2.checksum !== oldFiles[path].checksum;
    });
    var added = difference_default()(nFilesPaths, oFilesPaths);
    var removed = difference_default()(oFilesPaths, nFilesPaths);
    var diff = {
        added: added,
        removed: removed,
        updated: updated
    };
    var changes = Object.values(diff).reduce(function (sum, list) { return sum + list.length; }, 0);
    // return Object.values(diff).reduce((sum, list) => sum + list.length, 0) ? diff : null
    return mergin_utils_assign(mergin_utils_assign({}, diff), { changes: changes });
}
function splitFilePath(filePath) {
    var filename = filePath.replace(/^.*\//, '');
    var extension = filename.lastIndexOf('.') > 0 ? filename.split('.').pop() : '';
    return { filename: filename, extension: extension };
}
function ignoreFile(filePath) {
    var ignoreExt = ['-shm', '-wal', '~', 'pyc', 'swap'];
    var extension = splitFilePath(filePath).extension;
    return new RegExp("(".concat(ignoreExt.join('|'), ")$"), 'g').test(extension);
}
function isVersionedFile(filePath) {
    var extension = splitFilePath(filePath).extension;
    return ['gpkg', 'sqlite'].includes(extension);
}
function calculateChunks(fileSize) {
    var chunks = [];
    for (var i = 0; i < Math.ceil(fileSize / CHUNK_SIZE); i++) {
        chunks.push(Math.random().toString(36).substring(2));
    }
    return chunks;
}
function parseError(error, msg) {
    if (msg === void 0) { msg = ''; }
    return error.response && error.response.data && error.response.data.detail
        ? error.response.data.detail
        : msg;
}

;// CONCATENATED MODULE: ./src/common/module_utils.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
var module_utils_assign = (undefined && undefined.__assign) || function () {
    module_utils_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return module_utils_assign.apply(this, arguments);
};
var initializeAppModule = function (module, services, routeOverrides) {
    if (services.store) {
        services.store.registerModule(module.name, module.moduleStore);
        module.init(services, routeOverrides);
    }
};
function elevateToRouteConfig(route) {
    return true;
}
function applyRouteOverride(route, routeOverrides) {
    var overridenRoute = route;
    if (overridenRoute.children) {
        overridenRoute.children = route.children.map(function (child) {
            var overridenChild = applyRouteOverride(child, routeOverrides);
            var result = child;
            // ALWAYS true - this is just hack to cast Partial<RouteConfig> to RouteConfig to get rid of TS error
            if (elevateToRouteConfig(overridenChild)) {
                result = overridenChild;
            }
            return result;
        });
    }
    else if (routeOverrides && routeOverrides[route.name]) {
        overridenRoute = module_utils_assign(module_utils_assign({}, overridenRoute), routeOverrides[route.name]);
    }
    if (routeOverrides && routeOverrides[route.name]) {
        overridenRoute = module_utils_assign(module_utils_assign({}, overridenRoute), routeOverrides[route.name]);
    }
    return overridenRoute;
}

;// CONCATENATED MODULE: ./src/common/number_utils.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
var SizeUnits = {
    GB: function (value) { return (value / 1073741824).toFixed(2); },
    MB: function (value) { return (value / 1048576).toFixed(2); },
    kB: function (value) { return (value / 1024).toFixed(0); },
    B: function (value) { return "".concat(Math.round(value)); }
};
function formatFileSize(value, unit, digits, minUnit) {
    if (digits === void 0) { digits = 2; }
    if (minUnit === void 0) { minUnit = 'B'; }
    if (!value) {
        return "".concat(value, " MB");
    }
    if (!unit) {
        if (value >= 1073741824 || minUnit === 'GB') {
            unit = 'GB';
        }
        else if (value >= 1048576 || minUnit === 'MB') {
            unit = 'MB';
        }
        else if (value >= 1024 || minUnit === 'kB') {
            unit = 'kB';
        }
        else {
            unit = 'B';
        }
    }
    var unitsValue = parseFloat(SizeUnits[unit](value));
    unitsValue = unitsValue === 0 ? Math.pow(10, -digits) : unitsValue;
    return "".concat(unitsValue.toFixed(digits), " ").concat(unit);
}
function formatToCurrency(value, currency) {
    return value.toLocaleString('en-UK', {
        style: 'currency',
        currency: currency,
        currencySign: 'accounting'
    });
}

// EXTERNAL MODULE: ../../node_modules/path-browserify/index.js
var path_browserify = __webpack_require__(23);
var path_browserify_default = /*#__PURE__*/__webpack_require__.n(path_browserify);
;// CONCATENATED MODULE: ./src/common/path_utils.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial

function dirname(path) {
    var dir = path_browserify_default().dirname(path).replace(/\/$/, '');
    return dir === '.' ? '' : dir;
}

;// CONCATENATED MODULE: ./src/common/permission_utils.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
var _a, _b, _c;
var UserRole;
(function (UserRole) {
    UserRole[UserRole["guest"] = 0] = "guest";
    UserRole[UserRole["reader"] = 1] = "reader";
    UserRole[UserRole["writer"] = 2] = "writer";
    UserRole[UserRole["admin"] = 3] = "admin";
    UserRole[UserRole["owner"] = 4] = "owner";
})(UserRole || (UserRole = {}));
var ProjectRole;
(function (ProjectRole) {
    ProjectRole[ProjectRole["none"] = 0] = "none";
    ProjectRole[ProjectRole["reader"] = 1] = "reader";
    ProjectRole[ProjectRole["writer"] = 2] = "writer";
    ProjectRole[ProjectRole["owner"] = 3] = "owner";
})(ProjectRole || (ProjectRole = {}));
var USER_ROLE_NAME_BY_ROLE = (_a = {},
    _a[UserRole.guest] = 'guest',
    _a[UserRole.reader] = 'reader',
    _a[UserRole.writer] = 'writer',
    _a[UserRole.admin] = 'admin',
    _a[UserRole.owner] = 'owner',
    _a);
var USER_ROLE_LABEL_BY_NAME = {
    guest: 'Guest',
    reader: 'Reader',
    writer: 'Writer',
    admin: 'Admin',
    owner: 'Owner'
};
var USER_ROLE_BY_NAME = {
    guest: UserRole.guest,
    reader: UserRole.reader,
    writer: UserRole.writer,
    admin: UserRole.admin,
    owner: UserRole.owner
};
var PROJECT_ROLE_NAME_BY_ROLE = (_b = {},
    _b[ProjectRole.none] = 'none',
    _b[ProjectRole.reader] = 'reader',
    _b[ProjectRole.writer] = 'writer',
    _b[ProjectRole.owner] = 'owner',
    _b);
var PROJECT_ROLE_LABEL_BY_NAME = {
    none: 'None',
    reader: 'Reader',
    writer: 'Writer',
    owner: 'Owner'
};
var PROJECT_ROLE_BY_NAME = {
    none: ProjectRole.none,
    reader: ProjectRole.reader,
    writer: ProjectRole.writer,
    owner: ProjectRole.owner
};
var ProjectPermission;
(function (ProjectPermission) {
    ProjectPermission[ProjectPermission["read"] = 0] = "read";
    ProjectPermission[ProjectPermission["write"] = 1] = "write";
    ProjectPermission[ProjectPermission["owner"] = 2] = "owner";
})(ProjectPermission || (ProjectPermission = {}));
var PROJECT_PERMISSION_NAME_BY_PERMISSION = (_c = {},
    _c[ProjectPermission.read] = 'read',
    _c[ProjectPermission.write] = 'write',
    _c[ProjectPermission.owner] = 'owner',
    _c);
var PROJECT_PERMISSION_LABEL_BY_NAME = {
    read: 'Read',
    write: 'Write',
    owner: 'Owner'
};
var PROJECT_PERMISSION_BY_NAME = {
    read: ProjectPermission.read,
    write: ProjectPermission.write,
    owner: ProjectPermission.owner
};
function isAtLeastRole(roleName, role) {
    return USER_ROLE_BY_NAME[roleName] >= role;
}
function isAtLeastProjectRole(roleName, role) {
    return PROJECT_ROLE_BY_NAME[roleName] >= role;
}
function isAtLeastProjectPermission(permissionName, permission) {
    return PROJECT_PERMISSION_BY_NAME[permissionName] >= permission;
}
function getUserRoleValuesForSelect(roles) {
    return roles.map(function (role) { return ({
        value: role,
        label: USER_ROLE_LABEL_BY_NAME[role]
    }); });
}
function getProjectPermissionValuesForSelect(permissions) {
    return permissions.map(function (permission) { return ({
        value: permission,
        label: PROJECT_PERMISSION_LABEL_BY_NAME[permission]
    }); });
}

;// CONCATENATED MODULE: ./src/common/text_utils.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
function formatToTitle(string) {
    string = string.replace(/_/g, ' ');
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function removeAccents(text) {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function isValidEmail(email) {
    var emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailPattern.test(email);
}
var EMAIL_LIST_SEPARATORS = /[;, ]/;
var EMAIL_LIST_DEFAULT_SEPARATOR = ';';

;// CONCATENATED MODULE: external "lodash/isEqual"
var isEqual_namespaceObject = require("lodash/isEqual");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual_namespaceObject);
;// CONCATENATED MODULE: external "lodash/pick"
var pick_namespaceObject = require("lodash/pick");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick_namespaceObject);
;// CONCATENATED MODULE: ./src/common/route_utils.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial


function isTheSameRoute(from, to) {
    var properties = ['name', 'path', 'hash', 'params', 'query'];
    return isEqual_default()(pick_default()(from, properties), pick_default()(to, properties));
}
function getTagsFromQuery(route) {
    var tags = route.query.tags;
    return tags ? (typeof tags === 'string' ? tags.split(',') : tags) : [];
}
/** Handles redirect to /login when user is not authenticated. */
function isAuthenticatedGuard(to, from, next, store, options) {
    var _a;
    if (to.meta.public || store.getters['userModule/isLoggedIn']) {
        if (isTheSameRoute(from, to)) {
            return false;
        }
        else {
            next();
        }
    }
    else {
        next({
            path: (_a = options === null || options === void 0 ? void 0 : options.notAuthenticatedRedirectPath) !== null && _a !== void 0 ? _a : 'login',
            query: { redirect: to.fullPath }
        });
    }
}
/** Handles redirect to /login when user is not superUser. */
function isSuperUser(to, from, next, store) {
    if (store.getters['userModule/isSuperUser']) {
        next();
    }
    else {
        next('/login');
    }
}

;// CONCATENATED MODULE: ./src/common/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial

















;// CONCATENATED MODULE: ./src/modules/form/store.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
var store_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var store_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var FormStore = {
    namespaced: true,
    state: {
        errors: {}
    },
    getters: {
        getErrorByComponentId: function (state) { return function (payload) {
            return state.errors[payload];
        }; }
    },
    mutations: {
        setFormErrors: function (state, payload) {
            external_vue_default().set(state.errors, payload.componentId, payload.errors);
        },
        resetFormErrors: function (state, payload) {
            external_vue_default()["delete"](state.errors, payload.componentId);
        }
    },
    actions: {
        clearErrors: function (_a, payload) {
            var commit = _a.commit;
            commit('resetFormErrors', payload);
            if (!payload.keepNotification) {
                // reset error message in notification component
                commit('notificationModule/closeNotification', null, { root: true });
            }
        },
        handleError: function (_a, payload) {
            var _b, _c, _d, _e, _f, _g, _h;
            var commit = _a.commit, dispatch = _a.dispatch;
            return store_awaiter(this, void 0, void 0, function () {
                var errorMessage;
                return store_generator(this, function (_j) {
                    switch (_j.label) {
                        case 0:
                            if (typeof ((_c = (_b = payload.error) === null || _b === void 0 ? void 0 : _b.response) === null || _c === void 0 ? void 0 : _c.data) === 'object') {
                                // two types of error responses
                                // TODO: Get data from HTTP status code, handle formError not standard error with detail
                                if (typeof payload.error.response.data.status === 'number' ||
                                    payload.error.response.data.detail) {
                                    errorMessage = payload.error.response.data.detail;
                                }
                                else {
                                    commit('setFormErrors', {
                                        componentId: payload.componentId,
                                        errors: payload.error.response.data
                                    });
                                }
                            }
                            else {
                                errorMessage =
                                    (_h = (_g = (_f = (_e = (_d = payload === null || payload === void 0 ? void 0 : payload.error) === null || _d === void 0 ? void 0 : _d.response) === null || _e === void 0 ? void 0 : _e.data) !== null && _f !== void 0 ? _f : payload.generalMessage) !== null && _g !== void 0 ? _g : payload === null || payload === void 0 ? void 0 : payload.error) !== null && _h !== void 0 ? _h : 'Error';
                            }
                            if (!errorMessage) return [3 /*break*/, 2];
                            // show error message in notification component
                            return [4 /*yield*/, dispatch('notificationModule/error', { text: errorMessage }, { root: true })];
                        case 1:
                            // show error message in notification component
                            _j.sent();
                            _j.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
    }
};
/* harmony default export */ var store = (FormStore);

;// CONCATENATED MODULE: ./src/modules/form/module.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial

var FormModule = {
    name: 'formModule',
    moduleStore: store,
    init: function (_services) {
        // none initialization required
    }
};

;// CONCATENATED MODULE: external "lodash/uniqueId"
var uniqueId_namespaceObject = require("lodash/uniqueId");
var uniqueId_default = /*#__PURE__*/__webpack_require__.n(uniqueId_namespaceObject);
;// CONCATENATED MODULE: ./src/modules/form/MerginComponentUuidMixin.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial

/**
 * Adds globally unique id to each instance of project component.
 */
/* harmony default export */ var MerginComponentUuidMixin = ({
    data: function () {
        return {
            merginComponentUuid: uniqueId_default()()
        };
    }
});

;// CONCATENATED MODULE: ./src/modules/form/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial




;// CONCATENATED MODULE: external "vuetify/lib/components/VAutocomplete"
var VAutocomplete_namespaceObject = require("vuetify/lib/components/VAutocomplete");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/AccountAutocomplete.vue?vue&type=template&id=220f578a&scoped=true&






var AccountAutocompletevue_type_template_id_220f578a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VAutocomplete_namespaceObject.VAutocomplete,{ref:"autocomplete",attrs:{"placeholder":"Find user","loading":_vm.isLoading,"items":_vm.items,"search-input":_vm.query,"cache-items":"","multiple":"","clearable":"","hide-selected":"","filter":_vm.filterSelected,"item-text":"email","item-value":"email","no-data-text":!_vm.query || _vm.query.length <= 2
      ? 'Type more letters'
      : _vm.allowInvite
      ? 'No matches found - Try using their emails instead'
      : 'No matches found',"hide-no-data":!_vm.query,"hide-details":"","return-object":"","data-cy":"account-autocomplete-input"},on:{"update:searchInput":function($event){_vm.query=$event},"update:search-input":function($event){_vm.query=$event},"input":function($event){return _vm.$emit('update', _vm.users)}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('user-search-chip',_vm._b({attrs:{"item":data.item,"input-value":data.selected,"close":""},on:{"click":data.select,"click:close":function($event){return _vm.removeItem(data.item)}}},'user-search-chip',data.attrs,false))]}},{key:"item",fn:function({ item }){return [_c(VList_namespaceObject.VListItemAvatar,{attrs:{"size":"18","left":""}},[(_vm.allowInvite && item.isInvite)?_c('send-icon',{staticClass:"primary--text",attrs:{"size":"18"}}):_c('user-icon',{staticClass:"primary--text",attrs:{"size":"18"}})],1),_c(VList_namespaceObject.VListItemContent,{staticStyle:{"padding-bottom":"6px","padding-top":"6px"},attrs:{"data-cy":"account-autocomplete-list"}},[(_vm.allowInvite && item.isInvite)?_c(VList_namespaceObject.VListItemTitle,{domProps:{"innerHTML":_vm._s(`Invite \"${item.email}\" to your workspace`)}}):(!_vm.allowInvite || !item.isInvite)?_c(VList_namespaceObject.VListItemTitle,{domProps:{"innerHTML":_vm._s(
          `${_vm.emphasizeMatch(item.username, _vm.query)}${
            _vm.getUserProfileName(item)
              ? ` &bull; ${_vm.getUserProfileName(item)}`
              : ''
          }`
        )}}):_vm._e(),(!_vm.allowInvite || !item.isInvite)?_c(VList_namespaceObject.VListItemSubtitle,{domProps:{"innerHTML":_vm._s(_vm.emphasizeMatch(item.email, _vm.query))}}):_vm._e()],1)]}},{key:"append-item",fn:function(){return [_c('div',{staticClass:"text-right text-caption grey--text text--darken-1"},[(_vm.items && _vm.items.some((item) => !item.isInvite))?_c('span',{staticClass:"pr-1"},[_vm._v("Not the right person? Try typing their email address instead!")]):_vm._e()])]},proxy:true}]),model:{value:(_vm.users),callback:function ($$v) {_vm.users=$$v},expression:"users"}})
}
var AccountAutocompletevue_type_template_id_220f578a_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/components/AccountAutocomplete.vue?vue&type=template&id=220f578a&scoped=true&

;// CONCATENATED MODULE: external "lodash/isEmpty"
var isEmpty_namespaceObject = require("lodash/isEmpty");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty_namespaceObject);
;// CONCATENATED MODULE: external "vue-tabler-icons"
var external_vue_tabler_icons_namespaceObject = require("vue-tabler-icons");
;// CONCATENATED MODULE: external "vuetify/lib/components/VAvatar"
var VAvatar_namespaceObject = require("vuetify/lib/components/VAvatar");
;// CONCATENATED MODULE: external "vuetify/lib/components/VChip"
var VChip_namespaceObject = require("vuetify/lib/components/VChip");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/components/UserSearchChip.vue?vue&type=template&id=378c8376&scoped=true&



var UserSearchChipvue_type_template_id_378c8376_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VChip_namespaceObject.VChip,_vm._g(_vm._b({attrs:{"label":"","ripple":false}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_c(VAvatar_namespaceObject.VAvatar,{attrs:{"size":"18","left":""}},[(_vm.item.isInvite)?_c('send-icon',{staticClass:"primary--text",attrs:{"size":"18"}}):_c('user-icon',{staticClass:"primary--text",attrs:{"size":"18"}})],1),_vm._v(" "+_vm._s(_vm.item.isInvite ? _vm.item.email : _vm.item.username)+" ")],1)
}
var UserSearchChipvue_type_template_id_378c8376_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/user/components/UserSearchChip.vue?vue&type=template&id=378c8376&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/components/UserSearchChip.vue?vue&type=script&lang=ts&


/* harmony default export */ var UserSearchChipvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'UserSearchChip',
    components: { SendIcon: external_vue_tabler_icons_namespaceObject.SendIcon, UserIcon: external_vue_tabler_icons_namespaceObject.UserIcon },
    props: {
        item: Object
    }
}));

;// CONCATENATED MODULE: ./src/modules/user/components/UserSearchChip.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_UserSearchChipvue_type_script_lang_ts_ = (UserSearchChipvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/user/components/UserSearchChip.vue





/* normalize component */
;
var UserSearchChip_component = normalizeComponent(
  components_UserSearchChipvue_type_script_lang_ts_,
  UserSearchChipvue_type_template_id_378c8376_scoped_true_render,
  UserSearchChipvue_type_template_id_378c8376_scoped_true_staticRenderFns,
  false,
  null,
  "378c8376",
  null
  
)

/* harmony default export */ var UserSearchChip = (UserSearchChip_component.exports);
;// CONCATENATED MODULE: ./src/modules/user/constants.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
var EMPTY_INVITE_ITEM = {
    email: null,
    username: null,
    id: null,
    profile: null,
    isInvite: true
};

;// CONCATENATED MODULE: ./src/modules/user/routes.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
/* harmony default export */ var routes = (function (_rootStore) { return []; });

;// CONCATENATED MODULE: external "lodash/isObject"
var isObject_namespaceObject = require("lodash/isObject");
var isObject_default = /*#__PURE__*/__webpack_require__.n(isObject_namespaceObject);
;// CONCATENATED MODULE: external "universal-cookie"
var external_universal_cookie_namespaceObject = require("universal-cookie");
var external_universal_cookie_default = /*#__PURE__*/__webpack_require__.n(external_universal_cookie_namespaceObject);
;// CONCATENATED MODULE: ./src/modules/user/store.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
var store_assign = (undefined && undefined.__assign) || function () {
    store_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return store_assign.apply(this, arguments);
};
var user_store_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var user_store_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};








var isNavigationFailure = (external_vue_router_default()).isNavigationFailure, NavigationFailureType = (external_vue_router_default()).NavigationFailureType;
var cookies = new (external_universal_cookie_default())();
var COOKIES_CURRENT_WORKSPACE = 'currentWorkspace';
var UserStore = {
    namespaced: true,
    state: {
        loggedUser: null,
        workspaces: [],
        workspaceId: undefined
    },
    getters: {
        isLoggedIn: function (state, getters, rootState) {
            var _a, _b;
            return ((_a = rootState.instanceModule.initData) === null || _a === void 0 ? void 0 : _a.authenticated) ||
                ((_b = state.loggedUser) === null || _b === void 0 ? void 0 : _b.username) != null;
        },
        isSuperUser: function (state, getters, rootState) {
            var _a;
            return getters.isLoggedIn && ((_a = rootState.instanceModule.initData) === null || _a === void 0 ? void 0 : _a.superuser);
        },
        isGlobalWorkspaceAdmin: function (state, getters) {
            var _a;
            return isAtLeastRole((_a = getters.getPreferredWorkspace) === null || _a === void 0 ? void 0 : _a.role, UserRole.admin);
        },
        getPreferredWorkspace: function (state) {
            var _a, _b;
            return (((_a = state.loggedUser) === null || _a === void 0 ? void 0 : _a.workspaces) &&
                ((_b = state.loggedUser) === null || _b === void 0 ? void 0 : _b.workspaces.find(function (workspace) { return workspace.id === state.loggedUser.preferred_workspace; })));
        },
        getUserFullName: function (state) {
            var _a, _b, _c;
            return ((_a = state.loggedUser) === null || _a === void 0 ? void 0 : _a.name) && ((_b = state.loggedUser) === null || _b === void 0 ? void 0 : _b.name) !== ''
                ? state.loggedUser.name
                : ((_c = state.loggedUser) === null || _c === void 0 ? void 0 : _c.username)
                    ? state.loggedUser.username
                    : '';
        },
        isWorkspaceAdmin: function (state, getters) {
            return function (payload) {
                var workspace = (payload === null || payload === void 0 ? void 0 : payload.id)
                    ? getters.getWorkspaceById({ id: payload.id })
                    : getters.currentWorkspace;
                return isAtLeastRole(workspace === null || workspace === void 0 ? void 0 : workspace.role, UserRole.admin);
            };
        },
        isWorkspaceOwner: function (state, getters) {
            return function (payload) {
                var workspace = (payload === null || payload === void 0 ? void 0 : payload.id)
                    ? getters.getWorkspaceById({ id: payload.id })
                    : getters.currentWorkspace;
                return isAtLeastRole(workspace === null || workspace === void 0 ? void 0 : workspace.role, UserRole.owner);
            };
        },
        currentWorkspace: function (state) {
            return state.workspaces.find(function (workspace) { return workspace.id === state.workspaceId; });
        },
        getWorkspaceById: function (state) { return function (payload) {
            return state.workspaces.find(function (workspace) { return workspace.id === payload.id; });
        }; },
        getWorkspaceByName: function (state) { return function (payload) {
            return state.workspaces.find(function (workspace) { return workspace.name === payload.name; });
        }; },
        isWorkspaceUser: function (state) { return function (payload) {
            return state.workspaces.some(function (workspace) { return workspace.id === payload.id; });
        }; }
    },
    mutations: {
        updateLoggedUser: function (state, payload) {
            state.loggedUser = payload.loggedUser;
        },
        updateVerifiedEmail: function (state, payload) {
            external_vue_default().set(state.loggedUser, 'verified_email', payload.verifiedEmail);
        },
        setWorkspaces: function (state, payload) {
            state.workspaces = payload.workspaces;
        },
        setWorkspaceId: function (state, payload) {
            state.workspaceId = payload.id;
        }
    },
    actions: {
        editUserProfile: function (_a, payload) {
            var commit = _a.commit, dispatch = _a.dispatch;
            return user_store_awaiter(this, void 0, void 0, function () {
                var error_1;
                return user_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            waitCursor(true);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 5, 7, 8]);
                            return [4 /*yield*/, UserApi.editUserProfile(payload.editedUser, true)];
                        case 2:
                            _b.sent();
                            dispatch('dialogModule/close', undefined, { root: true });
                            commit('updateLoggedUser', {
                                loggedUser: payload.editedUser
                            });
                            return [4 /*yield*/, dispatch('fetchUserProfile')];
                        case 3:
                            _b.sent();
                            return [4 /*yield*/, dispatch('notificationModule/show', { text: 'Profile has been changed' }, { root: true })];
                        case 4:
                            _b.sent();
                            return [3 /*break*/, 8];
                        case 5:
                            error_1 = _b.sent();
                            return [4 /*yield*/, dispatch('formModule/handleError', {
                                    componentId: payload.componentId,
                                    error: error_1,
                                    generalMessage: 'Failed to change profile'
                                }, { root: true })];
                        case 6:
                            _b.sent();
                            return [3 /*break*/, 8];
                        case 7:
                            waitCursor(false);
                            return [7 /*endfinally*/];
                        case 8: return [2 /*return*/];
                    }
                });
            });
        },
        fetchUserProfile: function (_a) {
            var commit = _a.commit, dispatch = _a.dispatch, getters = _a.getters, rootState = _a.rootState;
            return user_store_awaiter(this, void 0, void 0, function () {
                var resp, preferredWorkspace, _b;
                return user_store_generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 2, , 4]);
                            return [4 /*yield*/, UserApi.fetchUserProfile()];
                        case 1:
                            resp = _c.sent();
                            commit('updateLoggedUser', { loggedUser: resp.data });
                            commit('updateVerifiedEmail', {
                                verifiedEmail: resp.data.verified_email
                            });
                            if (!rootState.projectModule.currentNamespace) {
                                preferredWorkspace = getters.getPreferredWorkspace;
                                if (preferredWorkspace === null || preferredWorkspace === void 0 ? void 0 : preferredWorkspace.name) {
                                    commit('projectModule/setCurrentNamespace', {
                                        currentNamespace: preferredWorkspace.name
                                    }, {
                                        root: true
                                    });
                                }
                            }
                            return [3 /*break*/, 4];
                        case 2:
                            _b = _c.sent();
                            return [4 /*yield*/, dispatch('notificationModule/error', { text: "Failed to fetch user's profile" }, {
                                    root: true
                                })];
                        case 3:
                            _c.sent();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/, resp === null || resp === void 0 ? void 0 : resp.data];
                    }
                });
            });
        },
        closeUserProfile: function (_a) {
            var commit = _a.commit, dispatch = _a.dispatch;
            return user_store_awaiter(this, void 0, void 0, function () {
                var err_1, msg;
                return user_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            waitCursor(true);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, 5, 6]);
                            return [4 /*yield*/, UserApi.closeUserProfile(true)];
                        case 2:
                            _b.sent();
                            commit('updateLoggedUser', {
                                loggedUser: null
                            });
                            // taken from logout action, router would return error because user is considered as logged in
                            location.href = '/';
                            return [3 /*break*/, 6];
                        case 3:
                            err_1 = _b.sent();
                            msg = err_1.response && err_1.response.data.detail
                                ? err_1.response.data.detail
                                : 'Unable to close account';
                            return [4 /*yield*/, dispatch('notificationModule/error', {
                                    text: msg
                                }, {
                                    root: true
                                })];
                        case 4:
                            _b.sent();
                            return [3 /*break*/, 6];
                        case 5:
                            waitCursor(false);
                            return [7 /*endfinally*/];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        },
        redirectAfterLogin: function (_a, payload) {
            var dispatch = _a.dispatch;
            return user_store_awaiter(this, void 0, void 0, function () {
                var e_1;
                return user_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 1, , 5]);
                            UserModule.routerService.push(payload.currentRoute.query.redirect)
                                .catch(function (e) {
                                if (!isNavigationFailure(e, NavigationFailureType.redirected)) {
                                    Promise.reject(e);
                                }
                            });
                            return [3 /*break*/, 5];
                        case 1:
                            e_1 = _b.sent();
                            if (!isNavigationFailure(e_1, NavigationFailureType.redirected)) return [3 /*break*/, 2];
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, dispatch('notificationModule/error', {
                                text: e_1
                            }, {
                                root: true
                            })];
                        case 3:
                            _b.sent();
                            _b.label = 4;
                        case 4: return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        redirectFromLoginAfterLogin: function (_, payload) {
            return user_store_awaiter(this, void 0, void 0, function () {
                return user_store_generator(this, function (_a) {
                    if (payload.currentRoute.path === '/login') {
                        UserModule.routerService.push({ path: '/' }).catch(function (e) {
                            if (!isNavigationFailure(e, NavigationFailureType.redirected)) {
                                Promise.reject(e);
                            }
                        });
                    }
                    return [2 /*return*/];
                });
            });
        },
        userLogin: function (_a, payload) {
            var dispatch = _a.dispatch;
            return user_store_awaiter(this, void 0, void 0, function () {
                var error_2;
                return user_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 3, , 5]);
                            return [4 /*yield*/, UserApi.login(payload.data)];
                        case 1:
                            _b.sent();
                            return [4 /*yield*/, dispatch('instanceModule/initApp', undefined, { root: true })];
                        case 2:
                            _b.sent();
                            return [3 /*break*/, 5];
                        case 3:
                            error_2 = _b.sent();
                            return [4 /*yield*/, dispatch('formModule/handleError', {
                                    componentId: payload.componentId,
                                    error: error_2,
                                    generalMessage: 'Failed to login'
                                }, { root: true })];
                        case 4:
                            _b.sent();
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        resetPassword: function (_a, payload) {
            var dispatch = _a.dispatch;
            return user_store_awaiter(this, void 0, void 0, function () {
                var error_3;
                return user_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 4, , 6]);
                            return [4 /*yield*/, UserApi.resetPassword({ email: payload.email })];
                        case 1:
                            _b.sent();
                            return [4 /*yield*/, UserModule.routerService.push({ path: '/login' })];
                        case 2:
                            _b.sent();
                            return [4 /*yield*/, dispatch('notificationModule/show', {
                                    text: 'Email with password reset link was sent to your email address',
                                    timeout: 3000
                                }, {
                                    root: true
                                })];
                        case 3:
                            _b.sent();
                            return [3 /*break*/, 6];
                        case 4:
                            error_3 = _b.sent();
                            return [4 /*yield*/, dispatch('formModule/handleError', {
                                    componentId: payload.componentId,
                                    error: error_3,
                                    generalMessage: 'Failed to send confirmation email'
                                }, { root: true })];
                        case 5:
                            _b.sent();
                            return [3 /*break*/, 6];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        },
        changePasswordWithToken: function (_a, payload) {
            var dispatch = _a.dispatch;
            return user_store_awaiter(this, void 0, void 0, function () {
                var e_2;
                return user_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            waitCursor(true);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 5]);
                            return [4 /*yield*/, UserApi.changePasswordWithToken(payload.token, payload.data, true)
                                // callback - set => this.success = true
                            ];
                        case 2:
                            _b.sent();
                            // callback - set => this.success = true
                            payload.callback(true);
                            waitCursor(false);
                            return [3 /*break*/, 5];
                        case 3:
                            e_2 = _b.sent();
                            waitCursor(false);
                            // callback - set => this.success = false
                            payload.callback(false);
                            return [4 /*yield*/, dispatch('formModule/handleError', {
                                    componentId: payload.componentId,
                                    error: e_2,
                                    generalMessage: 'Failed to change password'
                                }, { root: true })];
                        case 4:
                            _b.sent();
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        resendConfirmationEmail: function (_a, payload) {
            var dispatch = _a.dispatch;
            return user_store_awaiter(this, void 0, void 0, function () {
                var err_2;
                return user_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 3, , 5]);
                            return [4 /*yield*/, UserApi.resendEmail()];
                        case 1:
                            _b.sent();
                            return [4 /*yield*/, dispatch('notificationModule/show', {
                                    text: "Email was sent to address: ".concat(payload.email)
                                }, {
                                    root: true
                                })];
                        case 2:
                            _b.sent();
                            return [3 /*break*/, 5];
                        case 3:
                            err_2 = _b.sent();
                            return [4 /*yield*/, dispatch('notificationModule/error', {
                                    text: 'Failed to send confirmation email, please check your address in user profile settings'
                                }, {
                                    root: true
                                })];
                        case 4:
                            _b.sent();
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        changePassword: function (_a, payload) {
            var dispatch = _a.dispatch;
            return user_store_awaiter(this, void 0, void 0, function () {
                var error_4;
                return user_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            waitCursor(true);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 4, 6, 7]);
                            return [4 /*yield*/, UserApi.changePassword(payload.data, true)];
                        case 2:
                            _b.sent();
                            dispatch('dialogModule/close', undefined, { root: true });
                            return [4 /*yield*/, dispatch('notificationModule/show', { text: 'Password has been changed' }, { root: true })];
                        case 3:
                            _b.sent();
                            return [3 /*break*/, 7];
                        case 4:
                            error_4 = _b.sent();
                            return [4 /*yield*/, dispatch('formModule/handleError', {
                                    componentId: payload.componentId,
                                    error: error_4,
                                    generalMessage: 'Failed to change password'
                                }, { root: true })];
                        case 5:
                            _b.sent();
                            return [3 /*break*/, 7];
                        case 6:
                            waitCursor(false);
                            return [7 /*endfinally*/];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        },
        clearUserData: function (_a) {
            var commit = _a.commit, dispatch = _a.dispatch;
            dispatch('projectModule/clearProjects', undefined, { root: true });
            commit('updateLoggedUser', { loggedUser: null });
        },
        getWorkspace: function (_a, payload) {
            var commit = _a.commit, dispatch = _a.dispatch;
            return user_store_awaiter(this, void 0, void 0, function () {
                var newWorkspace, workspaceResponse, _err_1;
                return user_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 3, , 5]);
                            return [4 /*yield*/, UserApi.getWorkspaceById(payload.id)];
                        case 1:
                            workspaceResponse = _b.sent();
                            newWorkspace = workspaceResponse.data;
                            commit('setWorkspaceId', { id: payload.id });
                            return [4 /*yield*/, dispatch('updateWorkspacesWithWorkspaceChange', {
                                    workspace: newWorkspace
                                })];
                        case 2:
                            _b.sent();
                            return [3 /*break*/, 5];
                        case 3:
                            _err_1 = _b.sent();
                            return [4 /*yield*/, dispatch('notificationModule/error', {
                                    text: 'Failed to load workspace'
                                }, { root: true })];
                        case 4:
                            _b.sent();
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/, newWorkspace];
                    }
                });
            });
        },
        getWorkspaces: function (_a) {
            var commit = _a.commit, dispatch = _a.dispatch;
            return user_store_awaiter(this, void 0, void 0, function () {
                var workspacesResponse, _err_2;
                return user_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 4]);
                            return [4 /*yield*/, UserApi.getWorkspaces()];
                        case 1:
                            workspacesResponse = _b.sent();
                            commit('setWorkspaces', { workspaces: workspacesResponse.data });
                            return [3 /*break*/, 4];
                        case 2:
                            _err_2 = _b.sent();
                            return [4 /*yield*/, dispatch('notificationModule/error', {
                                    text: 'Failed to load workspaces'
                                }, { root: true })];
                        case 3:
                            _b.sent();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/, workspacesResponse];
                    }
                });
            });
        },
        updateWorkspacesWithWorkspaceChange: function (_a, payload) {
            var commit = _a.commit, state = _a.state;
            return user_store_awaiter(this, void 0, void 0, function () {
                var idx;
                return user_store_generator(this, function (_b) {
                    // update state.workspaces
                    if (state.workspaces) {
                        idx = state.workspaces.findIndex(function (workspace) { return workspace.id === payload.workspace.id; });
                        if (idx !== -1) {
                            commit('setWorkspaces', {
                                workspaces: __spreadArray(__spreadArray(__spreadArray([], state.workspaces.slice(0, idx), true), [
                                    payload.workspace
                                ], false), state.workspaces.slice(idx + 1), true)
                            });
                        }
                    }
                    return [2 /*return*/];
                });
            });
        },
        getPreferredWorkspaceId: function (_a) {
            var dispatch = _a.dispatch;
            return user_store_awaiter(this, void 0, void 0, function () {
                var preferredWorkspaceId, userProfileResponse, err_3;
                return user_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, dispatch('fetchUserProfile')];
                        case 1:
                            userProfileResponse = _b.sent();
                            preferredWorkspaceId = userProfileResponse.preferred_workspace;
                            return [3 /*break*/, 3];
                        case 2:
                            err_3 = _b.sent();
                            console.warn('Failed to get preferred workspace id', err_3);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/, preferredWorkspaceId];
                    }
                });
            });
        },
        setWorkspace: function (_a, payload) {
            var commit = _a.commit, dispatch = _a.dispatch, state = _a.state, getters = _a.getters;
            return user_store_awaiter(this, void 0, void 0, function () {
                return user_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (state.workspaceId === payload.workspaceId) {
                                return [2 /*return*/];
                            }
                            // 'setWorkspaceId' and 'projectModule/setCurrentNamespace' has to be called together synchronously.
                            // In case when there is some async call between their calls, the watchers can be updated incorrectly
                            commit('setWorkspaceId', { id: payload.workspaceId });
                            if (getters.currentWorkspace) {
                                commit('projectModule/setCurrentNamespace', { currentNamespace: getters.currentWorkspace.name }, { root: true });
                            }
                            if (!!payload.skipSavingInCookies) return [3 /*break*/, 2];
                            return [4 /*yield*/, dispatch('setUserWorkspaceToCookies', {
                                    id: payload.workspaceId
                                })];
                        case 1: return [2 /*return*/, _b.sent()];
                        case 2: return [2 /*return*/];
                    }
                });
            });
        },
        getAllUserWorkspacesFromCookies: function () {
            return user_store_awaiter(this, void 0, void 0, function () {
                var value, cookieValue, parsedValue;
                return user_store_generator(this, function (_a) {
                    try {
                        cookieValue = cookies.get(COOKIES_CURRENT_WORKSPACE, {
                            doNotParse: true
                        });
                        if (cookieValue) {
                            parsedValue = JSON.parse(cookieValue);
                            if (isObject_default()(parsedValue)) {
                                value = parsedValue;
                            }
                            else {
                                console.warn("Stored cookies (".concat(COOKIES_CURRENT_WORKSPACE, ") value is not an object, removing it."));
                                // stored cookies value has deprecated format
                                cookies.remove(COOKIES_CURRENT_WORKSPACE);
                            }
                        }
                    }
                    catch (e) {
                        console.warn("Stored cookies (".concat(COOKIES_CURRENT_WORKSPACE, ") value is malformed, removing it."), e);
                        // stored cookies value is malformed, remove it
                        cookies.remove(COOKIES_CURRENT_WORKSPACE);
                    }
                    return [2 /*return*/, value];
                });
            });
        },
        getUserWorkspaceFromCookies: function (_a) {
            var _b, _c;
            var dispatch = _a.dispatch, state = _a.state;
            return user_store_awaiter(this, void 0, void 0, function () {
                var userWorkspaceId, value, _d;
                return user_store_generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            if (!((_b = state.loggedUser) === null || _b === void 0 ? void 0 : _b.username)) return [3 /*break*/, 4];
                            _e.label = 1;
                        case 1:
                            _e.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, dispatch('getAllUserWorkspacesFromCookies')];
                        case 2:
                            value = _e.sent();
                            if (value) {
                                userWorkspaceId = value[(_c = state.loggedUser) === null || _c === void 0 ? void 0 : _c.username];
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            _d = _e.sent();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/, userWorkspaceId];
                    }
                });
            });
        },
        removeUserWorkspaceFromCookies: function (_a) {
            var _b, _c;
            var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
            return user_store_awaiter(this, void 0, void 0, function () {
                var value, _d, strValue, expires;
                return user_store_generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            if (!((_b = state.loggedUser) === null || _b === void 0 ? void 0 : _b.username)) return [3 /*break*/, 5];
                            value = void 0;
                            _e.label = 1;
                        case 1:
                            _e.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, dispatch('getAllUserWorkspacesFromCookies')];
                        case 2:
                            value = _e.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            _d = _e.sent();
                            return [3 /*break*/, 4];
                        case 4:
                            delete value[(_c = state.loggedUser) === null || _c === void 0 ? void 0 : _c.username];
                            strValue = JSON.stringify(value);
                            expires = new Date();
                            // cookies expire in one year
                            expires.setFullYear(expires.getFullYear() + 1);
                            cookies.set(COOKIES_CURRENT_WORKSPACE, strValue, {
                                expires: expires
                            });
                            _e.label = 5;
                        case 5: return [4 /*yield*/, commit('projectModule/setCurrentNamespace', {
                                currentNamespace: ''
                            }, { root: true })];
                        case 6:
                            _e.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        setUserWorkspaceToCookies: function (_a, payload) {
            var _b, _c;
            var dispatch = _a.dispatch, state = _a.state;
            return user_store_awaiter(this, void 0, void 0, function () {
                var oldValue, _d, value, expires;
                var _e;
                return user_store_generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            if (!((_b = state.loggedUser) === null || _b === void 0 ? void 0 : _b.username)) return [3 /*break*/, 5];
                            oldValue = void 0;
                            _f.label = 1;
                        case 1:
                            _f.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, dispatch('getAllUserWorkspacesFromCookies')];
                        case 2:
                            oldValue = _f.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            _d = _f.sent();
                            return [3 /*break*/, 4];
                        case 4:
                            value = JSON.stringify(store_assign(store_assign({}, oldValue), (_e = {}, _e[(_c = state.loggedUser) === null || _c === void 0 ? void 0 : _c.username] = payload.id, _e)));
                            expires = new Date();
                            // cookies expire in one year
                            expires.setFullYear(expires.getFullYear() + 1);
                            cookies.set(COOKIES_CURRENT_WORKSPACE, value, {
                                expires: expires
                            });
                            _f.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        setFirstWorkspace: function (_a) {
            var dispatch = _a.dispatch, state = _a.state;
            return user_store_awaiter(this, void 0, void 0, function () {
                return user_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(state.workspaces.length > 0)) return [3 /*break*/, 2];
                            return [4 /*yield*/, dispatch('setWorkspace', {
                                    workspaceId: state.workspaces[0].id
                                })];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        },
        checkCurrentWorkspace: function (_a) {
            var _b;
            var dispatch = _a.dispatch, getters = _a.getters, state = _a.state;
            return user_store_awaiter(this, void 0, void 0, function () {
                var currentWorkspaceFromCookie, foundWorkspace, skipSavingInCookies, preferredWorkspaceId, currentWorkspaceIdToSet, e_3;
                return user_store_generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 9, , 10]);
                            return [4 /*yield*/, dispatch('getWorkspaces')];
                        case 1:
                            _c.sent();
                            return [4 /*yield*/, dispatch('getUserWorkspaceFromCookies')];
                        case 2:
                            currentWorkspaceFromCookie = _c.sent();
                            if (!(state.workspaces.length > 0)) return [3 /*break*/, 6];
                            foundWorkspace = void 0;
                            skipSavingInCookies = true;
                            if (currentWorkspaceFromCookie !== undefined) {
                                // try to use workspace stored in cookies
                                foundWorkspace = getters.getWorkspaceById({
                                    id: parseInt(currentWorkspaceFromCookie)
                                });
                            }
                            if (!!foundWorkspace) return [3 /*break*/, 4];
                            return [4 /*yield*/, dispatch('getPreferredWorkspaceId')];
                        case 3:
                            preferredWorkspaceId = _c.sent();
                            if (preferredWorkspaceId) {
                                foundWorkspace = getters.getWorkspaceById({
                                    id: preferredWorkspaceId
                                });
                                if (foundWorkspace === null || foundWorkspace === void 0 ? void 0 : foundWorkspace.id) {
                                    // do not skip saving in cookies when using preferredWorkspace
                                    skipSavingInCookies = false;
                                }
                            }
                            _c.label = 4;
                        case 4:
                            currentWorkspaceIdToSet = (_b = foundWorkspace === null || foundWorkspace === void 0 ? void 0 : foundWorkspace.id) !== null && _b !== void 0 ? _b : state.workspaces[0].id;
                            return [4 /*yield*/, dispatch('setWorkspace', {
                                    workspaceId: currentWorkspaceIdToSet,
                                    // do not save workspaceId to cookies as it could be:
                                    // * already there, if was loaded from cookies
                                    // * used the first user workspace as fallback, then it is not a user choice
                                    skipSavingInCookies: skipSavingInCookies
                                })];
                        case 5:
                            _c.sent();
                            return [3 /*break*/, 8];
                        case 6: return [4 /*yield*/, dispatch('removeUserWorkspaceFromCookies')];
                        case 7:
                            _c.sent();
                            _c.label = 8;
                        case 8: return [3 /*break*/, 10];
                        case 9:
                            e_3 = _c.sent();
                            console.warn('Loading of stored user workspace id has failed.', e_3);
                            return [3 /*break*/, 10];
                        case 10: return [2 /*return*/];
                    }
                });
            });
        }
    }
};
/* harmony default export */ var user_store = (UserStore);

;// CONCATENATED MODULE: ./src/modules/user/module.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial



var UserModule = {
    name: 'userModule',
    routerService: undefined,
    httpService: undefined,
    moduleStore: user_store,
    _addRoutes: function (router, rootStore, routeOverrides) {
        // add routes to router
        routes(rootStore).forEach(function (route) {
            router.addRoute(applyRouteOverride(route, routeOverrides));
        });
    },
    init: function (services, routeOverrides) {
        if (services.httpService) {
            UserModule.httpService = services.httpService;
        }
        else {
            console.error("Module ".concat(UserModule.name, " - missing httpService"));
        }
        if (services.routerService) {
            UserModule.routerService = services.routerService;
            if (services.store) {
                UserModule._addRoutes(services.routerService, services.store, routeOverrides);
            }
        }
    }
};

;// CONCATENATED MODULE: ./src/modules/user/userApi.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
var userApi_assign = (undefined && undefined.__assign) || function () {
    userApi_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return userApi_assign.apply(this, arguments);
};
var userApi_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var userApi_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var UserApi = {
    getAuthUserSearch: function (params) {
        return UserModule.httpService.get('/app/auth/user/search', { params: params });
    },
    getAuthUserByUserName: function (userName) {
        return UserModule.httpService.get("/app/auth/user/".concat(userName, "?random=").concat(Math.random()));
    },
    editUserProfile: function (data, withRetry) {
        return UserModule.httpService.post('/app/auth/user/profile', data, userApi_assign({}, (withRetry ? getDefaultRetryOptions() : {})));
    },
    closeUserProfile: function (withRetry) {
        return UserModule.httpService["delete"]('/v1/user', userApi_assign({}, (withRetry ? getDefaultRetryOptions() : {})));
    },
    changePasswordWithToken: function (token, data, withRetry) {
        return UserModule.httpService.post("/app/auth/reset-password/".concat(token), data, userApi_assign({}, (withRetry ? getDefaultRetryOptions() : {})));
    },
    changePassword: function (data, withRetry) {
        return UserModule.httpService.post('/app/auth/change-password', data, userApi_assign({}, (withRetry ? getDefaultRetryOptions() : {})));
    },
    resetPassword: function (data) {
        return UserModule.httpService.post('/app/auth/reset-password', data);
    },
    // TODO: deprecated?
    confirmEmail: function (token) {
        return UserModule.httpService.post("/app/auth/confirm-email/".concat(token));
    },
    resendEmail: function () {
        return UserModule.httpService.get('/app/auth/resend-confirm-email');
    },
    login: function (data) {
        return UserModule.httpService.post('/app/auth/login', data);
    },
    logout: function () {
        return UserModule.httpService.get('/app/auth/logout');
    },
    fetchUserProfile: function () {
        return UserModule.httpService.get("/v1/user/profile");
    },
    getWorkspaces: function () {
        return userApi_awaiter(this, void 0, Promise, function () {
            return userApi_generator(this, function (_a) {
                return [2 /*return*/, UserModule.httpService.get("/v1/workspaces")];
            });
        });
    },
    getWorkspaceById: function (id) {
        return userApi_awaiter(this, void 0, Promise, function () {
            return userApi_generator(this, function (_a) {
                return [2 /*return*/, UserModule.httpService.get("/v1/workspace/".concat(id))];
            });
        });
    }
};

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/AccountAutocomplete.vue?vue&type=script&lang=ts&
var AccountAutocompletevue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    AccountAutocompletevue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return AccountAutocompletevue_type_script_lang_ts_assign.apply(this, arguments);
};









/* harmony default export */ var AccountAutocompletevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'AccountAutocomplete',
    components: { UserSearchChip: UserSearchChip, SendIcon: external_vue_tabler_icons_namespaceObject.SendIcon, UserIcon: external_vue_tabler_icons_namespaceObject.UserIcon },
    props: {
        inputUsers: Array,
        filterUsers: { type: Array, default: function () { return []; } },
        allowInvite: Boolean
    },
    data: function () {
        return {
            searchResults: [],
            isLoading: false,
            query: '',
            users: []
        };
    },
    computed: AccountAutocompletevue_type_script_lang_ts_assign(AccountAutocompletevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('projectModule', ['currentNamespace'])), { items: function () {
            return this.searchResults.map(function (item) {
                return AccountAutocompletevue_type_script_lang_ts_assign({}, item);
            });
        } }),
    created: function () {
        var _a;
        this.users = (_a = this.inputUsers) !== null && _a !== void 0 ? _a : [];
        this.refreshCachedItems(this.users);
    },
    watch: {
        query: 'search',
        inputUsers: {
            deep: true,
            handler: function (val) {
                this.users = val;
                this.refreshCachedItems(val);
                if (!val || val.length === 0) {
                    this.searchResults = [];
                    this.query = '';
                }
            }
        },
        users: {
            deep: true,
            handler: function (val) {
                this.$emit('update', val);
                if (!isEmpty_default()(val)) {
                    this.query = '';
                }
            }
        }
    },
    methods: {
        search: debounce_default()(function () {
            var _this = this;
            // clear non-relevant cached items
            this.refreshCachedItems(this.users);
            if (!this.query || this.query.length < 3) {
                this.searchResults = [];
                return;
            }
            // Items have already been requested
            if (this.isLoading) {
                return;
            }
            this.isLoading = true;
            var params = {
                namespace: this.currentNamespace,
                like: this.query
            };
            UserApi.getAuthUserSearch(params)
                .then(function (resp) {
                var _a;
                if (((_a = resp.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    // return data from api in search results and remove items included in filterUsers
                    _this.searchResults = resp.data.filter(function (item) { return !_this.filterUsers.find(function (user) { return user === item.username; }); });
                }
                else if (_this.allowInvite && isValidEmail(_this.query)) {
                    // return invite item in search results
                    _this.searchResults = [AccountAutocompletevue_type_script_lang_ts_assign(AccountAutocompletevue_type_script_lang_ts_assign({}, EMPTY_INVITE_ITEM), { email: _this.query })];
                }
                else {
                    // return empty search results
                    _this.searchResults = [];
                }
            })
                .finally(function () {
                _this.isLoading = false;
            });
        }, 300),
        filterSelected: function (item, queryText) {
            return ((item.username &&
                item.username
                    .toLocaleLowerCase()
                    .indexOf(queryText.toLocaleLowerCase()) > -1) ||
                (item.email &&
                    item.email
                        .toLocaleLowerCase()
                        .indexOf(queryText.toLocaleLowerCase()) > -1));
        },
        removeItem: function (item) {
            var index = this.users.findIndex(function (user) { return item.email === user.email; });
            if (index >= 0) {
                this.users.splice(index, 1);
            }
        },
        getUserProfileName: function (user) {
            var _a, _b, _c, _d;
            var firstName = (_b = (_a = user === null || user === void 0 ? void 0 : user.profile) === null || _a === void 0 ? void 0 : _a.first_name) !== null && _b !== void 0 ? _b : '';
            var lastName = (_d = (_c = user === null || user === void 0 ? void 0 : user.profile) === null || _c === void 0 ? void 0 : _c.last_name) !== null && _d !== void 0 ? _d : '';
            return firstName || lastName ? "(".concat(firstName, " ").concat(lastName, ")") : '';
        },
        emphasizeMatch: function (text, reg) {
            return text
                ? text.replace(new RegExp(reg, 'i'), function (str) {
                    return '<b>' + str + '</b>';
                })
                : '';
        },
        refreshCachedItems: function (users) {
            var _this = this;
            var _a;
            if ((_a = this.$refs) === null || _a === void 0 ? void 0 : _a.autocomplete) {
                // remove invalid values from cache
                this.$refs.autocomplete.cachedItems =
                    this.$refs.autocomplete.cachedItems.filter(function (cachedItem) {
                        return users.findIndex(function (user) {
                            return (_this.allowInvite &&
                                user.isInvite &&
                                user.email === cachedItem.email) ||
                                (!user.isInvite && user.id === cachedItem.id);
                        }) !== -1;
                    });
                // add missing values to cache
                users === null || users === void 0 ? void 0 : users.forEach(function (user) {
                    var idx = _this.$refs.autocomplete.cachedItems.findIndex(function (cachedItem) {
                        return (_this.allowInvite &&
                            user.isInvite &&
                            user.email === cachedItem.email) ||
                            (!user.isInvite && user.id === cachedItem.id);
                    });
                    if (idx === -1) {
                        _this.$refs.autocomplete.cachedItems.push(user);
                    }
                });
            }
        }
    }
}));

;// CONCATENATED MODULE: ./src/modules/project/components/AccountAutocomplete.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_AccountAutocompletevue_type_script_lang_ts_ = (AccountAutocompletevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/AccountAutocomplete.vue?vue&type=style&index=0&id=220f578a&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/components/AccountAutocomplete.vue?vue&type=style&index=0&id=220f578a&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/components/AccountAutocomplete.vue



;


/* normalize component */

var AccountAutocomplete_component = normalizeComponent(
  components_AccountAutocompletevue_type_script_lang_ts_,
  AccountAutocompletevue_type_template_id_220f578a_scoped_true_render,
  AccountAutocompletevue_type_template_id_220f578a_scoped_true_staticRenderFns,
  false,
  null,
  "220f578a",
  null
  
)

/* harmony default export */ var AccountAutocomplete = (AccountAutocomplete_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/CloneDialog.vue?vue&type=template&id=61bbeb14&
var CloneDialogvue_type_template_id_61bbeb14_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('clone-dialog-template',_vm._b({on:{"on-clone-project":_vm.onCloneProject}},'clone-dialog-template',_vm.$props,false))
}
var CloneDialogvue_type_template_id_61bbeb14_staticRenderFns = []


;// CONCATENATED MODULE: external "vuetify/lib/components/VTextField"
var VTextField_namespaceObject = require("vuetify/lib/components/VTextField");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/CloneDialogTemplate.vue?vue&type=template&id=3e5f3ad5&








var CloneDialogTemplatevue_type_template_id_3e5f3ad5_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCard_namespaceObject.VCard,{attrs:{"data-cy":"clone-dialog-card"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.onCloneProject.apply(null, arguments)}}},[_c(VCard_namespaceObject.VCardTitle,[_c('span',{staticClass:"text-h5"},[_vm._v("Clone Project")])]),_c(VCard_namespaceObject.VCardText,[_c(VTextField_namespaceObject.VTextField,{attrs:{"autofocus":"","label":"new project","data-cy":"clone-dialog-project-name"},model:{value:(_vm.newProjectName),callback:function ($$v) {_vm.newProjectName=$$v},expression:"newProjectName"}}),_vm._t("dynamic-items")],2),_c(VCard_namespaceObject.VCardActions,[_c(VGrid_namespaceObject.VSpacer),_c(VBtn_namespaceObject.VBtn,{attrs:{"data-cy":"clone-dialog-close-btn"},on:{"click":_vm.close}},[_vm._v(" Close ")]),_c(VBtn_namespaceObject.VBtn,{staticClass:"primary",attrs:{"id":"clone-project-btn","disabled":!_vm.newProjectName || !_vm.currentWorkspace,"data-cy":"clone-dialog-clone-btn"},on:{"click":_vm.onCloneProject}},[_vm._v(" Clone ")])],1)],1)
}
var CloneDialogTemplatevue_type_template_id_3e5f3ad5_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/components/CloneDialogTemplate.vue?vue&type=template&id=3e5f3ad5&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/CloneDialogTemplate.vue?vue&type=script&lang=ts&
var CloneDialogTemplatevue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    CloneDialogTemplatevue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return CloneDialogTemplatevue_type_script_lang_ts_assign.apply(this, arguments);
};


/* harmony default export */ var CloneDialogTemplatevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'clone-dialog-template',
    props: {
        namespace: String,
        project: String
    },
    data: function () {
        return {
            newProjectName: ''
        };
    },
    computed: CloneDialogTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapGetters)('userModule', ['currentWorkspace'])),
    created: function () {
        this.newProjectName = this.project;
    },
    beforeDestroy: function () {
        this.clearErrors({
            componentId: this.merginComponentUuid,
            keepNotification: true
        });
    },
    methods: CloneDialogTemplatevue_type_script_lang_ts_assign(CloneDialogTemplatevue_type_script_lang_ts_assign(CloneDialogTemplatevue_type_script_lang_ts_assign(CloneDialogTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('dialogModule', ['close'])), (0,external_vuex_namespaceObject.mapActions)('formModule', ['clearErrors', 'handleError'])), (0,external_vuex_namespaceObject.mapActions)('projectModule', ['cloneProject'])), { successCloneCallback: function () {
            this.close();
        }, onCloneProject: function () {
            this.clearErrors({ componentId: this.merginComponentUuid });
            var data = {
                project: this.newProjectName,
                namespace: this.namespace,
                merginComponentUuid: this.merginComponentUuid
            };
            this.$emit('on-clone-project', this.project, this.namespace, data, this.successCloneCallback);
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/components/CloneDialogTemplate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_CloneDialogTemplatevue_type_script_lang_ts_ = (CloneDialogTemplatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/project/components/CloneDialogTemplate.vue





/* normalize component */
;
var CloneDialogTemplate_component = normalizeComponent(
  components_CloneDialogTemplatevue_type_script_lang_ts_,
  CloneDialogTemplatevue_type_template_id_3e5f3ad5_render,
  CloneDialogTemplatevue_type_template_id_3e5f3ad5_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CloneDialogTemplate = (CloneDialogTemplate_component.exports);
;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/CloneDialog.vue?vue&type=script&lang=ts&
var CloneDialogvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    CloneDialogvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return CloneDialogvue_type_script_lang_ts_assign.apply(this, arguments);
};
var CloneDialogvue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CloneDialogvue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



/* harmony default export */ var CloneDialogvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'clone-dialog',
    props: {
        project: String,
        namespace: String
    },
    components: { CloneDialogTemplate: CloneDialogTemplate },
    methods: CloneDialogvue_type_script_lang_ts_assign(CloneDialogvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('projectModule', ['cloneProject'])), { onCloneProject: function (project, namespace, data, cbSuccess) {
            return CloneDialogvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                var err_1;
                var _this = this;
                return CloneDialogvue_type_script_lang_ts_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.cloneProject({
                                    namespace: namespace,
                                    project: project,
                                    data: data,
                                    cbSuccess: function () { return CloneDialogvue_type_script_lang_ts_awaiter(_this, void 0, void 0, function () {
                                        return CloneDialogvue_type_script_lang_ts_generator(this, function (_a) {
                                            cbSuccess();
                                            this.$emit('success', data);
                                            return [2 /*return*/];
                                        });
                                    }); }
                                })];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            this.$emit('error', err_1, data);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/components/CloneDialog.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_CloneDialogvue_type_script_lang_ts_ = (CloneDialogvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/project/components/CloneDialog.vue





/* normalize component */
;
var CloneDialog_component = normalizeComponent(
  components_CloneDialogvue_type_script_lang_ts_,
  CloneDialogvue_type_template_id_61bbeb14_render,
  CloneDialogvue_type_template_id_61bbeb14_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CloneDialog = (CloneDialog_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/DropArea.vue?vue&type=template&id=47f6724e&scoped=true&
var DropAreavue_type_template_id_47f6724e_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"drop-area",class:{ active: _vm.dragOver },on:{"dragover":function($event){$event.preventDefault();return _vm.onDragOver.apply(null, arguments)},"!dragleave":function($event){return _vm.setOver(false)},"drop":function($event){$event.preventDefault();return _vm.onDrop.apply(null, arguments)}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dragOver),expression:"dragOver"}],staticClass:"drop-highlight lighten-3",class:_vm.canDropFiles ? 'primary' : 'red'}),_c('div',{staticClass:"file-input",class:_vm.canDropFiles ? '' : 'disabled',on:{"click":function($event){return _vm.selectFiles()}}},[_c('input',{ref:"selectFilesInput",attrs:{"type":"file","name":"files","multiple":""},on:{"change":_vm.onFileSelected}})]),_vm._t("default")],2)
}
var DropAreavue_type_template_id_47f6724e_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: external "lodash/keyBy"
var keyBy_namespaceObject = require("lodash/keyBy");
var keyBy_default = /*#__PURE__*/__webpack_require__.n(keyBy_namespaceObject);
;// CONCATENATED MODULE: external "lodash/pickBy"
var pickBy_namespaceObject = require("lodash/pickBy");
var pickBy_default = /*#__PURE__*/__webpack_require__.n(pickBy_namespaceObject);
;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/DropArea.vue?vue&type=script&lang=ts&
var DropAreavue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    DropAreavue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return DropAreavue_type_script_lang_ts_assign.apply(this, arguments);
};
var DropAreavue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var DropAreavue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







/* harmony default export */ var DropAreavue_type_script_lang_ts_ = (external_vue_default().extend({
    props: ['location'],
    data: function () {
        return {
            dragOver: false
        };
    },
    computed: DropAreavue_type_script_lang_ts_assign(DropAreavue_type_script_lang_ts_assign(DropAreavue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('projectModule', ['project', 'uploads'])), (0,external_vuex_namespaceObject.mapState)('instanceModule', ['configData'])), { upload: function () {
            return this.project && this.uploads[this.project.name];
        }, canDragOver: function () {
            return this.project && this.$route.name === 'project-tree';
        }, canDropFiles: function () {
            var isUploadRunning = this.upload && this.upload.running;
            return (this.canDragOver && !isUploadRunning && this.project.permissions.upload);
        } }),
    methods: DropAreavue_type_script_lang_ts_assign(DropAreavue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapMutations)('projectModule', [
        'initUpload',
        'uploadFiles',
        'finishFileAnalysis',
        'analysingFiles'
    ])), { setOver: debounce_default()(function (isOver) {
            this.dragOver = isOver;
        }, 30), onDragOver: function () {
            if (!this.dragOver && this.canDragOver) {
                this.setOver(true);
            }
        }, onDrop: function (evt) {
            this.setOver(false);
            if (!this.dragOver || !this.canDropFiles) {
                return;
            }
            if (this.upload && this.upload.running) {
                return this.$store.dispatch('notificationModule/error', {
                    text: 'You cannot update files during upload'
                });
            }
            // prepare all entries because they will be not accessible after this callback ends (after 'await')
            var entries = Array.from(evt.dataTransfer.items).map(function (i) { return i.webkitGetAsEntry(); });
            if (entries.some(function (e) { return e === null; })) {
                return this.$store.dispatch('notificationModule/error', {
                    text: 'Drop only files or folders'
                });
            }
            this.createUpload(entries);
        }, selectFiles: function () {
            if (this.canDropFiles) {
                this.$refs.selectFilesInput.click();
            }
        }, onFileSelected: function (evt) {
            // prepare all entries because they will be not accessible after this callback ends (after 'await')
            var entries = Array.from(evt.target.files).map(function (i) {
                i.isFile = true;
                return i;
            });
            this.partialDrop(this.location, entries);
            this.createUpload(entries);
        }, createUpload: function (entries) {
            return DropAreavue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                var partial, item, files;
                return DropAreavue_type_script_lang_ts_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            partial = true;
                            if (entries.length === 1) {
                                item = entries[0];
                                if (item && item.isDirectory && item.name === this.project.name) {
                                    // whole project folder was dropped
                                    partial = false;
                                }
                            }
                            if (this.upload) {
                                partial = true;
                            }
                            else {
                                // initialize new upload data
                                this.initUpload({ files: partial ? this.project.files : null });
                            }
                            if (!partial) return [3 /*break*/, 1];
                            this.partialDrop(this.location, entries);
                            return [3 /*break*/, 4];
                        case 1: return [4 /*yield*/, getFiles(entries[0], this.configData)];
                        case 2:
                            files = _a.sent();
                            this.analysingFiles({ files: files.map(function (f) { return f.path; }) });
                            return [4 /*yield*/, this.analyzeFiles(files)];
                        case 3:
                            _a.sent();
                            this.uploadFiles({ files: files });
                            _a.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }, analyzeFiles: function (files) {
            return DropAreavue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                var _this = this;
                return DropAreavue_type_script_lang_ts_generator(this, function (_a) {
                    // or compute checksums sequentially?
                    // for (let file of files) {
                    //   const hash = await checksum(file.file)
                    //   file.checksum = hash
                    //   this.$store.commit('finishFileAnalysis', file.path)
                    // }
                    // return files
                    return [2 /*return*/, Promise.all(files.map(function (file) { return DropAreavue_type_script_lang_ts_awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return DropAreavue_type_script_lang_ts_generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _a = file;
                                        return [4 /*yield*/, checksum(file.file)];
                                    case 1:
                                        _a.checksum = _b.sent();
                                        this.finishFileAnalysis({ path: file.path });
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                });
            });
        }, partialDrop: function (location, entries) {
            return DropAreavue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                var uploadFiles, items, _i, entries_1, entry, _a, _b, allFiles;
                var _c;
                return DropAreavue_type_script_lang_ts_generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (this.upload) {
                                uploadFiles = this.upload.files;
                            }
                            else {
                                uploadFiles = DropAreavue_type_script_lang_ts_assign({}, this.project.files);
                            }
                            items = [];
                            _i = 0, entries_1 = entries;
                            _d.label = 1;
                        case 1:
                            if (!(_i < entries_1.length)) return [3 /*break*/, 4];
                            entry = entries_1[_i];
                            _b = (_a = items).push;
                            _c = {
                                name: entry.name,
                                isDirectory: entry.isDirectory
                            };
                            return [4 /*yield*/, getFiles(entry, this.configData)];
                        case 2:
                            _b.apply(_a, [(_c.files = _d.sent(),
                                    _c)]);
                            _d.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            allFiles = items.reduce(function (list, item) { return list.concat(item.files); }, []);
                            this.analysingFiles({ files: allFiles.map(function (f) { return f.path; }) });
                            return [4 /*yield*/, this.analyzeFiles(allFiles)];
                        case 5:
                            _d.sent();
                            items.forEach(function (entry) {
                                var _a;
                                if (entry.isDirectory) {
                                    var directory_1 = path_browserify_default().join(location, entry.name);
                                    var pathPrefix_1 = directory_1 + '/';
                                    uploadFiles = DropAreavue_type_script_lang_ts_assign(DropAreavue_type_script_lang_ts_assign({}, pickBy_default()(uploadFiles, function (file) { return !file.path.startsWith(pathPrefix_1); })), keyBy_default()(entry.files.map(function (f) { return (DropAreavue_type_script_lang_ts_assign(DropAreavue_type_script_lang_ts_assign({}, f), { path: path_browserify_default().join(directory_1, f.path) })); }), 'path'));
                                }
                                else {
                                    var file = entry.files[0];
                                    file.path = path_browserify_default().join(location, file.path);
                                    uploadFiles = DropAreavue_type_script_lang_ts_assign(DropAreavue_type_script_lang_ts_assign({}, uploadFiles), (_a = {}, _a[file.path] = file, _a));
                                }
                            });
                            this.uploadFiles({ files: uploadFiles });
                            return [2 /*return*/];
                    }
                });
            });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/components/DropArea.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_DropAreavue_type_script_lang_ts_ = (DropAreavue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/DropArea.vue?vue&type=style&index=0&id=47f6724e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/components/DropArea.vue?vue&type=style&index=0&id=47f6724e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/components/DropArea.vue



;


/* normalize component */

var DropArea_component = normalizeComponent(
  components_DropAreavue_type_script_lang_ts_,
  DropAreavue_type_template_id_47f6724e_scoped_true_render,
  DropAreavue_type_template_id_47f6724e_scoped_true_staticRenderFns,
  false,
  null,
  "47f6724e",
  null
  
)

/* harmony default export */ var DropArea = (DropArea_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VDataTable"
var VDataTable_namespaceObject = require("vuetify/lib/components/VDataTable");
;// CONCATENATED MODULE: external "vuetify/lib/components/VTooltip"
var VTooltip_namespaceObject = require("vuetify/lib/components/VTooltip");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/FileChangesetSummaryTable.vue?vue&type=template&id=b6488d64&scoped=true&




var FileChangesetSummaryTablevue_type_template_id_b6488d64_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(VDataTable_namespaceObject.VDataTable,{attrs:{"headers":_vm.headers,"items":_vm.displayedChangeset,"footer-props.items-per-page-options":"[10, 25, {\"text\": \"$vuetify.dataIterator.rowsPerPageAll\",\"value\": -1}]","hide-default-footer":_vm.displayedChangeset.length <= 10},scopedSlots:_vm._u([{key:"header.insert",fn:function({ header }){return [_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VIcon_namespaceObject.VIcon,_vm._g({attrs:{"small":"","color":header.color}},on),[_vm._v(_vm._s(header.icon)+" ")])]}}],null,true)},[_c('span',[_vm._v("Added")])])]}},{key:"header.delete",fn:function({ header }){return [_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VIcon_namespaceObject.VIcon,_vm._g({attrs:{"small":"","color":header.color}},on),[_vm._v(_vm._s(header.icon)+" ")])]}}],null,true)},[_c('span',[_vm._v("Deleted")])])]}},{key:"header.update",fn:function({ header }){return [_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VIcon_namespaceObject.VIcon,_vm._g({attrs:{"small":"","color":header.color}},on),[_vm._v(_vm._s(header.icon)+" ")])]}}],null,true)},[_c('span',[_vm._v("Modified")])])]}}])})],1)
}
var FileChangesetSummaryTablevue_type_template_id_b6488d64_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/components/FileChangesetSummaryTable.vue?vue&type=template&id=b6488d64&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/FileChangesetSummaryTable.vue?vue&type=script&lang=ts&

/* harmony default export */ var FileChangesetSummaryTablevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'file-changeset-summary-table',
    props: {
        changesets: Array
    },
    data: function () {
        return {
            headers: [
                { text: 'Table', value: 'table' },
                {
                    text: 'Inserts',
                    icon: 'add_circle',
                    color: 'green',
                    value: 'insert'
                },
                { text: 'Updates', icon: 'edit', color: 'orange', value: 'update' },
                { text: 'Deletes', icon: 'delete', color: 'red', value: 'delete' }
            ]
        };
    },
    computed: {
        displayedChangeset: function () {
            // Displayed changesets data into table data
            return this.changesets.filter(function (p) { return p.table !== 'gpkg_contents'; });
        }
    }
}));

;// CONCATENATED MODULE: ./src/modules/project/components/FileChangesetSummaryTable.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_FileChangesetSummaryTablevue_type_script_lang_ts_ = (FileChangesetSummaryTablevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/project/components/FileChangesetSummaryTable.vue





/* normalize component */
;
var FileChangesetSummaryTable_component = normalizeComponent(
  components_FileChangesetSummaryTablevue_type_script_lang_ts_,
  FileChangesetSummaryTablevue_type_template_id_b6488d64_scoped_true_render,
  FileChangesetSummaryTablevue_type_template_id_b6488d64_scoped_true_staticRenderFns,
  false,
  null,
  "b6488d64",
  null
  
)

/* harmony default export */ var FileChangesetSummaryTable = (FileChangesetSummaryTable_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/FileIcon.vue?vue&type=template&id=74e6ede7&scoped=true&


var FileIconvue_type_template_id_74e6ede7_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.icon)?[_c('span',[_c('img',{attrs:{"src":_vm.icon}})])]:[_c(VIcon_namespaceObject.VIcon,[_vm._v(_vm._s(_vm.mdi))])]],2)
}
var FileIconvue_type_template_id_74e6ede7_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/components/FileIcon.vue?vue&type=template&id=74e6ede7&scoped=true&

;// CONCATENATED MODULE: ./src/assets/qgis-icons/mIconDbSchema.svg
var mIconDbSchema_namespaceObject = "/img/mIconDbSchema.c205ffc0.svg";
;// CONCATENATED MODULE: ./src/assets/qgis-icons/mIconFolder.svg
var mIconFolder_namespaceObject = "/img/mIconFolder.48a61510.svg";
;// CONCATENATED MODULE: ./src/assets/qgis-icons/mIconRaster.svg
var mIconRaster_namespaceObject = "/img/mIconRaster.8d14167a.svg";
;// CONCATENATED MODULE: ./src/assets/qgis-icons/mIconTableLayer.svg
var mIconTableLayer_namespaceObject = "/img/mIconTableLayer.cef0e806.svg";
;// CONCATENATED MODULE: ./src/assets/qgis-icons/mIconZip.svg
var mIconZip_namespaceObject = "/img/mIconZip.e3082194.svg";
;// CONCATENATED MODULE: ./src/assets/qgis-icons/providerQgis.svg
var providerQgis_namespaceObject = "/img/providerQgis.f6621663.svg";
;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/FileIcon.vue?vue&type=script&lang=ts&







var mdiByExtensionDict = {
    jpg: 'image',
    jpeg: 'image',
    png: 'image'
};
var iconByExtensionDict = {
    folder: mIconFolder_namespaceObject,
    gpkg: mIconDbSchema_namespaceObject,
    qgs: providerQgis_namespaceObject,
    qgz: providerQgis_namespaceObject,
    rar: mIconZip_namespaceObject,
    sql: mIconDbSchema_namespaceObject,
    tif: mIconRaster_namespaceObject,
    tiff: mIconRaster_namespaceObject,
    xls: mIconTableLayer_namespaceObject,
    xlsx: mIconTableLayer_namespaceObject
};
/* harmony default export */ var FileIconvue_type_script_lang_ts_ = (external_vue_default().extend({
    props: {
        file: Object
    },
    computed: {
        icon: function () {
            var file = this.file;
            var splittedName = file.name.split('.');
            var ext = splittedName[splittedName.length - 1].toLowerCase();
            if (file.type === 'folder') {
                if (file.name !== '..') {
                    ext = 'folder';
                }
                else {
                    return null;
                }
            }
            return iconByExtensionDict[ext] ? iconByExtensionDict[ext] : null;
        },
        mdi: function () {
            var file = this.file;
            var mdi;
            if (file.type === 'folder') {
                if (file.name !== '..') {
                    mdi = 'folder';
                }
            }
            else {
                var splittedName = file.name.split('.');
                var ext = splittedName[splittedName.length - 1].toLowerCase();
                mdi = mdiByExtensionDict[ext] ? mdiByExtensionDict[ext] : 'description';
            }
            return mdi;
        }
    }
}));

;// CONCATENATED MODULE: ./src/modules/project/components/FileIcon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_FileIconvue_type_script_lang_ts_ = (FileIconvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/FileIcon.vue?vue&type=style&index=0&id=74e6ede7&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/components/FileIcon.vue?vue&type=style&index=0&id=74e6ede7&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/components/FileIcon.vue



;


/* normalize component */

var FileIcon_component = normalizeComponent(
  components_FileIconvue_type_script_lang_ts_,
  FileIconvue_type_template_id_74e6ede7_scoped_true_render,
  FileIconvue_type_template_id_74e6ede7_scoped_true_staticRenderFns,
  false,
  null,
  "74e6ede7",
  null
  
)

/* harmony default export */ var FileIcon = (FileIcon_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VMenu"
var VMenu_namespaceObject = require("vuetify/lib/components/VMenu");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/FileMenu.vue?vue&type=template&id=5082e62e&





var FileMenuvue_type_template_id_5082e62e_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VMenu_namespaceObject.VMenu,{attrs:{"position-x":_vm.x,"position-y":_vm.y,"absolute":"","offset-y":"","min-width":150},model:{value:(_vm.showMenu),callback:function ($$v) {_vm.showMenu=$$v},expression:"showMenu"}},[_c(VList_namespaceObject.VList,[_c(VList_namespaceObject.VListItem,{on:{"click":_vm.deleteFile}},[_c(VList_namespaceObject.VListItemTitle,[_vm._v("Delete")])],1)],1)],1)
}
var FileMenuvue_type_template_id_5082e62e_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/components/FileMenu.vue?vue&type=template&id=5082e62e&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/FileMenu.vue?vue&type=script&lang=ts&
var FileMenuvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    FileMenuvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return FileMenuvue_type_script_lang_ts_assign.apply(this, arguments);
};


/* harmony default export */ var FileMenuvue_type_script_lang_ts_ = (external_vue_default().extend({
    data: function () {
        return {
            showMenu: false,
            x: 0,
            y: 0,
            file: null
        };
    },
    methods: FileMenuvue_type_script_lang_ts_assign(FileMenuvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapMutations)('projectModule', ['deleteFiles'])), { open: function (evt, file) {
            this.showMenu = true;
            this.x = evt.clientX;
            this.y = evt.clientY;
            this.file = file;
        }, deleteFile: function () {
            this.deleteFiles({ files: [this.file.path] });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/components/FileMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_FileMenuvue_type_script_lang_ts_ = (FileMenuvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/project/components/FileMenu.vue





/* normalize component */
;
var FileMenu_component = normalizeComponent(
  components_FileMenuvue_type_script_lang_ts_,
  FileMenuvue_type_template_id_5082e62e_render,
  FileMenuvue_type_template_id_5082e62e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FileMenu = (FileMenu_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/FolderDiff.vue?vue&type=template&id=7ca55856&scoped=true&functional=true&
var FolderDiffvue_type_template_id_7ca55856_scoped_true_functional_true_render = function render(_c,_vm){return _c('span',{staticClass:"diff"},[(_vm.props.added)?_c('span',{staticClass:"added"},[_vm._v(_vm._s(_vm.props.added))]):_vm._e(),(_vm.props.removed)?_c('span',{staticClass:"removed"},[_vm._v(_vm._s(_vm.props.removed))]):_vm._e(),(_vm.props.updated)?_c('span',{staticClass:"updated"},[_vm._v(_vm._s(_vm.props.updated))]):_vm._e(),(_vm.props.added + _vm.props.removed + _vm.props.updated > 0)?_c('span',[_vm._v(" / "+_vm._s(_vm.props.count))]):_vm._e()])
}
var FolderDiffvue_type_template_id_7ca55856_scoped_true_functional_true_staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/FolderDiff.vue?vue&type=script&lang=ts&

/* harmony default export */ var FolderDiffvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'FolderDiff',
    functional: true,
    props: {
        added: Number,
        removed: Number,
        updated: Number,
        count: Number
    }
}));

;// CONCATENATED MODULE: ./src/modules/project/components/FolderDiff.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_FolderDiffvue_type_script_lang_ts_ = (FolderDiffvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/FolderDiff.vue?vue&type=style&index=0&id=7ca55856&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/components/FolderDiff.vue?vue&type=style&index=0&id=7ca55856&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/components/FolderDiff.vue



;


/* normalize component */

var FolderDiff_component = normalizeComponent(
  components_FolderDiffvue_type_script_lang_ts_,
  FolderDiffvue_type_template_id_7ca55856_scoped_true_functional_true_render,
  FolderDiffvue_type_template_id_7ca55856_scoped_true_functional_true_staticRenderFns,
  true,
  null,
  "7ca55856",
  null
  
)

/* harmony default export */ var FolderDiff = (FolderDiff_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/PermissionInfo.vue?vue&type=template&id=1a113a2a&scoped=true&


var PermissionInfovue_type_template_id_1a113a2a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"info-link",attrs:{"href":_vm.docsLinkManagePermissions,"target":"_blank"}},[_c(VIcon_namespaceObject.VIcon,{staticClass:"info-icon"},[_vm._v("info_outline")]),_c('span',{staticClass:"text-caption font-weight-bold info-text ml-2"},[_vm._v("Click here to learn more about roles and permissions")])],1)
}
var PermissionInfovue_type_template_id_1a113a2a_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/components/PermissionInfo.vue?vue&type=template&id=1a113a2a&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/PermissionInfo.vue?vue&type=script&lang=ts&
var PermissionInfovue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    PermissionInfovue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return PermissionInfovue_type_script_lang_ts_assign.apply(this, arguments);
};


/* harmony default export */ var PermissionInfovue_type_script_lang_ts_ = (external_vue_default().extend({
    computed: PermissionInfovue_type_script_lang_ts_assign(PermissionInfovue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('instanceModule', ['configData'])), { docsLinkManagePermissions: function () {
            var _a, _b;
            return "".concat((_b = (_a = this.configData) === null || _a === void 0 ? void 0 : _a.docs_url) !== null && _b !== void 0 ? _b : '', "/manage/permissions");
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/components/PermissionInfo.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_PermissionInfovue_type_script_lang_ts_ = (PermissionInfovue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/PermissionInfo.vue?vue&type=style&index=0&id=1a113a2a&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/components/PermissionInfo.vue?vue&type=style&index=0&id=1a113a2a&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/components/PermissionInfo.vue



;


/* normalize component */

var PermissionInfo_component = normalizeComponent(
  components_PermissionInfovue_type_script_lang_ts_,
  PermissionInfovue_type_template_id_1a113a2a_scoped_true_render,
  PermissionInfovue_type_template_id_1a113a2a_scoped_true_staticRenderFns,
  false,
  null,
  "1a113a2a",
  null
  
)

/* harmony default export */ var PermissionInfo = (PermissionInfo_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VSelect"
var VSelect_namespaceObject = require("vuetify/lib/components/VSelect");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectAccessRequest.vue?vue&type=template&id=78842739&scoped=true&






var ProjectAccessRequestvue_type_template_id_78842739_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VGrid_namespaceObject.VLayout,{staticClass:"no-shrink column"},[_c('label',{staticClass:"mt-4 grey--text text--darken-1"},[_vm._v("Access requests:")]),_c(VDataTable_namespaceObject.VDataTable,{attrs:{"headers":_vm.tableHeaders,"items":_vm.project.access_requests,"no-data-text":"No access requests","hide-default-footer":_vm.project.access_requests.length <= 10},scopedSlots:_vm._u([{key:"header.user",fn:function({ header }){return [(header.tooltip)?_c(VTooltip_namespaceObject.VTooltip,{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_vm._v(" "+_vm._s(header.text)+" ")])]}}],null,true)},[_c('span',[_vm._v(" "+_vm._s(header.tooltip)+" ")])]):_c('span',[_vm._v(" "+_vm._s(header.text)+" ")])]}},{key:"header.expire",fn:function({ header }){return [(header.tooltip)?_c(VTooltip_namespaceObject.VTooltip,{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_vm._v(" "+_vm._s(header.text)+" ")])]}}],null,true)},[_c('span',[_vm._v(" "+_vm._s(header.tooltip)+" ")])]):_c('span',[_vm._v(" "+_vm._s(header.text)+" ")])]}},{key:"item.user",fn:function({ value }){return [(
          value.profile &&
          (value.profile.first_name || value.profile.last_name)
        )?_c(VTooltip_namespaceObject.VTooltip,{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('b',_vm._g({},on),[_vm._v(" "+_vm._s(value.username)+" ")])]}}],null,true)},[_c('span',[(value.profile && value.profile.first_name)?_c('span',[_vm._v(_vm._s(value.profile.first_name))]):_vm._e(),(value.profile && value.profile.last_name)?_c('span',[_vm._v(" "+_vm._s(value.profile.last_name))]):_vm._e()])]):_c('b',[_vm._v(" "+_vm._s(value.username)+" ")])]}},{key:"item.expire",fn:function({ value }){return [_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_vm._v(_vm._s(_vm._f("remainingtime")(value)))])]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm._f("datetime")(value)))])])]}},{key:"item.permissions",fn:function({ item }){return [_c(VSelect_namespaceObject.VSelect,{attrs:{"items":['read', 'write', 'owner'],"return-object":""},model:{value:(_vm.permissions[item.id]),callback:function ($$v) {_vm.$set(_vm.permissions, item.id, $$v)},expression:"permissions[item.id]"}})]}},{key:"item.confirm",fn:function({ item }){return [_c('div',{staticClass:"justify-center px-0"},[_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_c(VChip_namespaceObject.VChip,{staticClass:"white--text",attrs:{"disabled":!_vm.canAcceptAccessRequest(item.user.id, item.expire),"elevation":"0","color":"green"},on:{"click":function($event){return _vm.acceptRequest(item)}}},[_vm._v(" accept ")])],1)]}}],null,true)},[_c('span',[_vm._v("Accept request")])])],1)]}},{key:"item.cancel",fn:function({ item }){return [_c('div',{staticClass:"justify-center"},[_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_c(VChip_namespaceObject.VChip,{staticClass:"white--text",attrs:{"disabled":!_vm.canCancelAccessRequest(item.user.id),"elevation":"0","color":"red"},on:{"click":function($event){return _vm.cancelRequest(item)}}},[_vm._v(" cancel ")])],1)]}}],null,true)},[_c('span',[_vm._v("Cancel access request")])])],1)]}}])}),_c('button',{ref:"hidden-btn",staticStyle:{"visibility":"hidden"},attrs:{"id":"accept-request-access-btn"}})],1)
}
var ProjectAccessRequestvue_type_template_id_78842739_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/components/ProjectAccessRequest.vue?vue&type=template&id=78842739&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectAccessRequest.vue?vue&type=script&lang=ts&
var ProjectAccessRequestvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ProjectAccessRequestvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ProjectAccessRequestvue_type_script_lang_ts_assign.apply(this, arguments);
};
var ProjectAccessRequestvue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var ProjectAccessRequestvue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



/* harmony default export */ var ProjectAccessRequestvue_type_script_lang_ts_ = (external_vue_default().extend({
    data: function () {
        return {
            permissions: {},
            tableHeaders: [
                {
                    text: 'User',
                    value: 'user',
                    align: 'left',
                    sortable: false,
                    tooltip: 'Request from user'
                },
                {
                    text: 'Expire',
                    value: 'expire',
                    align: 'left',
                    sortable: false,
                    tooltip: 'Project access request expiration date'
                },
                {
                    text: 'Permissions',
                    value: 'permissions',
                    align: 'right',
                    sortable: false,
                    width: 60
                },
                {
                    text: ' ',
                    value: 'confirm',
                    align: 'right',
                    sortable: false,
                    width: 60
                },
                {
                    text: '',
                    value: 'cancel',
                    align: 'right',
                    sortable: false,
                    width: 60
                }
            ],
            originalValue: null
        };
    },
    computed: ProjectAccessRequestvue_type_script_lang_ts_assign(ProjectAccessRequestvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('projectModule', ['project'])), (0,external_vuex_namespaceObject.mapState)('userModule', ['loggedUser'])),
    created: function () {
        var _this = this;
        this.project.access_requests.forEach(function (request) {
            _this.permissions[request.id] = 'read';
        });
    },
    methods: ProjectAccessRequestvue_type_script_lang_ts_assign(ProjectAccessRequestvue_type_script_lang_ts_assign(ProjectAccessRequestvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('projectModule', [
        'cancelProjectAccessRequest',
        'acceptProjectAccessRequest'
    ])), (0,external_vuex_namespaceObject.mapActions)('notificationModule', ['error'])), { canAcceptAccessRequest: function (userId, expire) {
            return (!this.expired(expire) &&
                this.project.creator !== userId &&
                isAtLeastProjectRole(this.project.role, ProjectRole.owner));
        }, canCancelAccessRequest: function (userId) {
            return (this.project.creator !== userId &&
                isAtLeastProjectRole(this.project.role, ProjectRole.owner));
        }, acceptRequest: function (request) {
            var _a;
            return ProjectAccessRequestvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                var el, data, err_1, msg;
                return ProjectAccessRequestvue_type_script_lang_ts_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            el = this.$refs['hidden-btn'];
                            el.value = this.permissions[request.id];
                            el.dispatchEvent(new Event('click', {}));
                            data = {
                                permissions: this.permissions[request.id]
                            };
                            return [4 /*yield*/, this.acceptProjectAccessRequest({
                                    data: data,
                                    itemId: request.id,
                                    refetchGlobalAccessRequests: false,
                                    namespace: this.project.namespace,
                                    projectName: this.project.name
                                })];
                        case 1:
                            _b.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _b.sent();
                            msg = err_1.response
                                ? (_a = err_1.response.data) === null || _a === void 0 ? void 0 : _a.detail
                                : 'Failed to accept access request';
                            this.error({ text: msg });
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }, expired: function (expire) {
            return Date.parse(expire) < Date.now();
        }, cancelRequest: function (request) {
            return ProjectAccessRequestvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                return ProjectAccessRequestvue_type_script_lang_ts_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.cancelProjectAccessRequest({
                                itemId: request.id,
                                refetchGlobalAccessRequests: false,
                                namespace: this.project.namespace,
                                projectName: this.project.name
                            })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectAccessRequest.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ProjectAccessRequestvue_type_script_lang_ts_ = (ProjectAccessRequestvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectAccessRequest.vue?vue&type=style&index=0&id=78842739&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectAccessRequest.vue?vue&type=style&index=0&id=78842739&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectAccessRequest.vue



;


/* normalize component */

var ProjectAccessRequest_component = normalizeComponent(
  components_ProjectAccessRequestvue_type_script_lang_ts_,
  ProjectAccessRequestvue_type_template_id_78842739_scoped_true_render,
  ProjectAccessRequestvue_type_template_id_78842739_scoped_true_staticRenderFns,
  false,
  null,
  "78842739",
  null
  
)

/* harmony default export */ var ProjectAccessRequest = (ProjectAccessRequest_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectAccessRequestTable.vue?vue&type=template&id=2c83baa4&scoped=true&
var ProjectAccessRequestTablevue_type_template_id_2c83baa4_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('project-access-request-table-template',{attrs:{"namespace":_vm.namespace},on:{"accept-access-request-error":_vm.onAcceptAccessRequestError}})
}
var ProjectAccessRequestTablevue_type_template_id_2c83baa4_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectAccessRequestTableTemplate.vue?vue&type=template&id=40163e53&scoped=true&





var ProjectAccessRequestTableTemplatevue_type_template_id_40163e53_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(VDataTable_namespaceObject.VDataTable,{ref:"table",attrs:{"headers":_vm.header,"items":_vm.accessRequestsData,"no-data-text":"No access requests","color":"primary","footer-props":{ 'items-per-page-options': [10, 25, 50] },"hide-default-footer":_vm.accessRequestsData.length <= 10,"options":_vm.options},scopedSlots:_vm._u([{key:"item.expire",fn:function({ value }){return [_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_vm._v(_vm._s(_vm._f("remainingtime")(value)))])]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm._f("datetime")(value)))])])]}},{key:"item.permission",fn:function({ item }){return [_c(VSelect_namespaceObject.VSelect,{attrs:{"items":['read', 'write', 'owner'],"return-object":"","disabled":!_vm.showAccept},model:{value:(_vm.permissions[item.id]),callback:function ($$v) {_vm.$set(_vm.permissions, item.id, $$v)},expression:"permissions[item.id]"}})]}},{key:"item.buttons",fn:function({ item }){return [_c('div',{staticClass:"justify-center"},[_c('div',{staticStyle:{"text-align":"end"}},[(_vm.showAccept)?_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_c(VChip_namespaceObject.VChip,{staticClass:"white--text",attrs:{"disabled":_vm.expired(item.expire),"elevation":"0","color":"green","value":_vm.permissions[item.id]},on:{"click":function($event){return _vm.acceptRequest(item)}}},[_vm._v(" accept ")])],1)]}}],null,true)},[_c('span',[_vm._v("Accept request")])]):_vm._e(),_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_c(VChip_namespaceObject.VChip,{staticClass:"white--text",attrs:{"elevation":"0","color":"red"},on:{"click":function($event){return _vm.cancelRequest(item)}}},[_vm._v(" cancel ")])],1)]}}],null,true)},[_c('span',[_vm._v("Cancel request")])])],1)])]}}])}),_c('button',{ref:"hidden-btn",staticStyle:{"visibility":"hidden"},attrs:{"id":"accept-request-access-btn"}})],1)
}
var ProjectAccessRequestTableTemplatevue_type_template_id_40163e53_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/components/ProjectAccessRequestTableTemplate.vue?vue&type=template&id=40163e53&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectAccessRequestTableTemplate.vue?vue&type=script&lang=ts&
var ProjectAccessRequestTableTemplatevue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ProjectAccessRequestTableTemplatevue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ProjectAccessRequestTableTemplatevue_type_script_lang_ts_assign.apply(this, arguments);
};
var ProjectAccessRequestTableTemplatevue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var ProjectAccessRequestTableTemplatevue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var ProjectAccessRequestTableTemplatevue_type_script_lang_ts_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};


/* harmony default export */ var ProjectAccessRequestTableTemplatevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'ProjectAccessRequestTableTemplate',
    props: {
        namespace: {
            type: String,
            default: null
        }
    },
    data: function () {
        return {
            options: {
                'sort-by': 'name'
            },
            projectAccessRequests: [],
            permissions: {}
        };
    },
    computed: ProjectAccessRequestTableTemplatevue_type_script_lang_ts_assign(ProjectAccessRequestTableTemplatevue_type_script_lang_ts_assign(ProjectAccessRequestTableTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)(['transfers'])), (0,external_vuex_namespaceObject.mapState)('projectModule', ['accessRequests', 'namespaceAccessRequests'])), { accessRequestsData: function () {
            return this.namespace == null
                ? this.accessRequests
                : this.namespaceAccessRequests;
        }, showAccept: function () {
            return this.namespace != null;
        }, header: function () {
            return ProjectAccessRequestTableTemplatevue_type_script_lang_ts_spreadArray(ProjectAccessRequestTableTemplatevue_type_script_lang_ts_spreadArray([], (this.namespace == null
                ? []
                : [{ text: 'Requester', value: 'requested_by', sortable: true }]), true), [
                { text: 'Project name', value: 'project_name', sortable: true },
                { text: 'Expire in', value: 'expire', sortable: true },
                {
                    text: 'Permissions',
                    value: 'permission',
                    width: 120,
                    sortable: false
                },
                { text: '', value: 'buttons', width: 190, sortable: false }
            ], false);
        } }),
    created: function () {
        return ProjectAccessRequestTableTemplatevue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
            var _this = this;
            return ProjectAccessRequestTableTemplatevue_type_script_lang_ts_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.reloadProjectAccessRequests({
                            refetchGlobalAccessRequests: true,
                            namespace: this.namespace
                        })];
                    case 1:
                        _a.sent();
                        this.accessRequestsData.forEach(function (request) {
                            _this.permissions[request.id] = 'read';
                        });
                        return [2 /*return*/];
                }
            });
        });
    },
    methods: ProjectAccessRequestTableTemplatevue_type_script_lang_ts_assign(ProjectAccessRequestTableTemplatevue_type_script_lang_ts_assign(ProjectAccessRequestTableTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('projectModule', [
        'cancelProjectAccessRequest',
        'acceptProjectAccessRequest',
        'reloadProjectAccessRequests'
    ])), (0,external_vuex_namespaceObject.mapActions)('notificationModule', ['error'])), { acceptRequest: function (request) {
            return ProjectAccessRequestTableTemplatevue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                var el, data, err_1;
                return ProjectAccessRequestTableTemplatevue_type_script_lang_ts_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            el = this.$refs['hidden-btn'];
                            el.value = this.permissions[request.id];
                            el.dispatchEvent(new Event('click', {}));
                            data = {
                                permissions: this.permissions[request.id]
                            };
                            return [4 /*yield*/, this.acceptProjectAccessRequest({
                                    data: data,
                                    itemId: request.id,
                                    refetchGlobalAccessRequests: true,
                                    namespace: this.namespace
                                })];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            this.$emit('accept-access-request-error', err_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }, changeSort: function (column) {
            if (this.options.sortBy === column) {
                this.options.descending = !this.options.descending;
            }
            else {
                this.options.sortBy = column;
                this.options.descending = false;
            }
        }, expired: function (expire) {
            return Date.parse(expire) < Date.now();
        }, cancelRequest: function (request) {
            return ProjectAccessRequestTableTemplatevue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                return ProjectAccessRequestTableTemplatevue_type_script_lang_ts_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.cancelProjectAccessRequest({
                                itemId: request.id,
                                refetchGlobalAccessRequests: true,
                                namespace: this.namespace
                            })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectAccessRequestTableTemplate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ProjectAccessRequestTableTemplatevue_type_script_lang_ts_ = (ProjectAccessRequestTableTemplatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectAccessRequestTableTemplate.vue?vue&type=style&index=0&id=40163e53&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectAccessRequestTableTemplate.vue?vue&type=style&index=0&id=40163e53&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectAccessRequestTableTemplate.vue



;


/* normalize component */

var ProjectAccessRequestTableTemplate_component = normalizeComponent(
  components_ProjectAccessRequestTableTemplatevue_type_script_lang_ts_,
  ProjectAccessRequestTableTemplatevue_type_template_id_40163e53_scoped_true_render,
  ProjectAccessRequestTableTemplatevue_type_template_id_40163e53_scoped_true_staticRenderFns,
  false,
  null,
  "40163e53",
  null
  
)

/* harmony default export */ var ProjectAccessRequestTableTemplate = (ProjectAccessRequestTableTemplate_component.exports);
;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectAccessRequestTable.vue?vue&type=script&lang=ts&
var ProjectAccessRequestTablevue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ProjectAccessRequestTablevue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ProjectAccessRequestTablevue_type_script_lang_ts_assign.apply(this, arguments);
};
var ProjectAccessRequestTablevue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var ProjectAccessRequestTablevue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



/* harmony default export */ var ProjectAccessRequestTablevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'ProjectAccessRequestTable',
    components: { ProjectAccessRequestTableTemplate: ProjectAccessRequestTableTemplate },
    props: {
        namespace: {
            type: String,
            default: null
        }
    },
    methods: ProjectAccessRequestTablevue_type_script_lang_ts_assign(ProjectAccessRequestTablevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('notificationModule', ['error'])), { 
        // TODO: Add more handlers from template, add more emits from template
        onAcceptAccessRequestError: function (err) {
            var _a;
            return ProjectAccessRequestTablevue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                var msg;
                return ProjectAccessRequestTablevue_type_script_lang_ts_generator(this, function (_b) {
                    msg = err.response
                        ? (_a = err.response.data) === null || _a === void 0 ? void 0 : _a.detail
                        : 'Failed to accept access request';
                    this.error({ text: msg });
                    return [2 /*return*/];
                });
            });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectAccessRequestTable.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ProjectAccessRequestTablevue_type_script_lang_ts_ = (ProjectAccessRequestTablevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/project/components/ProjectAccessRequestTable.vue





/* normalize component */
;
var ProjectAccessRequestTable_component = normalizeComponent(
  components_ProjectAccessRequestTablevue_type_script_lang_ts_,
  ProjectAccessRequestTablevue_type_template_id_2c83baa4_scoped_true_render,
  ProjectAccessRequestTablevue_type_template_id_2c83baa4_scoped_true_staticRenderFns,
  false,
  null,
  "2c83baa4",
  null
  
)

/* harmony default export */ var ProjectAccessRequestTable = (ProjectAccessRequestTable_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectForm.vue?vue&type=template&id=7846a7de&








var ProjectFormvue_type_template_id_7846a7de_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCard_namespaceObject.VCard,{on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.createProject.apply(null, arguments)}}},[_c(VCard_namespaceObject.VCardTitle,[_c('span',{staticClass:"text-h5"},[_vm._v("New project")])]),_c(VCard_namespaceObject.VCardText,[_c('p',{staticClass:"text-xs-center red--text",domProps:{"textContent":_vm._s(_vm.error)}}),_c(VTextField_namespaceObject.VTextField,{attrs:{"autofocus":"","label":"name","data-cy":"project-form-name"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_c(VCard_namespaceObject.VCardActions,[_c(VGrid_namespaceObject.VSpacer),_c(VBtn_namespaceObject.VBtn,{staticClass:"black--text",on:{"click":_vm.close}},[_vm._v(" Close")]),_c(VBtn_namespaceObject.VBtn,{staticClass:"primary",attrs:{"id":"create-project-btn","disabled":!_vm.name,"data-cy":"project-form-create-btn"},on:{"click":_vm.createProject}},[_vm._v(" Create ")])],1)],1)
}
var ProjectFormvue_type_template_id_7846a7de_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/components/ProjectForm.vue?vue&type=template&id=7846a7de&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectForm.vue?vue&type=script&lang=ts&
var ProjectFormvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ProjectFormvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ProjectFormvue_type_script_lang_ts_assign.apply(this, arguments);
};
var ProjectFormvue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var ProjectFormvue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


/* harmony default export */ var ProjectFormvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'new-project',
    data: function () {
        return {
            name: '',
            error: null
        };
    },
    computed: ProjectFormvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('projectModule', ['currentNamespace'])),
    beforeDestroy: function () {
        this.clearErrors({
            componentId: this.merginComponentUuid,
            keepNotification: true
        });
    },
    methods: ProjectFormvue_type_script_lang_ts_assign(ProjectFormvue_type_script_lang_ts_assign(ProjectFormvue_type_script_lang_ts_assign(ProjectFormvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('dialogModule', ['close'])), (0,external_vuex_namespaceObject.mapActions)('formModule', ['clearErrors'])), (0,external_vuex_namespaceObject.mapActions)('projectModule', { createProjectAction: 'createProject' })), { createProject: function () {
            return ProjectFormvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                var dialogData, data, err_1;
                return ProjectFormvue_type_script_lang_ts_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            dialogData = { componentId: this.merginComponentUuid };
                            return [4 /*yield*/, this.clearErrors(dialogData)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 5, , 6]);
                            data = {
                                name: this.name.trim(),
                                public: false
                            };
                            return [4 /*yield*/, this.createProjectAction({
                                    data: data,
                                    namespace: this.currentNamespace
                                })];
                        case 3:
                            _a.sent();
                            return [4 /*yield*/, this.close()];
                        case 4:
                            _a.sent();
                            this.$emit('success');
                            return [3 /*break*/, 6];
                        case 5:
                            err_1 = _a.sent();
                            this.$emit('error', err_1, dialogData);
                            return [3 /*break*/, 6];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectForm.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ProjectFormvue_type_script_lang_ts_ = (ProjectFormvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/project/components/ProjectForm.vue





/* normalize component */
;
var ProjectForm_component = normalizeComponent(
  components_ProjectFormvue_type_script_lang_ts_,
  ProjectFormvue_type_template_id_7846a7de_render,
  ProjectFormvue_type_template_id_7846a7de_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProjectForm = (ProjectForm_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectPermissionsTemplate.vue?vue&type=template&id=31eec9b4&scoped=true&







var ProjectPermissionsTemplatevue_type_template_id_31eec9b4_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VGrid_namespaceObject.VLayout,{staticClass:"no-shrink column"},[_c('label',{staticClass:"mt-4 grey--text text--darken-1"},[_vm._v("Manage Access:")]),_vm._t("banner"),_c(VDataTable_namespaceObject.VDataTable,{attrs:{"headers":_vm.header,"items":_vm.displayedValues,"no-data-text":"No users","hide-default-footer":_vm.displayedValues.length <= 10},scopedSlots:_vm._u([{key:"header.permissions",fn:function({ header }){return [(header.tooltip)?_c(VTooltip_namespaceObject.VTooltip,{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_vm._v(" "+_vm._s(header.text)+" ")])]}}],null,true)},[_c('span',[_vm._v(" "+_vm._s(header.tooltip)+" ")])]):_c('span',[_vm._v(" "+_vm._s(header.text)+" ")])]}},{key:"item.user",fn:function({ value }){return [(value.profile.first_name || value.profile.last_name)?_c(VTooltip_namespaceObject.VTooltip,{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('b',_vm._g({},on),[_vm._v(" "+_vm._s(value.username)+" ")])]}}],null,true)},[_c('span',[(value.profile.first_name)?_c('span',[_vm._v(_vm._s(value.profile.first_name))]):_vm._e(),(value.profile.last_name)?_c('span',[_vm._v(" "+_vm._s(value.profile.last_name))]):_vm._e()])]):_c('b',[_vm._v(" "+_vm._s(value.username)+" ")])]}},{key:"item.permissions",fn:function({ item }){return [_c(VSelect_namespaceObject.VSelect,{staticClass:"input-selection",staticStyle:{"width":"120px"},attrs:{"value":_vm.actualPermissions(item),"items":_vm.permissionStates,"disabled":!_vm.isProjectOwner,"hide-details":"","label":"reader","single-line":""},on:{"input":(e) => _vm.valueChanged(item, e)}})]}},{key:"item.remove",fn:function({ item }){return [_c('div',{staticClass:"justify-center px-0"},[_c(VBtn_namespaceObject.VBtn,{attrs:{"disabled":!_vm.canRemoveUser(item.user.id),"icon":""},on:{"click":function($event){return _vm.removeUser(item.user)}}},[_c(VIcon_namespaceObject.VIcon,{attrs:{"color":"red darken-3"}},[_vm._v("delete")])],1)],1)]}}])}),_c('button',{ref:"hidden-input",staticStyle:{"visibility":"hidden"},attrs:{"id":"change-permissions-input"}})],2)
}
var ProjectPermissionsTemplatevue_type_template_id_31eec9b4_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/components/ProjectPermissionsTemplate.vue?vue&type=template&id=31eec9b4&scoped=true&

;// CONCATENATED MODULE: external "lodash/chunk"
var chunk_namespaceObject = require("lodash/chunk");
var chunk_default = /*#__PURE__*/__webpack_require__.n(chunk_namespaceObject);
;// CONCATENATED MODULE: external "lodash/sortBy"
var sortBy_namespaceObject = require("lodash/sortBy");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy_namespaceObject);
;// CONCATENATED MODULE: external "lodash/toLower"
var toLower_namespaceObject = require("lodash/toLower");
var toLower_default = /*#__PURE__*/__webpack_require__.n(toLower_namespaceObject);
;// CONCATENATED MODULE: external "lodash/union"
var union_namespaceObject = require("lodash/union");
var union_default = /*#__PURE__*/__webpack_require__.n(union_namespaceObject);
;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectPermissionsTemplate.vue?vue&type=script&lang=ts&
var ProjectPermissionsTemplatevue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ProjectPermissionsTemplatevue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ProjectPermissionsTemplatevue_type_script_lang_ts_assign.apply(this, arguments);
};
var ProjectPermissionsTemplatevue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var ProjectPermissionsTemplatevue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};











/* harmony default export */ var ProjectPermissionsTemplatevue_type_script_lang_ts_ = (external_vue_default().extend({
    props: {
        value: Object
    },
    data: function () {
        return {
            // search data
            isLoading: false,
            users: [],
            header: [
                {
                    text: 'User',
                    value: 'user',
                    align: 'left',
                    sortable: false
                },
                {
                    text: 'Permissions',
                    value: 'permissions',
                    width: 60,
                    align: 'left',
                    sortable: false,
                    tooltip: 'Has permission to change project settings'
                },
                {
                    text: 'Remove',
                    value: 'remove',
                    align: 'right',
                    sortable: false,
                    width: 60
                }
            ],
            originalValue: null
        };
    },
    computed: ProjectPermissionsTemplatevue_type_script_lang_ts_assign(ProjectPermissionsTemplatevue_type_script_lang_ts_assign(ProjectPermissionsTemplatevue_type_script_lang_ts_assign(ProjectPermissionsTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('userModule', ['loggedUser'])), (0,external_vuex_namespaceObject.mapState)('projectModule', ['currentNamespace', 'project'])), (0,external_vuex_namespaceObject.mapGetters)('projectModule', ['isProjectOwner'])), { permissionStates: function () {
            return ['owner', 'writer', 'reader'];
        }, displayedValues: function () {
            var _a = this.value, ownersnames = _a.ownersnames, readersnames = _a.readersnames, writersnames = _a.writersnames;
            var users = this.users.map(function (user) { return ({
                username: user.username,
                user: user,
                owner: ownersnames.includes(user.username),
                read: readersnames.includes(user.username),
                write: writersnames.includes(user.username)
            }); });
            return sortBy_default()(users, [
                function (u) {
                    return toLower_default()(u.username);
                }
            ]);
        } }),
    created: function () {
        this.originalValue = JSON.parse(JSON.stringify(this.value));
        // this is just temporary solution for ESLint: Unexpected mutation of &quot;value&quot; prop. (vue/no-mutating-props)
        this.clonedValue = JSON.parse(JSON.stringify(this.value));
    },
    watch: {
        value: {
            deep: true,
            handler: function () {
                // update local clonedValue if value is changed in parent
                this.clonedValue = JSON.parse(JSON.stringify(this.value));
                this.emit();
            }
        },
        users: {
            immediate: true,
            deep: true,
            handler: function (_access) {
                var _this = this;
                var _a = this.value, ownersnames = _a.ownersnames, readersnames = _a.readersnames, writersnames = _a.writersnames;
                var names = union_default()(ownersnames, readersnames, writersnames);
                // server returns only 5 entries from db for single call
                var chunks = chunk_default()(names, 5);
                Promise.all(chunks.map(function (item) { return ProjectPermissionsTemplatevue_type_script_lang_ts_awaiter(_this, void 0, void 0, function () {
                    var params;
                    var _this = this;
                    return ProjectPermissionsTemplatevue_type_script_lang_ts_generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                params = {
                                    namespace: this.currentNamespace,
                                    names: item.join(',')
                                };
                                return [4 /*yield*/, UserApi.getAuthUserSearch(params).then(function (resp) {
                                        resp.data
                                            .filter(function (i) { return !_this.users.map(function (u) { return u.username; }).includes(i.username); })
                                            .forEach(function (i) { return _this.users.push(i); });
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }));
            }
        }
    },
    methods: {
        canRemoveUser: function (userId) {
            // project owner can remove project, but project creator cannot be removed
            return (this.project.creator !== userId &&
                isAtLeastProjectRole(this.project.role, ProjectRole.owner));
        },
        valueChanged: function (user, permission) {
            var el = this.$refs['hidden-input'];
            el.value = permission;
            el.dispatchEvent(new Event('click', {}));
            if (permission === 'owner') {
                this.setOwnerPermission(user);
            }
            else if (permission === 'writer') {
                this.setWritePermission(user);
            }
            else if (permission === 'reader') {
                this.setReadPermission(user);
            }
        },
        actualPermissions: function (item) {
            if (this.project.access.owners.includes(item.user.id)) {
                return 'owner';
            }
            else if (this.project.access.writers.includes(item.user.id)) {
                return 'writer';
            }
            else if (this.project.access.readers.includes(item.user.id)) {
                return 'reader';
            }
            return '';
        },
        removeUser: function (user) {
            var _this = this;
            // remove user.username from owners, writers and readers
            var permissionNames = ['ownersnames', 'writersnames', 'readersnames'];
            permissionNames.forEach(function (key) {
                _this.clonedValue[key] = difference_default()(_this.clonedValue[key], [
                    user.username
                ]);
            });
            // emit change of value
            this.emit(this.clonedValue);
            this.users.splice(this.users.indexOf(user), 1);
        },
        setWritePermission: function (user) {
            this.clonedValue.ownersnames = difference_default()(this.clonedValue.ownersnames, [
                user.username
            ]);
            this.clonedValue.writersnames = union_default()(this.clonedValue.writersnames, [
                user.username
            ]);
            this.clonedValue.readersnames = union_default()(this.clonedValue.readersnames, [
                user.username
            ]);
            // emit change of value
            this.emit(this.clonedValue);
        },
        setOwnerPermission: function (user) {
            this.clonedValue.ownersnames = union_default()(this.clonedValue.ownersnames, [
                user.username
            ]);
            this.clonedValue.writersnames = union_default()(this.clonedValue.writersnames, [
                user.username
            ]);
            this.clonedValue.readersnames = union_default()(this.clonedValue.readersnames, [
                user.username
            ]);
            // emit change of value
            this.emit(this.clonedValue);
        },
        setReadPermission: function (user) {
            this.clonedValue.ownersnames = difference_default()(this.clonedValue.ownersnames, [
                user.username
            ]);
            this.clonedValue.writersnames = difference_default()(this.clonedValue.writersnames, [user.username]);
            this.clonedValue.readersnames = union_default()(this.clonedValue.readersnames, [
                user.username
            ]);
            // emit change of value
            this.emit(this.clonedValue);
        },
        emit: function (newValues) {
            if (newValues === void 0) { newValues = undefined; }
            var modifiedValues = pick_default()(newValues, [
                'ownersnames',
                'writersnames',
                'readersnames'
            ]);
            var current = ProjectPermissionsTemplatevue_type_script_lang_ts_assign(ProjectPermissionsTemplatevue_type_script_lang_ts_assign({}, pick_default()(this.value, [
                'ownersnames',
                'writersnames',
                'readersnames',
                'public'
            ])), modifiedValues);
            var original = pick_default()(this.originalValue, [
                'ownersnames',
                'writersnames',
                'readersnames',
                'public'
            ]);
            // check if there is actual change (e.g. after refresh from previous server response)
            if (isEqual_default()(original, current)) {
                return;
            }
            this.$emit('save-project', newValues);
            this.originalValue = JSON.parse(JSON.stringify(ProjectPermissionsTemplatevue_type_script_lang_ts_assign(ProjectPermissionsTemplatevue_type_script_lang_ts_assign({}, this.value), modifiedValues)));
        }
    }
}));

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectPermissionsTemplate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ProjectPermissionsTemplatevue_type_script_lang_ts_ = (ProjectPermissionsTemplatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectPermissionsTemplate.vue?vue&type=style&index=0&id=31eec9b4&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectPermissionsTemplate.vue?vue&type=style&index=0&id=31eec9b4&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectPermissionsTemplate.vue



;


/* normalize component */

var ProjectPermissionsTemplate_component = normalizeComponent(
  components_ProjectPermissionsTemplatevue_type_script_lang_ts_,
  ProjectPermissionsTemplatevue_type_template_id_31eec9b4_scoped_true_render,
  ProjectPermissionsTemplatevue_type_template_id_31eec9b4_scoped_true_staticRenderFns,
  false,
  null,
  "31eec9b4",
  null
  
)

/* harmony default export */ var ProjectPermissionsTemplate = (ProjectPermissionsTemplate_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VChipGroup"
var VChipGroup_namespaceObject = require("vuetify/lib/components/VChipGroup");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectShareDialog.vue?vue&type=template&id=dea9c32c&









var ProjectShareDialogvue_type_template_id_dea9c32c_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCard_namespaceObject.VCard,[_c(VCard_namespaceObject.VCardTitle,[_c('span',{staticClass:"text-h5 primary--text font-weight-bold"},[_vm._v("Share project "+_vm._s(_vm.project.name))])]),_c(VCard_namespaceObject.VCardText,[_c(VGrid_namespaceObject.VLayout,{attrs:{"mt-2":"","column":""}},[_c('h4',{staticClass:"primary--text"},[_vm._v(" "+_vm._s(_vm.readonly ? `Project ${_vm.project.name} will be shared with following people` : 'Share with')+" ")]),(_vm.readonly)?_c(VGrid_namespaceObject.VLayout,{attrs:{"mx-0":"","mb-2":"","row":"","align-center":""}},[_c(VChipGroup_namespaceObject.VChipGroup,{attrs:{"active-class":"primary--text","column":""}},_vm._l((_vm.addedUsers.slice(0, 5)),function(user){return _c('user-search-chip',{key:user.id,attrs:{"item":user}})}),1),(_vm.addedUsers && _vm.addedUsers.length > 5)?_c('h4',{staticClass:"primary--text"},[_vm._v(" and "+_vm._s(_vm.addedUsers.length - 5)+" more ... ")]):_vm._e()],1):_c(VGrid_namespaceObject.VLayout,{attrs:{"mb-10":"","column":""}},[_c('account-autocomplete',{attrs:{"inputUsers":_vm.addedUsers,"filterUsers":_vm.projectUsers,"allowInvite":_vm.allowInvite},on:{"update":_vm.onAutocompleteUpdate}}),(_vm.invitedEmails.length > 0)?_c('span',{staticClass:"mt-2"},[_vm._v("You will add new people to your workspace in the next step")]):_vm._e()],1)],1)],1),_c(VCard_namespaceObject.VCardActions,{staticClass:"flex-row flex flex-wrap"},[_c('permission-info'),_c(VGrid_namespaceObject.VSpacer),_c('div',{staticClass:"flex-row"},[_c(VBtn_namespaceObject.VBtn,{attrs:{"outlined":""},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.readonly ? 'Back' : 'Cancel'))]),_c(VBtn_namespaceObject.VBtn,{staticClass:"primary",attrs:{"id":"share-project-btn","disabled":_vm.isPending ||
          !_vm.addedUsers ||
          _vm.addedUsers.length === 0 ||
          !_vm.isProjectOwner},on:{"click":_vm.onShare}},[_vm._v(" "+_vm._s(_vm.invitedEmails.length === 0 || _vm.readonly ? 'Share' : 'Next')+" ")])],1)],1)],1)
}
var ProjectShareDialogvue_type_template_id_dea9c32c_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/components/ProjectShareDialog.vue?vue&type=template&id=dea9c32c&

;// CONCATENATED MODULE: external "lodash/omit"
var omit_namespaceObject = require("lodash/omit");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit_namespaceObject);
;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectShareDialog.vue?vue&type=script&lang=ts&
var ProjectShareDialogvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ProjectShareDialogvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ProjectShareDialogvue_type_script_lang_ts_assign.apply(this, arguments);
};
var ProjectShareDialogvue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var ProjectShareDialogvue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var ProjectShareDialogvue_type_script_lang_ts_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};







/* harmony default export */ var ProjectShareDialogvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'ProjectShareDialog',
    components: { PermissionInfo: PermissionInfo, UserSearchChip: UserSearchChip, AccountAutocomplete: AccountAutocomplete },
    props: {
        allowInvite: Boolean,
        inputUsers: Array,
        readonly: Boolean,
        name: String
    },
    data: function () {
        return {
            addedUsers: [],
            isPending: false
        };
    },
    computed: ProjectShareDialogvue_type_script_lang_ts_assign(ProjectShareDialogvue_type_script_lang_ts_assign(ProjectShareDialogvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('projectModule', ['currentNamespace', 'project'])), (0,external_vuex_namespaceObject.mapGetters)('projectModule', ['isProjectOwner'])), { projectAccess: function () {
            var _a;
            return (_a = this.project) === null || _a === void 0 ? void 0 : _a.access;
        }, projectUsers: function () {
            return ProjectShareDialogvue_type_script_lang_ts_spreadArray(ProjectShareDialogvue_type_script_lang_ts_spreadArray(ProjectShareDialogvue_type_script_lang_ts_spreadArray([], this.projectAccess.readersnames, true), this.projectAccess.writersnames, true), this.projectAccess.ownersnames, true);
        }, invitedEmails: function () {
            return this.addedUsers
                ? this.addedUsers.filter(function (addedUserItem) { return addedUserItem.isInvite; })
                : [];
        } }),
    created: function () {
        var _a;
        this.addedUsers = (_a = this.inputUsers) !== null && _a !== void 0 ? _a : [];
    },
    methods: ProjectShareDialogvue_type_script_lang_ts_assign(ProjectShareDialogvue_type_script_lang_ts_assign(ProjectShareDialogvue_type_script_lang_ts_assign(ProjectShareDialogvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('dialogModule', ['close'])), (0,external_vuex_namespaceObject.mapActions)('projectModule', ['saveProjectSettings'])), (0,external_vuex_namespaceObject.mapActions)('notificationModule', ['error'])), { onAutocompleteUpdate: function (event) {
            this.addedUsers = event;
        }, getNewProjectAccess: function () {
            var addedUsers = this.addedUsers
                .filter(function (addedUserItem) { return !addedUserItem.isInvite; })
                .map(function (addedUserItem) { return omit_default()(addedUserItem, ['isInvite']); });
            var addedUserNames = addedUsers.map(function (addedUser) { return addedUser.username; });
            return {
                access: ProjectShareDialogvue_type_script_lang_ts_assign(ProjectShareDialogvue_type_script_lang_ts_assign({}, this.projectAccess), { readersnames: this.projectAccess.readersnames.concat(addedUserNames) })
            };
        }, hasAccessChanged: function (newAccess, oldAccess) {
            return !isEqual_default()(oldAccess.readersnames, newAccess.readersnames);
        }, onShare: function () {
            var _a;
            return ProjectShareDialogvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                var newProjectAccess, newProjectAccess, err_1;
                return ProjectShareDialogvue_type_script_lang_ts_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(this.addedUsers && this.addedUsers.length > 0)) return [3 /*break*/, 6];
                            if (!(this.allowInvite && this.invitedEmails.length > 0)) return [3 /*break*/, 1];
                            if (this.readonly) {
                                newProjectAccess = this.getNewProjectAccess();
                                this.$emit('on-share', newProjectAccess, this.hasAccessChanged(newProjectAccess.access, this.projectAccess));
                            }
                            else {
                                this.$emit('on-invite', this.invitedEmails.map(function (item) { return item.email; }), this.addedUsers);
                            }
                            this.isPending = true;
                            return [3 /*break*/, 6];
                        case 1:
                            newProjectAccess = this.getNewProjectAccess();
                            if (!this.hasAccessChanged(newProjectAccess.access, this.projectAccess)) return [3 /*break*/, 5];
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 5]);
                            // save only if access has changed
                            return [4 /*yield*/, this.saveProjectSettings({
                                    namespace: this.currentNamespace,
                                    newSettings: newProjectAccess,
                                    projectName: this.project.name
                                })];
                        case 3:
                            // save only if access has changed
                            _b.sent();
                            this.close();
                            return [3 /*break*/, 5];
                        case 4:
                            err_1 = _b.sent();
                            this.error({
                                text: ((_a = err_1.response.data) === null || _a === void 0 ? void 0 : _a.detail) || 'Failed to save project settings'
                            });
                            return [3 /*break*/, 5];
                        case 5:
                            this.addedUsers = [];
                            _b.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            });
        }, closeDialog: function () {
            if (this.readonly) {
                this.$emit('cancel', this.invitedEmails.map(function (item) { return item.email; }), this.addedUsers);
            }
            else {
                this.close();
            }
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectShareDialog.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ProjectShareDialogvue_type_script_lang_ts_ = (ProjectShareDialogvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/project/components/ProjectShareDialog.vue





/* normalize component */
;
var ProjectShareDialog_component = normalizeComponent(
  components_ProjectShareDialogvue_type_script_lang_ts_,
  ProjectShareDialogvue_type_template_id_dea9c32c_render,
  ProjectShareDialogvue_type_template_id_dea9c32c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProjectShareDialog = (ProjectShareDialog_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectShareButton.vue?vue&type=template&id=e8793c3e&scoped=true&
var ProjectShareButtonvue_type_template_id_e8793c3e_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.canShareProject)?_c('project-share-button-template'):_vm._e()
}
var ProjectShareButtonvue_type_template_id_e8793c3e_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectShareButtonTemplate.vue?vue&type=template&id=596f1e5a&scoped=true&
var ProjectShareButtonTemplatevue_type_template_id_596f1e5a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loggedUser)?_c('action-button',{attrs:{"disabled":false},on:{"click":_vm.onShareProject},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('plus-icon')]},proxy:true}],null,false,348396351)},[_vm._v(" Share ")]):_vm._e()
}
var ProjectShareButtonTemplatevue_type_template_id_596f1e5a_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectShareButtonTemplate.vue?vue&type=script&lang=ts&
var ProjectShareButtonTemplatevue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ProjectShareButtonTemplatevue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ProjectShareButtonTemplatevue_type_script_lang_ts_assign.apply(this, arguments);
};





/* harmony default export */ var ProjectShareButtonTemplatevue_type_script_lang_ts_ = (external_vue_default().extend({
    props: {
        allowInvite: Boolean
    },
    components: { ActionButton: ActionButton, PlusIcon: external_vue_tabler_icons_namespaceObject.PlusIcon },
    computed: ProjectShareButtonTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('userModule', ['loggedUser'])),
    methods: ProjectShareButtonTemplatevue_type_script_lang_ts_assign(ProjectShareButtonTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('dialogModule', ['show'])), { onShareProject: function () {
            var dialogProps = { allowInvite: this.allowInvite };
            var listeners = ProjectShareButtonTemplatevue_type_script_lang_ts_assign({}, (this.$listeners['on-invite']
                ? { 'on-invite': this.$listeners['on-invite'] }
                : {}));
            var dialog = {
                maxWidth: 600,
                persistent: true
            };
            this.show({
                component: ProjectShareDialog,
                params: {
                    props: dialogProps,
                    listeners: listeners,
                    dialog: dialog
                }
            });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectShareButtonTemplate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ProjectShareButtonTemplatevue_type_script_lang_ts_ = (ProjectShareButtonTemplatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/project/components/ProjectShareButtonTemplate.vue





/* normalize component */
;
var ProjectShareButtonTemplate_component = normalizeComponent(
  components_ProjectShareButtonTemplatevue_type_script_lang_ts_,
  ProjectShareButtonTemplatevue_type_template_id_596f1e5a_scoped_true_render,
  ProjectShareButtonTemplatevue_type_template_id_596f1e5a_scoped_true_staticRenderFns,
  false,
  null,
  "596f1e5a",
  null
  
)

/* harmony default export */ var ProjectShareButtonTemplate = (ProjectShareButtonTemplate_component.exports);
;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectShareButton.vue?vue&type=script&lang=ts&
var ProjectShareButtonvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ProjectShareButtonvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ProjectShareButtonvue_type_script_lang_ts_assign.apply(this, arguments);
};



/* harmony default export */ var ProjectShareButtonvue_type_script_lang_ts_ = (external_vue_default().extend({
    components: { ProjectShareButtonTemplate: ProjectShareButtonTemplate },
    computed: ProjectShareButtonvue_type_script_lang_ts_assign(ProjectShareButtonvue_type_script_lang_ts_assign(ProjectShareButtonvue_type_script_lang_ts_assign(ProjectShareButtonvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapGetters)('userModule', ['currentWorkspace'])), (0,external_vuex_namespaceObject.mapState)('projectModule', ['project'])), (0,external_vuex_namespaceObject.mapGetters)('projectModule', ['isProjectOwner'])), { canShareProject: function () {
            var _a, _b;
            return (((_a = this.project) === null || _a === void 0 ? void 0 : _a.workspace_id) === ((_b = this.currentWorkspace) === null || _b === void 0 ? void 0 : _b.id) &&
                this.isProjectOwner);
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectShareButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ProjectShareButtonvue_type_script_lang_ts_ = (ProjectShareButtonvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/project/components/ProjectShareButton.vue





/* normalize component */
;
var ProjectShareButton_component = normalizeComponent(
  components_ProjectShareButtonvue_type_script_lang_ts_,
  ProjectShareButtonvue_type_template_id_e8793c3e_scoped_true_render,
  ProjectShareButtonvue_type_template_id_e8793c3e_scoped_true_staticRenderFns,
  false,
  null,
  "e8793c3e",
  null
  
)

/* harmony default export */ var ProjectShareButton = (ProjectShareButton_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VBtnToggle"
var VBtnToggle_namespaceObject = require("vuetify/lib/components/VBtnToggle");
;// CONCATENATED MODULE: external "vuetify/lib/components/VDataIterator"
var VDataIterator_namespaceObject = require("vuetify/lib/components/VDataIterator");
;// CONCATENATED MODULE: external "vuetify/lib/components/VDivider"
var VDivider_namespaceObject = require("vuetify/lib/components/VDivider");
;// CONCATENATED MODULE: external "vuetify/lib/components/VPagination"
var VPagination_namespaceObject = require("vuetify/lib/components/VPagination");
;// CONCATENATED MODULE: external "vuetify/lib/components/VToolbar"
var VToolbar_namespaceObject = require("vuetify/lib/components/VToolbar");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectsTable.vue?vue&type=template&id=08b7b811&scoped=true&


















var ProjectsTablevue_type_template_id_08b7b811_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(VDataIterator_namespaceObject.VDataIterator,{staticStyle:{"background-color":"#ffffff"},attrs:{"options":_vm.options,"items":_vm.projects,"server-items-length":_vm.numberOfItems,"item-key":"updated","loading":_vm.loading,"hide-default-footer":true,"flat":"","no-data-text":"No projects found"},on:{"update:options":_vm.paginating},scopedSlots:_vm._u([{key:"header",fn:function(){return [(_vm.showHeader)?_c(VToolbar_namespaceObject.VToolbar,{staticClass:"mb-1",attrs:{"color":"","flat":""}},[_c(VTextField_namespaceObject.VTextField,{staticStyle:{"margin-right":"8px"},attrs:{"clearable":"","flat":"","hide-details":"","prepend-inner-icon":"mdi-magnify","label":"Search projects","data-cy":"project-table-search-bar"},on:{"input":_vm.filterData},model:{value:(_vm.searchFilterByProjectName),callback:function ($$v) {_vm.searchFilterByProjectName=$$v},expression:"searchFilterByProjectName"}}),(_vm.$vuetify.breakpoint.smAndUp)?[_c(VSelect_namespaceObject.VSelect,{attrs:{"flat":"","hide-details":"","items":_vm.selectKeys,"prepend-inner-icon":"sort_by_alpha","data-cy":"project-table-sort-type"},on:{"change":function($event){return _vm.paginating(_vm.options)}},model:{value:(_vm.options.sortBy[0]),callback:function ($$v) {_vm.$set(_vm.options.sortBy, 0, $$v)},expression:"options.sortBy[0]"}}),_c(VGrid_namespaceObject.VSpacer),_c(VBtnToggle_namespaceObject.VBtnToggle,{attrs:{"mandatory":""},on:{"change":function($event){return _vm.paginating(_vm.options)}},model:{value:(_vm.options.sortDesc[0]),callback:function ($$v) {_vm.$set(_vm.options.sortDesc, 0, $$v)},expression:"options.sortDesc[0]"}},[_c(VBtn_namespaceObject.VBtn,{attrs:{"large":"","depressed":"","color":"#ffffff","value":false,"data-cy":"project-table-sort-btn-up"}},[_c(VIcon_namespaceObject.VIcon,[_vm._v("mdi-arrow-up")])],1),_c(VBtn_namespaceObject.VBtn,{attrs:{"large":"","depressed":"","color":"#ffffff","value":true,"data-cy":"project-table-sort-btn-down"}},[_c(VIcon_namespaceObject.VIcon,[_vm._v("mdi-arrow-down")])],1)],1)]:_vm._e()],2):_vm._e()]},proxy:true},{key:"item",fn:function({ item }){return [_c(VCard_namespaceObject.VCard,{staticClass:"mx-auto",attrs:{"outlined":false,"data-cy":"project-table-card","flat":""}},[_c(VList_namespaceObject.VListItem,{attrs:{"three-line":""}},[_c(VList_namespaceObject.VListItemContent,[_c(VList_namespaceObject.VListItemTitle,{staticClass:"text-h5 mb-1"},[_c('router-link',{attrs:{"to":{
                  name: 'project',
                  params: {
                    namespace: item.namespace,
                    projectName: item.name
                  }
                }}},[_c('b',[(_vm.showNamespace)?_c('span',[_vm._v(_vm._s(item.namespace)+" /")]):_vm._e(),_vm._v(" "+_vm._s(item.name))])]),(item.access.public && !_vm.onlyPublic)?_c(VChip_namespaceObject.VChip,{staticStyle:{"margin-left":"8px"},attrs:{"elevation":"0","outlined":"","color":"primary"}},[_vm._v(" Public ")]):_vm._e()],1),_c(VList_namespaceObject.VListItemSubtitle,[_vm._v(_vm._s(item.description)+" ")]),_c('div',{staticStyle:{"font-size":"smaller"}},[_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({staticStyle:{"margin-right":"20px"},attrs:{"data-cy":"project-form-collaborators"}},on),[_c(VIcon_namespaceObject.VIcon,{staticClass:"icon",attrs:{"size":"20"}},[_vm._v("share")]),_vm._v(_vm._s(item.access.readers.length))],1)]}}],null,true)},[_c('span',[_vm._v("collaborators")])]),(item.version)?_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({staticStyle:{"margin-right":"20px"},attrs:{"data-cy":"project-form-history"}},on),[_c('router-link',{attrs:{"to":{
                        name: 'project-versions',
                        params: {
                          namespace: item.namespace,
                          projectName: item.name
                        }
                      }}},[_c('span',{staticStyle:{"font-size":"smaller"}},[_c(VIcon_namespaceObject.VIcon,{staticClass:"icon",attrs:{"size":"20"}},[_vm._v("history")]),_vm._v(_vm._s(item.version.substr(1)))],1)])],1)]}}],null,true)},[_c('span',[_vm._v("versions")])]):_vm._e(),_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({staticStyle:{"margin-right":"20px"},attrs:{"data-cy":"project-form-project-size"}},on),[_c(VIcon_namespaceObject.VIcon,{staticClass:"icon",attrs:{"size":"20"}},[_vm._v("folder")]),_vm._v(_vm._s(_vm._f("filesize")(item.disk_usage,'MB', 1)))],1)]}}],null,true)},[_c('span',[_vm._v("project size")])]),_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({staticStyle:{"margin-right":"20px"},attrs:{"data-cy":"project-form-updated"}},on),[_vm._v("Updated "+_vm._s(_vm._f("timediff")(item.updated)))])]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm._f("datetime")(item.updated)))])]),_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [(!item.tags.includes('valid_qgis'))?_c('span',_vm._g({staticStyle:{"margin-right":"20px"},attrs:{"data-cy":"project-form-missing-project"}},on),[_c(VIcon_namespaceObject.VIcon,{attrs:{"color":"#fb8c0087","size":"20"}},[_vm._v("warning")])],1):_vm._e()]}}],null,true)},[_c('span',[_vm._v("Missing QGIS project file")])]),_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [(item.has_conflict)?_c('span',_vm._g({staticStyle:{"margin-right":"20px"},attrs:{"data-cy":"project-form-conflict-file"}},on),[_c(VIcon_namespaceObject.VIcon,{attrs:{"color":"#fb8c0087","size":"20"}},[_vm._v("error")])],1):_vm._e()]}}],null,true)},[_c('span',[_vm._v("There is conflict file in project")])])],1)],1)],1),_c(VDivider_namespaceObject.VDivider,{staticStyle:{"color":"black"}})],1)]}},{key:"footer",fn:function({ options }){return [_c('div',{staticClass:"text-center"},[(_vm.showFooter && _vm.numberOfItems > options.itemsPerPage)?_c(VPagination_namespaceObject.VPagination,{attrs:{"length":Math.ceil(_vm.numberOfItems / options.itemsPerPage),"total-visible":7,"circle":"","color":"primary"},on:{"input":_vm.fetchPage},model:{value:(options.page),callback:function ($$v) {_vm.$set(options, "page", $$v)},expression:"options.page"}}):_vm._e()],1)]}}])})],1)
}
var ProjectsTablevue_type_template_id_08b7b811_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/components/ProjectsTable.vue?vue&type=template&id=08b7b811&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectsTable.vue?vue&type=script&lang=ts&



/* harmony default export */ var ProjectsTablevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'projects-table',
    props: {
        showNamespace: {
            type: Boolean,
            default: false
        },
        namespace: String,
        onlyPublic: {
            type: Boolean,
            default: true
        },
        sortable: {
            type: Boolean,
            default: true
        },
        showHeader: {
            type: Boolean,
            default: true
        },
        showFooter: {
            type: Boolean,
            default: true
        },
        initialOptions: {
            type: Object,
            default: function () { return ({
                sortBy: ['updated'],
                sortDesc: [true],
                itemsPerPage: 25,
                page: 1
            }); }
        },
        numberOfItems: {
            type: Number,
            default: 0
        },
        projects: Array
    },
    data: function () {
        return {
            options: Object.assign({}, this.initialOptions),
            searchFilterByProjectName: '',
            searchFilterByNamespace: '',
            searchFilterByDay: '',
            loading: false,
            keys: ['name', 'updated', 'disk_usage'],
            sortBy: ''
        };
    },
    computed: {
        header: function () {
            var header = [];
            if (this.showNamespace) {
                header.push({
                    text: 'Owner',
                    value: 'namespace',
                    sortable: this.sortable
                });
            }
            header = header.concat({ text: 'Name', value: 'name', sortable: this.sortable }, { text: '', width: 90, sortable: false }, { text: 'Last Update', value: 'updated', sortable: this.sortable }, { text: 'Size', value: 'meta.size', sortable: this.sortable });
            return header;
        },
        selectKeys: function () {
            return this.keys.map(function (i) {
                return { text: formatToTitle(i), value: i };
            });
        }
    },
    watch: {
        $route: {
            immediate: false,
            handler: 'changedRoute'
        }
    },
    created: function () {
        this.filterData = debounce_default()(this.filterData, 3000);
    },
    methods: {
        paginating: function (options) {
            this.options = options;
            this.fetchProjects();
        },
        fetchPage: function (number) {
            this.options.page = number;
            this.fetchProjects();
        },
        changedRoute: function () {
            this.options.page = 1;
            this.fetchProjects();
        },
        fetchProjects: function () {
            var _this = this;
            this.loading = true;
            this.$emit('fetch-projects', {
                searchFilterByProjectName: this.searchFilterByProjectName,
                searchFilterByNamespace: this.searchFilterByNamespace,
                namespace: this.namespace,
                searchFilterByDay: this.searchFilterByDay
            }, this.options, function () {
                _this.loading = false;
            });
        },
        changeSort: function (column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            }
            else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
        },
        filterData: function () {
            this.options.page = 1;
            this.fetchProjects();
        }
    }
}));

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectsTable.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ProjectsTablevue_type_script_lang_ts_ = (ProjectsTablevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectsTable.vue?vue&type=style&index=0&id=08b7b811&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectsTable.vue?vue&type=style&index=0&id=08b7b811&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectsTable.vue



;


/* normalize component */

var ProjectsTable_component = normalizeComponent(
  components_ProjectsTablevue_type_script_lang_ts_,
  ProjectsTablevue_type_template_id_08b7b811_scoped_true_render,
  ProjectsTablevue_type_template_id_08b7b811_scoped_true_staticRenderFns,
  false,
  null,
  "08b7b811",
  null
  
)

/* harmony default export */ var ProjectsTable = (ProjectsTable_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectsTableDataLoader.vue?vue&type=template&id=7fe398b9&
var ProjectsTableDataLoadervue_type_template_id_7fe398b9_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('projects-table',_vm._b({attrs:{"projects":_vm.projects,"numberOfItems":_vm.numberOfItems,"onlyPublic":_vm.onlyPublic},on:{"fetch-projects":_vm.fetchProjects}},'projects-table',_vm.$props,false))
}
var ProjectsTableDataLoadervue_type_template_id_7fe398b9_staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/ProjectsTableDataLoader.vue?vue&type=script&lang=ts&
var ProjectsTableDataLoadervue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ProjectsTableDataLoadervue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ProjectsTableDataLoadervue_type_script_lang_ts_assign.apply(this, arguments);
};
var ProjectsTableDataLoadervue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var ProjectsTableDataLoadervue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



/* harmony default export */ var ProjectsTableDataLoadervue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'projects-table-data-loader',
    components: { ProjectsTable: ProjectsTable },
    props: {
        showNamespace: Boolean,
        onlyPublic: {
            type: Boolean,
            default: false
        },
        namespace: String,
        sortable: {
            type: Boolean,
            default: true
        },
        asAdmin: {
            type: Boolean,
            default: false
        },
        public: {
            type: Boolean,
            default: true
        },
        showHeader: {
            type: Boolean,
            default: true
        },
        showFooter: {
            type: Boolean,
            default: true
        },
        initialOptions: {
            type: Object,
            default: function () { return ({
                sortBy: ['updated'],
                sortDesc: [true],
                itemsPerPage: 25,
                page: 1
            }); }
        }
    },
    data: function () {
        return {
            numberOfItems: 0,
            projects: []
        };
    },
    methods: ProjectsTableDataLoadervue_type_script_lang_ts_assign(ProjectsTableDataLoadervue_type_script_lang_ts_assign(ProjectsTableDataLoadervue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('projectModule', ['getProjects'])), (0,external_vuex_namespaceObject.mapActions)('notificationModule', ['error'])), { fetchProjects: function (projectGridState, gridOptions, onFinish) {
            var _a, _b;
            return ProjectsTableDataLoadervue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                var params, orderParam, response, _c;
                return ProjectsTableDataLoadervue_type_script_lang_ts_generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            params = {};
                            if (this.$route.name === 'shared_projects' ||
                                this.$route.name === 'my_projects') {
                                params.flag = this.$route.meta.flag;
                            }
                            params.page = gridOptions.page;
                            params.per_page = gridOptions.itemsPerPage;
                            if (gridOptions.sortBy[0]) {
                                orderParam = '';
                                if (gridOptions.sortBy[0] === 'meta.size') {
                                    orderParam = 'disk_usage';
                                }
                                else {
                                    orderParam =
                                        gridOptions.sortBy[0] === 'owner'
                                            ? 'namespace'
                                            : gridOptions.sortBy[0];
                                }
                                params.order_params =
                                    orderParam + (gridOptions.sortDesc[0] ? '_desc' : '_asc');
                            }
                            if (projectGridState.searchFilterByProjectName) {
                                params.name = projectGridState.searchFilterByProjectName.trim();
                            }
                            if (projectGridState.searchFilterByNamespace) {
                                params.namespace = projectGridState.searchFilterByNamespace.trim();
                            }
                            if (projectGridState.namespace) {
                                params.only_namespace = projectGridState.namespace;
                            }
                            if (this.asAdmin) {
                                params.as_admin = true;
                            }
                            if (!this.public) {
                                params.public = false;
                            }
                            if (this.onlyPublic) {
                                params.only_public = true;
                            }
                            if (projectGridState.searchFilterByDay &&
                                projectGridState.searchFilterByDay >= 0) {
                                params.last_updated_in = projectGridState.searchFilterByDay;
                            }
                            _d.label = 1;
                        case 1:
                            _d.trys.push([1, 3, , 5]);
                            return [4 /*yield*/, this.getProjects({ params: params })];
                        case 2:
                            response = _d.sent();
                            this.projects = (_a = response.data) === null || _a === void 0 ? void 0 : _a.projects;
                            this.numberOfItems = (_b = response.data) === null || _b === void 0 ? void 0 : _b.count;
                            if (onFinish) {
                                onFinish();
                            }
                            return [3 /*break*/, 5];
                        case 3:
                            _c = _d.sent();
                            if (onFinish) {
                                onFinish();
                            }
                            return [4 /*yield*/, this.error({ text: 'Failed to fetch list of projects' })];
                        case 4:
                            _d.sent();
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/components/ProjectsTableDataLoader.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ProjectsTableDataLoadervue_type_script_lang_ts_ = (ProjectsTableDataLoadervue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/project/components/ProjectsTableDataLoader.vue





/* normalize component */
;
var ProjectsTableDataLoader_component = normalizeComponent(
  components_ProjectsTableDataLoadervue_type_script_lang_ts_,
  ProjectsTableDataLoadervue_type_template_id_7fe398b9_render,
  ProjectsTableDataLoadervue_type_template_id_7fe398b9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProjectsTableDataLoader = (ProjectsTableDataLoader_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/UploadPanel.vue?vue&type=template&id=e82169fe&scoped=true&











var UploadPanelvue_type_template_id_e82169fe_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCard_namespaceObject.VCard,[_c(VToolbar_namespaceObject.VToolbar,{attrs:{"dense":"","text":"","dark":"","color":"primary"}},[_c(VToolbar_namespaceObject.VToolbarTitle,[_vm._v("Data Sync")]),_c(VGrid_namespaceObject.VSpacer),_c(VBtn_namespaceObject.VBtn,{attrs:{"icon":""},on:{"click":_vm.resetUpload}},[_c(VIcon_namespaceObject.VIcon,[_vm._v("close")])],1)],1),(_vm.upload.diff && _vm.upload.diff.changes)?_c(VCard_namespaceObject.VCardText,[_c(VGrid_namespaceObject.VLayout,{staticClass:"stats-line"},[_c('label',[_vm._v("Removed files:")]),_c(VGrid_namespaceObject.VSpacer),_c('span',{staticClass:"red--text"},[_vm._v(_vm._s(_vm.upload.diff.removed.length))]),_c(VIcon_namespaceObject.VIcon,{attrs:{"small":"","color":"red"}},[_vm._v("delete")])],1),_c(VGrid_namespaceObject.VLayout,{staticClass:"stats-line"},[_c('label',[_vm._v("Added files:")]),_c(VGrid_namespaceObject.VSpacer),_c('span',{staticClass:"green--text"},[_vm._v(_vm._s(_vm.upload.diff.added.length))]),_c(VIcon_namespaceObject.VIcon,{attrs:{"small":"","color":"green"}},[_vm._v("add_circle")])],1),_c(VGrid_namespaceObject.VLayout,{staticClass:"stats-line"},[_c('label',[_vm._v("Modified files:")]),_c(VGrid_namespaceObject.VSpacer),_c('span',{staticClass:"orange--text"},[_vm._v(_vm._s(_vm.upload.diff.updated.length))]),_c(VIcon_namespaceObject.VIcon,{attrs:{"small":"","color":"orange"}},[_vm._v("edit")])],1),_c(VGrid_namespaceObject.VLayout,{staticClass:"stats-line"},[_c('label',[_vm._v("Upload data size:")]),_c(VGrid_namespaceObject.VSpacer),_c('span',[_vm._v(_vm._s(_vm._f("filesize")(_vm.uploadSize)))])],1)],1):(_vm.upload.diff)?_c(VCard_namespaceObject.VCardText,[_vm._v(" All files are up to date! ")]):_vm._e(),(_vm.remainingAnalyzingFiles)?_c(VCard_namespaceObject.VCardText,[_c(VGrid_namespaceObject.VLayout,{attrs:{"row":""}},[_c(VProgressCircular_namespaceObject.VProgressCircular,{attrs:{"size":30,"width":3,"color":"primary","indeterminate":""}}),_c(VGrid_namespaceObject.VSpacer),_c('span',{staticStyle:{"padding-right":"30px"}},[_vm._v("Remaining files: "+_vm._s(_vm.remainingAnalyzingFiles))])],1)],1):_vm._e(),(_vm.upload.diff && _vm.upload.diff.changes)?_c(VCard_namespaceObject.VCardActions,[_c(VGrid_namespaceObject.VSpacer),_c('action-button',{attrs:{"id":"update-files-btn","disabled":_vm.upload.running || _vm.remainingAnalyzingFiles > 0},on:{"click":_vm.confirmUpload},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('cloud-upload-icon')]},proxy:true}],null,false,1039603066)},[_vm._v(" Update ")]),_c(VGrid_namespaceObject.VSpacer)],1):_vm._e()],1)
}
var UploadPanelvue_type_template_id_e82169fe_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/components/UploadPanel.vue?vue&type=template&id=e82169fe&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/UploadPanel.vue?vue&type=script&lang=ts&
var UploadPanelvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    UploadPanelvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return UploadPanelvue_type_script_lang_ts_assign.apply(this, arguments);
};
var UploadPanelvue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var UploadPanelvue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







/* harmony default export */ var UploadPanelvue_type_script_lang_ts_ = (external_vue_default().extend({
    data: function () {
        return {
            source: null
        };
    },
    props: {
        namespace: String
    },
    components: {
        ActionButton: ActionButton,
        CloudUploadIcon: external_vue_tabler_icons_namespaceObject.CloudUploadIcon
    },
    computed: UploadPanelvue_type_script_lang_ts_assign(UploadPanelvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('projectModule', ['project', 'uploads'])), { upload: function () {
            return this.uploads[this.project.path];
        }, uploadSize: function () {
            var _this = this;
            if (this.upload) {
                var _a = this.upload.diff, added = _a.added, updated = _a.updated;
                return added.concat(updated).reduce(function (sum, path) {
                    return sum + _this.upload.files[path].size;
                }, 0);
            }
            return 0;
        }, remainingAnalyzingFiles: function () {
            var list = (this.upload && this.upload.analysingFiles) || [];
            return list.length;
        } }),
    methods: UploadPanelvue_type_script_lang_ts_assign(UploadPanelvue_type_script_lang_ts_assign(UploadPanelvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapMutations)('projectModule', [
        'setProject',
        'discardUpload',
        'startUpload'
    ])), (0,external_vuex_namespaceObject.mapActions)('projectModule', [
        'pushProjectChanges',
        'pushProjectChunks',
        'pushFinishTransaction',
        'pushCancelTransaction'
    ])), { resetUpload: function () {
            this.discardUpload({ projectPath: this.project.path });
            if (this.source) {
                this.source.cancel('Operation canceled by the user.');
                delete this.source;
            }
        }, uploadChanges: function () {
            return UploadPanelvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                var _a, added, removed, updated, fileInfoFields, changes, projectPath, version, resp, transaction, promises;
                var _this = this;
                return UploadPanelvue_type_script_lang_ts_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = this.upload.diff, added = _a.added, removed = _a.removed, updated = _a.updated;
                            fileInfoFields = ['path', 'checksum', 'size', 'mtime', 'chunks'];
                            changes = {
                                removed: removed.map(function (path) {
                                    return pick_default()(_this.project.files[path], fileInfoFields);
                                }),
                                added: added.map(function (path) {
                                    return pick_default()(_this.upload.files[path], fileInfoFields);
                                }),
                                updated: updated.map(function (path) {
                                    return pick_default()(_this.upload.files[path], fileInfoFields);
                                })
                            };
                            projectPath = this.project.path;
                            version = this.project.version || 'v0';
                            return [4 /*yield*/, this.pushProjectChanges({
                                    data: { version: version, changes: changes },
                                    projectPath: projectPath
                                })];
                        case 1:
                            resp = _b.sent();
                            transaction = resp.data.transaction;
                            if (!!transaction) return [3 /*break*/, 3];
                            this.discardUpload({ projectPath: projectPath });
                            return [4 /*yield*/, this.$store.dispatch('notificationModule/show', {
                                    text: 'Project updated'
                                })];
                        case 2:
                            _b.sent();
                            this.setProject({ project: resp.data });
                            return [2 /*return*/];
                        case 3:
                            this.source = external_axios_default().CancelToken.source();
                            promises = [];
                            added.concat(updated).forEach(function (path) {
                                _this.upload.files[path].chunks.forEach(function (chunk, index) {
                                    var file = _this.upload.files[path].file;
                                    var offset = index * CHUNK_SIZE;
                                    var data = file.slice(offset, offset + CHUNK_SIZE);
                                    var p = new Promise(function (resolve) {
                                        var pc = _this.pushProjectChunks({
                                            chunk: chunk,
                                            data: data,
                                            projectPath: projectPath,
                                            transaction: transaction,
                                            token: _this.source.token
                                        });
                                        resolve(pc);
                                    });
                                    promises.push(p);
                                });
                            });
                            // fire up chunks uploads
                            this.startUpload();
                            Promise.all(promises)
                                .then(function () {
                                // call server to finish upload transaction
                                _this.pushFinishTransaction({
                                    projectPath: projectPath,
                                    token: _this.source.token,
                                    transaction: transaction
                                });
                            })
                                .catch(function (err) {
                                _this.pushCancelTransaction({
                                    err: err,
                                    transaction: transaction
                                });
                            });
                            return [2 /*return*/];
                    }
                });
            });
        }, confirmUpload: function () {
            var _this = this;
            var props = {
                text: 'Changes from other users <strong> may get lost </strong> when uploading data from browser. It is highly recommended to use Mergin Maps QGIS plugin instead. <br> <br> Are you really sure you want to continue?',
                confirmText: 'Update'
            };
            var listeners = {
                confirm: function () { return _this.uploadChanges(); }
            };
            if (this.upload.diff.updated.filter(function (i) { return isVersionedFile(i); }).length) {
                this.$store.dispatch('dialogModule/prompt', {
                    params: { props: props, listeners: listeners, dialog: { maxWidth: 500 } }
                });
            }
            else {
                this.uploadChanges();
            }
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/components/UploadPanel.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_UploadPanelvue_type_script_lang_ts_ = (UploadPanelvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/components/UploadPanel.vue?vue&type=style&index=0&id=e82169fe&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/components/UploadPanel.vue?vue&type=style&index=0&id=e82169fe&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/components/UploadPanel.vue



;


/* normalize component */

var UploadPanel_component = normalizeComponent(
  components_UploadPanelvue_type_script_lang_ts_,
  UploadPanelvue_type_template_id_e82169fe_scoped_true_render,
  UploadPanelvue_type_template_id_e82169fe_scoped_true_staticRenderFns,
  false,
  null,
  "e82169fe",
  null
  
)

/* harmony default export */ var UploadPanel = (UploadPanel_component.exports);
;// CONCATENATED MODULE: ./src/modules/project/components/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial





















;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/FileBrowserView.vue?vue&type=template&id=b244fbbe&scoped=true&











var FileBrowserViewvue_type_template_id_b244fbbe_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(VGrid_namespaceObject.VLayout,{staticClass:"column"},[_c(VGrid_namespaceObject.VRow,[_c(VGrid_namespaceObject.VCol,{staticClass:"pa-0"},[(_vm.searchFilter !== '' || _vm.items.length > 0)?_c(VTextField_namespaceObject.VTextField,{staticClass:"search",staticStyle:{"padding-left":"7px","padding-bottom":"10px"},attrs:{"placeholder":"Find file","append-icon":"search","hide-details":""},model:{value:(_vm.searchFilter),callback:function ($$v) {_vm.searchFilter=$$v},expression:"searchFilter"}}):_vm._e()],1)],1),(
        _vm.searchFilter !== '' ||
        _vm.items.length ||
        (_vm.project && !_vm.project.permissions.upload) ||
        _vm.filter !== ''
      )?_c(VDataTable_namespaceObject.VDataTable,{staticClass:"file-table",attrs:{"headers":_vm.header,"items":_vm.items,"color":"primary","no-data-text":"No files found.","items-per-page":_vm.itemPerPage,"hide-default-footer":_vm.items.length <= _vm.itemPerPage,"options":_vm.options,"item-key":"path","data-cy":"file-browser-table"},scopedSlots:_vm._u([{key:"item.name",fn:function({ item }){return [_c('router-link',{attrs:{"to":item.link}},[_c('file-icon',{attrs:{"file":item}}),_c('span',{attrs:{"data-cy":"file-browser-item"}},[_vm._v(_vm._s(item.name))])],1),_c(VGrid_namespaceObject.VSpacer),(item.diffStats)?_c('folder-diff',_vm._b({},'folder-diff',item.diffStats,false)):_vm._e()]}},{key:"item.mtime",fn:function({ value }){return [_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[(value)?[_vm._v(" "+_vm._s(_vm._f("timediff")(value))+" ")]:_vm._e()],2)]}}],null,true)},[_c('span',[(value)?[_vm._v(" "+_vm._s(_vm._f("datetime")(value))+" ")]:_vm._e()],2)])]}},{key:"item.size",fn:function({ value }){return [(value !== undefined)?[_vm._v(" "+_vm._s(_vm._f("filesize")(value))+" ")]:_vm._e()]}}],null,false,1151457907),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_c(VCard_namespaceObject.VCard,{staticStyle:{"-webkit-box-shadow":"none","box-shadow":"none"}},[_c(VCard_namespaceObject.VCardTitle,{staticStyle:{"padding-left":"0"}},[_c('strong',[_vm._v(" Well done! The next step is adding some data. ")])]),_c(VCard_namespaceObject.VCardText,{staticStyle:{"padding-left":"0"}},[_vm._v(" There are two options: "),_c('br'),_c('br'),_vm._v(" 1. Use the Mergin Maps plugin for QGIS to upload data. This is the easiest and "),_c('strong',[_vm._v("recommended")]),_vm._v(" way. See the documentation on "),_c('a',{attrs:{"target":"_blank","href":_vm.docsLinkManageCreateProject}},[_vm._v("how to install and use the plugin")]),_vm._v(". "),_c('br'),_c('br'),_vm._v(" 2. Drag and drop files from your computer to the lower part of this page. This option is convenient if your project files are already fully prepared and only need uploading. ")])],1),_c(VGrid_namespaceObject.VSpacer),_c('file-menu',{ref:"menu"})],1)],1)
}
var FileBrowserViewvue_type_template_id_b244fbbe_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/views/FileBrowserView.vue?vue&type=template&id=b244fbbe&scoped=true&

;// CONCATENATED MODULE: external "lodash/escapeRegExp"
var escapeRegExp_namespaceObject = require("lodash/escapeRegExp");
var escapeRegExp_default = /*#__PURE__*/__webpack_require__.n(escapeRegExp_namespaceObject);
;// CONCATENATED MODULE: external "lodash/max"
var max_namespaceObject = require("lodash/max");
var max_default = /*#__PURE__*/__webpack_require__.n(max_namespaceObject);
;// CONCATENATED MODULE: external "lodash/orderBy"
var orderBy_namespaceObject = require("lodash/orderBy");
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy_namespaceObject);
;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/FileBrowserView.vue?vue&type=script&lang=ts&
var FileBrowserViewvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    FileBrowserViewvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return FileBrowserViewvue_type_script_lang_ts_assign.apply(this, arguments);
};














/* harmony default export */ var FileBrowserViewvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'FileBrowserView',
    components: { FileIcon: FileIcon, FolderDiff: FolderDiff, FileMenu: FileMenu },
    props: {
        namespace: String,
        projectName: String,
        location: {
            type: String,
            default: ''
        },
        asAdmin: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            options: {
                rowsPerPage: -1
            },
            itemPerPage: 50,
            sortBy: 'name',
            searchFilter: '',
            filter: '',
            selected: [],
            header: [
                { text: 'Name', value: 'name' },
                { text: 'Modified', value: 'mtime' },
                { text: 'Size', value: 'size' }
            ]
        };
    },
    computed: FileBrowserViewvue_type_script_lang_ts_assign(FileBrowserViewvue_type_script_lang_ts_assign(FileBrowserViewvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('instanceModule', ['configData'])), (0,external_vuex_namespaceObject.mapState)('projectModule', ['project', 'uploads'])), { docsLinkManageCreateProject: function () {
            var _a, _b;
            return "".concat((_b = (_a = this.configData) === null || _a === void 0 ? void 0 : _a.docs_url) !== null && _b !== void 0 ? _b : '', "/manage/create-project");
        }, upload: function () {
            return this.uploads[this.project.path];
        }, projectFiles: function () {
            var files = this.project.files;
            if (this.upload && this.diff) {
                files = FileBrowserViewvue_type_script_lang_ts_assign(FileBrowserViewvue_type_script_lang_ts_assign({}, files), this.upload.files);
            }
            return Object.values(files).map(this.fileTreeView);
        }, directoryFiles: function () {
            var _this = this;
            return this.projectFiles.filter(function (file) { return dirname(file.path) === _this.location; });
        }, folders: function () {
            var _this = this;
            var folders = {};
            var prefix = this.location ? escapeRegExp_default()(this.location + '/') : '';
            var regex = new RegExp("^".concat(prefix, "([^/]+)/"));
            this.projectFiles.forEach(function (f) {
                var m = f.path.match(regex);
                if (m) {
                    var name = m[1];
                    if (folders[name]) {
                        folders[name].push(f);
                    }
                    else {
                        folders[name] = [f];
                    }
                }
            });
            return Object.keys(folders)
                .sort()
                .map(function (name) {
                var path = path_browserify_default().join(_this.location, name);
                var files = folders[name];
                return {
                    name: name,
                    path: path,
                    files: files,
                    type: 'folder',
                    link: _this.folderLink(path),
                    size: files.reduce(function (sum, f) { return sum + f.size; }, 0),
                    mtime: max_default()(files, function (f) { return f.mtime; }).mtime,
                    flags: _this.folderFlags(files),
                    diffStats: _this.diff ? _this.folderDiffStats(files) : null
                };
            });
        }, diffsList: function () {
            var _this = this;
            var list = [];
            if (this.diff) {
                var _a = this.diff, added = _a.added, removed = _a.removed, updated = _a.updated;
                list.push.apply(list, orderBy_default()(removed
                    .map(function (path) { return _this.project.files[path]; })
                    .map(this.fullPathView), this.sortBy, this.options.descending ? 'desc' : 'asc'));
                list.push.apply(list, orderBy_default()(added.map(function (path) { return _this.upload.files[path]; }).map(this.fullPathView), this.sortBy, this.options.descending ? 'desc' : 'asc'));
                list.push.apply(list, orderBy_default()(updated
                    .map(function (path) { return _this.upload.files[path]; })
                    .map(this.fullPathView), this.sortBy, this.options.descending ? 'desc' : 'asc'));
            }
            return list;
        }, items: function () {
            if (this.filter === 'diff') {
                var changedFiles = this.filterByLocation(this.diffsList);
                if (this.searchFilter) {
                    var regex_1 = new RegExp(escapeRegExp_default()(removeAccents(this.searchFilter)), 'i');
                    return changedFiles.filter(function (f) { return f.path.search(regex_1) !== -1; });
                }
                return changedFiles;
            }
            if (this.searchFilter) {
                var regex_2 = new RegExp(escapeRegExp_default()(removeAccents(this.searchFilter)), 'i');
                return orderBy_default()(this.filterByLocation(this.projectFiles).filter(function (f) { return f.path.search(regex_2) !== -1; }), this.sortBy, this.options.descending ? 'desc' : 'asc');
            }
            var items = [];
            if (this.location) {
                items.push({
                    name: '..',
                    type: 'folder',
                    link: path_browserify_default().normalize(path_browserify_default().join(this.$route.path, '@/')),
                    mtime: ''
                });
            }
            items.push.apply(items, orderBy_default()(this.folders, this.sortBy, this.options.descending ? 'desc' : 'asc'));
            items.push.apply(items, orderBy_default()(this.directoryFiles, this.sortBy, this.options.descending ? 'desc' : 'asc'));
            return items;
        }, diff: function () {
            var diff = this.upload && this.upload.diff;
            if (diff && diff.changes) {
                return FileBrowserViewvue_type_script_lang_ts_assign({}, diff);
            }
            return null;
        }, allSelected: function () {
            var _this = this;
            return this.items.every(function (i) { return _this.selected.includes(i.path); });
        } }),
    methods: {
        fileFlags: function (file) {
            return (this.diff && {
                added: this.diff.added.includes(file.path),
                updated: this.diff.updated.includes(file.path),
                removed: this.diff.removed.includes(file.path)
            });
        },
        folderFlags: function (files) {
            var _this = this;
            // TODO: or use file.flags ?
            return (this.diff && {
                added: files.every(function (f) { return _this.diff.added.includes(f.path); }),
                removed: files.every(function (f) { return _this.diff.removed.includes(f.path); })
            });
        },
        folderDiffStats: function (files) {
            var _a = this.diff, added = _a.added, removed = _a.removed, updated = _a.updated;
            return {
                added: files.filter(function (f) { return added.includes(f.path); }).length,
                removed: files.filter(function (f) { return removed.includes(f.path); }).length,
                updated: files.filter(function (f) { return updated.includes(f.path); }).length,
                count: files.length
            };
        },
        fullPathView: function (file) {
            return FileBrowserViewvue_type_script_lang_ts_assign(FileBrowserViewvue_type_script_lang_ts_assign({}, file), { name: file.path, link: this.fileLink(file), mtime: formatDateTime(file.mtime), flags: this.fileFlags(file) });
        },
        fileTreeView: function (file) {
            var filename = path_browserify_default().basename(file.path);
            return FileBrowserViewvue_type_script_lang_ts_assign(FileBrowserViewvue_type_script_lang_ts_assign({}, file), { type: 'file', name: filename, link: this.fileLink(file), mtime: formatDateTime(file.mtime), flags: this.fileFlags(file) });
        },
        fileLink: function (file) {
            return "/projects/".concat(this.namespace, "/").concat(this.projectName, "/blob/").concat(encodeURIComponent(file.path));
        },
        folderLink: function (path) {
            return "/projects/".concat(this.namespace, "/").concat(this.projectName, "/tree/").concat(path);
        },
        filterByLocation: function (files) {
            var dirPrefix = '';
            if (this.location) {
                dirPrefix = this.location.replace(/\/$/, '') + '/';
                files = files.filter(function (file) {
                    return (dirname(file.path) + '/').startsWith(dirPrefix);
                });
            }
            return files.map(function (f) { return (FileBrowserViewvue_type_script_lang_ts_assign(FileBrowserViewvue_type_script_lang_ts_assign({}, f), { name: f.path.slice(dirPrefix.length) })); });
        },
        openMenu: function (evt, file) {
            // TODO: highlight
            this.$refs.menu.open(evt, file);
        },
        toggleAll: function (selected) {
            var fn = selected ? (union_default()) : (difference_default());
            this.selected = fn(this.selected, this.items.map(function (i) { return i.path; }));
        },
        changeSort: function (column) {
            if (this.sortBy === column) {
                this.options.descending = !this.options.descending;
            }
            else {
                this.sortBy = column;
                this.options.descending = false;
            }
        }
    }
}));

;// CONCATENATED MODULE: ./src/modules/project/views/FileBrowserView.vue?vue&type=script&lang=ts&
 /* harmony default export */ var views_FileBrowserViewvue_type_script_lang_ts_ = (FileBrowserViewvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/FileBrowserView.vue?vue&type=style&index=0&id=b244fbbe&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/views/FileBrowserView.vue?vue&type=style&index=0&id=b244fbbe&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/views/FileBrowserView.vue



;


/* normalize component */

var FileBrowserView_component = normalizeComponent(
  views_FileBrowserViewvue_type_script_lang_ts_,
  FileBrowserViewvue_type_template_id_b244fbbe_scoped_true_render,
  FileBrowserViewvue_type_template_id_b244fbbe_scoped_true_staticRenderFns,
  false,
  null,
  "b244fbbe",
  null
  
)

/* harmony default export */ var FileBrowserView = (FileBrowserView_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VTextarea"
var VTextarea_namespaceObject = require("vuetify/lib/components/VTextarea");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/FileDetailView.vue?vue&type=template&id=3701f25f&scoped=true&







var FileDetailViewvue_type_template_id_3701f25f_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.state)?_c('div',{class:['status', _vm.colors[_vm.state]],domProps:{"textContent":_vm._s(_vm.stateText)}}):_vm._e(),_c(VList_namespaceObject.VList,{attrs:{"two-line":"","subheader":""}},[_c(VList_namespaceObject.VListItem,[_c(VList_namespaceObject.VListItemContent,[_c(VList_namespaceObject.VListItemTitle,[_vm._v("Name")]),_c(VList_namespaceObject.VListItemSubtitle,[_vm._v(_vm._s(_vm.filename))])],1)],1),_c(VList_namespaceObject.VListItem,[_c(VList_namespaceObject.VListItemContent,[_c(VList_namespaceObject.VListItemTitle,[_vm._v("Size")]),_c(VList_namespaceObject.VListItemSubtitle,[_vm._v(" "+_vm._s(_vm._f("filesize")(_vm.file.size))+" "),(_vm.state === 'updated')?_c('span',[_vm._v("(new: "+_vm._s(_vm._f("filesize")(_vm.upload.files[_vm.file.path].size))+")")]):_vm._e()])],1)],1),_c(VList_namespaceObject.VListItem,[_c(VList_namespaceObject.VListItemContent,[_c(VList_namespaceObject.VListItemTitle,[_vm._v("Last update")]),_c(VList_namespaceObject.VListItemSubtitle,[_vm._v(_vm._s(_vm._f("datetime")(_vm.file.mtime))+" ("+_vm._s(_vm._f("timediff")(_vm.file.mtime))+") ")])],1)],1)],1),(_vm.mimetype && _vm.file.size < 104857600)?_c('div',{staticClass:"container"},[_c('output',[(_vm.mimetype.match('pdf'))?_c('pdf',{attrs:{"src":_vm.downloadLink},on:{"num-pages":function($event){_vm.pageCount = $event},"page-loaded":function($event){_vm.currentPage = $event}}}):(_vm.mimetype.match('image'))?_c('img',{attrs:{"src":_vm.downloadLink}}):(_vm.mimetype.match('text'))?_c(VTextarea_namespaceObject.VTextarea,{attrs:{"auto-grow":true,"readonly":true,"value":_vm.content,"filled":"","solo":""}}):_vm._e()],1)]):_vm._e()],1)
}
var FileDetailViewvue_type_template_id_3701f25f_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/views/FileDetailView.vue?vue&type=template&id=3701f25f&scoped=true&

;// CONCATENATED MODULE: external "vue-pdf"
var external_vue_pdf_namespaceObject = require("vue-pdf");
var external_vue_pdf_default = /*#__PURE__*/__webpack_require__.n(external_vue_pdf_namespaceObject);
;// CONCATENATED MODULE: ./src/modules/project/routes.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
/* harmony default export */ var project_routes = (function (_rootStore) { return []; });

;// CONCATENATED MODULE: ./src/modules/project/store.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
var project_store_assign = (undefined && undefined.__assign) || function () {
    project_store_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return project_store_assign.apply(this, arguments);
};
var project_store_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var project_store_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};









var ProjectStore = {
    namespaced: true,
    state: {
        accessRequests: undefined,
        namespaceAccessRequests: undefined,
        project: null,
        projectsCount: 0,
        projects: undefined,
        uploads: {},
        currentNamespace: null,
        versions: [],
        versionsCount: 0,
        versionsLoading: false
    },
    mutations: {
        setAccessRequests: function (state, payload) {
            state.accessRequests = payload.accessRequests;
        },
        setNamespaceAccessRequests: function (state, payload) {
            state.namespaceAccessRequests = payload.accessRequests;
        },
        setProject: function (state, payload) {
            var enhancedProject = null;
            if (payload.project) {
                enhancedProject = project_store_assign({}, omit_default()(payload.project, ['files']));
                if (enhancedProject) {
                    enhancedProject.files = keyBy_default()(payload.project.files, 'path');
                    enhancedProject.path = [
                        enhancedProject.namespace,
                        enhancedProject.name
                    ].join('/');
                    var upload = state.uploads[enhancedProject.path];
                    if (upload) {
                        upload.diff = filesDiff(enhancedProject.files, upload.files);
                    }
                }
            }
            state.project = enhancedProject;
        },
        setProjects: function (state, payload) {
            state.projects = payload.projects;
            state.projectsCount = payload.count;
        },
        projectVersions: function (state, payload) {
            state.versions = payload.versions;
            state.versionsCount = payload.count;
        },
        projectVersionsLoading: function (state, loading) {
            state.versionsLoading = loading;
        },
        initUpload: function (state, payload) {
            var _a;
            var upload = {
                files: (_a = payload.files) !== null && _a !== void 0 ? _a : {},
                diff: null,
                analysingFiles: []
            };
            external_vue_default().set(state.uploads, state.project.path, upload);
        },
        analysingFiles: function (state, payload) {
            var upload = state.uploads[state.project.path];
            external_vue_default().set(upload, 'analysingFiles', payload.files);
        },
        finishFileAnalysis: function (state, payload) {
            var upload = state.uploads[state.project.path];
            if (upload.analysingFiles) {
                // upload.analysingFiles = upload.analysingFiles.filter(p => p !== path)
                external_vue_default().set(upload, 'analysingFiles', upload.analysingFiles.filter(function (p) { return p !== payload.path; }));
            }
        },
        uploadFiles: function (state, payload) {
            var files = payload.files;
            files = keyBy_default()(files, 'path');
            var chunks = Object.values(files)
                .filter(function (f) { return f.chunks !== undefined; })
                .map(function (f) { return f.chunks.length; })
                .reduce(function (sum, item) { return sum + item; });
            var upload = {
                files: files,
                diff: filesDiff(state.project.files, files),
                running: false,
                progress: 0,
                loaded: 0,
                total: chunks
            };
            external_vue_default().set(state.uploads, state.project.path, upload);
        },
        discardUpload: function (state, payload) {
            external_vue_default()["delete"](state.uploads, payload.projectPath);
        },
        startUpload: function (state) {
            var upload = state.uploads[state.project.path];
            if (upload) {
                upload.running = true;
                upload.progress = 0;
            }
        },
        chunkUploaded: function (state, payload) {
            var upload = state.uploads[payload.project];
            if (upload) {
                upload.loaded++;
                if (upload.loaded === upload.total) {
                    upload.running = false;
                }
            }
        },
        cancelUpload: function (state) {
            var upload = state.uploads[state.project.path];
            if (upload) {
                upload.running = false;
                upload.progress = 0;
            }
        },
        deleteFiles: function (state, payload) {
            var upload = state.uploads[state.project.path];
            if (!upload) {
                upload = {
                    files: project_store_assign({}, state.project.files),
                    diff: filesDiff({}, {})
                };
                external_vue_default().set(state.uploads, state.project.path, upload);
            }
            payload.files.forEach(function (path) {
                if (upload.files[path]) {
                    external_vue_default()["delete"](upload.files, path);
                }
                else {
                    // should be folder
                    var dirPrefix_1 = path + '/';
                    var removed = Object.keys(upload.files).filter(function (path) {
                        return path.startsWith(dirPrefix_1);
                    });
                    upload.files = omit_default()(upload.files, removed);
                }
            });
            upload.diff = filesDiff(state.project.files, upload.files);
        },
        setCurrentNamespace: function (state, payload) {
            state.currentNamespace = payload.currentNamespace;
        }
    },
    getters: {
        isProjectOwner: function (state) { var _a; return isAtLeastProjectRole((_a = state.project) === null || _a === void 0 ? void 0 : _a.role, ProjectRole.owner); },
        getProjectByName: function (state) { return function (payload) {
            var _a;
            return (_a = state.projects) === null || _a === void 0 ? void 0 : _a.find(function (project) { return project.name === payload.name; });
        }; }
    },
    actions: {
        initProjects: function (_a, payload) {
            var _b;
            var dispatch = _a.dispatch, state = _a.state;
            return project_store_awaiter(this, void 0, void 0, function () {
                return project_store_generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!!(((_b = state.projects) === null || _b === void 0 ? void 0 : _b.length) > 0)) return [3 /*break*/, 2];
                            return [4 /*yield*/, dispatch('getProjects', payload)];
                        case 1:
                            _c.sent();
                            _c.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        },
        getProjects: function (_a, payload) {
            var _b, _c;
            var commit = _a.commit, dispatch = _a.dispatch;
            return project_store_awaiter(this, void 0, void 0, function () {
                var response, _err_1;
                return project_store_generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 2, , 4]);
                            return [4 /*yield*/, ProjectApi.getPaginatedProject(payload.params)];
                        case 1:
                            response = _d.sent();
                            commit('setProjects', {
                                projects: (_b = response.data) === null || _b === void 0 ? void 0 : _b.projects,
                                count: (_c = response.data) === null || _c === void 0 ? void 0 : _c.count
                            });
                            return [3 /*break*/, 4];
                        case 2:
                            _err_1 = _d.sent();
                            return [4 /*yield*/, dispatch('notificationModule/error', {
                                    text: 'Failed to load projects'
                                }, { root: true })];
                        case 3:
                            _d.sent();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/, response];
                    }
                });
            });
        },
        clearProjects: function (_a) {
            var commit = _a.commit;
            commit('setProjects', { projects: [], count: 0 });
            commit('setProject', { project: null });
        },
        createProject: function (_a, payload) {
            var commit = _a.commit, dispatch = _a.dispatch;
            return project_store_awaiter(this, void 0, void 0, function () {
                return project_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            waitCursor(true);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, , 4, 5]);
                            return [4 /*yield*/, ProjectApi.createProject(payload.namespace, payload.data, true)];
                        case 2:
                            _b.sent();
                            commit('setProject', { project: null });
                            return [4 /*yield*/, ProjectModule.routerService.push({
                                    name: 'project',
                                    params: {
                                        namespace: payload.namespace,
                                        projectName: payload.data.name
                                    }
                                })];
                        case 3:
                            _b.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            waitCursor(false);
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        deleteProject: function (_a, payload) {
            var _b;
            var commit = _a.commit, dispatch = _a.dispatch;
            return project_store_awaiter(this, void 0, void 0, function () {
                var e_1;
                return project_store_generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 3, , 5]);
                            waitCursor(true);
                            return [4 /*yield*/, ProjectApi.deleteProject(payload.namespace, payload.projectName, true)];
                        case 1:
                            _c.sent();
                            commit('setProject', { project: null });
                            return [4 /*yield*/, dispatch('userModule/fetchUserProfile', undefined, { root: true })];
                        case 2:
                            _c.sent();
                            waitCursor(false);
                            ProjectModule.routerService.replace({ path: '/' });
                            return [3 /*break*/, 5];
                        case 3:
                            e_1 = _c.sent();
                            return [4 /*yield*/, dispatch('notificationModule/error', { text: ((_b = e_1.response.data) === null || _b === void 0 ? void 0 : _b.detail) || 'Failed to remove project' }, { root: true })];
                        case 4:
                            _c.sent();
                            waitCursor(false);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        initAccessRequests: function (_a) {
            var _b;
            var dispatch = _a.dispatch, state = _a.state;
            return project_store_awaiter(this, void 0, void 0, function () {
                return project_store_generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!!(((_b = state.accessRequests) === null || _b === void 0 ? void 0 : _b.length) > 0)) return [3 /*break*/, 2];
                            return [4 /*yield*/, dispatch('fetchAccessRequests')];
                        case 1:
                            _c.sent();
                            _c.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        },
        fetchAccessRequests: function (_a) {
            var commit = _a.commit, dispatch = _a.dispatch;
            return project_store_awaiter(this, void 0, void 0, function () {
                var accessRequestResponse, _b;
                return project_store_generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 2, , 4]);
                            return [4 /*yield*/, ProjectApi.fetchAccessRequests()];
                        case 1:
                            accessRequestResponse = _c.sent();
                            commit('setAccessRequests', {
                                accessRequests: accessRequestResponse.data
                            });
                            return [3 /*break*/, 4];
                        case 2:
                            _b = _c.sent();
                            return [4 /*yield*/, dispatch('notificationModule/error', { text: 'Failed to fetch project access requests' }, {
                                    root: true
                                })];
                        case 3:
                            _c.sent();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        initNamespaceAccessRequests: function (_a, payload) {
            var _b;
            var dispatch = _a.dispatch, state = _a.state;
            return project_store_awaiter(this, void 0, void 0, function () {
                return project_store_generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!!(((_b = state.namespaceAccessRequests) === null || _b === void 0 ? void 0 : _b.length) > 0)) return [3 /*break*/, 2];
                            return [4 /*yield*/, dispatch('fetchNamespaceAccessRequests', payload)];
                        case 1:
                            _c.sent();
                            _c.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        },
        fetchNamespaceAccessRequests: function (_a, payload) {
            var commit = _a.commit, dispatch = _a.dispatch;
            return project_store_awaiter(this, void 0, void 0, function () {
                var accessRequestResponse, _b;
                return project_store_generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 2, , 4]);
                            return [4 /*yield*/, ProjectApi.fetchNamespaceAccessRequests(payload.namespace)];
                        case 1:
                            accessRequestResponse = _c.sent();
                            commit('setNamespaceAccessRequests', {
                                accessRequests: accessRequestResponse.data
                            });
                            return [3 /*break*/, 4];
                        case 2:
                            _b = _c.sent();
                            return [4 /*yield*/, dispatch('notificationModule/error', { text: 'Failed to fetch project access requests' }, {
                                    root: true
                                })];
                        case 3:
                            _c.sent();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        reloadProjectAccessRequests: function (_a, payload) {
            var dispatch = _a.dispatch;
            return project_store_awaiter(this, void 0, void 0, function () {
                return project_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!payload.refetchGlobalAccessRequests) return [3 /*break*/, 5];
                            if (!payload.namespace) return [3 /*break*/, 2];
                            return [4 /*yield*/, dispatch('fetchNamespaceAccessRequests', {
                                    namespace: payload.namespace
                                })];
                        case 1:
                            _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, dispatch('fetchAccessRequests')];
                        case 3:
                            _b.sent();
                            _b.label = 4;
                        case 4: return [3 /*break*/, 8];
                        case 5:
                            if (!(payload.namespace && payload.projectName)) return [3 /*break*/, 7];
                            // refetch project to update project access requests
                            return [4 /*yield*/, dispatch('fetchProject', {
                                    projectName: payload.projectName,
                                    namespace: payload.namespace
                                })];
                        case 6:
                            // refetch project to update project access requests
                            _b.sent();
                            return [3 /*break*/, 8];
                        case 7:
                            console.warn('Cannot reload project access requests. Missing namespace or projectName.');
                            _b.label = 8;
                        case 8: return [2 /*return*/];
                    }
                });
            });
        },
        cancelProjectAccessRequest: function (_a, payload) {
            var _b;
            var dispatch = _a.dispatch;
            return project_store_awaiter(this, void 0, void 0, function () {
                var err_1, msg;
                return project_store_generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            waitCursor(true);
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 4, 6, 7]);
                            return [4 /*yield*/, ProjectApi.cancelProjectAccessRequest(payload.itemId, true)];
                        case 2:
                            _c.sent();
                            return [4 /*yield*/, dispatch('reloadProjectAccessRequests', payload)];
                        case 3:
                            _c.sent();
                            return [3 /*break*/, 7];
                        case 4:
                            err_1 = _c.sent();
                            msg = err_1.response
                                ? (_b = err_1.response.data) === null || _b === void 0 ? void 0 : _b.detail
                                : 'Failed to cancel access request';
                            return [4 /*yield*/, dispatch('notificationModule/error', { text: msg }, {
                                    root: true
                                })];
                        case 5:
                            _c.sent();
                            return [3 /*break*/, 7];
                        case 6:
                            waitCursor(false);
                            return [7 /*endfinally*/];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        },
        acceptProjectAccessRequest: function (_a, payload) {
            var dispatch = _a.dispatch;
            return project_store_awaiter(this, void 0, void 0, function () {
                return project_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            waitCursor(true);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, , 4, 5]);
                            return [4 /*yield*/, ProjectApi.acceptProjectAccessRequest(payload.itemId, payload.data, true)];
                        case 2:
                            _b.sent();
                            return [4 /*yield*/, dispatch('reloadProjectAccessRequests', payload)];
                        case 3:
                            _b.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            waitCursor(false);
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        cloneProject: function (_a, payload) {
            var commit = _a.commit;
            return project_store_awaiter(this, void 0, void 0, function () {
                var namespace, project, data, cbSuccess, err_2;
                return project_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            namespace = payload.namespace, project = payload.project, data = payload.data, cbSuccess = payload.cbSuccess;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 4, , 5]);
                            waitCursor(true);
                            return [4 /*yield*/, ProjectApi.cloneProject(namespace, project, data)];
                        case 2:
                            _b.sent();
                            waitCursor(false);
                            cbSuccess();
                            commit('setProject', { project: null });
                            return [4 /*yield*/, ProjectModule.routerService.push({
                                    name: 'project',
                                    params: {
                                        namespace: data.namespace,
                                        projectName: data.project
                                    }
                                })];
                        case 3:
                            _b.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            err_2 = _b.sent();
                            waitCursor(false);
                            throw err_2;
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        fetchProject: function (_a, payload) {
            var commit = _a.commit, dispatch = _a.dispatch;
            return project_store_awaiter(this, void 0, void 0, function () {
                var projectResponse, e_2;
                return project_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 4]);
                            return [4 /*yield*/, ProjectApi.fetchProject(payload.namespace, payload.projectName)];
                        case 1:
                            projectResponse = _b.sent();
                            commit('setProject', { project: projectResponse.data });
                            return [3 /*break*/, 4];
                        case 2:
                            e_2 = _b.sent();
                            console.warn('Failed to load project data', e_2);
                            return [4 /*yield*/, dispatch('notificationModule/error', { text: 'Failed to load project data' }, {
                                    root: true
                                })];
                        case 3:
                            _b.sent();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        unsubscribeProject: function (_a, payload) {
            var _b;
            var commit = _a.commit, dispatch = _a.dispatch;
            return project_store_awaiter(this, void 0, void 0, function () {
                var err_3, msg;
                return project_store_generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 2, , 4]);
                            waitCursor(true);
                            return [4 /*yield*/, ProjectApi.unsubscribeProject(payload.id)];
                        case 1:
                            _c.sent();
                            commit('setProject', { project: null });
                            waitCursor(false);
                            return [3 /*break*/, 4];
                        case 2:
                            err_3 = _c.sent();
                            msg = err_3.response
                                ? (_b = err_3.response.data) === null || _b === void 0 ? void 0 : _b.detail
                                : 'Failed to unsubscribe from project';
                            return [4 /*yield*/, dispatch('notificationModule/error', { text: msg }, {
                                    root: true
                                })];
                        case 3:
                            _c.sent();
                            waitCursor(false);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        fetchProjectDetail: function (_a, payload) {
            var commit = _a.commit, dispatch = _a.dispatch;
            return project_store_awaiter(this, void 0, void 0, function () {
                var callbackStatus, namespace, projectName, isLoggedUser, projectResponse, e_3;
                return project_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            callbackStatus = payload.callbackStatus, namespace = payload.namespace, projectName = payload.projectName, isLoggedUser = payload.isLoggedUser;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 8]);
                            return [4 /*yield*/, ProjectApi.fetchProject(payload.namespace, payload.projectName)];
                        case 2:
                            projectResponse = _b.sent();
                            commit('setProject', { project: projectResponse.data });
                            return [3 /*break*/, 8];
                        case 3:
                            e_3 = _b.sent();
                            callbackStatus(e_3.response.status);
                            if (!(e_3.response.status !== 404 && e_3.response.status !== 403)) return [3 /*break*/, 4];
                            dispatch('notificationModule/error', {
                                text: 'Failed to load project data'
                            }, { root: true });
                            return [3 /*break*/, 7];
                        case 4:
                            if (!(e_3.response.status === 403 && !isLoggedUser)) return [3 /*break*/, 6];
                            return [4 /*yield*/, ProjectModule.routerService.push("/login?redirect=/projects/".concat(namespace, "/").concat(projectName))];
                        case 5:
                            _b.sent();
                            return [3 /*break*/, 7];
                        case 6:
                            if (e_3.response.status === 403) {
                                ProjectApi.fetchAccessRequests()
                                    .then(function (resp) {
                                    for (var _i = 0, _a = resp.data; _i < _a.length; _i++) {
                                        var ar = _a[_i];
                                        if (ar.namespace === namespace &&
                                            ar.project_name === projectName) {
                                            callbackStatus(409);
                                        }
                                    }
                                })
                                    .catch(function () {
                                    dispatch('notificationModule/error', {
                                        text: 'Failed to load project access requests data'
                                    }, { root: true });
                                });
                            }
                            _b.label = 7;
                        case 7: return [3 /*break*/, 8];
                        case 8: return [2 /*return*/];
                    }
                });
            });
        },
        fetchProjectVersions: function (_a, payload) {
            var _b, _c;
            var commit = _a.commit, dispatch = _a.dispatch;
            return project_store_awaiter(this, void 0, void 0, function () {
                var response, e_4;
                return project_store_generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 2, 4, 5]);
                            commit('projectVersionsLoading', true);
                            return [4 /*yield*/, ProjectApi.fetchProjectVersions(payload.namespace, payload.projectName, payload.params)];
                        case 1:
                            response = _d.sent();
                            commit('projectVersions', {
                                versions: (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.versions,
                                count: (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.count
                            });
                            return [3 /*break*/, 5];
                        case 2:
                            e_4 = _d.sent();
                            return [4 /*yield*/, dispatch('notificationModule/error', {
                                    text: 'Failed to fetch project versions'
                                }, { root: true })];
                        case 3:
                            _d.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            commit('projectVersionsLoading', false);
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        saveProjectSettings: function (_a, payload) {
            var commit = _a.commit;
            return project_store_awaiter(this, void 0, Promise, function () {
                var namespace, newSettings, projectName, saveProjectSettingsResponse;
                return project_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            namespace = payload.namespace, newSettings = payload.newSettings, projectName = payload.projectName;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, , 3, 4]);
                            waitCursor(true);
                            return [4 /*yield*/, ProjectApi.saveProjectSettings(namespace, projectName, newSettings, true)];
                        case 2:
                            saveProjectSettingsResponse = _b.sent();
                            commit('setProject', { project: saveProjectSettingsResponse.data });
                            waitCursor(false);
                            return [2 /*return*/, saveProjectSettingsResponse];
                        case 3:
                            waitCursor(false);
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        pushProjectChunks: function (_a, payload) {
            var commit = _a.commit;
            return project_store_awaiter(this, void 0, void 0, function () {
                var pushProjectChunksResponse;
                return project_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ProjectApi.pushProjectChunks(payload.transaction, payload.chunk, payload.token, payload.data, true)];
                        case 1:
                            pushProjectChunksResponse = _b.sent();
                            commit('chunkUploaded', { project: payload.projectPath });
                            return [2 /*return*/, pushProjectChunksResponse];
                    }
                });
            });
        },
        pushFinishTransaction: function (_a, payload) {
            var commit = _a.commit, dispatch = _a.dispatch;
            return project_store_awaiter(this, void 0, void 0, function () {
                var projectPath, token, transaction, pushFinishTransactionResponse, err_4;
                return project_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            projectPath = payload.projectPath, token = payload.token, transaction = payload.transaction;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, ProjectApi.pushFinishTransaction(transaction, token, true)];
                        case 2:
                            pushFinishTransactionResponse = _b.sent();
                            commit('discardUpload', { projectPath: projectPath });
                            dispatch('notificationModule/show', {
                                text: "Upload finished: ".concat(projectPath)
                            }, { root: true });
                            commit('setProject', { project: pushFinishTransactionResponse.data });
                            dispatch('userModule/fetchUserProfile', undefined, { root: true });
                            waitCursor(false);
                            return [3 /*break*/, 4];
                        case 3:
                            err_4 = _b.sent();
                            dispatch('pushCancelTransaction', { err: err_4, transaction: transaction });
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        pushProjectChanges: function (_a, payload) {
            var _b;
            var dispatch = _a.dispatch;
            return project_store_awaiter(this, void 0, void 0, function () {
                var data, projectPath, err_5, msg;
                return project_store_generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            data = payload.data, projectPath = payload.projectPath;
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 5]);
                            return [4 /*yield*/, ProjectApi.pushProjectChanges(projectPath, data)];
                        case 2: return [2 /*return*/, _c.sent()];
                        case 3:
                            err_5 = _c.sent();
                            msg = (err_5.response && ((_b = err_5.response.data) === null || _b === void 0 ? void 0 : _b.detail)) || 'Error';
                            return [4 /*yield*/, dispatch('notificationModule/error', { text: msg }, { root: true })];
                        case 4:
                            _c.sent();
                            return [2 /*return*/, undefined];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        pushCancelTransaction: function (_a, payload) {
            var _b;
            var commit = _a.commit, dispatch = _a.dispatch;
            return project_store_awaiter(this, void 0, void 0, function () {
                var err, transaction, msg;
                return project_store_generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            err = payload.err, transaction = payload.transaction;
                            commit('cancelUpload');
                            msg = err.__CANCEL__
                                ? err.message
                                : (err.response && ((_b = err.response.data) === null || _b === void 0 ? void 0 : _b.detail)) || 'Error';
                            dispatch('notificationModule/error', { text: msg }, { root: true });
                            return [4 /*yield*/, ProjectApi.pushCancelTransaction(transaction)];
                        case 1:
                            _c.sent();
                            waitCursor(false);
                            return [2 /*return*/];
                    }
                });
            });
        },
        downloadArchive: function (_a, payload) {
            var dispatch = _a.dispatch;
            return project_store_awaiter(this, void 0, void 0, function () {
                var resp, fileName, e_5, resp_1, blob;
                return project_store_generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, ProjectApi.downloadFile(payload.url)];
                        case 1:
                            resp = _b.sent();
                            fileName = resp.headers['content-disposition'].split('filename=')[1];
                            external_file_saver_default().saveAs(resp.data, fileName);
                            return [3 /*break*/, 3];
                        case 2:
                            e_5 = _b.sent();
                            blob = new Blob([e_5.response.data], { type: 'text/plain' });
                            blob.text().then(function (text) {
                                resp_1 = JSON.parse(text);
                                dispatch('notificationModule/error', { text: resp_1.detail }, { root: true });
                            });
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
    }
};
/* harmony default export */ var project_store = (ProjectStore);

;// CONCATENATED MODULE: ./src/modules/project/module.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial



var ProjectModule = {
    name: 'projectModule',
    routerService: undefined,
    httpService: undefined,
    moduleStore: project_store,
    _addRoutes: function (router, rootStore, routeOverrides) {
        // add routes to router
        project_routes(rootStore).forEach(function (route) {
            router.addRoute(applyRouteOverride(route, routeOverrides));
        });
    },
    init: function (services, routeOverrides) {
        if (services.httpService) {
            ProjectModule.httpService = services.httpService;
        }
        else {
            console.error("Module ".concat(ProjectModule.name, " - missing httpService"));
        }
        if (services.routerService) {
            ProjectModule.routerService = services.routerService;
            if (services.store) {
                ProjectModule._addRoutes(services.routerService, services.store, routeOverrides);
            }
        }
    }
};

;// CONCATENATED MODULE: ./src/modules/project/projectApi.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
var projectApi_assign = (undefined && undefined.__assign) || function () {
    projectApi_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return projectApi_assign.apply(this, arguments);
};
var projectApi_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var projectApi_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var ProjectApi = {
    fetchProject: function (namespace, projectName) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService("/v1/project/".concat(namespace, "/").concat(projectName))];
            });
        });
    },
    createProject: function (namespace, data, withRetry) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService.post("/v1/project/".concat(namespace), data, projectApi_assign({}, (withRetry ? getDefaultRetryOptions() : {})))];
            });
        });
    },
    cloneProject: function (namespace, projectName, data, withRetry) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService.post("/v1/project/clone/".concat(namespace, "/").concat(projectName), data, projectApi_assign({}, (withRetry ? getDefaultRetryOptions() : {})))];
            });
        });
    },
    deleteProject: function (namespace, projectName, withRetry) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService["delete"]("/v1/project/".concat(namespace ? "".concat(namespace, "/").concat(projectName) : projectName), projectApi_assign({}, (withRetry ? getDefaultRetryOptions() : {})))];
            });
        });
    },
    unsubscribeProject: function (id) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService.post("/app/project/unsubscribe/".concat(id))];
            });
        });
    },
    getProjectFileByUrl: function (url) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService.get(url)];
            });
        });
    },
    getPaginatedProject: function (params) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService('/v1/project/paginated', { params: params })];
            });
        });
    },
    // TODO: refactor to admin-lib?
    getPaginatedAdminProject: function (params) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService('/app/admin/projects', { params: params })];
            });
        });
    },
    saveProjectSettings: function (namespace, projectName, data, withRetry) {
        return ProjectModule.httpService.put("/v1/project/".concat(namespace, "/").concat(projectName), data, projectApi_assign(projectApi_assign({}, (withRetry ? getDefaultRetryOptions() : {})), { validateStatus: validateStatus }));
    },
    fetchProjectVersions: function (namespace, projectName, params) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService.get("/v1/project/versions/paginated/".concat(namespace, "/").concat(projectName), { params: params })];
            });
        });
    },
    fetchAccessRequests: function () {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService('/app/project/access-requests')];
            });
        });
    },
    fetchNamespaceAccessRequests: function (namespace) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService("/app/project/access-request/".concat(namespace))];
            });
        });
    },
    acceptProjectAccessRequest: function (itemId, data, withRetry) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService.post("/app/project/access-request/accept/".concat(itemId), data, projectApi_assign({}, (withRetry ? getDefaultRetryOptions() : {})))];
            });
        });
    },
    cancelProjectAccessRequest: function (itemId, withRetry) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService["delete"]("/app/project/access-request/".concat(itemId), projectApi_assign({}, (withRetry ? getDefaultRetryOptions() : {})))];
            });
        });
    },
    createProjectAccessRequest: function (namespace, projectName, withRetry) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService.post("/app/project/access-request/".concat(namespace, "/").concat(projectName), {}, projectApi_assign({}, (withRetry ? getDefaultRetryOptions() : {})))];
            });
        });
    },
    updateProjectAccessForUser: function (id, data, withRetry) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService.patch("/app/project/".concat(id, "/access"), data, projectApi_assign({}, (withRetry ? getDefaultRetryOptions() : {})))];
            });
        });
    },
    pushProjectChanges: function (url, data) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService.post("/v1/project/push/".concat(url), data)];
            });
        });
    },
    pushProjectChunks: function (transaction, chunk, token, data, withRetry) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService.post("/v1/project/push/chunk/".concat(transaction, "/").concat(chunk), data, projectApi_assign({ cancelToken: token }, (withRetry ? getDefaultRetryOptions() : {})))];
            });
        });
    },
    pushFinishTransaction: function (transaction, token, withRetry) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService.post("/v1/project/push/finish/".concat(transaction), null, projectApi_assign({ cancelToken: token }, (withRetry ? getDefaultRetryOptions() : {})))];
            });
        });
    },
    pushCancelTransaction: function (transaction) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService.post("/v1/project/push/cancel/".concat(transaction))];
            });
        });
    },
    constructDownloadProjectUrl: function (namespace, projectName) {
        return ProjectModule.httpService.absUrl("/v1/project/download/".concat(namespace, "/").concat(projectName, "?format=zip"));
    },
    constructDownloadProjectVersionUrl: function (namespace, projectName, versionId) {
        return ProjectModule.httpService.absUrl("/v1/project/download/".concat(namespace, "/").concat(projectName, "?version=").concat(versionId, "&format=zip"));
    },
    constructDownloadProjectFileUrl: function (namespace, projectName, file) {
        return ProjectModule.httpService.absUrl("/v1/project/raw/".concat(namespace, "/").concat(projectName, "?file=").concat(file, "&random=").concat(Math.random()));
    },
    getProjectVersion: function (projectId, versionName) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService.get("/v1/project/version/".concat(projectId, "/").concat(versionName))];
            });
        });
    },
    getProjectTemplates: function () {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService.get('/app/project/templates')];
            });
        });
    },
    /**
     * Permanently remove project
     * @param id removed project id
     * @return Result promise
     */
    removeProject: function (id) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ProjectModule.httpService["delete"]("/app/project/removed-project/".concat(id), {
                            'axios-retry': { retries: 5 }
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    },
    /**
     * Restore removed project
     * @param id (Int) removed project id
     * @return Result promise
     */
    restoreProject: function (id) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ProjectModule.httpService.post("/app/project/removed-project/restore/".concat(id), null, { 'axios-retry': { retries: 5 } })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    },
    downloadFile: function (url) {
        return projectApi_awaiter(this, void 0, Promise, function () {
            return projectApi_generator(this, function (_a) {
                return [2 /*return*/, ProjectModule.httpService.get(url, { responseType: 'blob' })];
            });
        });
    }
};

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/FileDetailView.vue?vue&type=script&lang=ts&
var FileDetailViewvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    FileDetailViewvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return FileDetailViewvue_type_script_lang_ts_assign.apply(this, arguments);
};







var Colors = {
    added: 'green',
    removed: 'red',
    updated: 'orange'
};
/* harmony default export */ var FileDetailViewvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'FileInfoView',
    props: {
        namespace: String,
        projectName: String,
        location: {
            type: String,
            default: ''
        }
    },
    components: {
        pdf: (external_vue_pdf_default()),
        ActionButton: ActionButton,
        DownloadIcon: external_vue_tabler_icons_namespaceObject.DownloadIcon,
        TrashIcon: external_vue_tabler_icons_namespaceObject.TrashIcon
    },
    computed: FileDetailViewvue_type_script_lang_ts_assign(FileDetailViewvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('projectModule', ['project', 'uploads'])), { upload: function () {
            return this.uploads[this.project.path];
        }, file: function () {
            if (!this.project.files[this.location]) {
                this.$router.replace({
                    name: 'project',
                    namespace: this.namespace,
                    projectName: this.projectName
                });
            }
            return (this.project.files[this.location] || this.upload.files[this.location]);
        }, filename: function () {
            return path_browserify_default().basename(this.file.path);
        }, downloadLink: function () {
            // added random number to request avoid to browser caching files
            return ProjectApi.constructDownloadProjectFileUrl(this.namespace, this.projectName, encodeURIComponent(this.file.path));
        }, state: function () {
            var diff = this.upload && this.upload.diff;
            if (diff) {
                var path = this.file.path;
                if (diff.added.includes(path)) {
                    return 'added';
                }
                else if (diff.removed.includes(path)) {
                    return 'removed';
                }
                else if (diff.updated.includes(path)) {
                    return 'updated';
                }
            }
            return null;
        }, stateText: function () {
            return ({
                added: 'New file',
                removed: 'Deleted file',
                updated: 'Modified file'
            }[this.state] || this.state);
        }, colors: function () {
            return Colors;
        } }),
    data: function () {
        return {
            previewUrl: '',
            pageCount: 0,
            currentPage: 0,
            content: null,
            mimetype: null
        };
    },
    created: function () {
        this.txtPreview();
    },
    methods: FileDetailViewvue_type_script_lang_ts_assign(FileDetailViewvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapMutations)('projectModule', ['deleteFiles'])), { txtPreview: function () {
            var _this = this;
            ProjectApi.getProjectFileByUrl(this.downloadLink).then(function (resp) {
                _this.mimetype = resp.headers['content-type'];
                if (resp.headers['content-type'].match('text')) {
                    if (resp.data.constructor === Object) {
                        resp.data = JSON.stringify(resp.data);
                    }
                    _this.content = resp.data.match(/^.*([^\n]*\n){0,50}/gi)[0];
                    if (!_this.content) {
                        _this.content = '';
                        return;
                    }
                    if (_this.content.length > 10000) {
                        _this.content = _this.content.substring(0, 10000);
                    }
                }
                else {
                    _this.content = null;
                }
            });
        }, removeSelected: function () {
            this.deleteFiles({ files: [this.file.path] });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/views/FileDetailView.vue?vue&type=script&lang=ts&
 /* harmony default export */ var views_FileDetailViewvue_type_script_lang_ts_ = (FileDetailViewvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/FileDetailView.vue?vue&type=style&index=0&id=3701f25f&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/views/FileDetailView.vue?vue&type=style&index=0&id=3701f25f&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/views/FileDetailView.vue



;


/* normalize component */

var FileDetailView_component = normalizeComponent(
  views_FileDetailViewvue_type_script_lang_ts_,
  FileDetailViewvue_type_template_id_3701f25f_scoped_true_render,
  FileDetailViewvue_type_template_id_3701f25f_scoped_true_staticRenderFns,
  false,
  null,
  "3701f25f",
  null
  
)

/* harmony default export */ var FileDetailView = (FileDetailView_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/FileVersionDetailView.vue?vue&type=template&id=9f2e4790&scoped=true&








var FileVersionDetailViewvue_type_template_id_9f2e4790_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.tables)?_c(VList_namespaceObject.VList,{attrs:{"two-line":"","subheader":""}},_vm._l((_vm.tables),function(value,name){return _c(VList_namespaceObject.VListItem,{key:name},[_c(VList_namespaceObject.VListItemContent,[_c(VList_namespaceObject.VListItemTitle,[_c('h3',{staticClass:"primary--text"},[_vm._v(_vm._s(name))])]),_c('br'),_c(VDataTable_namespaceObject.VDataTable,{staticStyle:{"overflow-x":"auto"},attrs:{"headers":value.headers,"items":value.changes,"no-data-text":"No changeset","color":"primary","footer-props.items-per-page-options":"[10, 25, {\"text\": \"$vuetify.dataIterator.rowsPerPageAll\",\"value\": -1}]","hide-default-footer":value.changes.length <= 10,"disable-sort":""},scopedSlots:_vm._u([{key:"item.operationTypeHeader",fn:function({ value }){return [_c(VIcon_namespaceObject.VIcon,{attrs:{"small":"","color":_vm.actions[value].color}},[_vm._v(_vm._s(_vm.actions[value].icon))])]}}],null,true)})],1)],1)}),1):(!_vm.tables && !_vm.loading)?_c(VCard_namespaceObject.VCard,{staticClass:"bubble mt-3",attrs:{"outlined":""}},[_c('h4',[_vm._v("Changes cannot be calculated")]),_vm._v(" For details please check the "),_c('a',{attrs:{"href":_vm.docsLinkManageSynchronisation,"target":"_blank"}},[_vm._v("documentation")]),_vm._v(". ")]):_vm._e()],1)
}
var FileVersionDetailViewvue_type_template_id_9f2e4790_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/views/FileVersionDetailView.vue?vue&type=template&id=9f2e4790&scoped=true&

;// CONCATENATED MODULE: external "lodash/groupBy"
var groupBy_namespaceObject = require("lodash/groupBy");
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy_namespaceObject);
;// CONCATENATED MODULE: external "lodash/isArray"
var isArray_namespaceObject = require("lodash/isArray");
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray_namespaceObject);
;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/FileVersionDetailView.vue?vue&type=script&lang=ts&
var FileVersionDetailViewvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    FileVersionDetailViewvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return FileVersionDetailViewvue_type_script_lang_ts_assign.apply(this, arguments);
};





/* harmony default export */ var FileVersionDetailViewvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'FileVersionDetailView',
    props: {
        namespace: String,
        projectName: String,
        version_id: String,
        path: String,
        asAdmin: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            tables: null,
            loading: true,
            actions: {
                insert: { icon: 'add_circle', color: 'green' },
                update: { icon: 'edit', color: 'orange' },
                delete: { icon: 'delete', color: 'red' }
            }
        };
    },
    computed: FileVersionDetailViewvue_type_script_lang_ts_assign(FileVersionDetailViewvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('instanceModule', ['configData'])), { docsLinkManageSynchronisation: function () {
            var _a, _b;
            return "".concat((_b = (_a = this.configData) === null || _a === void 0 ? void 0 : _a.docs_url) !== null && _b !== void 0 ? _b : '', "/manage/synchronisation");
        } }),
    created: function () {
        this.getChangeset();
    },
    methods: {
        // TODO: refactor to vuex action
        getChangeset: function () {
            var _this_1 = this;
            waitCursor(true);
            this.$http
                .get("/v1/resource/changesets/".concat(this.namespace, "/").concat(this.projectName, "/").concat(this.version_id, "?path=").concat(this.path))
                .then(function (resp) {
                if (!resp.data.length)
                    return;
                // process data grouped by tables
                _this_1.tables = {};
                var changeset = FileVersionDetailViewvue_type_script_lang_ts_assign({}, resp.data);
                changeset = groupBy_default()(changeset, 'table');
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                var _this = _this_1;
                var _loop_1 = function (key, value) {
                    _this.tables[key] = {};
                    var headers = [
                        { text: 'Change', value: 'operationTypeHeader', width: 50 }
                    ];
                    var changes = [];
                    if (isArray_default()(value)) {
                        var arrayValue = value;
                        arrayValue.forEach(function (data) {
                            if (data.table === 'gpkg_contents') {
                                return;
                            }
                            data.values = { operationTypeHeader: data.type };
                            data.changes.forEach(function (row) {
                                var columnIdentifier = row.name;
                                // based on operation type create a value to display: old, new or change old -> new
                                // display undefined values as N/A
                                row.value = {};
                                if (data.type === 'insert') {
                                    data.values[columnIdentifier] =
                                        typeof row.new === 'undefined' ? 'N/A' : row.new;
                                }
                                else if (data.type === 'update') {
                                    if (typeof row.new === 'undefined') {
                                        data.values[columnIdentifier] =
                                            typeof row.old === 'undefined' ? 'N/A' : row.old;
                                    }
                                    else {
                                        data.values[columnIdentifier] =
                                            (typeof row.old === 'undefined' ? 'N/A' : row.old) +
                                                ' ' +
                                                String.fromCharCode(parseInt('2794', 16)) +
                                                ' ' +
                                                (typeof row.new === 'undefined' ? 'N/A' : row.new);
                                    }
                                }
                                else if (data.type === 'delete') {
                                    data.values[columnIdentifier] =
                                        typeof row.old === 'undefined' ? 'N/A' : row.old;
                                }
                                if (!headers.map(function (h) { return h.value; }).includes(columnIdentifier)) {
                                    headers.push({
                                        text: row.name,
                                        value: columnIdentifier,
                                        width: 50
                                    });
                                }
                            });
                            changes.push(data.values);
                        });
                    }
                    _this.tables[key].headers = headers;
                    _this.tables[key].changes = changes;
                };
                for (var _i = 0, _a = Object.entries(changeset); _i < _a.length; _i++) {
                    var _b = _a[_i], key = _b[0], value = _b[1];
                    _loop_1(key, value);
                }
            })
                .catch(function (err) {
                var _a;
                var msg = err.response
                    ? (_a = err.response.data) === null || _a === void 0 ? void 0 : _a.detail
                    : 'Failed to display changeset of file';
                _this_1.$store.dispatch('notificationModule/error', { text: msg });
            })
                .finally(function () {
                _this_1.loading = false;
                waitCursor(false);
            });
        }
    }
}));

;// CONCATENATED MODULE: ./src/modules/project/views/FileVersionDetailView.vue?vue&type=script&lang=ts&
 /* harmony default export */ var views_FileVersionDetailViewvue_type_script_lang_ts_ = (FileVersionDetailViewvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/FileVersionDetailView.vue?vue&type=style&index=0&id=9f2e4790&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/views/FileVersionDetailView.vue?vue&type=style&index=0&id=9f2e4790&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/views/FileVersionDetailView.vue



;


/* normalize component */

var FileVersionDetailView_component = normalizeComponent(
  views_FileVersionDetailViewvue_type_script_lang_ts_,
  FileVersionDetailViewvue_type_template_id_9f2e4790_scoped_true_render,
  FileVersionDetailViewvue_type_template_id_9f2e4790_scoped_true_staticRenderFns,
  false,
  null,
  "9f2e4790",
  null
  
)

/* harmony default export */ var FileVersionDetailView = (FileVersionDetailView_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/ProjectsListViewTemplate.vue?vue&type=template&id=2f3c0067&scoped=true&







var ProjectsListViewTemplatevue_type_template_id_2f3c0067_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-view',{style:(`padding-left: ${
    _vm.drawer ? 260 : 20
  }px; overflow-y: auto; padding-right:20px; margin-right: 0px;`)},[(!_vm.namespace)?_c(VGrid_namespaceObject.VLayout,{staticClass:"column fill-height main-content"},[_c(VGrid_namespaceObject.VLayout,{staticClass:"column ml-1 my-2 pl-3",attrs:{"shrink":""}},[_c(VGrid_namespaceObject.VLayout,{attrs:{"align-center":"","shrink":""}},[_c('h1',{staticClass:"primary--text"},[_vm._v(" "+_vm._s(_vm.header)+" "),(_vm.namespace)?_c('span',[_c(VIcon_namespaceObject.VIcon,{staticClass:"arrow"},[_vm._v("chevron_right")]),_vm._v(" "+_vm._s(_vm.namespace))],1):_vm._e()]),_c(VGrid_namespaceObject.VSpacer),_c('portal-target',{attrs:{"name":"additional-action"}}),(_vm.canCreateProject)?_c('div',{staticClass:"action-button"},[(_vm.loggedUser && _vm.loggedUser.email)?_c('action-button',{attrs:{"data-cy":"action-button-create"},on:{"click":_vm.newProjectDialog},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('plus-icon')]},proxy:true}],null,false,348396351)},[_vm._v(" Create ")]):_vm._e()],1):_vm._e(),(!_vm.onlyPublic)?_c('div',{staticClass:"action-button"},[(_vm.loggedUser && _vm.loggedUser.email)?_c('action-button',{on:{"click":_vm.findPublicProjects},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('search-icon')]},proxy:true}],null,false,1038510507)},[_vm._v(" Find public projects ")]):_vm._e()],1):_vm._e()],1),_c('br'),_c(VDivider_namespaceObject.VDivider)],1),_c(VCard_namespaceObject.VCard,{staticClass:"table",staticStyle:{"-webkit-box-shadow":"none","box-shadow":"none"}},[_c(VCard_namespaceObject.VCardText,[_vm._t("projects",null,{"onlyPublic":_vm.onlyPublic})],2)],1)],1):_c(VGrid_namespaceObject.VLayout,{staticClass:"column fill-height main-content"},[_c(VCard_namespaceObject.VCard,[_c('span',{staticClass:"private-public-text",staticStyle:{"padding-top":"25px","padding-left":"25px"}},[_c('b',[_vm._v("Namespace not found")]),_c('br'),_vm._v(" Please check if address is written correctly ")])])],1)],1)
}
var ProjectsListViewTemplatevue_type_template_id_2f3c0067_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/views/ProjectsListViewTemplate.vue?vue&type=template&id=2f3c0067&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/layout/components/PageView.vue?vue&type=template&id=1c741d5a&scoped=true&



var PageViewvue_type_template_id_1c741d5a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VGrid_namespaceObject.VLayout,{attrs:{"row":"","justify-center":"","align-start":"","fill-height":"","my-1":""}},[_vm._t("left",function(){return [_c(VGrid_namespaceObject.VSpacer,{staticClass:"hidden-md-and-down"})]}),_vm._t("default"),_vm._t("right",function(){return [_c(VGrid_namespaceObject.VSpacer,{staticClass:"hidden-md-and-down"})]}),(_vm.slackLink)?_c('a',{staticClass:"btn slack-link",attrs:{"href":_vm.slackLink,"target":"_blank"}},[_c('message-icon',{staticClass:"primary--text"})],1):_vm._e(),_c('p',{staticClass:"version hidden-md-and-down"},[_vm._v("Version: "+_vm._s(_vm.version))])],2)
}
var PageViewvue_type_template_id_1c741d5a_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/layout/components/PageView.vue?vue&type=template&id=1c741d5a&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/layout/components/PageView.vue?vue&type=script&lang=ts&
var PageViewvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    PageViewvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return PageViewvue_type_script_lang_ts_assign.apply(this, arguments);
};



/* harmony default export */ var PageViewvue_type_script_lang_ts_ = (external_vue_default().extend({
    components: { MessageIcon: external_vue_tabler_icons_namespaceObject.MessageIcon },
    computed: PageViewvue_type_script_lang_ts_assign(PageViewvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('instanceModule', ['configData'])), { version: function () {
            var _a, _b, _c;
            return "".concat((_b = (_a = this.configData) === null || _a === void 0 ? void 0 : _a.server_type) === null || _b === void 0 ? void 0 : _b.toUpperCase(), " ").concat((_c = this.configData) === null || _c === void 0 ? void 0 : _c.version);
        }, slackLink: function () {
            return "https://merginmaps.com/community/join";
        } })
}));

;// CONCATENATED MODULE: ./src/modules/layout/components/PageView.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_PageViewvue_type_script_lang_ts_ = (PageViewvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/layout/components/PageView.vue?vue&type=style&index=0&id=1c741d5a&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/layout/components/PageView.vue?vue&type=style&index=0&id=1c741d5a&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/layout/components/PageView.vue



;


/* normalize component */

var PageView_component = normalizeComponent(
  components_PageViewvue_type_script_lang_ts_,
  PageViewvue_type_template_id_1c741d5a_scoped_true_render,
  PageViewvue_type_template_id_1c741d5a_scoped_true_staticRenderFns,
  false,
  null,
  "1c741d5a",
  null
  
)

/* harmony default export */ var PageView = (PageView_component.exports);
;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/ProjectsListViewTemplate.vue?vue&type=script&lang=ts&
var ProjectsListViewTemplatevue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ProjectsListViewTemplatevue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ProjectsListViewTemplatevue_type_script_lang_ts_assign.apply(this, arguments);
};






/* harmony default export */ var ProjectsListViewTemplatevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'ProjectsListView',
    components: { ActionButton: ActionButton, PageView: PageView, PlusIcon: external_vue_tabler_icons_namespaceObject.PlusIcon, SearchIcon: external_vue_tabler_icons_namespaceObject.SearchIcon },
    props: {
        namespace: String,
        canCreateProject: Boolean
    },
    computed: ProjectsListViewTemplatevue_type_script_lang_ts_assign(ProjectsListViewTemplatevue_type_script_lang_ts_assign(ProjectsListViewTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('userModule', ['loggedUser'])), (0,external_vuex_namespaceObject.mapState)('layoutModule', ['drawer'])), { header: function () {
            return this.onlyPublic ? 'Mergin Maps public projects' : 'Projects';
        }, onlyPublic: function () {
            var _a;
            return this.$route.name === 'explore' || !((_a = this.loggedUser) === null || _a === void 0 ? void 0 : _a.email);
        } }),
    methods: {
        findPublicProjects: function () {
            this.$router.push({
                name: 'explore'
            });
        },
        newProjectDialog: function () {
            var _this = this;
            var dialog = { maxWidth: 500, persistent: true };
            this.$store.dispatch('dialogModule/show', {
                component: ProjectForm,
                params: {
                    listeners: {
                        error: function (err, data) { return _this.$emit('new-project-error', err, data); }
                    },
                    dialog: dialog
                }
            });
        }
    }
}));

;// CONCATENATED MODULE: ./src/modules/project/views/ProjectsListViewTemplate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var views_ProjectsListViewTemplatevue_type_script_lang_ts_ = (ProjectsListViewTemplatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/ProjectsListViewTemplate.vue?vue&type=style&index=0&id=2f3c0067&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/views/ProjectsListViewTemplate.vue?vue&type=style&index=0&id=2f3c0067&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/views/ProjectsListViewTemplate.vue



;


/* normalize component */

var ProjectsListViewTemplate_component = normalizeComponent(
  views_ProjectsListViewTemplatevue_type_script_lang_ts_,
  ProjectsListViewTemplatevue_type_template_id_2f3c0067_scoped_true_render,
  ProjectsListViewTemplatevue_type_template_id_2f3c0067_scoped_true_staticRenderFns,
  false,
  null,
  "2f3c0067",
  null
  
)

/* harmony default export */ var ProjectsListViewTemplate = (ProjectsListViewTemplate_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/ProjectSettingsViewTemplate.vue?vue&type=template&id=25879f87&scoped=true&






var ProjectSettingsViewTemplatevue_type_template_id_25879f87_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VGrid_namespaceObject.VLayout,{staticClass:"settings column"},[_vm._t("permissions",null,{"settingsAccess":_vm.settings.access,"keyProp":_vm.key,"saveProject":_vm.saveProject}),_c('project-access-requests'),_c(VGrid_namespaceObject.VLayout,{staticClass:"public-private-zone"},[_c(VGrid_namespaceObject.VContainer,[_c(VGrid_namespaceObject.VRow,[_c(VGrid_namespaceObject.VCol,[(_vm.settings.access.public)?_c('span',{staticClass:"private-public-text"},[_c('b',[_vm._v("This is public project")]),_c('br'),_c('span',{staticClass:"description-text"},[_vm._v("Hide this project from everyone.")])]):_c('span',{staticClass:"private-public-text"},[_c('b',[_vm._v("This is private project")]),_c('br'),_c('span',{staticClass:"description-text"},[_vm._v("Make this project visible to anyone.")])])]),_c(VGrid_namespaceObject.VCol,[_c(VBtn_namespaceObject.VBtn,{staticClass:"private-public-btn",attrs:{"outlined":""},on:{"click":function($event){return _vm.confirmPublicPrivate()}}},[(_vm.settings.access.public)?_c('span',[_vm._v("Make private")]):_c('span',[_vm._v("Make public")])])],1)],1),_vm._t("operations"),(_vm.project && _vm.project.permissions && _vm.project.permissions.delete)?_c(VGrid_namespaceObject.VRow):_vm._e()],2)],1)],2)
}
var ProjectSettingsViewTemplatevue_type_template_id_25879f87_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/views/ProjectSettingsViewTemplate.vue?vue&type=template&id=25879f87&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/ProjectSettingsViewTemplate.vue?vue&type=script&lang=ts&
var ProjectSettingsViewTemplatevue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ProjectSettingsViewTemplatevue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ProjectSettingsViewTemplatevue_type_script_lang_ts_assign.apply(this, arguments);
};




/* harmony default export */ var ProjectSettingsViewTemplatevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'ProjectSettingsViewTemplate',
    components: {
        ProjectAccessRequests: ProjectAccessRequest
    },
    props: {
        namespace: String,
        projectName: String,
        asAdmin: {
            type: Boolean,
            default: false
        },
        showSettings: Boolean
    },
    data: function () {
        return {
            settings: {},
            key: 0
        };
    },
    computed: ProjectSettingsViewTemplatevue_type_script_lang_ts_assign(ProjectSettingsViewTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('userModule', ['loggedUser'])), (0,external_vuex_namespaceObject.mapState)('projectModule', ['project'])),
    watch: {
        project: {
            immediate: true,
            handler: function (project) {
                if (JSON.stringify(this.settings.access) !==
                    JSON.stringify(this.project.access)) {
                    this.settings = {
                        access: JSON.parse(JSON.stringify(project.access))
                    };
                }
                this.key++;
            }
        }
    },
    created: function () {
        if (!this.showSettings) {
            this.$router.push('/projects');
        }
        this.settings = {
            access: JSON.parse(JSON.stringify(this.project.access))
        };
    },
    methods: ProjectSettingsViewTemplatevue_type_script_lang_ts_assign(ProjectSettingsViewTemplatevue_type_script_lang_ts_assign(ProjectSettingsViewTemplatevue_type_script_lang_ts_assign(ProjectSettingsViewTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('projectModule', ['deleteProject', 'saveProjectSettings'])), (0,external_vuex_namespaceObject.mapActions)('dialogModule', ['prompt'])), (0,external_vuex_namespaceObject.mapActions)('notificationModule', ['error'])), { saveProject: function (newSettingsAccessValues) {
            var newSettings = ProjectSettingsViewTemplatevue_type_script_lang_ts_assign(ProjectSettingsViewTemplatevue_type_script_lang_ts_assign({}, this.settings), { access: ProjectSettingsViewTemplatevue_type_script_lang_ts_assign(ProjectSettingsViewTemplatevue_type_script_lang_ts_assign({}, this.settings.access), newSettingsAccessValues) });
            this.settings.access.readersnames = newSettings.access.readersnames;
            this.settings.access.ownersnames = newSettings.access.ownersnames;
            this.settings.access.writersnames = newSettings.access.writersnames;
            this.saveSettings(newSettings);
        }, saveSettings: debounce_default()(function (newSettings) {
            var _a;
            try {
                this.saveProjectSettings({
                    namespace: this.namespace,
                    newSettings: newSettings,
                    projectName: this.projectName
                });
            }
            catch (err) {
                this.error({
                    text: ((_a = err.response.data) === null || _a === void 0 ? void 0 : _a.detail) || 'Failed to save project settings'
                });
            }
        }, 2000), togglePublicPrivate: function () {
            this.settings.access.public = !this.settings.access.public;
        }, confirmDelete: function () {
            var _this = this;
            var props = {
                text: "Are you sure to delete project: ".concat(this.projectName, "? All files will be lost. <br> <br> Type in project name to confirm:"),
                confirmText: 'Delete',
                confirmField: {
                    label: 'Project name',
                    expected: this.projectName
                }
            };
            var listeners = {
                confirm: function () { return _this.onDeleteProject(); }
            };
            this.prompt({
                params: { props: props, listeners: listeners, dialog: { maxWidth: 500 } }
            });
        }, confirmPublicPrivate: function () {
            var _this = this;
            var props = {
                text: "Do you really want to make this project ".concat(this.settings.access.public ? 'private' : 'public', "?"),
                confirmText: 'Yes'
            };
            var listeners = {
                confirm: function () { return _this.togglePublicPrivate(); }
            };
            this.prompt({
                params: { props: props, listeners: listeners, dialog: { maxWidth: 500 } }
            });
        }, onDeleteProject: function () {
            this.deleteProject({
                namespace: this.namespace,
                projectName: this.projectName
            });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/views/ProjectSettingsViewTemplate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var views_ProjectSettingsViewTemplatevue_type_script_lang_ts_ = (ProjectSettingsViewTemplatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/ProjectSettingsViewTemplate.vue?vue&type=style&index=0&id=25879f87&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/views/ProjectSettingsViewTemplate.vue?vue&type=style&index=0&id=25879f87&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/views/ProjectSettingsViewTemplate.vue



;


/* normalize component */

var ProjectSettingsViewTemplate_component = normalizeComponent(
  views_ProjectSettingsViewTemplatevue_type_script_lang_ts_,
  ProjectSettingsViewTemplatevue_type_template_id_25879f87_scoped_true_render,
  ProjectSettingsViewTemplatevue_type_template_id_25879f87_scoped_true_staticRenderFns,
  false,
  null,
  "25879f87",
  null
  
)

/* harmony default export */ var ProjectSettingsViewTemplate = (ProjectSettingsViewTemplate_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/ProjectVersionsView.vue?vue&type=template&id=73cb3a2a&scoped=true&
var ProjectVersionsViewvue_type_template_id_73cb3a2a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('project-versions-view-template',{attrs:{"projectName":_vm.projectName,"namespace":_vm.namespace,"asAdmin":_vm.asAdmin}})
}
var ProjectVersionsViewvue_type_template_id_73cb3a2a_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/ProjectVersionsViewTemplate.vue?vue&type=template&id=1875c690&scoped=true&







var ProjectVersionsViewTemplatevue_type_template_id_1875c690_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(VGrid_namespaceObject.VLayout,{attrs:{"align-center":"","shrink":""}},[_c(VGrid_namespaceObject.VSpacer)],1),_c('div',{staticClass:"text-center"},[(_vm.showPagination && _vm.options && _vm.versionsCount > _vm.options.itemsPerPage)?_c(VPagination_namespaceObject.VPagination,{attrs:{"length":Math.ceil(_vm.versionsCount / _vm.options.itemsPerPage),"total-visible":2,"circle":"","color":"primary"},on:{"input":_vm.fetchPage},model:{value:(_vm.options.page),callback:function ($$v) {_vm.$set(_vm.options, "page", $$v)},expression:"options.page"}}):_vm._e()],1),_c(VDataTable_namespaceObject.VDataTable,{attrs:{"headers":_vm.headers,"items":_vm.items,"item-key":"name","options":_vm.options,"server-items-length":_vm.versionsCount,"hide-default-footer":true,"loading":_vm.versionsLoading,"no-data-text":"No project history","color":"primary","data-cy":"project-verision-table"},on:{"update:options":_vm.paginating},scopedSlots:_vm._u([{key:"header.changes.added",fn:function({ header }){return [_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VIcon_namespaceObject.VIcon,_vm._g({attrs:{"small":"","color":header.color}},on),[_vm._v(_vm._s(header.icon)+" ")])]}}],null,true)},[_c('span',[_vm._v("Added")])])]}},{key:"header.changes.removed",fn:function({ header }){return [_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VIcon_namespaceObject.VIcon,_vm._g({attrs:{"small":"","color":header.color}},on),[_vm._v(_vm._s(header.icon)+" ")])]}}],null,true)},[_c('span',[_vm._v("Deleted")])])]}},{key:"header.changes.updated",fn:function({ header }){return [_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VIcon_namespaceObject.VIcon,_vm._g({attrs:{"small":"","color":header.color}},on),[_vm._v(_vm._s(header.icon)+" ")])]}}],null,true)},[_c('span',[_vm._v("Modified")])])]}},{key:"item.created",fn:function({ item }){return [_c('span',[_c(VTooltip_namespaceObject.VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({style:([_vm.rowStyle(item)])},on),[_vm._v(_vm._s(_vm._f("timediff")(item.created)))])]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm._f("datetime")(item.created)))])])],1)]}},{key:"item.author",fn:function({ item }){return [_c('span',{style:([_vm.rowStyle(item)])},[_vm._v(_vm._s(item.author))])]}},{key:"item.name",fn:function({ item }){return [_c('span',{attrs:{"data-cy":"project-versions-version"}},[_c('router-link',{style:([_vm.rowStyle(item)]),attrs:{"to":item.disabled
              ? ''
              : {
                  name: 'project-versions-detail',
                  params: { version_id: item.name }
                }}},[_vm._v(" "+_vm._s(item.name)+" ")])],1)]}},{key:"item.changes.added",fn:function({ item }){return [_c('span',[_c('span',{staticClass:"green--text",style:([_vm.rowStyle(item)])},[_vm._v(_vm._s(item.changes.added.length))])])]}},{key:"item.changes.removed",fn:function({ item }){return [_c('span',[_c('span',{staticClass:"red--text",style:([_vm.rowStyle(item)])},[_vm._v(_vm._s(item.changes.removed.length))])])]}},{key:"item.changes.updated",fn:function({ item }){return [_c('span',[_c('span',{staticClass:"orange--text",style:([_vm.rowStyle(item)])},[_vm._v(_vm._s(item.changes.updated.length))])])]}},{key:"item.project_size",fn:function({ item }){return [_c('span',{style:([_vm.rowStyle(item)])},[_vm._v(_vm._s(_vm._f("filesize")(item.project_size)))])]}}])}),_c('div',{staticClass:"text-center"},[(_vm.showPagination && _vm.options && _vm.versionsCount > _vm.options.itemsPerPage)?_c(VPagination_namespaceObject.VPagination,{attrs:{"length":Math.ceil(_vm.versionsCount / _vm.options.itemsPerPage),"total-visible":7,"circle":"","color":"primary"},on:{"input":_vm.fetchPage},model:{value:(_vm.options.page),callback:function ($$v) {_vm.$set(_vm.options, "page", $$v)},expression:"options.page"}}):_vm._e()],1),_vm._t("table-footer")],2)
}
var ProjectVersionsViewTemplatevue_type_template_id_1875c690_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/views/ProjectVersionsViewTemplate.vue?vue&type=template&id=1875c690&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/ProjectVersionsViewTemplate.vue?vue&type=script&lang=ts&
var ProjectVersionsViewTemplatevue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ProjectVersionsViewTemplatevue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ProjectVersionsViewTemplatevue_type_script_lang_ts_assign.apply(this, arguments);
};
var ProjectVersionsViewTemplatevue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var ProjectVersionsViewTemplatevue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



/* harmony default export */ var ProjectVersionsViewTemplatevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'ProjectVersionsViewTemplate',
    mixins: [MerginAPIMixin],
    props: {
        projectName: String,
        namespace: String,
        asAdmin: {
            type: Boolean,
            default: false
        },
        /** Default items per page */
        defaultItemsPerPage: Number,
        /** Disabled keys (name attribute of rows in vuetify table are keys for items) */
        disabledKeys: { type: Array, default: function () { return []; } },
        /** Show pagination */
        showPagination: { type: Boolean, default: true }
    },
    data: function () {
        var _a;
        return {
            headers: [
                { text: 'Version', value: 'name' },
                { text: 'Created', value: 'created' },
                { text: 'Author', value: 'author', sortable: false },
                {
                    text: 'Added',
                    value: 'changes.added',
                    icon: 'add_circle',
                    color: 'green',
                    sortable: false
                },
                {
                    text: 'Removed',
                    value: 'changes.removed',
                    icon: 'delete',
                    color: 'red',
                    sortable: false
                },
                {
                    text: 'Modified',
                    value: 'changes.updated',
                    icon: 'edit',
                    color: 'orange',
                    sortable: false
                },
                { text: 'Size', value: 'project_size', sortable: false },
                // { text: '', value: 'archived', sortable: false }
            ],
            options: {
                sortDesc: [true],
                itemsPerPage: (_a = this.defaultItemsPerPage) !== null && _a !== void 0 ? _a : 50,
                page: 1
            }
        };
    },
    computed: ProjectVersionsViewTemplatevue_type_script_lang_ts_assign(ProjectVersionsViewTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('projectModule', [
        'versions',
        'versionsLoading',
        'versionsCount'
    ])), { 
        /**
         * Table data from versions in global state transformed
         */
        items: function () {
            var _this = this;
            var versions = this.versions;
            return versions === null || versions === void 0 ? void 0 : versions.map(function (v) { return (ProjectVersionsViewTemplatevue_type_script_lang_ts_assign(ProjectVersionsViewTemplatevue_type_script_lang_ts_assign({}, v), { disabled: _this.disabledKeys.some(function (d) { return d === v.name; }) })); });
        } }),
    watch: {
        $route: 'fetchVersions'
    },
    methods: ProjectVersionsViewTemplatevue_type_script_lang_ts_assign(ProjectVersionsViewTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('projectModule', ['fetchProjectVersions'])), { paginating: function (options) {
            this.options = options;
            this.fetchVersions();
        }, fetchPage: function (number) {
            this.options.page = number;
            this.fetchVersions();
        }, rowStyle: function (item) {
            return item.disabled && { opacity: 0.5, cursor: 'not-allowed' };
        }, fetchVersions: function () {
            return ProjectVersionsViewTemplatevue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                var params;
                return ProjectVersionsViewTemplatevue_type_script_lang_ts_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            params = {
                                page: this.options.page,
                                per_page: this.options.itemsPerPage,
                                descending: this.options.sortDesc[0]
                            };
                            return [4 /*yield*/, this.fetchProjectVersions({
                                    params: params,
                                    namespace: this.namespace,
                                    projectName: this.projectName
                                })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/views/ProjectVersionsViewTemplate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var views_ProjectVersionsViewTemplatevue_type_script_lang_ts_ = (ProjectVersionsViewTemplatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/ProjectVersionsViewTemplate.vue?vue&type=style&index=0&id=1875c690&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/views/ProjectVersionsViewTemplate.vue?vue&type=style&index=0&id=1875c690&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/views/ProjectVersionsViewTemplate.vue



;


/* normalize component */

var ProjectVersionsViewTemplate_component = normalizeComponent(
  views_ProjectVersionsViewTemplatevue_type_script_lang_ts_,
  ProjectVersionsViewTemplatevue_type_template_id_1875c690_scoped_true_render,
  ProjectVersionsViewTemplatevue_type_template_id_1875c690_scoped_true_staticRenderFns,
  false,
  null,
  "1875c690",
  null
  
)

/* harmony default export */ var ProjectVersionsViewTemplate = (ProjectVersionsViewTemplate_component.exports);
;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/ProjectVersionsView.vue?vue&type=script&lang=ts&


/* harmony default export */ var ProjectVersionsViewvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'ProjectVersionsView',
    components: { ProjectVersionsViewTemplate: ProjectVersionsViewTemplate },
    props: {
        projectName: String,
        namespace: String,
        asAdmin: {
            type: Boolean,
            default: false
        }
    }
}));

;// CONCATENATED MODULE: ./src/modules/project/views/ProjectVersionsView.vue?vue&type=script&lang=ts&
 /* harmony default export */ var views_ProjectVersionsViewvue_type_script_lang_ts_ = (ProjectVersionsViewvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/project/views/ProjectVersionsView.vue





/* normalize component */
;
var ProjectVersionsView_component = normalizeComponent(
  views_ProjectVersionsViewvue_type_script_lang_ts_,
  ProjectVersionsViewvue_type_template_id_73cb3a2a_scoped_true_render,
  ProjectVersionsViewvue_type_template_id_73cb3a2a_scoped_true_staticRenderFns,
  false,
  null,
  "73cb3a2a",
  null
  
)

/* harmony default export */ var ProjectVersionsView = (ProjectVersionsView_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VTabs"
var VTabs_namespaceObject = require("vuetify/lib/components/VTabs");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/ProjectViewTemplate.vue?vue&type=template&id=1dc261c0&scoped=true&











var ProjectViewTemplatevue_type_template_id_1dc261c0_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-view',{style:(`padding-left: ${
    _vm.drawer ? 260 : 20
  }px; overflow-y: auto; padding-right:20px; margin-right: 0px;`)},[_c('div',{staticClass:"panel",attrs:{"slot":"left"},slot:"left"}),_c(VGrid_namespaceObject.VLayout,{staticClass:"column fill-height project-page main-content"},[(_vm.project)?_c(VCard_namespaceObject.VCard,{staticStyle:{"margin-bottom":"0"},attrs:{"outlined":""}},[_c(VGrid_namespaceObject.VLayout,{staticClass:"row align-center toolbar"},[_c('div',{staticClass:"breadcrumbs",staticStyle:{"font-size":"20px"}},[_c(VIcon_namespaceObject.VIcon,{attrs:{"color":"primary"}},[_vm._v("map")]),(_vm.showNamespace)?_c('span',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.project.namespace)+" /")]):_vm._e(),_c('router-link',{attrs:{"to":{
              name: 'project',
              project: _vm.project
            }}},[_c('b',[_vm._v(_vm._s(_vm.project.name))])]),_c('router-link',{attrs:{"to":{
              name: 'project-versions-detail'
            }},scopedSlots:_vm._u([{key:"default",fn:function({ href, route, navigate }){return [(route.params.version_id)?_c('span',[_vm._v(" > "),_c('a',{attrs:{"href":href},on:{"click":navigate}},[_vm._v(" "+_vm._s(route.params.version_id)+" ")])]):_vm._e()]}}],null,false,1632237936)}),_c('router-link',{attrs:{"to":{ name: 'file-version-detail' }},scopedSlots:_vm._u([{key:"default",fn:function({ href, route, navigate }){return [(route.params.path)?_c('span',[_vm._v(" > "),_c('a',{attrs:{"href":href},on:{"click":navigate}},[_vm._v(" "+_vm._s(route.params.path)+" ")])]):_vm._e()]}}],null,false,905695472)})],1),_c(VGrid_namespaceObject.VSpacer),_c('portal-target',{staticClass:"layout row shrink",attrs:{"name":"project-toolbar"}}),_vm._t("shareButton",function(){return [_c('project-share-button')]}),(_vm.canCloneProject)?_c('action-button',{attrs:{"data-cy":"project-clone-btn"},on:{"click":_vm.cloneDialog},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('copy-icon')]},proxy:true}],null,false,746414720)},[_vm._v(" Clone ")]):_vm._e(),(_vm.canLeaveProject)?_c('action-button',{attrs:{"data-cy":"project-leave-btn"},on:{"click":_vm.unsubscribeDialog},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('square-minus-icon')]},proxy:true}],null,false,3541227173)},[_vm._v(" Leave project ")]):_vm._e()],2),_c(VCard_namespaceObject.VCard,{staticClass:"layout column fill-height",attrs:{"flat":""}},[_c(VCard_namespaceObject.VCardTitle,[_c(VTabs_namespaceObject.VTabs,{attrs:{"left-active":"","show-arrows":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c(VTabs_namespaceObject.VTabsSlider,{attrs:{"color":"primary"}}),_c(VTabs_namespaceObject.VTab,{key:"files",attrs:{"to":{
                name: `project-tree`,
                params: { namespace: _vm.namespace, projectName: _vm.project.name }
              }}},[_vm._v("Files ")]),(_vm.loggedUser)?_vm._t("map.tab"):_vm._e(),(_vm.loggedUser && _vm.showHistory)?_c(VTabs_namespaceObject.VTab,{key:"history",attrs:{"to":{
                name: `project-versions`,
                params: { namespace: _vm.namespace, projectName: _vm.project.name }
              }}},[_vm._v("History ")]):_vm._e(),(_vm.loggedUser && _vm.showSettings)?_c(VTabs_namespaceObject.VTab,{key:"settings",attrs:{"to":{
                name: `project-settings`,
                params: { namespace: _vm.namespace, projectName: _vm.project.name }
              }}},[_vm._v("Settings ")]):_vm._e()],2)],1),_c(VDivider_namespaceObject.VDivider),(_vm.project)?_c('router-view',{staticClass:"content-container"}):_vm._e()],1)],1):(_vm.fetchProjectsResponseStatus === 403)?_c(VCard_namespaceObject.VCard,[_c(VGrid_namespaceObject.VLayout,{staticClass:"public-private-zone",staticStyle:{"padding-top":"25px","padding-left":"25px"}},[_c(VBtn_namespaceObject.VBtn,{attrs:{"id":"request-access-btn"},on:{"click":_vm.createAccessRequest}},[_vm._v("Request access ")]),_c('span',{staticClass:"private-public-text"},[_c('b',[_vm._v("This is a private project")]),_c('br'),_vm._v(" You don't have permissions to access this project. ")])],1)],1):(_vm.fetchProjectsResponseStatus === 404)?_c(VCard_namespaceObject.VCard,[_c('span',{staticClass:"private-public-text",staticStyle:{"padding-top":"25px","padding-left":"25px"}},[_c('b',[_vm._v("Project not found")]),_c('br'),_vm._v(" Please check if address is written correctly ")])]):(_vm.fetchProjectsResponseStatus === 409)?_c(VCard_namespaceObject.VCard,[_c('span',{staticClass:"private-public-text",staticStyle:{"padding-top":"25px","padding-left":"25px"}},[_c('b',[_vm._v("You don't have permission to access this project")]),_c('br'),_vm._v(" You already requested access ")])]):_vm._e(),(
        _vm.project &&
        _vm.$route.name === 'project-tree' &&
        _vm.project.permissions.upload
      )?_c('drop-area',{staticClass:"drop-area",attrs:{"location":_vm.location,"data-cy":"project-drop-area"}},[_c(VGrid_namespaceObject.VLayout,{staticClass:"drag-drop-text",attrs:{"row":"","wrap":"","align-center":""}},[_c('span',[_c(VIcon_namespaceObject.VIcon,[_vm._v("publish")]),_vm._v(" Drag & drop here or click and select file(s) to upload ")],1)])],1):_vm._e()],1),_c('div',{staticClass:"panel",attrs:{"slot":"right"},slot:"right"},[(_vm.upload)?_c('upload-panel',{staticClass:"my-1 mr-1",attrs:{"namespace":_vm.namespace}}):_vm._e()],1)],1)
}
var ProjectViewTemplatevue_type_template_id_1dc261c0_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/views/ProjectViewTemplate.vue?vue&type=template&id=1dc261c0&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/ProjectViewTemplate.vue?vue&type=script&lang=ts&
var ProjectViewTemplatevue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ProjectViewTemplatevue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ProjectViewTemplatevue_type_script_lang_ts_assign.apply(this, arguments);
};
var ProjectViewTemplatevue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var ProjectViewTemplatevue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};












/* harmony default export */ var ProjectViewTemplatevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'ProjectViewTemplate',
    mixins: [MerginAPIMixin],
    components: {
        ActionButton: ActionButton,
        ProjectShareButton: ProjectShareButton,
        PageView: PageView,
        UploadPanel: UploadPanel,
        DropArea: DropArea,
        CopyIcon: external_vue_tabler_icons_namespaceObject.CopyIcon,
        DownloadIcon: external_vue_tabler_icons_namespaceObject.DownloadIcon,
        SquareMinusIcon: external_vue_tabler_icons_namespaceObject.SquareMinusIcon
    },
    props: {
        /**  Show namespace (ws) label in breadcrumb of page */
        showNamespace: {
            type: Boolean,
            default: true
        },
        namespace: String,
        projectName: String,
        location: {
            type: String,
            default: ''
        },
        showSettings: Boolean,
        showHistory: { type: Boolean, default: true },
        hideCloneButton: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            fetchProjectsResponseStatus: null,
            tab: null
        };
    },
    computed: ProjectViewTemplatevue_type_script_lang_ts_assign(ProjectViewTemplatevue_type_script_lang_ts_assign(ProjectViewTemplatevue_type_script_lang_ts_assign(ProjectViewTemplatevue_type_script_lang_ts_assign(ProjectViewTemplatevue_type_script_lang_ts_assign(ProjectViewTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('layoutModule', ['drawer'])), (0,external_vuex_namespaceObject.mapState)('projectModule', ['project', 'uploads'])), (0,external_vuex_namespaceObject.mapState)('userModule', ['loggedUser'])), (0,external_vuex_namespaceObject.mapGetters)('projectModule', ['isProjectOwner'])), (0,external_vuex_namespaceObject.mapGetters)('userModule', ['currentWorkspace', 'isLoggedIn'])), { canCloneProject: function () {
            return this.isLoggedIn && !this.hideCloneButton;
        }, canLeaveProject: function () {
            var _a, _b, _c;
            return (((_a = this.project) === null || _a === void 0 ? void 0 : _a.workspace_id) === ((_b = this.currentWorkspace) === null || _b === void 0 ? void 0 : _b.id) &&
                ((_c = this.currentWorkspace) === null || _c === void 0 ? void 0 : _c.role) === USER_ROLE_NAME_BY_ROLE[UserRole.guest]);
        }, upload: function () {
            return this.project && this.uploads[this.project.path];
        }, downloadUrl: function () {
            if (this.$route.name === 'project-versions-detail') {
                return ProjectApi.constructDownloadProjectVersionUrl(this.namespace, this.projectName, this.$route.params.version_id);
            }
            else {
                return ProjectApi.constructDownloadProjectUrl(this.namespace, this.projectName);
            }
        } }),
    created: function () {
        return ProjectViewTemplatevue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
            return ProjectViewTemplatevue_type_script_lang_ts_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.project ||
                            this.project.name !== this.projectName ||
                            this.project.namespace !== this.namespace)) return [3 /*break*/, 2];
                        this.setProject({ project: null });
                        return [4 /*yield*/, this.getProject()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    },
    watch: {
        project: function () {
            if (!this.project ||
                this.project.name !== this.projectName ||
                this.project.namespace !== this.namespace) {
                this.setProject({ project: null });
                this.getProject();
            }
        }
    },
    methods: ProjectViewTemplatevue_type_script_lang_ts_assign(ProjectViewTemplatevue_type_script_lang_ts_assign(ProjectViewTemplatevue_type_script_lang_ts_assign(ProjectViewTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('projectModule', [
        'fetchProjectDetail',
        'unsubscribeProject'
    ])), (0,external_vuex_namespaceObject.mapMutations)('projectModule', ['setProject'])), (0,external_vuex_namespaceObject.mapActions)('dialogModule', ['show'])), { setFetchProjectResponseStatus: function (status) {
            this.fetchProjectsResponseStatus = status;
        }, getProject: function () {
            return ProjectViewTemplatevue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                var _this = this;
                return ProjectViewTemplatevue_type_script_lang_ts_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, new Promise(function (resolve) {
                                resolve(_this.fetchProjectDetail({
                                    callbackStatus: _this.setFetchProjectResponseStatus,
                                    projectName: _this.projectName,
                                    namespace: _this.namespace,
                                    isLoggedUser: !!_this.loggedUser
                                }));
                            })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }, cloneDialog: function () {
            this.$emit('open-clone-dialog');
        }, createAccessRequest: function () {
            var _this = this;
            waitCursor(true);
            ProjectApi.createProjectAccessRequest(this.namespace, this.projectName, true)
                .then(function () {
                waitCursor(false);
                _this.$store.dispatch('notificationModule/show', {
                    text: 'Access has been requested'
                });
                _this.$router.push({
                    name: 'projects'
                });
            })
                .catch(function () {
                _this.$store.dispatch('notificationModule/error', {
                    text: 'Failed to request'
                });
                waitCursor(false);
            });
        }, unsubscribeDialog: function () {
            var _this = this;
            var projPath = "".concat(this.namespace, "/").concat(this.projectName);
            var props = {
                text: "Are you sure to leave the project <strong>".concat(projPath, "</strong>?\n        You will not have access to it anymore."),
                confirmText: 'OK'
            };
            var listeners = {
                confirm: function () { return ProjectViewTemplatevue_type_script_lang_ts_awaiter(_this, void 0, void 0, function () {
                    return ProjectViewTemplatevue_type_script_lang_ts_generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.unsubscribeProject({ id: this.project.id })];
                            case 1:
                                _a.sent();
                                if (!!this.project) return [3 /*break*/, 3];
                                return [4 /*yield*/, this.$router.push('/dashboard')];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); }
            };
            this.$store.dispatch('dialogModule/prompt', {
                params: { props: props, listeners: listeners, dialog: { maxWidth: 500 } }
            });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/project/views/ProjectViewTemplate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var views_ProjectViewTemplatevue_type_script_lang_ts_ = (ProjectViewTemplatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/ProjectViewTemplate.vue?vue&type=style&index=0&id=1dc261c0&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/views/ProjectViewTemplate.vue?vue&type=style&index=0&id=1dc261c0&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/views/ProjectViewTemplate.vue



;


/* normalize component */

var ProjectViewTemplate_component = normalizeComponent(
  views_ProjectViewTemplatevue_type_script_lang_ts_,
  ProjectViewTemplatevue_type_template_id_1dc261c0_scoped_true_render,
  ProjectViewTemplatevue_type_template_id_1dc261c0_scoped_true_staticRenderFns,
  false,
  null,
  "1dc261c0",
  null
  
)

/* harmony default export */ var ProjectViewTemplate = (ProjectViewTemplate_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/VersionDetailView.vue?vue&type=template&id=5fda1c90&scoped=true&








var VersionDetailViewvue_type_template_id_5fda1c90_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.version)?_c('div',[_c(VList_namespaceObject.VList,{attrs:{"two-line":"","subheader":""}},[_c(VList_namespaceObject.VListItem,[_c(VList_namespaceObject.VListItemContent,[_c(VList_namespaceObject.VListItemTitle,[_vm._v("Version")]),_c(VList_namespaceObject.VListItemSubtitle,[_vm._v(_vm._s(_vm.version.name))])],1)],1),_c(VList_namespaceObject.VListItem,[_c(VList_namespaceObject.VListItemContent,[_c(VList_namespaceObject.VListItemTitle,[_vm._v("Author")]),_c(VList_namespaceObject.VListItemSubtitle,[_vm._v(_vm._s(_vm.version.author))])],1)],1),_c(VList_namespaceObject.VListItem,[_c(VList_namespaceObject.VListItemContent,[_c(VList_namespaceObject.VListItemTitle,[_vm._v("Project Size")]),_c(VList_namespaceObject.VListItemSubtitle,[_vm._v(_vm._s(_vm._f("filesize")(_vm.version.project_size))+" ")])],1)],1),_c(VList_namespaceObject.VListItem,[_c(VList_namespaceObject.VListItemContent,[_c(VList_namespaceObject.VListItemTitle,[_vm._v("Created")]),_c(VList_namespaceObject.VListItemSubtitle,[_vm._v(_vm._s(_vm._f("datetime")(_vm.version.created))+" ")])],1)],1),_c(VList_namespaceObject.VListItem,[_c(VList_namespaceObject.VListItemContent,[_c(VList_namespaceObject.VListItemTitle,[_vm._v("User Agent")]),_c(VList_namespaceObject.VListItemSubtitle,[_vm._v(_vm._s(_vm.version.user_agent))])],1)],1)],1),_c(VList_namespaceObject.VList,{staticClass:"files",attrs:{"expand":""}},[_c(VList_namespaceObject.VListItem,[_c(VList_namespaceObject.VListItemContent,[_c(VList_namespaceObject.VListItemTitle,[_vm._v("Files changes:")])],1)],1),_vm._l((_vm.changeHeader),function({ key, text, icon }){return _c(VList_namespaceObject.VListGroup,{key:key,attrs:{"data-cy":"version-detail-groups","no-action":""},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c(VList_namespaceObject.VListItemContent,[_c(VList_namespaceObject.VListItemTitle,[_c(VIcon_namespaceObject.VIcon,{staticClass:"mr-2",attrs:{"small":""},domProps:{"textContent":_vm._s(icon)}}),_c('span',[_vm._v(_vm._s(text)+" ("+_vm._s(_vm.changes[key].length)+")")])],1)],1)]},proxy:true}],null,true)},_vm._l((_vm.changes[key]),function(item){return _c('div',{key:item.path,staticClass:"v-list__tile v-list-item-file",attrs:{"no-action":""}},[_c('div',{class:_vm.colors[key]},[_vm._v(" "+_vm._s(item.path)+": "+_vm._s(_vm._f("filesize")(_vm.version.changesets[item.path] ? _vm.version.changesets[item.path]['size'] : item.size))+" "),(_vm.version.changesets[item.path])?[(!_vm.version.changesets[item.path].error)?_c('div',[_c('file-changeset-summary-table',{attrs:{"changesets":_vm.version.changesets[item.path]['summary']}})],1):_c('div',{staticClass:"text--primary"},[_vm._v(" Details not available: "+_vm._s(_vm.version.changesets[item.path].error)+" ")])]:_vm._e()],2)])}),0)})],2)],1):_vm._e()
}
var VersionDetailViewvue_type_template_id_5fda1c90_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/project/views/VersionDetailView.vue?vue&type=template&id=5fda1c90&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/VersionDetailView.vue?vue&type=script&lang=ts&
var VersionDetailViewvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    VersionDetailViewvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return VersionDetailViewvue_type_script_lang_ts_assign.apply(this, arguments);
};
var VersionDetailViewvue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var VersionDetailViewvue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var VersionDetailViewvue_type_script_lang_ts_Colors = {
    added: 'green--text',
    removed: 'red--text',
    updated: 'orange--text'
};
/* harmony default export */ var VersionDetailViewvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'VersionDetailView',
    components: { FileChangesetSummaryTable: FileChangesetSummaryTable },
    props: {
        version_id: {
            type: String,
            default: ''
        },
        asAdmin: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            version: null
        };
    },
    created: function () {
        this.getVersion();
    },
    computed: VersionDetailViewvue_type_script_lang_ts_assign(VersionDetailViewvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('projectModule', ['project', 'versions'])), { colors: function () {
            return VersionDetailViewvue_type_script_lang_ts_Colors;
        }, changeHeader: function () {
            return [
                { key: 'added', text: 'Added', icon: 'add_circle' },
                { key: 'removed', text: 'Removed', icon: 'delete' },
                { key: 'updated', text: 'Modified', icon: 'edit' }
            ];
        }, changes: function () {
            var _a;
            return (_a = this.version) === null || _a === void 0 ? void 0 : _a.changes;
        } }),
    watch: {
        $route: 'getVersion'
    },
    methods: {
        getVersion: function () {
            var _a, _b;
            return VersionDetailViewvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                var currentVersion, response, err_1, msg;
                var _this = this;
                return VersionDetailViewvue_type_script_lang_ts_generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 2, , 3]);
                            currentVersion = (_a = this.versions) === null || _a === void 0 ? void 0 : _a.find(function (v) { return v.name === _this.version_id; });
                            if (currentVersion) {
                                this.version = currentVersion;
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, ProjectApi.getProjectVersion(this.project.id, this.version_id)];
                        case 1:
                            response = _c.sent();
                            this.version = response.data;
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _c.sent();
                            msg = err_1.response
                                ? (_b = err_1.response.data) === null || _b === void 0 ? void 0 : _b.detail
                                : 'Failed to fetch project version';
                            this.$store.dispatch('notificationModule/error', { text: msg });
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
    }
}));

;// CONCATENATED MODULE: ./src/modules/project/views/VersionDetailView.vue?vue&type=script&lang=ts&
 /* harmony default export */ var views_VersionDetailViewvue_type_script_lang_ts_ = (VersionDetailViewvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/project/views/VersionDetailView.vue?vue&type=style&index=0&id=5fda1c90&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/project/views/VersionDetailView.vue?vue&type=style&index=0&id=5fda1c90&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/project/views/VersionDetailView.vue



;


/* normalize component */

var VersionDetailView_component = normalizeComponent(
  views_VersionDetailViewvue_type_script_lang_ts_,
  VersionDetailViewvue_type_template_id_5fda1c90_scoped_true_render,
  VersionDetailViewvue_type_template_id_5fda1c90_scoped_true_staticRenderFns,
  false,
  null,
  "5fda1c90",
  null
  
)

/* harmony default export */ var VersionDetailView = (VersionDetailView_component.exports);
;// CONCATENATED MODULE: ./src/modules/project/views/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial










;// CONCATENATED MODULE: ./src/modules/project/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial







;// CONCATENATED MODULE: external "vuetify/lib/components/VForm"
var VForm_namespaceObject = require("vuetify/lib/components/VForm");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/components/ChangePasswordForm.vue?vue&type=template&id=9876db3a&












var ChangePasswordFormvue_type_template_id_9876db3a_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCard_namespaceObject.VCard,[_c(VCard_namespaceObject.VCardTitle,[_c('span',{staticClass:"text-h5"},[_vm._v("Change password")])]),_c(VCard_namespaceObject.VCardText,[_c(VForm_namespaceObject.VForm,{staticClass:"layout column",attrs:{"cy-data":"user-change-password-form"},on:{"submit":function($event){$event.preventDefault();}}},[_c(VTextField_namespaceObject.VTextField,{attrs:{"label":"Old Password","name":"oldPassword","color":"inputColor","cy-data":"user-change-password-old","append-icon":_vm.passwordVisible ? 'visibility_off' : 'visibility',"type":_vm.passwordVisible ? 'text' : 'password',"error-messages":_vm.errors.old_password},on:{"click:append":function($event){_vm.passwordVisible = !_vm.passwordVisible}},model:{value:(_vm.oldPassword),callback:function ($$v) {_vm.oldPassword=$$v},expression:"oldPassword"}}),_c(VTextField_namespaceObject.VTextField,{attrs:{"label":"New Password","name":"password","color":"inputColor","cy-data":"user-change-password-new","type":_vm.passwordVisible ? 'text' : 'password',"error-messages":_vm.errors.password},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.changePassword.apply(null, arguments)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_c(VTextField_namespaceObject.VTextField,{attrs:{"label":"Confirm New Password","name":"confirm","color":"inputColor","cy-data":"user-change-password-confirm","type":_vm.passwordVisible ? 'text' : 'password',"error-messages":_vm.errors.confirm},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.changePassword.apply(null, arguments)}},model:{value:(_vm.confirm),callback:function ($$v) {_vm.confirm=$$v},expression:"confirm"}}),_c(VGrid_namespaceObject.VLayout,{staticClass:"d-flex flex-row-reverse",attrs:{"row":""}},[_c(VTooltip_namespaceObject.VTooltip,{attrs:{"top":"","color":"orange","max-width":"350","content-class":"form-tooltip"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VIcon_namespaceObject.VIcon,_vm._g({staticClass:"ml-1 mb-1",staticStyle:{"margin-right":"1rem"}},on),[_vm._v("info ")])]}}])},[_c('ul',[_c('li',[_vm._v("Password must be at least 8 characters long.")]),_c('li',[_vm._v(" Password must contain at least 3 character categories among the following: "),_c('ul',[_c('li',[_vm._v("Lowercase characters (a-z)")]),_c('li',[_vm._v("Uppercase characters (A-Z)")]),_c('li',[_vm._v("Digits (0-9)")]),_c('li',[_vm._v("Special characters")])])])])])],1),_c(VCard_namespaceObject.VCardActions,[_c(VGrid_namespaceObject.VSpacer),_c(VBtn_namespaceObject.VBtn,{staticClass:"text--primary",attrs:{"cy-data":"user-change-password-close-btn"},on:{"click":_vm.close}},[_vm._v(" Close ")]),_c(VBtn_namespaceObject.VBtn,{staticClass:"primary text--white",attrs:{"disabled":!_vm.password || !_vm.oldPassword || !_vm.confirm,"cy-data":"user-change-password-change-btn"},on:{"click":_vm.changePassword}},[_vm._v(" Change ")])],1)],1)],1)],1)
}
var ChangePasswordFormvue_type_template_id_9876db3a_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/user/components/ChangePasswordForm.vue?vue&type=template&id=9876db3a&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/components/ChangePasswordForm.vue?vue&type=script&lang=ts&
var ChangePasswordFormvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ChangePasswordFormvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ChangePasswordFormvue_type_script_lang_ts_assign.apply(this, arguments);
};



/* harmony default export */ var ChangePasswordFormvue_type_script_lang_ts_ = (external_vue_default().extend({
    data: function () {
        return {
            oldPassword: '',
            password: '',
            confirm: '',
            passwordVisible: false
        };
    },
    computed: ChangePasswordFormvue_type_script_lang_ts_assign(ChangePasswordFormvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapGetters)('formModule', ['getErrorByComponentId'])), { errors: function () {
            var _a;
            return (_a = this.getErrorByComponentId(this.merginComponentUuid)) !== null && _a !== void 0 ? _a : {};
        } }),
    beforeDestroy: function () {
        this.clearErrors({
            componentId: this.merginComponentUuid,
            keepNotification: true
        });
    },
    methods: ChangePasswordFormvue_type_script_lang_ts_assign(ChangePasswordFormvue_type_script_lang_ts_assign(ChangePasswordFormvue_type_script_lang_ts_assign(ChangePasswordFormvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('formModule', ['clearErrors'])), (0,external_vuex_namespaceObject.mapActions)('dialogModule', ['close'])), (0,external_vuex_namespaceObject.mapActions)('userModule', {
        changePasswordAction: 'changePassword'
    })), { changePassword: function () {
            this.clearErrors({ componentId: this.merginComponentUuid });
            var data = {
                old_password: this.oldPassword,
                password: this.password,
                confirm: this.confirm
            };
            waitCursor(true);
            this.changePasswordAction({ data: data, componentId: this.merginComponentUuid });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/user/components/ChangePasswordForm.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ChangePasswordFormvue_type_script_lang_ts_ = (ChangePasswordFormvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/user/components/ChangePasswordForm.vue





/* normalize component */
;
var ChangePasswordForm_component = normalizeComponent(
  components_ChangePasswordFormvue_type_script_lang_ts_,
  ChangePasswordFormvue_type_template_id_9876db3a_render,
  ChangePasswordFormvue_type_template_id_9876db3a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ChangePasswordForm = (ChangePasswordForm_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VCheckbox"
var VCheckbox_namespaceObject = require("vuetify/lib/components/VCheckbox");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/components/EditProfileForm.vue?vue&type=template&id=f08587ba&










var EditProfileFormvue_type_template_id_f08587ba_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCard_namespaceObject.VCard,{attrs:{"cy-data":"profile-edit-form"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.submit.apply(null, arguments)}}},[_c(VCard_namespaceObject.VCardTitle,[_c('span',{staticClass:"text-h5"},[_vm._v("Edit profile")])]),_c(VCard_namespaceObject.VCardText,[_c(VForm_namespaceObject.VForm,{staticClass:"layout column",on:{"submit":function($event){$event.preventDefault();}}},[_c(VTextField_namespaceObject.VTextField,{attrs:{"label":"First name","cy-data":"profile-edit-first-name","error-messages":_vm.errors.first_name},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.submit.apply(null, arguments)}},model:{value:(_vm.editedProfile.first_name),callback:function ($$v) {_vm.$set(_vm.editedProfile, "first_name", $$v)},expression:"editedProfile.first_name"}}),_c(VTextField_namespaceObject.VTextField,{attrs:{"label":"Last name","cy-data":"profile-edit-last-name","error-messages":_vm.errors.last_name},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.submit.apply(null, arguments)}},model:{value:(_vm.editedProfile.last_name),callback:function ($$v) {_vm.$set(_vm.editedProfile, "last_name", $$v)},expression:"editedProfile.last_name"}}),_c(VTextField_namespaceObject.VTextField,{attrs:{"label":"Email address","cy-data":"profile-edit-email","error-messages":_vm.errors.email},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.submit.apply(null, arguments)}},model:{value:(_vm.editedProfile.email),callback:function ($$v) {_vm.$set(_vm.editedProfile, "email", $$v)},expression:"editedProfile.email"}}),_c(VCheckbox_namespaceObject.VCheckbox,{attrs:{"label":"Receive notifications","color":"orange","cy-data":"profile-edit-notification","error-messages":_vm.errors.receive_notifications},model:{value:(_vm.editedProfile.receive_notifications),callback:function ($$v) {_vm.$set(_vm.editedProfile, "receive_notifications", $$v)},expression:"editedProfile.receive_notifications"}}),_c(VCard_namespaceObject.VCardActions,[_c(VGrid_namespaceObject.VSpacer),_c(VBtn_namespaceObject.VBtn,{staticClass:"text--primary",attrs:{"cy-data":"profile-edit-close-btn"},on:{"click":_vm.close}},[_vm._v(" Close ")]),_c(VBtn_namespaceObject.VBtn,{staticClass:"primary white--text",attrs:{"cy-data":"profile-edit-save-btn"},on:{"click":_vm.submit}},[_vm._v(" Save ")])],1)],1)],1)],1)
}
var EditProfileFormvue_type_template_id_f08587ba_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/user/components/EditProfileForm.vue?vue&type=template&id=f08587ba&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/components/EditProfileForm.vue?vue&type=script&lang=ts&
var EditProfileFormvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    EditProfileFormvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return EditProfileFormvue_type_script_lang_ts_assign.apply(this, arguments);
};


/* harmony default export */ var EditProfileFormvue_type_script_lang_ts_ = (external_vue_default().extend({
    props: {
        profile: Object
    },
    data: function () {
        return {
            editedProfile: Object.assign({}, this.profile)
        };
    },
    computed: EditProfileFormvue_type_script_lang_ts_assign(EditProfileFormvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapGetters)('formModule', ['getErrorByComponentId'])), { errors: function () {
            var _a;
            return (_a = this.getErrorByComponentId(this.merginComponentUuid)) !== null && _a !== void 0 ? _a : {};
        } }),
    beforeDestroy: function () {
        this.clearErrors({
            componentId: this.merginComponentUuid,
            keepNotification: true
        });
    },
    methods: EditProfileFormvue_type_script_lang_ts_assign(EditProfileFormvue_type_script_lang_ts_assign(EditProfileFormvue_type_script_lang_ts_assign(EditProfileFormvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('formModule', ['clearErrors'])), (0,external_vuex_namespaceObject.mapActions)('userModule', ['editUserProfile'])), (0,external_vuex_namespaceObject.mapActions)('dialogModule', ['close'])), { submit: function () {
            var _this = this;
            this.clearErrors({ componentId: this.merginComponentUuid });
            var keys = ['first_name', 'last_name', 'email'];
            keys.forEach(function (key) {
                if (_this.editedProfile[key])
                    _this.editedProfile[key] = _this.editedProfile[key].trim();
            });
            this.editUserProfile({
                editedUser: this.editedProfile,
                componentId: this.merginComponentUuid
            });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/user/components/EditProfileForm.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_EditProfileFormvue_type_script_lang_ts_ = (EditProfileFormvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/user/components/EditProfileForm.vue





/* normalize component */
;
var EditProfileForm_component = normalizeComponent(
  components_EditProfileFormvue_type_script_lang_ts_,
  EditProfileFormvue_type_template_id_f08587ba_render,
  EditProfileFormvue_type_template_id_f08587ba_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var EditProfileForm = (EditProfileForm_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/components/ProfileAccessRequestsRow.vue?vue&type=template&id=56788bb8&scoped=true&



var ProfileAccessRequestsRowvue_type_template_id_56788bb8_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.accessRequests && _vm.accessRequests.length > 0)?_c(VCard_namespaceObject.VCard,{staticClass:"table",attrs:{"flat":""}},[_c(VCard_namespaceObject.VCardText,[_c('h3',[_vm._v("Project access requests")]),_c('project-access-request-table')],1)],1):_vm._e()
}
var ProfileAccessRequestsRowvue_type_template_id_56788bb8_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/user/components/ProfileAccessRequestsRow.vue?vue&type=template&id=56788bb8&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/components/ProfileAccessRequestsRow.vue?vue&type=script&lang=ts&
var ProfileAccessRequestsRowvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ProfileAccessRequestsRowvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ProfileAccessRequestsRowvue_type_script_lang_ts_assign.apply(this, arguments);
};
var ProfileAccessRequestsRowvue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var ProfileAccessRequestsRowvue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



/* harmony default export */ var ProfileAccessRequestsRowvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'ProfileAccessRequestsRow',
    components: { ProjectAccessRequestTable: ProjectAccessRequestTable },
    computed: ProfileAccessRequestsRowvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('projectModule', ['accessRequests'])),
    created: function () {
        return ProfileAccessRequestsRowvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
            return ProfileAccessRequestsRowvue_type_script_lang_ts_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.initAccessRequests()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    methods: ProfileAccessRequestsRowvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('projectModule', ['initAccessRequests']))
}));

;// CONCATENATED MODULE: ./src/modules/user/components/ProfileAccessRequestsRow.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ProfileAccessRequestsRowvue_type_script_lang_ts_ = (ProfileAccessRequestsRowvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/user/components/ProfileAccessRequestsRow.vue





/* normalize component */
;
var ProfileAccessRequestsRow_component = normalizeComponent(
  components_ProfileAccessRequestsRowvue_type_script_lang_ts_,
  ProfileAccessRequestsRowvue_type_template_id_56788bb8_scoped_true_render,
  ProfileAccessRequestsRowvue_type_template_id_56788bb8_scoped_true_staticRenderFns,
  false,
  null,
  "56788bb8",
  null
  
)

/* harmony default export */ var ProfileAccessRequestsRow = (ProfileAccessRequestsRow_component.exports);
;// CONCATENATED MODULE: ./src/modules/user/components/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial





;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/views/ChangePasswordView.vue?vue&type=template&id=85f02ba8&scoped=true&










var ChangePasswordViewvue_type_template_id_85f02ba8_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('custom-page',[_c(VCard_namespaceObject.VCard,{staticClass:"text-center",staticStyle:{"min-width":"300px"},on:{"":_vm.changePasswordWithToken}},[_c(VCard_namespaceObject.VCardTitle,{staticClass:"justify-center primary--text font-weight-bold ml-3"},[_c('h3',[_vm._v("Change password")])]),_c(VCard_namespaceObject.VCardText,[(!_vm.success)?_c(VForm_namespaceObject.VForm,{staticClass:"layout column",on:{"submit":function($event){$event.preventDefault();}}},[_c(VTextField_namespaceObject.VTextField,_vm._g({attrs:{"label":"New Password","name":"password","color":"inputColor","data-cy":"change-password","append-icon":_vm.passwordVisible ? 'visibility_off' : 'visibility',"type":_vm.passwordVisible ? 'text' : 'password',"error-messages":_vm.errors.password},on:{"click:append":function($event){_vm.passwordVisible = !_vm.passwordVisible}},scopedSlots:_vm._u([{key:"append-outer",fn:function(){return [_c(VTooltip_namespaceObject.VTooltip,{attrs:{"top":"","color":"orange","max-width":"350","content-class":"form-tooltip"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VIcon_namespaceObject.VIcon,_vm._g({staticClass:"ml-1 mb-1"},on),[_vm._v("info")])]}}],null,false,1671665250)},[_c('ul',[_c('li',[_vm._v("Password must be at least 8 characters long.")]),_c('li',[_vm._v(" Password must contain at least 3 character categories among the following: "),_c('ul',[_c('li',[_vm._v("Lowercase characters (a-z)")]),_c('li',[_vm._v("Uppercase characters (A-Z)")]),_c('li',[_vm._v("Digits (0-9)")]),_c('li',[_vm._v("Special characters")])])])])])]},proxy:true}],null,false,2519316969),model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}},_vm.on)),_c(VTextField_namespaceObject.VTextField,{attrs:{"label":"Confirm New Password","name":"confirm","color":"inputColor","data-cy":"change-password-confirm","type":_vm.passwordVisible ? 'text' : 'password',"error-messages":_vm.errors.confirm},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.changePasswordWithToken.apply(null, arguments)}},model:{value:(_vm.confirm),callback:function ($$v) {_vm.confirm=$$v},expression:"confirm"}}),_c(VCard_namespaceObject.VCardActions,{staticClass:"justify-center"},[_c(VBtn_namespaceObject.VBtn,{staticClass:"primary text--white",attrs:{"data-cy":"change-password-btn","disabled":!_vm.password || !_vm.confirm},on:{"click":_vm.changePasswordWithToken}},[_vm._v(" Change ")])],1)],1):_c('div',[_c('p',[_vm._v("Your password was changed. You can now Sign In")]),_c(VBtn_namespaceObject.VBtn,{staticClass:"align-self-center orange white--text",attrs:{"data-cy":"change-password-btn-signin","href":"/login"}},[_vm._v("Sign in ")])],1),_c('br')],1)],1)],1)
}
var ChangePasswordViewvue_type_template_id_85f02ba8_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/user/views/ChangePasswordView.vue?vue&type=template&id=85f02ba8&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/views/ChangePasswordView.vue?vue&type=script&lang=ts&
var ChangePasswordViewvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ChangePasswordViewvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ChangePasswordViewvue_type_script_lang_ts_assign.apply(this, arguments);
};



/* harmony default export */ var ChangePasswordViewvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'ChangePasswordView',
    components: { CustomPage: CustomPage },
    data: function () {
        return {
            on: '',
            success: false,
            password: '',
            confirm: '',
            passwordVisible: false
        };
    },
    computed: ChangePasswordViewvue_type_script_lang_ts_assign(ChangePasswordViewvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapGetters)('formModule', ['getErrorByComponentId'])), { errors: function () {
            var _a;
            return (_a = this.getErrorByComponentId(this.merginComponentUuid)) !== null && _a !== void 0 ? _a : {};
        }, token: function () {
            return this.$route.params.token;
        } }),
    beforeDestroy: function () {
        this.clearErrors({
            componentId: this.merginComponentUuid,
            keepNotification: true
        });
    },
    methods: ChangePasswordViewvue_type_script_lang_ts_assign(ChangePasswordViewvue_type_script_lang_ts_assign(ChangePasswordViewvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('userModule', {
        changePasswordWithTokenAction: 'changePasswordWithToken'
    })), (0,external_vuex_namespaceObject.mapActions)('formModule', ['clearErrors', 'handleError'])), { responseCallback: function (value) {
            this.success = value;
        }, changePasswordWithToken: function () {
            this.clearErrors({ componentId: this.merginComponentUuid });
            var data = {
                password: this.password,
                confirm: this.confirm
            };
            this.changePasswordWithTokenAction({
                data: data,
                token: this.token,
                callback: this.responseCallback,
                componentId: this.merginComponentUuid
            });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/user/views/ChangePasswordView.vue?vue&type=script&lang=ts&
 /* harmony default export */ var views_ChangePasswordViewvue_type_script_lang_ts_ = (ChangePasswordViewvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/views/ChangePasswordView.vue?vue&type=style&index=0&id=85f02ba8&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/user/views/ChangePasswordView.vue?vue&type=style&index=0&id=85f02ba8&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/user/views/ChangePasswordView.vue



;


/* normalize component */

var ChangePasswordView_component = normalizeComponent(
  views_ChangePasswordViewvue_type_script_lang_ts_,
  ChangePasswordViewvue_type_template_id_85f02ba8_scoped_true_render,
  ChangePasswordViewvue_type_template_id_85f02ba8_scoped_true_staticRenderFns,
  false,
  null,
  "85f02ba8",
  null
  
)

/* harmony default export */ var ChangePasswordView = (ChangePasswordView_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/views/LoginViewTemplate.vue?vue&type=template&id=32a8bbee&scoped=true&






var LoginViewTemplatevue_type_template_id_32a8bbee_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-page',{staticClass:"login-window"},[_c(VCard_namespaceObject.VCard,[_c('mergin-logo-light',{on:{"click":_vm.navigateHome}}),_c(VCard_namespaceObject.VCardText,[_c(VForm_namespaceObject.VForm,{staticClass:"login-form",on:{"submit":function($event){$event.preventDefault();}}},[(_vm.forgotPassword)?[_c(VTextField_namespaceObject.VTextField,{attrs:{"placeholder":"Email","name":"email","color":"inputColor","data-cy":"reset-form-email","error-messages":_vm.errors.email},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.reset.apply(null, arguments)}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_c(VBtn_namespaceObject.VBtn,{attrs:{"dark":_vm.email !== '',"color":"secondary","data-cy":"reset-form-btn","disabled":!_vm.email},on:{"click":_vm.reset}},[_vm._v(" Reset Password ")])]:[_c(VTextField_namespaceObject.VTextField,{attrs:{"placeholder":"Username or email","data-cy":"login-form-login","name":"login","color":"inputColor","error-messages":_vm.errors.login},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.loginUser.apply(null, arguments)}},model:{value:(_vm.login),callback:function ($$v) {_vm.login=$$v},expression:"login"}}),_c(VTextField_namespaceObject.VTextField,{attrs:{"placeholder":"Password","data-cy":"login-form-password","name":"password","color":"inputColor","append-icon":_vm.passwordVisible ? 'visibility_off' : 'visibility',"type":_vm.passwordVisible ? 'text' : 'password',"error-messages":_vm.errors.password},on:{"click:append":function($event){_vm.passwordVisible = !_vm.passwordVisible},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.loginUser.apply(null, arguments)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_c(VBtn_namespaceObject.VBtn,{staticClass:"mx-0 mt-3",attrs:{"dark":Boolean(_vm.login && _vm.password),"disabled":!_vm.login || !_vm.password,"data-cy":"login-form-btn-login","color":"secondary","id":"login-btn"},on:{"click":_vm.loginUser}},[_vm._v(" Sign In ")])]],2),_c('div',{staticClass:"d-flex justify-space-between"},[(!_vm.forgotPassword)?_c(VBtn_namespaceObject.VBtn,{staticClass:"reset",attrs:{"text":"","small":"","data-cy":"login-form-btn-reset","color":"primary","to":{ name: 'login', params: { reset: 'reset' } }}},[_vm._v("Forgot password? ")]):_vm._e(),_vm._t("additionalButtons")],2)],1)],1)],1)
}
var LoginViewTemplatevue_type_template_id_32a8bbee_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/user/views/LoginViewTemplate.vue?vue&type=template&id=32a8bbee&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/views/LoginViewTemplate.vue?vue&type=script&lang=ts&
var LoginViewTemplatevue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    LoginViewTemplatevue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return LoginViewTemplatevue_type_script_lang_ts_assign.apply(this, arguments);
};



/* harmony default export */ var LoginViewTemplatevue_type_script_lang_ts_ = ({
    name: 'LoginViewTemplate',
    components: { MerginLogoLight: MerginLogoLight, CustomPage: CustomPage },
    props: {
        presetLogin: {
            type: String,
            default: null
        }
    },
    data: function () {
        var _a;
        return {
            valid: true,
            login: (_a = this.presetLogin) !== null && _a !== void 0 ? _a : '',
            password: '',
            email: '',
            passwordVisible: false
        };
    },
    created: function () {
        if (this.presetLogin) {
            this.login = this.presetLogin;
        }
        this.updateLoggedUser({ loggedUser: null }); // clear current user to prevent commit to store (and thus reload)
    },
    computed: LoginViewTemplatevue_type_script_lang_ts_assign(LoginViewTemplatevue_type_script_lang_ts_assign(LoginViewTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('userModule', ['loggedUser'])), (0,external_vuex_namespaceObject.mapGetters)('formModule', ['getErrorByComponentId'])), { errors: function () {
            var _a;
            return (_a = this.getErrorByComponentId(this.merginComponentUuid)) !== null && _a !== void 0 ? _a : {};
        }, forgotPassword: function () {
            return this.$route.params.reset === 'reset';
        } }),
    beforeDestroy: function () {
        this.clearErrors({
            componentId: this.merginComponentUuid,
            keepNotification: true
        });
    },
    methods: LoginViewTemplatevue_type_script_lang_ts_assign(LoginViewTemplatevue_type_script_lang_ts_assign(LoginViewTemplatevue_type_script_lang_ts_assign(LoginViewTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('formModule', ['clearErrors'])), (0,external_vuex_namespaceObject.mapMutations)('userModule', ['updateLoggedUser'])), (0,external_vuex_namespaceObject.mapActions)('userModule', ['userLogin', 'resetPassword'])), { loginUser: function () {
            this.clearErrors({ componentId: this.merginComponentUuid });
            var data = {
                login: this.login.trim(),
                password: this.password.trim()
            };
            this.$emit('userLogin', {
                data: data,
                currentRoute: this.$route,
                componentId: this.merginComponentUuid
            });
        }, reset: function () {
            this.clearErrors({ componentId: this.merginComponentUuid });
            this.resetPassword({
                email: this.email,
                componentId: this.merginComponentUuid
            });
        }, navigateHome: function () {
            this.$router.push('/');
        } })
});

;// CONCATENATED MODULE: ./src/modules/user/views/LoginViewTemplate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var views_LoginViewTemplatevue_type_script_lang_ts_ = (LoginViewTemplatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/views/LoginViewTemplate.vue?vue&type=style&index=0&id=32a8bbee&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/user/views/LoginViewTemplate.vue?vue&type=style&index=0&id=32a8bbee&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/user/views/LoginViewTemplate.vue



;


/* normalize component */

var LoginViewTemplate_component = normalizeComponent(
  views_LoginViewTemplatevue_type_script_lang_ts_,
  LoginViewTemplatevue_type_template_id_32a8bbee_scoped_true_render,
  LoginViewTemplatevue_type_template_id_32a8bbee_scoped_true_staticRenderFns,
  false,
  null,
  "32a8bbee",
  null
  
)

/* harmony default export */ var LoginViewTemplate = (LoginViewTemplate_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/views/ProfileViewTemplate.vue?vue&type=template&id=5985a6bc&scoped=true&












var ProfileViewTemplatevue_type_template_id_5985a6bc_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-view',{style:(`padding-left: ${
    _vm.drawer ? 260 : 20
  }px; overflow-y: auto; padding-right:20px; margin-right: 0px;`)},[_c(VGrid_namespaceObject.VLayout,{staticClass:"column main-content fill-height"},[_c(VGrid_namespaceObject.VContainer,[_vm._t("additionalBeforeContent"),_c(VGrid_namespaceObject.VRow,[_c(VGrid_namespaceObject.VCol,{staticClass:"pa-0",attrs:{"cols":"12"}},[(!_vm.loggedUser.verified_email)?_c(VCard_namespaceObject.VCard,{staticClass:"bubble mt-3",staticStyle:{"background-color":"#ffc863","color":"rgba(0, 0, 0, 0.87)","overflow":"hidden"},attrs:{"outlined":""}},[_vm._v(" Your email hasn't been confirmed yet "),_c(VBtn_namespaceObject.VBtn,{staticStyle:{"float":"right"},attrs:{"color":"#ecf3ff"},on:{"click":_vm.resendConfirmationEmail}},[_vm._v("Send confirmation email ")])],1):_vm._e()],1)],1),_c(VGrid_namespaceObject.VRow,[_c(VGrid_namespaceObject.VCol,{staticClass:"pa-0",attrs:{"cols":"12"}},[_c(VCard_namespaceObject.VCard,{attrs:{"flat":""}},[_c(VCard_namespaceObject.VCardText,[_c('div',{staticClass:"profile"},[_c('h1',{staticClass:"primary--text"},[_vm._v("Profile")]),_c('br'),_c(VDivider_namespaceObject.VDivider),_c(VGrid_namespaceObject.VLayout,{attrs:{"align-center":""}},[_c(VGrid_namespaceObject.VRow,[_c(VGrid_namespaceObject.VCol,[_c('div',{staticClass:"section",attrs:{"cy-data":"profile-info"}},[(_vm.loggedUser)?_c('ul',[_c('li',{attrs:{"cy-data":"profile-username"}},[_c('b',[_vm._v(" Username: ")]),_vm._v(_vm._s(_vm.loggedUser.username)+" ")]),_c('li',{attrs:{"cy-data":"profile-name"}},[_c('b',[_vm._v(" Name: ")]),_vm._v(_vm._s(_vm.loggedUser.name)+" ")]),_c('li',{attrs:{"cy-data":"profile-email"}},[_c('b',[_vm._v(" Email: ")]),_vm._v(_vm._s(_vm.loggedUser.email)+" "),(
                                'project-versions' !== _vm.$route.name &&
                                'project-versions-detail' !== _vm.$route.name
                              )?_c(VTooltip_namespaceObject.VTooltip,{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[(_vm.loggedUser.verified_email)?_c(VIcon_namespaceObject.VIcon,{attrs:{"color":"green"}},[_vm._v("check")]):_c(VIcon_namespaceObject.VIcon,{attrs:{"color":"red"}},[_vm._v("clear")])],1)]}}],null,false,2576507740)},[_c('span',[_vm._v("Email verification status")])]):_vm._e()],1),_c('li',{attrs:{"cy-data":"profile-notification"}},[_c('b',[_vm._v(" Receive notifications: ")]),(_vm.loggedUser.receive_notifications)?_c(VIcon_namespaceObject.VIcon,{attrs:{"color":"green"}},[_vm._v("check")]):_c(VIcon_namespaceObject.VIcon,{attrs:{"color":"red"}},[_vm._v("clear")])],1),_c('li',{attrs:{"cy-data":"profile-registered"}},[_c('b',[_vm._v(" Registered: ")]),_vm._v(_vm._s(_vm._f("date")(_vm.loggedUser.registration_date))+" ")])]):_vm._e(),_c('br')]),_c(VGrid_namespaceObject.VSpacer)],1),_c(VGrid_namespaceObject.VCol,[_c('div',[_c('div',[_c(VBtn_namespaceObject.VBtn,{staticClass:"primary--text",attrs:{"cy-data":"profile-change-password-btn"},on:{"click":_vm.changePasswordDialog}},[_c(VIcon_namespaceObject.VIcon,{staticClass:"mr-2"},[_vm._v("edit")]),_vm._v(" Change password ")],1)],1),_c('div',[_c(VBtn_namespaceObject.VBtn,{staticClass:"primary--text",attrs:{"cy-data":"profile-edit-btn"},on:{"click":_vm.editProfileDialog}},[_c(VIcon_namespaceObject.VIcon,{staticClass:"mr-2"},[_vm._v("edit")]),_vm._v(" Edit profile ")],1)],1),_c('div',[_c(VBtn_namespaceObject.VBtn,{staticClass:"primary--text",attrs:{"disabled":_vm.loggedUser.verified_profile,"cy-data":"profile-verify-email-btn"},on:{"click":_vm.showConfirmationDialog}},[_c(VIcon_namespaceObject.VIcon,{staticClass:"mr-2"},[_vm._v("edit")]),_vm._v(" Verify email ")],1)],1),_c('div',[_c(VBtn_namespaceObject.VBtn,{staticClass:"white--text",attrs:{"depressed":"","color":"red","cy-data":"profile-close-account-btn"},on:{"click":_vm.confirmDeleteUser}},[_c(VIcon_namespaceObject.VIcon,{staticClass:"mr-2"},[_vm._v("remove_circle")]),_vm._v(" Close my account ")],1)],1)])])],1)],1)],1),_c(VDivider_namespaceObject.VDivider)],1),_vm._t("additionalContent")],2)],1)],1)],2)],1)],1)
}
var ProfileViewTemplatevue_type_template_id_5985a6bc_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/user/views/ProfileViewTemplate.vue?vue&type=template&id=5985a6bc&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/views/ProfileViewTemplate.vue?vue&type=script&lang=ts&
var ProfileViewTemplatevue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ProfileViewTemplatevue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ProfileViewTemplatevue_type_script_lang_ts_assign.apply(this, arguments);
};
var ProfileViewTemplatevue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var ProfileViewTemplatevue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





/* harmony default export */ var ProfileViewTemplatevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'ProfileViewTemplate',
    props: {
        name: String
    },
    components: { PageView: PageView },
    data: function () {
        return {
            dialog: false
        };
    },
    computed: ProfileViewTemplatevue_type_script_lang_ts_assign(ProfileViewTemplatevue_type_script_lang_ts_assign(ProfileViewTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('layoutModule', ['drawer'])), (0,external_vuex_namespaceObject.mapState)('userModule', ['loggedUser'])), { usage: function () {
            var _a, _b;
            return ((_a = this.loggedUser) === null || _a === void 0 ? void 0 : _a.disk_usage) / ((_b = this.loggedUser) === null || _b === void 0 ? void 0 : _b.storage);
        } }),
    created: function () {
        this.fetchUserProfile();
    },
    watch: {
        name: function () {
            this.fetchUserProfile();
        }
    },
    methods: ProfileViewTemplatevue_type_script_lang_ts_assign(ProfileViewTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('userModule', {
        fetchUserProfile: 'fetchUserProfile',
        resendConfirmationEmailToUser: 'resendConfirmationEmail',
        closeUserProfile: 'closeUserProfile'
    })), { resendConfirmationEmail: function () {
            var _a;
            this.resendConfirmationEmailToUser({ email: (_a = this.loggedUser) === null || _a === void 0 ? void 0 : _a.email });
        }, showConfirmationDialog: function (_email) {
            var _this = this;
            var props = {
                text: 'Do you want send confirmation email?',
                confirmText: 'Send email'
            };
            var listeners = {
                confirm: function () { return _this.resendConfirmationEmail(); }
            };
            this.$store.dispatch('dialogModule/prompt', {
                params: {
                    props: props,
                    listeners: listeners,
                    dialog: { maxWidth: 500, persistent: true }
                }
            });
        }, confirmDeleteUser: function () {
            var _this = this;
            var _a;
            var props = {
                text: 'Are you sure to close your account? <br>  <br> Type in username to confirm:',
                confirmText: 'Delete',
                confirmField: {
                    label: 'Username',
                    expected: (_a = this.loggedUser) === null || _a === void 0 ? void 0 : _a.username
                }
            };
            var listeners = {
                confirm: function () { return ProfileViewTemplatevue_type_script_lang_ts_awaiter(_this, void 0, void 0, function () { return ProfileViewTemplatevue_type_script_lang_ts_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.closeUserProfile()];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                }); }); }
            };
            this.$store.dispatch('dialogModule/prompt', {
                params: {
                    props: props,
                    listeners: listeners,
                    dialog: { maxWidth: 500 }
                }
            });
        }, changePasswordDialog: function () {
            var props = {};
            var dialog = { maxWidth: 500, persistent: true };
            this.$store.dispatch('dialogModule/show', {
                component: ChangePasswordForm,
                params: {
                    props: props,
                    dialog: dialog
                }
            });
        }, editProfileDialog: function () {
            var props = { profile: this.loggedUser };
            var dialog = { maxWidth: 500, persistent: true };
            this.$store.dispatch('dialogModule/show', {
                component: EditProfileForm,
                params: {
                    props: props,
                    dialog: dialog
                }
            });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/user/views/ProfileViewTemplate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var views_ProfileViewTemplatevue_type_script_lang_ts_ = (ProfileViewTemplatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/views/ProfileViewTemplate.vue?vue&type=style&index=0&id=5985a6bc&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/user/views/ProfileViewTemplate.vue?vue&type=style&index=0&id=5985a6bc&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/user/views/ProfileViewTemplate.vue



;


/* normalize component */

var ProfileViewTemplate_component = normalizeComponent(
  views_ProfileViewTemplatevue_type_script_lang_ts_,
  ProfileViewTemplatevue_type_template_id_5985a6bc_scoped_true_render,
  ProfileViewTemplatevue_type_template_id_5985a6bc_scoped_true_staticRenderFns,
  false,
  null,
  "5985a6bc",
  null
  
)

/* harmony default export */ var ProfileViewTemplate = (ProfileViewTemplate_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/views/VerifyEmailView.vue?vue&type=template&id=6a54a249&scoped=true&





var VerifyEmailViewvue_type_template_id_6a54a249_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-page',[_c(VCard_namespaceObject.VCard,{staticClass:"text-center",staticStyle:{"min-width":"300px"}},[_c(VCard_namespaceObject.VCardTitle,{staticClass:"justify-center primary--text font-weight-bold ml-3"},[_c('h3',[_vm._v("Email confirmation")])]),_c(VCard_namespaceObject.VCardText,[(_vm.verified)?_c('p',[_vm._v("Your email address has been verified.")]):_c('p',{staticClass:"error--text"},[_vm._v("Invalid token")]),_c('br'),_c(VBtn_namespaceObject.VBtn,{staticClass:"align-self-center orange white--text",attrs:{"data-cy":"verify-email-btn","href":"/"}},[_vm._v("Continue ")])],1)],1)],1)
}
var VerifyEmailViewvue_type_template_id_6a54a249_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/user/views/VerifyEmailView.vue?vue&type=template&id=6a54a249&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/user/views/VerifyEmailView.vue?vue&type=script&lang=js&




// TODO: deprecated?
/* harmony default export */ var VerifyEmailViewvue_type_script_lang_js_ = ({
  name: 'VerifyEmailView',
  components: { CustomPage: CustomPage },
  data() {
    return {
      verified: false
    }
  },
  computed: {
    token() {
      return this.$route.params.token
    }
  },
  async created() {
    try {
      await UserApi.confirmEmail(this.token)
      this.verified = true
    } catch (e) {
      this.verified = false
    }
  }
});

;// CONCATENATED MODULE: ./src/modules/user/views/VerifyEmailView.vue?vue&type=script&lang=js&
 /* harmony default export */ var views_VerifyEmailViewvue_type_script_lang_js_ = (VerifyEmailViewvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modules/user/views/VerifyEmailView.vue





/* normalize component */
;
var VerifyEmailView_component = normalizeComponent(
  views_VerifyEmailViewvue_type_script_lang_js_,
  VerifyEmailViewvue_type_template_id_6a54a249_scoped_true_render,
  VerifyEmailViewvue_type_template_id_6a54a249_scoped_true_staticRenderFns,
  false,
  null,
  "6a54a249",
  null
  
)

/* harmony default export */ var VerifyEmailView = (VerifyEmailView_component.exports);
;// CONCATENATED MODULE: ./src/modules/user/views/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial





;// CONCATENATED MODULE: ./src/modules/user/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial








;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/Notifications.vue?vue&type=template&id=232b6fcb&



var Notificationsvue_type_template_id_232b6fcb_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VSnackbar_namespaceObject.VSnackbar,_vm._b({staticStyle:{"overflow-y":"auto"},attrs:{"value":_vm.isOpen,"timeout":_vm.timeout},on:{"input":_vm.closeNotification}},'v-snackbar',_vm.params,false),[(_vm.params)?[_c('span',{domProps:{"textContent":_vm._s(_vm.text)}}),(_vm.params.action)?_c(VBtn_namespaceObject.VBtn,{attrs:{"text":"","color":"yellow"},on:{"click":_vm.params.action.handler}},[_vm._v(" "+_vm._s(_vm.params.action.text)+" ")]):_c(VBtn_namespaceObject.VBtn,{attrs:{"text":"","color":_vm.buttonColor},on:{"click":_vm.closeNotification}},[_vm._v(" Close")])]:_vm._e()],2)
}
var Notificationsvue_type_template_id_232b6fcb_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/notification/components/Notifications.vue?vue&type=template&id=232b6fcb&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/Notifications.vue?vue&type=script&lang=ts&
var Notificationsvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    Notificationsvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Notificationsvue_type_script_lang_ts_assign.apply(this, arguments);
};


/* harmony default export */ var Notificationsvue_type_script_lang_ts_ = (external_vue_default().extend({
    computed: Notificationsvue_type_script_lang_ts_assign(Notificationsvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('notificationModule', ['isOpen', 'params', 'text'])), { buttonColor: function () {
            var _a, _b;
            return (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.buttonColor) !== null && _b !== void 0 ? _b : 'yellow';
        }, timeout: function () {
            var _a, _b;
            return (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.timeout) !== null && _b !== void 0 ? _b : 3000;
        } }),
    methods: Notificationsvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapMutations)('notificationModule', ['closeNotification']))
}));

;// CONCATENATED MODULE: ./src/modules/notification/components/Notifications.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_Notificationsvue_type_script_lang_ts_ = (Notificationsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/notification/components/Notifications.vue





/* normalize component */
;
var Notifications_component = normalizeComponent(
  components_Notificationsvue_type_script_lang_ts_,
  Notificationsvue_type_template_id_232b6fcb_render,
  Notificationsvue_type_template_id_232b6fcb_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Notifications = (Notifications_component.exports);
;// CONCATENATED MODULE: ./src/modules/notification/components/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial


;// CONCATENATED MODULE: ./src/modules/notification/store.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
var notification_store_assign = (undefined && undefined.__assign) || function () {
    notification_store_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return notification_store_assign.apply(this, arguments);
};
var SNACK_BAR_ERROR_DEFAULT_PARAMS = {
    color: 'red darken-4'
};
var SNACK_BAR_WARN_DEFAULT_PARAMS = {
    color: 'orange',
    buttonColor: 'black'
};
var NotificationStore = {
    namespaced: true,
    state: {
        isOpen: false,
        text: '',
        params: null
    },
    mutations: {
        openNotification: function (state, payload) {
            state.isOpen = true;
            state.text = payload.text;
            state.params = payload.params;
        },
        closeNotification: function (state) {
            state.isOpen = false;
            state.text = '';
            state.params = null;
        }
    },
    actions: {
        show: function (_a, payload) {
            var _b;
            var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
            if (state.isOpen) {
                if (state.text === payload.text) {
                    // ignore same notifications
                    return;
                }
                // previous notification is open, close it first
                commit('closeNotification');
                // show new notification after some time
                setTimeout(function () {
                    dispatch('show', { text: payload.text, params: payload.params });
                }, 300);
            }
            else {
                commit('openNotification', {
                    text: payload.text,
                    params: ((_b = payload.params) === null || _b === void 0 ? void 0 : _b.timeout)
                        ? notification_store_assign(notification_store_assign({}, payload.params), { timeout: payload.params.timeout }) : notification_store_assign({}, payload.params)
                });
            }
        },
        warn: function (_a, payload) {
            var dispatch = _a.dispatch;
            dispatch('show', notification_store_assign(notification_store_assign({}, payload), { params: notification_store_assign(notification_store_assign({}, payload.params), SNACK_BAR_WARN_DEFAULT_PARAMS) }));
        },
        error: function (_a, payload) {
            var dispatch = _a.dispatch;
            dispatch('show', notification_store_assign(notification_store_assign({}, payload), { params: notification_store_assign(notification_store_assign({}, payload.params), SNACK_BAR_ERROR_DEFAULT_PARAMS) }));
        },
        displayResult: function (_a, payload) {
            var _b, _c, _d;
            var dispatch = _a.dispatch;
            if ((_b = payload === null || payload === void 0 ? void 0 : payload.result) === null || _b === void 0 ? void 0 : _b.success) {
                dispatch('show', { text: (_c = payload === null || payload === void 0 ? void 0 : payload.result) === null || _c === void 0 ? void 0 : _c.message });
            }
            else {
                dispatch('error', {
                    text: (_d = payload === null || payload === void 0 ? void 0 : payload.result) === null || _d === void 0 ? void 0 : _d.message,
                    params: { timeout: 5000 }
                });
            }
        }
    }
};
/* harmony default export */ var notification_store = (NotificationStore);

;// CONCATENATED MODULE: ./src/modules/notification/module.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial

var NotificationModule = {
    name: 'notificationModule',
    moduleStore: notification_store,
    init: function (_services) {
        // none initialization required
    }
};

;// CONCATENATED MODULE: ./src/modules/notification/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial




;// CONCATENATED MODULE: external "vuetify/lib/components/VDialog"
var VDialog_namespaceObject = require("vuetify/lib/components/VDialog");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/dialog/components/DialogWindows.vue?vue&type=template&id=2101b5ab&


var DialogWindowsvue_type_template_id_2101b5ab_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VDialog_namespaceObject.VDialog,_vm._b({attrs:{"value":_vm.isDialogOpen},on:{"input":_vm.close}},'v-dialog',_vm.dialogProps,false),[(_vm.params)?_c(_vm.params.component,_vm._g(_vm._b({tag:"div"},'div',_vm.params.props,false),_vm.params.listeners)):_vm._e()],1)
}
var DialogWindowsvue_type_template_id_2101b5ab_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/dialog/components/DialogWindows.vue?vue&type=template&id=2101b5ab&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/dialog/components/DialogWindows.vue?vue&type=script&lang=ts&
var DialogWindowsvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    DialogWindowsvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return DialogWindowsvue_type_script_lang_ts_assign.apply(this, arguments);
};


/* harmony default export */ var DialogWindowsvue_type_script_lang_ts_ = (external_vue_default().extend({
    computed: DialogWindowsvue_type_script_lang_ts_assign(DialogWindowsvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('dialogModule', ['isDialogOpen', 'params'])), (0,external_vuex_namespaceObject.mapGetters)('dialogModule', ['dialogProps'])),
    methods: DialogWindowsvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('dialogModule', ['close']))
}));

;// CONCATENATED MODULE: ./src/modules/dialog/components/DialogWindows.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_DialogWindowsvue_type_script_lang_ts_ = (DialogWindowsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/dialog/components/DialogWindows.vue





/* normalize component */
;
var DialogWindows_component = normalizeComponent(
  components_DialogWindowsvue_type_script_lang_ts_,
  DialogWindowsvue_type_template_id_2101b5ab_render,
  DialogWindowsvue_type_template_id_2101b5ab_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DialogWindows = (DialogWindows_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/dialog/components/ConfirmDialog.vue?vue&type=template&id=1ec1b383&








var ConfirmDialogvue_type_template_id_1ec1b383_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCard_namespaceObject.VCard,[_c(VCard_namespaceObject.VCardTitle,{staticClass:"text-h5"},[_vm._v(_vm._s(_vm.headline))]),_c(VCard_namespaceObject.VCardText,{domProps:{"innerHTML":_vm._s(_vm.text)}}),_c(VCard_namespaceObject.VCardActions,[(_vm.confirmField)?_c(VTextField_namespaceObject.VTextField,{staticStyle:{"margin-left":"15px"},attrs:{"autofocus":"","label":_vm.confirmField.label},model:{value:(_vm.confirmValue),callback:function ($$v) {_vm.confirmValue=$$v},expression:"confirmValue"}}):_vm._e(),_c(VGrid_namespaceObject.VSpacer),_c(VBtn_namespaceObject.VBtn,{attrs:{"text":""},on:{"click":_vm.close}},[_vm._v(" "+_vm._s(_vm.cancelText)+" ")]),_c(VBtn_namespaceObject.VBtn,{attrs:{"disabled":!_vm.isConfirmed,"color":"primary"},on:{"click":_vm.confirm}},[_vm._v(" "+_vm._s(_vm.confirmText)+" ")])],1)],1)
}
var ConfirmDialogvue_type_template_id_1ec1b383_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/dialog/components/ConfirmDialog.vue?vue&type=template&id=1ec1b383&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/dialog/components/ConfirmDialog.vue?vue&type=script&lang=ts&
var ConfirmDialogvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    ConfirmDialogvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ConfirmDialogvue_type_script_lang_ts_assign.apply(this, arguments);
};


/* harmony default export */ var ConfirmDialogvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'confirm-dialog',
    props: {
        text: String,
        confirmField: Object,
        confirmText: {
            type: String,
            default: 'Ok'
        },
        cancelText: {
            type: String,
            default: 'Cancel'
        },
        headline: {
            type: String,
            default: 'Confirm'
        }
    },
    data: function () {
        return {
            confirmValue: ''
        };
    },
    computed: {
        isConfirmed: function () {
            return this.confirmField
                ? this.confirmField.expected === this.confirmValue
                : true;
        }
    },
    methods: ConfirmDialogvue_type_script_lang_ts_assign(ConfirmDialogvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('dialogModule', ['close'])), { confirm: function () {
            this.close();
            this.$emit('confirm');
        } })
}));

;// CONCATENATED MODULE: ./src/modules/dialog/components/ConfirmDialog.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_ConfirmDialogvue_type_script_lang_ts_ = (ConfirmDialogvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/dialog/components/ConfirmDialog.vue





/* normalize component */
;
var ConfirmDialog_component = normalizeComponent(
  components_ConfirmDialogvue_type_script_lang_ts_,
  ConfirmDialogvue_type_template_id_1ec1b383_render,
  ConfirmDialogvue_type_template_id_1ec1b383_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ConfirmDialog = (ConfirmDialog_component.exports);
;// CONCATENATED MODULE: ./src/modules/dialog/components/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial



;// CONCATENATED MODULE: ./src/modules/dialog/store.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
var dialog_store_assign = (undefined && undefined.__assign) || function () {
    dialog_store_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return dialog_store_assign.apply(this, arguments);
};

var DialogStore = {
    namespaced: true,
    state: {
        isDialogOpen: false,
        params: null
    },
    getters: {
        dialogProps: function (state) {
            return state.params ? state.params.dialog : {};
        }
    },
    mutations: {
        openDialog: function (state, payload) {
            state.isDialogOpen = true;
            state.params = payload.params;
        },
        closeDialog: function (state) {
            state.isDialogOpen = false;
        },
        changeParams: function (state, payload) {
            state.params = payload.params;
        }
    },
    actions: {
        show: function (_a, payload) {
            var commit = _a.commit;
            commit('openDialog', {
                params: dialog_store_assign(dialog_store_assign({}, payload.params), { component: payload.component })
            });
        },
        prompt: function (_a, payload) {
            var dispatch = _a.dispatch;
            dispatch('show', {
                component: ConfirmDialog,
                params: payload.params
            });
        },
        close: function (_a) {
            var _b;
            var commit = _a.commit, state = _a.state;
            commit('closeDialog');
            if (((_b = state.params) === null || _b === void 0 ? void 0 : _b.dialog) && !state.params.dialog.keepAlive) {
                setTimeout(function () {
                    commit('changeParams', { params: null });
                }, 300);
            }
        }
    }
};
/* harmony default export */ var dialog_store = (DialogStore);

;// CONCATENATED MODULE: ./src/modules/dialog/module.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial

var DialogModule = {
    name: 'dialogModule',
    moduleStore: dialog_store,
    init: function (_services) {
        // none initialization required
    }
};

;// CONCATENATED MODULE: ./src/modules/dialog/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial




;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/dashboard/components/DashboardAccessRequestsRow.vue?vue&type=template&id=66e8dbf5&scoped=true&




var DashboardAccessRequestsRowvue_type_template_id_66e8dbf5_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (
    _vm.currentNamespace &&
    _vm.namespaceAccessRequests &&
    _vm.namespaceAccessRequests.length > 0
  )?_c(VGrid_namespaceObject.VRow,[_c(VCard_namespaceObject.VCard,{staticClass:"bubble mt-3"},[_c('h3',[_vm._v("Project access requests")]),_c(VCard_namespaceObject.VCardText,[_vm._t("table",null,{"namespace":_vm.currentNamespace})],2)],1)],1):_vm._e()
}
var DashboardAccessRequestsRowvue_type_template_id_66e8dbf5_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/dashboard/components/DashboardAccessRequestsRow.vue?vue&type=template&id=66e8dbf5&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/dashboard/components/DashboardAccessRequestsRow.vue?vue&type=script&lang=ts&
var DashboardAccessRequestsRowvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    DashboardAccessRequestsRowvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return DashboardAccessRequestsRowvue_type_script_lang_ts_assign.apply(this, arguments);
};
var DashboardAccessRequestsRowvue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var DashboardAccessRequestsRowvue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


/* harmony default export */ var DashboardAccessRequestsRowvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'DashboardAccessRequestsRow',
    computed: DashboardAccessRequestsRowvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('projectModule', [
        'namespaceAccessRequests',
        'currentNamespace'
    ])),
    watch: {
        currentNamespace: {
            immediate: true,
            handler: function (value) {
                return DashboardAccessRequestsRowvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                    return DashboardAccessRequestsRowvue_type_script_lang_ts_generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!value) return [3 /*break*/, 2];
                                return [4 /*yield*/, this.initNamespaceAccessRequests({
                                        namespace: value
                                    })];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                });
            }
        }
    },
    methods: DashboardAccessRequestsRowvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('projectModule', ['initNamespaceAccessRequests']))
}));

;// CONCATENATED MODULE: ./src/modules/dashboard/components/DashboardAccessRequestsRow.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_DashboardAccessRequestsRowvue_type_script_lang_ts_ = (DashboardAccessRequestsRowvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/dashboard/components/DashboardAccessRequestsRow.vue?vue&type=style&index=0&id=66e8dbf5&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/dashboard/components/DashboardAccessRequestsRow.vue?vue&type=style&index=0&id=66e8dbf5&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/modules/dashboard/components/DashboardAccessRequestsRow.vue



;


/* normalize component */

var DashboardAccessRequestsRow_component = normalizeComponent(
  components_DashboardAccessRequestsRowvue_type_script_lang_ts_,
  DashboardAccessRequestsRowvue_type_template_id_66e8dbf5_scoped_true_render,
  DashboardAccessRequestsRowvue_type_template_id_66e8dbf5_scoped_true_staticRenderFns,
  false,
  null,
  "66e8dbf5",
  null
  
)

/* harmony default export */ var DashboardAccessRequestsRow = (DashboardAccessRequestsRow_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/dashboard/components/DashboardFullStorageWarningRow.vue?vue&type=template&id=f05bb5ca&scoped=true&


var DashboardFullStorageWarningRowvue_type_template_id_f05bb5ca_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.usage > 90)?_c(VGrid_namespaceObject.VRow,[_vm._t("default",null,{"usage":_vm.usage,"username":_vm.loggedUser.username})],2):_vm._e()
}
var DashboardFullStorageWarningRowvue_type_template_id_f05bb5ca_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/dashboard/components/DashboardFullStorageWarningRow.vue?vue&type=template&id=f05bb5ca&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/dashboard/components/DashboardFullStorageWarningRow.vue?vue&type=script&lang=ts&
var DashboardFullStorageWarningRowvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    DashboardFullStorageWarningRowvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return DashboardFullStorageWarningRowvue_type_script_lang_ts_assign.apply(this, arguments);
};


/* harmony default export */ var DashboardFullStorageWarningRowvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'DashboardFullStorageWarningRow',
    computed: DashboardFullStorageWarningRowvue_type_script_lang_ts_assign(DashboardFullStorageWarningRowvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('userModule', ['loggedUser'])), { usage: function () {
            var _a, _b;
            return Math.floor((((_a = this.loggedUser) === null || _a === void 0 ? void 0 : _a.disk_usage) / ((_b = this.loggedUser) === null || _b === void 0 ? void 0 : _b.storage)) * 100);
        } })
}));

;// CONCATENATED MODULE: ./src/modules/dashboard/components/DashboardFullStorageWarningRow.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_DashboardFullStorageWarningRowvue_type_script_lang_ts_ = (DashboardFullStorageWarningRowvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/dashboard/components/DashboardFullStorageWarningRow.vue





/* normalize component */
;
var DashboardFullStorageWarningRow_component = normalizeComponent(
  components_DashboardFullStorageWarningRowvue_type_script_lang_ts_,
  DashboardFullStorageWarningRowvue_type_template_id_f05bb5ca_scoped_true_render,
  DashboardFullStorageWarningRowvue_type_template_id_f05bb5ca_scoped_true_staticRenderFns,
  false,
  null,
  "f05bb5ca",
  null
  
)

/* harmony default export */ var DashboardFullStorageWarningRow = (DashboardFullStorageWarningRow_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/dashboard/components/DashboardProjectsRow.vue?vue&type=template&id=94787918&scoped=true&





var DashboardProjectsRowvue_type_template_id_94787918_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VGrid_namespaceObject.VRow,[_c(VGrid_namespaceObject.VCol,{staticClass:"pa-0"},[_c(VCard_namespaceObject.VCard,{staticClass:"bubble mt-3",attrs:{"outlined":true,"color":"white"}},[_c('h3',[_vm._v("Recent active projects")]),_c(VCard_namespaceObject.VCardText,{staticStyle:{"padding-left":"0"}},[_vm._t("projects")],2)],1)],1)],1)
}
var DashboardProjectsRowvue_type_template_id_94787918_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/dashboard/components/DashboardProjectsRow.vue?vue&type=template&id=94787918&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/dashboard/components/DashboardProjectsRow.vue?vue&type=script&lang=ts&

/* harmony default export */ var DashboardProjectsRowvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'DashboardProjectsRow'
}));

;// CONCATENATED MODULE: ./src/modules/dashboard/components/DashboardProjectsRow.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_DashboardProjectsRowvue_type_script_lang_ts_ = (DashboardProjectsRowvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/dashboard/components/DashboardProjectsRow.vue?vue&type=style&index=0&id=94787918&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/dashboard/components/DashboardProjectsRow.vue?vue&type=style&index=0&id=94787918&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/modules/dashboard/components/DashboardProjectsRow.vue



;


/* normalize component */

var DashboardProjectsRow_component = normalizeComponent(
  components_DashboardProjectsRowvue_type_script_lang_ts_,
  DashboardProjectsRowvue_type_template_id_94787918_scoped_true_render,
  DashboardProjectsRowvue_type_template_id_94787918_scoped_true_staticRenderFns,
  false,
  null,
  "94787918",
  null
  
)

/* harmony default export */ var DashboardProjectsRow = (DashboardProjectsRow_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/dashboard/components/DashboardUsageInfoRow.vue?vue&type=template&id=01989520&scoped=true&
var DashboardUsageInfoRowvue_type_template_id_01989520_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('usage-status'),_c('dashboard-full-storage-warning-row',{scopedSlots:_vm._u([{key:"default",fn:function({ usage, username }){return [_c('full-storage-warning',{attrs:{"usage":usage,"username":username}})]}}])})],1)
}
var DashboardUsageInfoRowvue_type_template_id_01989520_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/dashboard/components/DashboardUsageInfoRow.vue?vue&type=script&lang=ts&




/* harmony default export */ var DashboardUsageInfoRowvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'DashboardUsageInfoRow',
    components: {
        DashboardFullStorageWarningRow: DashboardFullStorageWarningRow,
        FullStorageWarning: FullStorageWarning,
        UsageStatus: UsageStatus
    }
}));

;// CONCATENATED MODULE: ./src/modules/dashboard/components/DashboardUsageInfoRow.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_DashboardUsageInfoRowvue_type_script_lang_ts_ = (DashboardUsageInfoRowvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/dashboard/components/DashboardUsageInfoRow.vue





/* normalize component */
;
var DashboardUsageInfoRow_component = normalizeComponent(
  components_DashboardUsageInfoRowvue_type_script_lang_ts_,
  DashboardUsageInfoRowvue_type_template_id_01989520_scoped_true_render,
  DashboardUsageInfoRowvue_type_template_id_01989520_scoped_true_staticRenderFns,
  false,
  null,
  "01989520",
  null
  
)

/* harmony default export */ var DashboardUsageInfoRow = (DashboardUsageInfoRow_component.exports);
;// CONCATENATED MODULE: ./src/modules/dashboard/components/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial





;// CONCATENATED MODULE: ./src/modules/dashboard/module.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
var DashboardModule = {
    name: 'dashboardModule',
    init: function (_services) {
        // nothing to do
    }
};

;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/dashboard/views/DashboardViewTemplate.vue?vue&type=template&id=79b9e6db&scoped=true&







var DashboardViewTemplatevue_type_template_id_79b9e6db_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-view',{style:(`padding-left: ${
    _vm.drawer ? 280 : 20
  }px; overflow-y: auto; padding-right:20px; margin-right: 0px;`)},[_c(VGrid_namespaceObject.VLayout,{staticClass:"column fill-height main-content"},[_c(VGrid_namespaceObject.VContainer,[_vm._t("usageInfo"),(_vm.projectsCount === 0 && _vm.canCreateProject)?_c(VGrid_namespaceObject.VRow,[_c(VCard_namespaceObject.VCard,{staticClass:"bubble mt-3",attrs:{"outlined":""}},[_c('h3',[_vm._v("Welcome "+_vm._s(_vm.loggedUser.username)+", are you ready to start?")]),_c('p',[_vm._v(" First create new project, add people to it or explore public project for more inspiration ")]),_c(VBtn_namespaceObject.VBtn,{attrs:{"color":"orange"},on:{"click":function($event){return _vm.newProjectDialog(_vm.loggedUser.email)}}},[_c('span',{staticStyle:{"color":"white"}},[_vm._v("New project")])])],1)],1):_vm._e(),_c(VGrid_namespaceObject.VRow,[_c(VGrid_namespaceObject.VCol,{staticClass:"pa-0"},[_c(VCard_namespaceObject.VCard,{staticClass:"bubble mt-3",attrs:{"outlined":""}},[_c('h3',[_vm._v("Download Mergin Maps Input app")]),_c('p',[_vm._v(" Capture geo-info easily through your mobile/tablet with the Mergin Maps Input app. Designed to be compatible with all mobile devices - even those with small screens. ")]),_c(VGrid_namespaceObject.VRow,[_c(VGrid_namespaceObject.VCol,{attrs:{"cols":"7","md":"3","sm":"3"}},[_c('div',{staticClass:"store-button"},[_c('a',{attrs:{"href":"https://play.google.com/store/apps/details?id=uk.co.lutraconsulting&utm_source=mergin-website&utm_medium=banner&utm_campaign=input","target":"_blank"}},[_c('img',{attrs:{"alt":"Get it on Google Play","src":"https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png","height":"70px"}})])])]),_c(VGrid_namespaceObject.VCol,{attrs:{"cols":"7","md":"3","sm":"3"}},[_c('div',{staticClass:"store-button app-store-button"},[_c('a',{attrs:{"href":"https://apps.apple.com/us/app/input/id1478603559?ls=1&utm_source=mergin-website&utm_medium=banner&utm_campaign=input","target":"_blank"}},[_c('img',{attrs:{"alt":"Get it on Apple store","src":__webpack_require__(298),"height":"48px"}})])])]),_c(VGrid_namespaceObject.VCol,{attrs:{"cols":"7","md":"3","sm":"3"}},[_c('div',{staticClass:"store-button huawei-store-button"},[_c('a',{attrs:{"href":"https://appgallery.huawei.com/app/C104422773","target":"_blank"}},[_c('img',{attrs:{"alt":"Explore it on AppGallery","src":__webpack_require__(915),"height":"48px"}})])])])],1)],1)],1)],1),_vm._t("content")],2)],1)],1)
}
var DashboardViewTemplatevue_type_template_id_79b9e6db_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/dashboard/views/DashboardViewTemplate.vue?vue&type=template&id=79b9e6db&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/dashboard/views/DashboardViewTemplate.vue?vue&type=script&lang=ts&
var DashboardViewTemplatevue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    DashboardViewTemplatevue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return DashboardViewTemplatevue_type_script_lang_ts_assign.apply(this, arguments);
};
var DashboardViewTemplatevue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var DashboardViewTemplatevue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




/* harmony default export */ var DashboardViewTemplatevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'DashboardViewTemplate',
    components: {
        PageView: PageView
    },
    props: {
        canCreateProject: {
            type: Boolean,
            default: false
        }
    },
    computed: DashboardViewTemplatevue_type_script_lang_ts_assign(DashboardViewTemplatevue_type_script_lang_ts_assign(DashboardViewTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('layoutModule', ['drawer'])), (0,external_vuex_namespaceObject.mapState)('userModule', ['loggedUser'])), (0,external_vuex_namespaceObject.mapState)('projectModule', ['projectsCount'])),
    created: function () {
        return DashboardViewTemplatevue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
            return DashboardViewTemplatevue_type_script_lang_ts_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchAccessRequests()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    methods: DashboardViewTemplatevue_type_script_lang_ts_assign(DashboardViewTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapActions)('projectModule', {
        fetchAccessRequests: 'fetchAccessRequests'
    })), { newProjectDialog: function () {
            var dialog = { maxWidth: 500, persistent: true };
            this.$store.dispatch('dialogModule/show', {
                component: ProjectForm,
                params: {
                    dialog: dialog
                }
            });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/dashboard/views/DashboardViewTemplate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var views_DashboardViewTemplatevue_type_script_lang_ts_ = (DashboardViewTemplatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/dashboard/views/DashboardViewTemplate.vue?vue&type=style&index=0&id=79b9e6db&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/dashboard/views/DashboardViewTemplate.vue?vue&type=style&index=0&id=79b9e6db&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/modules/dashboard/views/DashboardViewTemplate.vue



;


/* normalize component */

var DashboardViewTemplate_component = normalizeComponent(
  views_DashboardViewTemplatevue_type_script_lang_ts_,
  DashboardViewTemplatevue_type_template_id_79b9e6db_scoped_true_render,
  DashboardViewTemplatevue_type_template_id_79b9e6db_scoped_true_staticRenderFns,
  false,
  null,
  "79b9e6db",
  null
  
)

/* harmony default export */ var DashboardViewTemplate = (DashboardViewTemplate_component.exports);
;// CONCATENATED MODULE: ./src/modules/dashboard/views/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial


;// CONCATENATED MODULE: ./src/modules/dashboard/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial




;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/layout/components/AppHeaderTemplate.vue?vue&type=template&id=558da33a&scoped=true&









var AppHeaderTemplatevue_type_template_id_558da33a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VGrid_namespaceObject.VLayout,{staticClass:"row shrink align-end justify-center header",class:{ primary: _vm.isPrimary }},[_c(VGrid_namespaceObject.VLayout,{staticClass:"content"},[_c('router-link',{staticClass:"logo",attrs:{"to":{ name: 'home' }}},[_c('img',{attrs:{"src":__webpack_require__(243),"alt":"Mergin logo"}})]),_vm._t("menu",function(){return [_c(VBtn_namespaceObject.VBtn,{staticClass:"mr-3 toggle-toolbar small-screen",attrs:{"elevation":"1","fab":"","small":""},on:{"click":function($event){return _vm.setDrawer({ drawer: !_vm.drawer })}}},[(_vm.drawer)?_c(VIcon_namespaceObject.VIcon,{staticClass:"primary--text"},[_vm._v(" fa-angle-double-left ")]):_c(VIcon_namespaceObject.VIcon,{staticClass:"primary--text"},[_vm._v(" fa-angle-double-right")])],1),_c(VGrid_namespaceObject.VSpacer)]}),(_vm.loggedUser && _vm.loggedUser.email)?_c(VMenu_namespaceObject.VMenu,{attrs:{"min-width":150,"bottom":"","left":"","offset-y":"","origin":"top right","transition":"scale-transition","id":"user-menu"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VBtn_namespaceObject.VBtn,_vm._g({staticClass:"icon-btn",attrs:{"text":"","dark":"","ripple":false,"cy-data":"app-header-btn"}},on),[_c('div',{staticClass:"mr-2",staticStyle:{"position":"relative","align-self":"flex-end"}},[_c(VIcon_namespaceObject.VIcon,{attrs:{"size":"35"}},[_vm._v("account_circle")]),_vm._t("invitationsIcon")],2),_c('div',{staticClass:"accountWrapper"},[_c('div',{staticClass:"accountNameWrapper"},[_c('span',{staticClass:"accountName font-weight-bold"},[_vm._v(" "+_vm._s(_vm.getUserFullName)+" ")]),_c(VIcon_namespaceObject.VIcon,{attrs:{"small":""}},[_vm._v("keyboard_arrow_down")])],1),(_vm.renderNamespace)?_c('div',{staticClass:"namespace font-weight-bold"},[_vm._v(" "+_vm._s(_vm.currentNamespace || 'no workspace')+" ")]):_vm._e()])])]}}],null,true)},[_c(VList_namespaceObject.VList,{attrs:{"dense":""}},[_c(VList_namespaceObject.VListItem,{staticClass:"pb-1"},[_c('div',{staticClass:"user-name"},[_c('strong',[_vm._v(" "+_vm._s(_vm.getUserFullName)+" ")]),_c('span',{staticClass:"caption"},[_vm._v(" "+_vm._s(this.loggedUser.email)+" ")])])]),_c(VDivider_namespaceObject.VDivider,{staticClass:"mx-4 my-1"}),_c(VList_namespaceObject.VListItem,{staticClass:"menuItemProfile",attrs:{"to":{
            name: 'user_profile',
            params: { name: _vm.loggedUser.username }
          },"cy-data":"app-header-profile"}},[_vm._v(" Your Profile ")]),_c(VList_namespaceObject.VListItem,{attrs:{"cy-data":"app-header-logout"},on:{"click":_vm.logout}},[_c('span',{staticClass:"menuItem"},[_vm._v(" Sign Out ")])]),_vm._t("menuItems")],2)],1):_vm._e()],2)],1)
}
var AppHeaderTemplatevue_type_template_id_558da33a_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/layout/components/AppHeaderTemplate.vue?vue&type=template&id=558da33a&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/layout/components/AppHeaderTemplate.vue?vue&type=script&lang=ts&
var AppHeaderTemplatevue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    AppHeaderTemplatevue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return AppHeaderTemplatevue_type_script_lang_ts_assign.apply(this, arguments);
};
var AppHeaderTemplatevue_type_script_lang_ts_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var AppHeaderTemplatevue_type_script_lang_ts_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



/* harmony default export */ var AppHeaderTemplatevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'app-header-template',
    props: {
        isPrimary: {
            type: Boolean,
            default: true
        },
        renderNamespace: {
            type: Boolean,
            default: true
        }
    },
    computed: AppHeaderTemplatevue_type_script_lang_ts_assign(AppHeaderTemplatevue_type_script_lang_ts_assign(AppHeaderTemplatevue_type_script_lang_ts_assign(AppHeaderTemplatevue_type_script_lang_ts_assign(AppHeaderTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('layoutModule', ['drawer'])), (0,external_vuex_namespaceObject.mapState)('userModule', ['loggedUser'])), (0,external_vuex_namespaceObject.mapGetters)('userModule', ['getUserFullName'])), (0,external_vuex_namespaceObject.mapState)('projectModule', ['currentNamespace'])), { profileUrl: function () {
            var _a;
            return {
                name: 'user',
                params: { username: (_a = this.loggedUser) === null || _a === void 0 ? void 0 : _a.username }
            };
        } }),
    methods: AppHeaderTemplatevue_type_script_lang_ts_assign(AppHeaderTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapMutations)('layoutModule', ['setDrawer'])), { logout: function () {
            return AppHeaderTemplatevue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
                var e_1;
                return AppHeaderTemplatevue_type_script_lang_ts_generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, UserApi.logout()];
                        case 1:
                            _a.sent();
                            if (this.$route.path === '/') {
                                location.reload();
                            }
                            else {
                                location.href = '/';
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            console.log(e_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        } })
}));

;// CONCATENATED MODULE: ./src/modules/layout/components/AppHeaderTemplate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_AppHeaderTemplatevue_type_script_lang_ts_ = (AppHeaderTemplatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/layout/components/AppHeaderTemplate.vue?vue&type=style&index=0&id=558da33a&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/layout/components/AppHeaderTemplate.vue?vue&type=style&index=0&id=558da33a&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/layout/components/AppHeaderTemplate.vue



;


/* normalize component */

var AppHeaderTemplate_component = normalizeComponent(
  components_AppHeaderTemplatevue_type_script_lang_ts_,
  AppHeaderTemplatevue_type_template_id_558da33a_scoped_true_render,
  AppHeaderTemplatevue_type_template_id_558da33a_scoped_true_staticRenderFns,
  false,
  null,
  "558da33a",
  null
  
)

/* harmony default export */ var AppHeaderTemplate = (AppHeaderTemplate_component.exports);
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/layout/components/SideBarItem.vue?vue&type=template&id=d0aa4c7a&scoped=true&
var SideBarItemvue_type_template_id_d0aa4c7a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-item',{key:`item-${_vm.idx}`,staticClass:"ma-0",attrs:{"id":`item-${_vm.idx}`,"item":_vm.item,"color":"primary","data-cy":"side-bar-main-items"},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_vm._t("icon")]},proxy:true}],null,true)})],1)
}
var SideBarItemvue_type_template_id_d0aa4c7a_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/layout/components/SideBarItem.vue?vue&type=script&lang=js&



/* harmony default export */ var SideBarItemvue_type_script_lang_js_ = ({
  props: {
    item: Object,
    idx: Number
  },
  components: { BaseItem: BaseItem }
});

;// CONCATENATED MODULE: ./src/modules/layout/components/SideBarItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_SideBarItemvue_type_script_lang_js_ = (SideBarItemvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/layout/components/SideBarItem.vue?vue&type=style&index=0&id=d0aa4c7a&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/layout/components/SideBarItem.vue?vue&type=style&index=0&id=d0aa4c7a&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/layout/components/SideBarItem.vue



;


/* normalize component */

var SideBarItem_component = normalizeComponent(
  components_SideBarItemvue_type_script_lang_js_,
  SideBarItemvue_type_template_id_d0aa4c7a_scoped_true_render,
  SideBarItemvue_type_template_id_d0aa4c7a_scoped_true_staticRenderFns,
  false,
  null,
  "d0aa4c7a",
  null
  
)

/* harmony default export */ var SideBarItem = (SideBarItem_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VNavigationDrawer"
var VNavigationDrawer_namespaceObject = require("vuetify/lib/components/VNavigationDrawer");
;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/layout/components/SideBarTemplate.vue?vue&type=template&id=7d66925b&scoped=true&





var SideBarTemplatevue_type_template_id_7d66925b_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loggedUser)?_c(VNavigationDrawer_namespaceObject.VNavigationDrawer,_vm._b({staticClass:"user-side-bar d-flex align-start flex-column mb-6",attrs:{"id":"core-navigation-drawer-user","expand-on-hover":_vm.expandOnHover,"right":_vm.$vuetify.rtl,"mobile-breakpoint":"960","dark":_vm.barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)',"app":"","width":"200","data-cy":"side-bar"},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},'v-navigation-drawer',_vm.$attrs,false),[_c('div',{staticStyle:{"height":"100%"}},[_c(VCard_namespaceObject.VCard,{staticClass:"d-flex flex-column",staticStyle:{"height":"100%","width":"200px"},attrs:{"flat":"","tile":"","outlined":true}},[_c(VCard_namespaceObject.VCard,{staticClass:"pa-2",staticStyle:{"margin-top":"40px"},attrs:{"tile":"","outlined":true}},[_vm._t("items"),_c(VDivider_namespaceObject.VDivider,{staticStyle:{"width":"90%","margin":"5px 0 5px 0"}}),_c(VList_namespaceObject.VList,{attrs:{"nav":"","flat":""}},[_c('side-bar-item',{key:"item-userProfile",attrs:{"id":"item-userProfile","item":_vm.profileItem},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c(_vm.profileItem.tablerIcon,{tag:"component"})]},proxy:true}],null,false,3599253049)})],1)],2),_vm._t("footer")],2)],1)]):_vm._e()
}
var SideBarTemplatevue_type_template_id_7d66925b_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/layout/components/SideBarTemplate.vue?vue&type=template&id=7d66925b&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/layout/components/SideBarTemplate.vue?vue&type=script&lang=ts&
var SideBarTemplatevue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    SideBarTemplatevue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return SideBarTemplatevue_type_script_lang_ts_assign.apply(this, arguments);
};




/* harmony default export */ var SideBarTemplatevue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'SideBarTemplate',
    components: {
        SideBarItem: SideBarItem,
        UserIcon: external_vue_tabler_icons_namespaceObject.UserIcon
    },
    props: {
        expandOnHover: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            profileItem: {
                title: 'User profile',
                to: '/profile',
                tablerIcon: 'user-icon'
            }
        };
    },
    computed: SideBarTemplatevue_type_script_lang_ts_assign(SideBarTemplatevue_type_script_lang_ts_assign(SideBarTemplatevue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('userModule', ['loggedUser'])), (0,external_vuex_namespaceObject.mapState)('layoutModule', {
        barColor: 'barColor',
        drawerState: 'drawer'
    })), { drawer: {
            get: function () {
                return this.drawerState;
            },
            set: function (val) {
                this.$store.commit('layoutModule/setDrawer', { drawer: val });
            }
        } }),
    methods: {}
}));

;// CONCATENATED MODULE: ./src/modules/layout/components/SideBarTemplate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_SideBarTemplatevue_type_script_lang_ts_ = (SideBarTemplatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-65.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-65.use[1]!../../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-65.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-65.use[3]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/layout/components/SideBarTemplate.vue?vue&type=style&index=0&id=7d66925b&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/layout/components/SideBarTemplate.vue?vue&type=style&index=0&id=7d66925b&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/layout/components/SideBarTemplate.vue



;


/* normalize component */

var SideBarTemplate_component = normalizeComponent(
  components_SideBarTemplatevue_type_script_lang_ts_,
  SideBarTemplatevue_type_template_id_7d66925b_scoped_true_render,
  SideBarTemplatevue_type_template_id_7d66925b_scoped_true_staticRenderFns,
  false,
  null,
  "7d66925b",
  null
  
)

/* harmony default export */ var SideBarTemplate = (SideBarTemplate_component.exports);
;// CONCATENATED MODULE: ./src/modules/layout/components/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial





;// CONCATENATED MODULE: ./src/modules/layout/store.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
var LayoutStore = {
    namespaced: true,
    state: {
        barColor: 'rgba(176, 177, 181 1), rgba(176, 177, 181 1)',
        barImage: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
        drawer: null
    },
    mutations: {
        setBarImage: function (state, payload) {
            state.barImage = payload.barImage;
        },
        setDrawer: function (state, payload) {
            state.drawer = payload.drawer;
        }
    }
};
/* harmony default export */ var layout_store = (LayoutStore);

;// CONCATENATED MODULE: ./src/modules/layout/module.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial

var LayoutModule = {
    name: 'layoutModule',
    moduleStore: layout_store,
    init: function (_services) {
        // none initialization required
    }
};

;// CONCATENATED MODULE: ../../node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!../../node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/layout/views/NotFoundView.vue?vue&type=template&id=467abff8&scoped=true&






var NotFoundViewvue_type_template_id_467abff8_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('custom-page',[_c(VCard_namespaceObject.VCard,{staticClass:"text-center",staticStyle:{"min-width":"300px"}},[_c(VCard_namespaceObject.VCardTitle,{staticClass:"justify-center primary--text font-weight-bold ml-3"},[_c('h3',[_vm._v("Page not found")])]),_c(VCard_namespaceObject.VCardText,[_c('p',[_vm._v("This page does not exist, check your url for mistakes, please.")])]),_c(VCard_namespaceObject.VCardActions,{staticClass:"justify-center"},[(_vm.displayBackButton)?_c(VBtn_namespaceObject.VBtn,{attrs:{"data-cy":"login-form-btn-back-dashboard","color":"primary","to":{ name: 'dashboard' }}},[_vm._v("Back to Dashboard ")]):_vm._e()],1)],1)],1)
}
var NotFoundViewvue_type_template_id_467abff8_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./src/modules/layout/views/NotFoundView.vue?vue&type=template&id=467abff8&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/ts-loader/index.js??clonedRuleSet-83.use[1]!../../node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/layout/views/NotFoundView.vue?vue&type=script&lang=ts&
var NotFoundViewvue_type_script_lang_ts_assign = (undefined && undefined.__assign) || function () {
    NotFoundViewvue_type_script_lang_ts_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return NotFoundViewvue_type_script_lang_ts_assign.apply(this, arguments);
};



/* harmony default export */ var NotFoundViewvue_type_script_lang_ts_ = (external_vue_default().extend({
    name: 'NotFoundView',
    components: { CustomPage: CustomPage },
    computed: NotFoundViewvue_type_script_lang_ts_assign(NotFoundViewvue_type_script_lang_ts_assign({}, (0,external_vuex_namespaceObject.mapState)('userModule', ['loggedUser'])), { displayBackButton: function () {
            return this.loggedUser;
        } })
}));

;// CONCATENATED MODULE: ./src/modules/layout/views/NotFoundView.vue?vue&type=script&lang=ts&
 /* harmony default export */ var views_NotFoundViewvue_type_script_lang_ts_ = (NotFoundViewvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/layout/views/NotFoundView.vue





/* normalize component */
;
var NotFoundView_component = normalizeComponent(
  views_NotFoundViewvue_type_script_lang_ts_,
  NotFoundViewvue_type_template_id_467abff8_scoped_true_render,
  NotFoundViewvue_type_template_id_467abff8_scoped_true_staticRenderFns,
  false,
  null,
  "467abff8",
  null
  
)

/* harmony default export */ var NotFoundView = (NotFoundView_component.exports);
;// CONCATENATED MODULE: ./src/modules/layout/views/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial


;// CONCATENATED MODULE: ./src/modules/layout/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial





;// CONCATENATED MODULE: ./src/modules/instance/instanceApi.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial

var InstanceApi = {
    getInit: function () {
        return InstanceModule.httpService.get('/app/init');
    },
    getPing: function () {
        return InstanceModule.httpService.get('/ping');
    },
    getConfig: function () {
        return InstanceModule.httpService.get('/config');
    }
};

;// CONCATENATED MODULE: ./src/modules/instance/store.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial
var instance_store_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var instance_store_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var InstanceStore = {
    namespaced: true,
    state: {
        initData: undefined,
        initialized: false,
        pingData: undefined,
        configData: undefined
    },
    mutations: {
        setConfigData: function (state, payload) {
            state.configData = payload;
        },
        setInitData: function (state, payload) {
            state.initData = payload;
        },
        setPingData: function (state, payload) {
            state.pingData = payload;
        },
        setInitialized: function (state) {
            state.initialized = true;
        }
    },
    actions: {
        initApp: function (_a) {
            var _b;
            var commit = _a.commit, dispatch = _a.dispatch;
            return instance_store_awaiter(this, void 0, void 0, function () {
                var response, _c;
                return instance_store_generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 4, , 6]);
                            return [4 /*yield*/, InstanceApi.getInit()];
                        case 1:
                            response = _d.sent();
                            commit('setInitData', response.data);
                            if (!((_b = response.data) === null || _b === void 0 ? void 0 : _b.authenticated)) return [3 /*break*/, 3];
                            // fetch user profile if user is logged in
                            return [4 /*yield*/, dispatch('userModule/fetchUserProfile', undefined, {
                                    root: true
                                })];
                        case 2:
                            // fetch user profile if user is logged in
                            _d.sent();
                            _d.label = 3;
                        case 3:
                            commit('setInitialized');
                            return [2 /*return*/, response];
                        case 4:
                            _c = _d.sent();
                            return [4 /*yield*/, dispatch('notificationModule/error', { text: 'Failed to init application.' }, {
                                    root: true
                                })];
                        case 5:
                            _d.sent();
                            return [3 /*break*/, 6];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        },
        fetchPing: function (_a) {
            var commit = _a.commit, dispatch = _a.dispatch;
            return instance_store_awaiter(this, void 0, void 0, function () {
                var response, _b;
                return instance_store_generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 2, , 4]);
                            return [4 /*yield*/, InstanceApi.getPing()];
                        case 1:
                            response = _c.sent();
                            commit('setPingData', response.data);
                            return [2 /*return*/, response];
                        case 2:
                            _b = _c.sent();
                            return [4 /*yield*/, dispatch('notificationModule/error', { text: 'Failed to fetch ping data.' }, {
                                    root: true
                                })];
                        case 3:
                            _c.sent();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        fetchConfig: function (_a) {
            var commit = _a.commit, dispatch = _a.dispatch;
            return instance_store_awaiter(this, void 0, void 0, function () {
                var response, _b;
                return instance_store_generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 2, , 4]);
                            return [4 /*yield*/, InstanceApi.getConfig()];
                        case 1:
                            response = _c.sent();
                            commit('setConfigData', response.data);
                            return [2 /*return*/, response];
                        case 2:
                            _b = _c.sent();
                            return [4 /*yield*/, dispatch('notificationModule/error', { text: 'Failed to fetch config data.' }, {
                                    root: true
                                })];
                        case 3:
                            _c.sent();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
    }
};
/* harmony default export */ var instance_store = (InstanceStore);

;// CONCATENATED MODULE: ./src/modules/instance/module.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial

var InstanceModule = {
    name: 'instanceModule',
    httpService: undefined,
    moduleStore: instance_store,
    init: function (services) {
        if (services.httpService) {
            InstanceModule.httpService = services.httpService;
        }
        else {
            console.error("Module ".concat(InstanceModule.name, " - missing httpService"));
        }
    }
};

;// CONCATENATED MODULE: ./src/modules/instance/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial





;// CONCATENATED MODULE: ./src/modules/index.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial










;// CONCATENATED MODULE: ./src/main.ts
// Copyright (C) Lutra Consulting Limited
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-MerginMaps-Commercial



;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=lib.umd.js.map